/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		7: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://liaswebpubassetsredesign.blob.core.windows.net/components/userdata/v6/noteservice/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 742);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(16);
var hide = __webpack_require__(19);
var redefine = __webpack_require__(20);
var ctx = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _Action = __webpack_require__(751);

Object.defineProperty(exports, 'Action', {
  enumerable: true,
  get: function get() {
    return _Action.Action;
  } });


var _isType = __webpack_require__(761);

Object.defineProperty(exports, 'isType', {
  enumerable: true,
  get: function get() {
    return _isType.isType;
  } });


var _isTypeOneOf = __webpack_require__(764);

Object.defineProperty(exports, 'isTypeOneOf', {
  enumerable: true,
  get: function get() {
    return _isTypeOneOf.isTypeOneOf;
  } });


var _isAction = __webpack_require__(502);

Object.defineProperty(exports, 'isAction', {
  enumerable: true,
  get: function get() {
    return _isAction.isAction;
  } });


var _isError = __webpack_require__(765);

Object.defineProperty(exports, 'isError', {
  enumerable: true,
  get: function get() {
    return _isError.isError;
  } });


var _Factory = __webpack_require__(571);

Object.defineProperty(exports, 'Factory', {
  enumerable: true,
  get: function get() {
    return _Factory.Factory;
  } });

//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(86)('wks');
var uid = __webpack_require__(49);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(173);
var toPrimitive = __webpack_require__(29);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(5)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(31);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(477);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(71);
var defined = __webpack_require__(30);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(152)('wks');
var uid = __webpack_require__(103);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(43);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(19);
var has = __webpack_require__(15);
var SRC = __webpack_require__(49)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(16).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(72);
var createDesc = __webpack_require__(43);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(29);
var has = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(173);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(15);
var toObject = __webpack_require__(10);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(5);
var defined = __webpack_require__(30);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(79);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(69);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(12);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(16);
var fails = __webpack_require__(5);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(26);
var IObject = __webpack_require__(71);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(9);
var asc = __webpack_require__(136);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(13);
var ctx = __webpack_require__(60);
var hide = __webpack_require__(48);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(40);
var IE8_DOM_DEFINE = __webpack_require__(207);
var toPrimitive = __webpack_require__(150);
var dP = Object.defineProperty;

exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(175);
var enumBugKeys = __webpack_require__(121);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(176);
var enumBugKeys = __webpack_require__(121);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(118)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(122).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(8)) {
  var LIBRARY = __webpack_require__(50);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(5);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(98);
  var $buffer = __webpack_require__(143);
  var ctx = __webpack_require__(26);
  var anInstance = __webpack_require__(56);
  var propertyDesc = __webpack_require__(43);
  var hide = __webpack_require__(19);
  var redefineAll = __webpack_require__(57);
  var toInteger = __webpack_require__(31);
  var toLength = __webpack_require__(9);
  var toIndex = __webpack_require__(196);
  var toAbsoluteIndex = __webpack_require__(51);
  var toPrimitive = __webpack_require__(29);
  var has = __webpack_require__(15);
  var classof = __webpack_require__(53);
  var isObject = __webpack_require__(4);
  var toObject = __webpack_require__(10);
  var isArrayIter = __webpack_require__(134);
  var create = __webpack_require__(37);
  var getPrototypeOf = __webpack_require__(22);
  var gOPN = __webpack_require__(52).f;
  var getIterFn = __webpack_require__(73);
  var uid = __webpack_require__(49);
  var wks = __webpack_require__(6);
  var createArrayMethod = __webpack_require__(33);
  var createArrayIncludes = __webpack_require__(87);
  var speciesConstructor = __webpack_require__(96);
  var ArrayIterators = __webpack_require__(138);
  var Iterators = __webpack_require__(54);
  var $iterDetect = __webpack_require__(93);
  var setSpecies = __webpack_require__(55);
  var arrayFill = __webpack_require__(137);
  var arrayCopyWithin = __webpack_require__(187);
  var $DP = __webpack_require__(7);
  var $GOPD = __webpack_require__(21);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(191);
var $export = __webpack_require__(0);
var shared = __webpack_require__(86)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(194))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(70)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(49)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(15);
var setDesc = __webpack_require__(7).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(5)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(6)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(19)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(26);
var call = __webpack_require__(185);
var isArrayIter = __webpack_require__(134);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(9);
var getIterFn = __webpack_require__(73);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.select = exports.cancel = exports.race = exports.join = exports.fork = exports.call = exports.put = exports.delay = exports.CANCEL = exports.createSagaMiddleware = undefined;var _reduxSaga = __webpack_require__(596);Object.defineProperty(exports, 'CANCEL', { enumerable: true, get: function get() {return _reduxSaga.

    CANCEL;} });Object.defineProperty(exports, 'delay', { enumerable: true, get: function get() {return _reduxSaga.delay;} });var _effects = __webpack_require__(170);Object.defineProperty(exports, 'put', { enumerable: true, get: function get() {return _effects.
    put;} });Object.defineProperty(exports, 'call', { enumerable: true, get: function get() {return _effects.call;} });Object.defineProperty(exports, 'fork', { enumerable: true, get: function get() {return _effects.fork;} });Object.defineProperty(exports, 'join', { enumerable: true, get: function get() {return _effects.join;} });Object.defineProperty(exports, 'race', { enumerable: true, get: function get() {return _effects.race;} });Object.defineProperty(exports, 'cancel', { enumerable: true, get: function get() {return _effects.cancel;} });Object.defineProperty(exports, 'select', { enumerable: true, get: function get() {return _effects.select;} });var _saga = _interopRequireWildcard(_reduxSaga);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}var createSagaMiddleware = exports.createSagaMiddleware = _saga.default;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var createDesc = __webpack_require__(74);
module.exports = __webpack_require__(42) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(175);
var hiddenKeys = __webpack_require__(121).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(27);
var TAG = __webpack_require__(6)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(8);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _put = __webpack_require__(788);

Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _put.put;
  } });


var _take = __webpack_require__(794);

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _take.take;
  } });


var _takeEvery = __webpack_require__(795);

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _takeEvery.takeEvery;
  } });


var _takeLatest = __webpack_require__(796);

Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _takeLatest.takeLatest;
  } });

//# sourceMappingURL=index.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(81);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(226);
var defined = __webpack_require__(148);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f;
var has = __webpack_require__(15);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var fails = __webpack_require__(5);
var spaces = __webpack_require__(126);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('AUTH_LOGGEDOUT');

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(463)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(166)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(479), __esModule: true };

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(470), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(53);
var ITERATOR = __webpack_require__(6)('iterator');
var Iterators = __webpack_require__(54);
module.exports = __webpack_require__(16).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lib = __webpack_require__(799);
var ua_parser_js_1 = __webpack_require__(817);
var engine = new ua_parser_js_1.UAParser().getEngine().name;
if (engine !== undefined && !/WebKit/i.test(engine)) {
    if (!Array.prototype.qMapMany) {
        Array.prototype.qMapMany = function (selector) {return lib.mapManyNative(this, selector);};
    }
    if (!Array.prototype.qSelect) {
        Array.prototype.qSelect = Array.prototype.map;
    }
}
if (!Array.prototype.qContains) {
    Array.prototype.qContains = function (right, comparer) {
        return lib.contains(this, right, comparer);
    };
}
if (!Array.prototype.qIntersect) {
    Array.prototype.qIntersect = function (right, comparer) {
        return lib.intersect(this, right, comparer);
    };
}
if (!Array.prototype.qSame) {
    Array.prototype.qSame = function (right, comparer) {
        return lib.same(this, right, comparer);
    };
}
if (!Array.prototype.qEmpty) {
    Array.prototype.qEmpty = function () {
        return lib.empty(this);
    };
}
if (!Array.prototype.qFirst) {
    Array.prototype.qFirst = function (predicate) {
        return lib.first(this, predicate);
    };
}
if (!Array.prototype.qLast) {
    Array.prototype.qLast = function (predicate) {
        return lib.last(this, predicate);
    };
}
if (!Array.prototype.qRotate) {
    Array.prototype.qRotate = function (offset) {
        return lib.rotate(this, offset);
    };
}
if (!Array.prototype.qMapMany) {
    Array.prototype.qMapMany = function (selector) {
        return lib.mapMany(this, selector);
    };
}
if (!Array.prototype.qDistinct) {
    Array.prototype.qDistinct = function (key) {
        return lib.distinct(this, key);
    };
}
if (!Array.prototype.qSelect) {
    Array.prototype.qSelect = function (predicate) {
        return lib.select(this, predicate);
    };
}
if (!Array.prototype.qAny) {
    Array.prototype.qAny = function (predicate) {
        return lib.any(this, predicate);
    };
}
if (!Array.prototype.qAll) {
    Array.prototype.qAll = function (predicate) {
        return lib.all(this, predicate);
    };
}
if (!Array.prototype.qIncludes) {
    Array.prototype.qIncludes = function (value) {
        return lib.includes(this, value);
    };
}
if (!Array.prototype.qNone) {
    Array.prototype.qNone = function (predicate) {
        return lib.none(this, predicate);
    };
}
if (!Array.prototype.qCount) {
    Array.prototype.qCount = function (predicate) {
        return lib.count(this, predicate);
    };
}
if (!Array.prototype.qWhere) {
    Array.prototype.qWhere = function (predicate) {
        return lib.where(this, predicate);
    };
}
//# sourceMappingURL=prototype.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(682), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var selectors = exports.selectors = {
    docId: function docId(state) {return state.meta.docId;},
    docName: function docName(state) {return state.meta.docName;},
    pageCount: function pageCount(state) {return state.meta.pageCount;},
    pageId: function pageId(state) {return state.meta.pageId;},
    pageName: function pageName(state) {return state.meta.pageName;},
    pageNumber: function pageNumber(state) {return state.meta.pageNumber;},
    pageUrl: function pageUrl(state) {return state.meta.pageUrl;},
    tenantId: function tenantId(state) {return state.meta.tenantId;},
    tenantName: function tenantName(state) {return state.meta.tenantName;},
    breadcrumb: function breadcrumb(state) {return state.meta.breadcrumb;},
    mailToName: function mailToName(state) {return state.meta.mailToName;},
    mailToAddress: function mailToAddress(state) {return state.meta.mailToAddress;} };

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(462), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(468);
var global = __webpack_require__(18);
var hide = __webpack_require__(48);
var Iterators = __webpack_require__(67);
var TO_STRING_TAG = __webpack_require__(17)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(35).f;
var has = __webpack_require__(58);
var TAG = __webpack_require__(17)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var getTenantId = exports.getTenantId = function getTenantId() {return getMetaContent('lias-tenant-id');};
var getTenantName = exports.getTenantName = function getTenantName() {return getMetaContent('lias-tenant-name');};
var getDocumentId = exports.getDocumentId = function getDocumentId() {return getMetaContent('lias-document-id');};
var getDocumentName = exports.getDocumentName = function getDocumentName() {return getMetaContent('lias-document-name');};
var getPageId = exports.getPageId = function getPageId() {return parseInt(getMetaContent('lias-page-id'), 10);};
var getPageName = exports.getPageName = function getPageName() {return getMetaContent('lias-page-name');};
var getPageNumber = exports.getPageNumber = function getPageNumber() {return parseInt(getMetaContent('lias-page-number').split('/')[0], 10);};
var getPageCount = exports.getPageCount = function getPageCount() {return parseInt(getMetaContent('lias-page-number').split('/')[1], 10);};
var getBreadcrumb = exports.getBreadcrumb = function getBreadcrumb() {return getMetaContent('lias-page-breadcrumb');};
var getMailToAddress = exports.getMailToAddress = function getMailToAddress() {return getMetaContent('lias-mailto-address');};
var getMailToName = exports.getMailToName = function getMailToName() {return getMetaContent('lias-mailto-name');};
var getTestNoteService = exports.getTestNoteService = function getTestNoteService() {return getMetaContent('lias-test-noteservice');};
var homePage = exports.homePage = window.location.origin || window.location.protocol + '//' + window.location.host;
var noteServiceUserApi = exports.noteServiceUserApi = Object({"NODE_ENV":'production',"IDENTITYSERVICEURL":'https://login.liasonline.nl',"NOTESERVICEUSERAPI":'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user'}).NODE_STAGE === 'development' ?
'http://localhost:50455/api/user' : Object({"NODE_ENV":'production',"IDENTITYSERVICEURL":'https://login.liasonline.nl',"NOTESERVICEUSERAPI":'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user'}).NODE_STAGE === 'test' ?
'https://lias-webpub-noteservice-redesign-dev.azurewebsites.net/api/user' :
'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user';
function getMetaContent(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    if (el) {
        return el.content;
    } else
    {
        return '';
    }
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('AUTH_AUTHENTICATED');

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(678), __esModule: true };

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(14);
var toLength = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(51);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(27);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(19);
var has = __webpack_require__(15);
var Iterators = __webpack_require__(54);
var $iterCreate = __webpack_require__(91);
var setToStringTag = __webpack_require__(62);
var getPrototypeOf = __webpack_require__(22);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(37);
var descriptor = __webpack_require__(43);
var setToStringTag = __webpack_require__(62);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(19)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(4);
var cof = __webpack_require__(27);
var MATCH = __webpack_require__(6)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(6)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(19);
var redefine = __webpack_require__(20);
var fails = __webpack_require__(5);
var defined = __webpack_require__(30);
var wks = __webpack_require__(6);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(12);
var SPECIES = __webpack_require__(6)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var redefineAll = __webpack_require__(57);
var meta = __webpack_require__(44);
var forOf = __webpack_require__(46);
var anInstance = __webpack_require__(56);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(5);
var $iterDetect = __webpack_require__(93);
var setToStringTag = __webpack_require__(62);
var inheritIfRequired = __webpack_require__(127);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(19);
var uid = __webpack_require__(49);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(50) || !__webpack_require__(5)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(3)[K];
});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var ctx = __webpack_require__(26);
var forOf = __webpack_require__(46);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(68);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.notesBatch = exports.notesEditor = exports.notesResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _reduxSaga = __webpack_require__(47);
var _settings = __webpack_require__(83);
var _selectors = __webpack_require__(78);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(






customUrls);function preprocess(note) {if (!note.categoryId) {note.categoryId = undefined;}return note;}function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 11;break;}
                    preprocess(create);_context.next = 4;return (
                        (0, _reduxSaga.select)(_selectors.selectors.docId));case 4:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/notes';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 12;break;case 11:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/notes/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        preprocess(update);
                        request.url = _settings.noteServiceUserApi + '/notes/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/notes/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notes';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/notes';
                        request.params = {};
                    }case 12:return _context.delegateYield(
                    next(), 't0', 13);case 13:case 'end':return _context.stop();}}}, _marked, this);}

var notesResource = exports.notesResource = (0, _reduxSagaResources.createResource)('notes', {}, (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notes', _resource.authMiddleware, customUrls));
var notesEditor = exports.notesEditor = (0, _reduxSagaResources.createEditor)('notes', { createImmediately: false }, notesResource);
var notesBatch = exports.notesBatch = (0, _reduxSagaResources.createBatch)('notes', {}, notesResource);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(209);
var enumBugKeys = __webpack_require__(153);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {



/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _resource = __webpack_require__(485);

Object.defineProperty(exports, 'createResource', {
  enumerable: true,
  get: function get() {
    return _resource.createResource;
  } });


var _editor = __webpack_require__(819);

Object.defineProperty(exports, 'createEditor', {
  enumerable: true,
  get: function get() {
    return _editor.createEditor;
  } });


var _batch = __webpack_require__(824);

Object.defineProperty(exports, 'createBatch', {
  enumerable: true,
  get: function get() {
    return _batch.createBatch;
  } });


var _middlewares = __webpack_require__(831);

Object.defineProperty(exports, 'FetchMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.FetchMiddleware;
  } });

Object.defineProperty(exports, 'HttpMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.HttpMiddleware;
  } });

Object.defineProperty(exports, 'RestMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.RestMiddleware;
  } });

Object.defineProperty(exports, 'AuthBearerMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.AuthBearerMiddleware;
  } });

Object.defineProperty(exports, 'JsonRestMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.JsonRestMiddleware;
  } });

Object.defineProperty(exports, 'JsonTransportMiddleware', {
  enumerable: true,
  get: function get() {
    return _middlewares.JsonTransportMiddleware;
  } });


var _utils = __webpack_require__(156);

Object.defineProperty(exports, 'applyMiddlewares', {
  enumerable: true,
  get: function get() {
    return _utils.applyMiddlewares;
  } });

Object.defineProperty(exports, 'internal', {
  enumerable: true,
  get: function get() {
    return _utils.internal;
  } });

Object.defineProperty(exports, 'isInternal', {
  enumerable: true,
  get: function get() {
    return _utils.isInternal;
  } });

Object.defineProperty(exports, 'listAddOrUpdate', {
  enumerable: true,
  get: function get() {
    return _utils.listAddOrUpdate;
  } });

Object.defineProperty(exports, 'listRemove', {
  enumerable: true,
  get: function get() {
    return _utils.listRemove;
  } });

Object.defineProperty(exports, 'isTempKey', {
  enumerable: true,
  get: function get() {
    return _utils.isTempKey;
  } });

Object.defineProperty(exports, 'makeTempKey', {
  enumerable: true,
  get: function get() {
    return _utils.makeTempKey;
  } });

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(161);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(148);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(147);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.authMiddleware = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);__webpack_require__(593);
var _reduxSagaResources = __webpack_require__(109);
var _reduxSaga = __webpack_require__(47);
var _selectors = __webpack_require__(649);var _selectors2 = _interopRequireDefault(_selectors);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(


logout401);var authMiddleware = exports.authMiddleware = (0, _reduxSagaResources.applyMiddlewares)((0, _reduxSagaResources.AuthBearerMiddleware)(_selectors2.default.token), logout401);var httpUnauthorized = 401;function logout401(_ref, next) {var response = _ref.response;return _regenerator2.default.wrap(function logout401$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:return _context.delegateYield(
                    next(), 't0', 1);case 1:if (!(
                    response.statusCode === httpUnauthorized)) {_context.next = 4;break;}_context.next = 4;return (
                        (0, _reduxSaga.put)((0, _LOGGEDOUT2.default)({})));case 4:case 'end':return _context.stop();}}}, _marked, this);}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(685), __esModule: true };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(482), __esModule: true };

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(16);
var LIBRARY = __webpack_require__(50);
var wksExt = __webpack_require__(174);
var defineProperty = __webpack_require__(7).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(86)('keys');
var uid = __webpack_require__(49);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(88);
var pIE = __webpack_require__(72);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(71);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(5)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(26)(Function.call, __webpack_require__(21).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(124).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(30);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(92);
var defined = __webpack_require__(30);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(6)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(54);
var ITERATOR = __webpack_require__(6)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(7);
var createDesc = __webpack_require__(43);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(342);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(51);
var toLength = __webpack_require__(9);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(45);
var step = __webpack_require__(139);
var Iterators = __webpack_require__(54);
var toIObject = __webpack_require__(14);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(90)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(26);
var invoke = __webpack_require__(125);
var html = __webpack_require__(122);
var cel = __webpack_require__(118);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(27)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(140).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(27)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(12);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(8);
var LIBRARY = __webpack_require__(50);
var $typed = __webpack_require__(98);
var hide = __webpack_require__(19);
var redefineAll = __webpack_require__(57);
var fails = __webpack_require__(5);
var anInstance = __webpack_require__(56);
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(9);
var toIndex = __webpack_require__(196);
var gOPN = __webpack_require__(52).f;
var dP = __webpack_require__(7).f;
var arrayFill = __webpack_require__(137);
var setToStringTag = __webpack_require__(62);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(52);
var gOPS = __webpack_require__(88);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(41);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(152)('keys');
var uid = __webpack_require__(103);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(13);
var LIBRARY = __webpack_require__(102);
var wksExt = __webpack_require__(116);
var defineProperty = __webpack_require__(35).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(81);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _applyMiddlewares = __webpack_require__(785);

Object.defineProperty(exports, 'applyMiddlewares', {
  enumerable: true,
  get: function get() {
    return _applyMiddlewares.applyMiddlewares;
  } });


var _internal = __webpack_require__(582);

Object.defineProperty(exports, 'internal', {
  enumerable: true,
  get: function get() {
    return _internal.internal;
  } });

Object.defineProperty(exports, 'isInternal', {
  enumerable: true,
  get: function get() {
    return _internal.isInternal;
  } });


var _list = __webpack_require__(786);

Object.defineProperty(exports, 'listAddOrUpdate', {
  enumerable: true,
  get: function get() {
    return _list.listAddOrUpdate;
  } });

Object.defineProperty(exports, 'listRemove', {
  enumerable: true,
  get: function get() {
    return _list.listRemove;
  } });


var _tempKey = __webpack_require__(787);

Object.defineProperty(exports, 'isTempKey', {
  enumerable: true,
  get: function get() {
    return _tempKey.isTempKey;
  } });

Object.defineProperty(exports, 'makeTempKey', {
  enumerable: true,
  get: function get() {
    return _tempKey.makeTempKey;
  } });

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : (0, _typeof3.default)(window)) === "object")
	g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(40);
var dPs = __webpack_require__(465);
var enumBugKeys = __webpack_require__(153);
var IE_PROTO = __webpack_require__(151)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(149)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(210).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(75);
var TAG = __webpack_require__(17)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _normalizeTextNodes = __webpack_require__(844);Object.defineProperty(exports, 'normalizeTextNodes', { enumerable: true, get: function get() {return _normalizeTextNodes.normalizeTextNodes;} });var _NodeTextPosition = __webpack_require__(602);Object.defineProperty(exports, 'NodeTextPosition', { enumerable: true, get: function get() {return _NodeTextPosition.
        NodeTextPosition;} });exports.
















parents = parents;exports.






closest = closest;exports.






followingNode = followingNode;exports.






nextNode = nextNode;exports.










prevNode = prevNode;var isElement = exports.isElement = function isElement(node) {return node && node.nodeType === 1;};var isText = exports.isText = function isText(node) {return node && node.nodeType === 3;};function precedingNode(node) {if (node.previousSibling) {node = node.previousSibling;node = lastLeafNode(node);return node;}return node.parentNode;}function lastLeafNode(node) {while (node.lastChild) {node = node.lastChild;}return node;}function parents(start, end) {var res = [];for (var current = start && start.parentNode; current && current !== end; current = current.parentNode) {res.push(current);}return res;}function closest(start, end, selector) {for (var current = start; current && current !== end; current = current.parentNode) {if (isElement(current) && current.matches(selector)) {return current;}}}function followingNode(node) {for (var current = node; current; current = current.parentNode) {if (current.nextSibling) {return current.nextSibling;}}}function nextNode(node) {if (!node) {return;}if (node.firstChild) {return node.firstChild;} else {return followingNode(node);}}function prevNode(node) {
    if (!node) {
        return;
    }
    if (node.previousSibling) {
        node = node.previousSibling;
        node = lastLeafNode(node);
        return node;
    } else
    {
        return precedingNode(node);
    }
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(671), __esModule: true };

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.categoriesBatch = exports.categoriesEditor = exports.categoriesResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _selectors = __webpack_require__(78);
var _reduxSaga = __webpack_require__(47);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 10;break;}_context.next = 3;return (
                        (0, _reduxSaga.select)(_selectors.selectors.docId));case 3:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/categories';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 11;break;case 10:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/categories/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/categories/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/categories/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/categories';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/categories';
                        request.params = {};
                    }case 11:return _context.delegateYield(
                    next(), 't0', 12);case 12:case 'end':return _context.stop();}}}, _marked, this);}

var categoriesJsonMiddleware = (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/categories', _resource.authMiddleware, customUrls);
var categoriesResource = exports.categoriesResource = (0, _reduxSagaResources.createResource)('categories', {}, categoriesJsonMiddleware);
var categoriesEditor = exports.categoriesEditor = (0, _reduxSagaResources.createEditor)('categories', { createImmediately: false }, categoriesResource);
var categoriesBatch = exports.categoriesBatch = (0, _reduxSagaResources.createBatch)('categories', {}, categoriesResource);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.bookmarksBatch = exports.bookmarksEditor = exports.bookmarksResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _selectors = __webpack_require__(78);
var _reduxSaga = __webpack_require__(47);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(






customUrls);function preprocess(bookmark) {if (!bookmark.categoryId) {bookmark.categoryId = undefined;}return bookmark;}function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 11;break;}
                    preprocess(create);_context.next = 4;return (
                        (0, _reduxSaga.select)(_selectors.selectors.docId));case 4:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/bookmarks';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 12;break;case 11:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/bookmarks/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        preprocess(update);
                        request.url = _settings.noteServiceUserApi + '/bookmarks/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/bookmarks/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/bookmarks';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/bookmarks';
                        request.params = {};
                    }case 12:return _context.delegateYield(
                    next(), 't0', 13);case 13:case 'end':return _context.stop();}}}, _marked, this);}

var bookmarksJsonMiddleware = (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/bookmarks', _resource.authMiddleware, customUrls);
var bookmarksResource = exports.bookmarksResource = (0, _reduxSagaResources.createResource)('bookmarks', {}, bookmarksJsonMiddleware);
var bookmarksEditor = exports.bookmarksEditor = (0, _reduxSagaResources.createEditor)('bookmarks', { createImmediately: false }, bookmarksResource);
var bookmarksBatch = exports.bookmarksBatch = (0, _reduxSagaResources.createBatch)('bookmarks', {}, bookmarksResource);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(159);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(67);
module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(102);
var $export = __webpack_require__(34);
var redefine = __webpack_require__(208);
var hide = __webpack_require__(48);
var has = __webpack_require__(58);
var Iterators = __webpack_require__(67);
var $iterCreate = __webpack_require__(464);
var setToStringTag = __webpack_require__(82);
var getPrototypeOf = __webpack_require__(236);
var ITERATOR = __webpack_require__(17)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(60);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(214);
var anObject = __webpack_require__(40);
var toLength = __webpack_require__(113);
var getIterFn = __webpack_require__(165);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.createSetContextWarning = exports.internalErr = exports.uid = exports.object = exports.is = exports.isDev = exports.ident = exports.noop = exports.kFalse = exports.kTrue = exports.konst = exports.SELF_CANCELLATION = exports.SAGA_ACTION = exports.CANCEL = exports.MATCH = exports.HELPER = exports.TASK = exports.sym = undefined;var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.




























check = check;exports.







hasOwn = hasOwn;exports.

































































remove = remove;exports.






deferred = deferred;exports.











arrayOfDeffered = arrayOfDeffered;exports.







delay = delay;exports.
















createMockTask = createMockTask;exports.





















autoInc = autoInc;exports.















makeIterator = makeIterator;exports.






















log = log;exports.










deprecate = deprecate;exports.














wrapSagaDispatch = wrapSagaDispatch;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var sym = exports.sym = function sym(id) {return '@@redux-saga/' + id;};var TASK = exports.TASK = sym('TASK');var HELPER = exports.HELPER = sym('HELPER');var MATCH = exports.MATCH = sym('MATCH');var CANCEL = exports.CANCEL = sym('cancelPromise');var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');var konst = exports.konst = function konst(v) {return function () {return v;};};var kTrue = exports.kTrue = konst(true);var kFalse = exports.kFalse = konst(false);var noop = exports.noop = function noop() {};var ident = exports.ident = function ident(v) {return v;};var isDev = exports.isDev = 'production' === 'development';function check(value, predicate, error) {if (!predicate(value)) {log('error', 'uncaught at check', error);throw new Error(error);}}var hasOwnProperty = Object.prototype.hasOwnProperty;function hasOwn(object, property) {return is.notUndef(object) && hasOwnProperty.call(object, property);}var is = exports.is = { undef: function undef(v) {return v === null || v === undefined;}, notUndef: function notUndef(v) {return v !== null && v !== undefined;}, func: function func(f) {return typeof f === 'function';}, number: function number(n) {return typeof n === 'number';}, string: function string(s) {return typeof s === 'string';}, array: Array.isArray, object: function object(obj) {return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';}, promise: function promise(p) {return p && is.func(p.then);}, iterator: function iterator(it) {return it && is.func(it.next) && is.func(it.throw);}, iterable: function iterable(it) {return it && is.func(_symbol2.default) ? is.func(it[_iterator2.default]) : is.array(it);}, task: function task(t) {return t && t[TASK];}, observable: function observable(ob) {return ob && is.func(ob.subscribe);}, buffer: function buffer(buf) {return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);}, pattern: function pattern(pat) {return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));}, channel: function channel(ch) {return ch && is.func(ch.take) && is.func(ch.close);}, helper: function helper(it) {return it && it[HELPER];}, stringableFunc: function stringableFunc(f) {return is.func(f) && hasOwn(f, 'toString');} };var object = exports.object = { assign: function assign(target, source) {for (var i in source) {if (hasOwn(source, i)) {target[i] = source[i];}}} };function remove(array, item) {var index = array.indexOf(item);if (index >= 0) {array.splice(index, 1);}}function deferred() {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var def = _extends({}, props);var promise = new _promise2.default(function (resolve, reject) {def.resolve = resolve;def.reject = reject;});def.promise = promise;return def;}function arrayOfDeffered(length) {var arr = [];for (var i = 0; i < length; i++) {arr.push(deferred());}return arr;}function delay(ms) {var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var timeoutId = void 0;var promise = new _promise2.default(function (resolve) {timeoutId = setTimeout(function () {return resolve(val);}, ms);});promise[CANCEL] = function () {return clearTimeout(timeoutId);};return promise;}function createMockTask() {var _ref;var running = true;var _result = void 0,_error = void 0;return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {return running;}), _defineProperty(_ref, 'result', function result() {return _result;}), _defineProperty(_ref, 'error', function error() {return _error;}), _defineProperty(_ref, 'setRunning', function setRunning(b) {return running = b;}), _defineProperty(_ref, 'setResult', function setResult(r) {return _result = r;}), _defineProperty(_ref, 'setError', function setError(e) {return _error = e;}), _ref;}function autoInc() {var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;return function () {return ++seed;};}var uid = exports.uid = autoInc();var kThrow = function kThrow(err) {throw err;};var kReturn = function kReturn(value) {return { value: value, done: true };};function makeIterator(next) {var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var isHelper = arguments[3];var iterator = { name: name, next: next, throw: thro, return: kReturn };if (isHelper) {iterator[HELPER] = true;}if (typeof _symbol2.default !== 'undefined') {iterator[_iterator2.default] = function () {return iterator;};}return iterator;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    Print error in a useful way whether in a browser environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    (with expandable error stack traces), or in a node.js environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    (text-only log output)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   **/function log(level, message) {var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''; /*eslint-disable no-console*/if (typeof window === 'undefined') {console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));} else {console[level](message, error);}}function deprecate(fn, deprecationWarning) {return function () {if (isDev) log('warn', deprecationWarning);return fn.apply(undefined, arguments);};}var internalErr = exports.internalErr = function internalErr(err) {return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');};var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';};function wrapSagaDispatch(dispatch) {return function sagaDispatch(action) {var wrappedAction = (0, _defineProperty3.default)(action, SAGA_ACTION, { value: true });return dispatch(wrappedAction);};
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.cloneableGenerator = exports.wrapSagaDispatch = exports.createSetContextWarning = exports.internalErr = exports.updateIncentive = exports.uid = exports.array = exports.object = exports.is = exports.ident = exports.noop = exports.kFalse = exports.kTrue = exports.konst = exports.SELF_CANCELLATION = exports.SAGA_ACTION = exports.CANCEL = exports.MATCH = exports.HELPER = exports.TASK = exports.sym = undefined;var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.

























check = check;exports.







hasOwn = hasOwn;exports.

































































remove = remove;exports.


















deferred = deferred;exports.











arrayOfDeffered = arrayOfDeffered;exports.







delay = delay;exports.
















createMockTask = createMockTask;exports.





















autoInc = autoInc;exports.















makeIterator = makeIterator;exports.






















log = log;exports.










deprecate = deprecate;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};var sym = exports.sym = function sym(id) {return '@@redux-saga/' + id;};var TASK = exports.TASK = sym('TASK');var HELPER = exports.HELPER = sym('HELPER');var MATCH = exports.MATCH = sym('MATCH');var CANCEL = exports.CANCEL = sym('CANCEL_PROMISE');var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');var konst = exports.konst = function konst(v) {return function () {return v;};};var kTrue = exports.kTrue = konst(true);var kFalse = exports.kFalse = konst(false);var noop = exports.noop = function noop() {};var ident = exports.ident = function ident(v) {return v;};function check(value, predicate, error) {if (!predicate(value)) {log('error', 'uncaught at check', error);throw new Error(error);}}var hasOwnProperty = Object.prototype.hasOwnProperty;function hasOwn(object, property) {return is.notUndef(object) && hasOwnProperty.call(object, property);}var is = exports.is = { undef: function undef(v) {return v === null || v === undefined;}, notUndef: function notUndef(v) {return v !== null && v !== undefined;}, func: function func(f) {return typeof f === 'function';}, number: function number(n) {return typeof n === 'number';}, string: function string(s) {return typeof s === 'string';}, array: Array.isArray, object: function object(obj) {return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';}, promise: function promise(p) {return p && is.func(p.then);}, iterator: function iterator(it) {return it && is.func(it.next) && is.func(it.throw);}, iterable: function iterable(it) {return it && is.func(_symbol2.default) ? is.func(it[_iterator2.default]) : is.array(it);}, task: function task(t) {return t && t[TASK];}, observable: function observable(ob) {return ob && is.func(ob.subscribe);}, buffer: function buffer(buf) {return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);}, pattern: function pattern(pat) {return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));}, channel: function channel(ch) {return ch && is.func(ch.take) && is.func(ch.close);}, helper: function helper(it) {return it && it[HELPER];}, stringableFunc: function stringableFunc(f) {return is.func(f) && hasOwn(f, 'toString');} };var object = exports.object = { assign: function assign(target, source) {for (var i in source) {if (hasOwn(source, i)) {target[i] = source[i];}}} };function remove(array, item) {var index = array.indexOf(item);if (index >= 0) {array.splice(index, 1);}}var array = exports.array = { 'from': function from(obj) {var arr = Array(obj.length);for (var i in obj) {if (hasOwn(obj, i)) {arr[i] = obj[i];}}return arr;} };function deferred() {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var def = _extends({}, props);var promise = new _promise2.default(function (resolve, reject) {def.resolve = resolve;def.reject = reject;});def.promise = promise;return def;}function arrayOfDeffered(length) {var arr = [];for (var i = 0; i < length; i++) {arr.push(deferred());}return arr;}function delay(ms) {var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var timeoutId = void 0;var promise = new _promise2.default(function (resolve) {timeoutId = setTimeout(function () {return resolve(val);}, ms);});promise[CANCEL] = function () {return clearTimeout(timeoutId);};return promise;}function createMockTask() {var _ref;var running = true;var _result = void 0,_error = void 0;return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {return running;}, _ref.result = function result() {return _result;}, _ref.error = function error() {return _error;}, _ref.setRunning = function setRunning(b) {return running = b;}, _ref.setResult = function setResult(r) {return _result = r;}, _ref.setError = function setError(e) {return _error = e;}, _ref;}function autoInc() {var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;return function () {return ++seed;};}var uid = exports.uid = autoInc();var kThrow = function kThrow(err) {throw err;};var kReturn = function kReturn(value) {return { value: value, done: true };};function makeIterator(next) {var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var isHelper = arguments[3];var iterator = { name: name, next: next, throw: thro, return: kReturn };if (isHelper) {iterator[HELPER] = true;}if (typeof _symbol2.default !== 'undefined') {iterator[_iterator2.default] = function () {return iterator;};}return iterator;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                Print error in a useful way whether in a browser environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                (with expandable error stack traces), or in a node.js environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                (text-only log output)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/function log(level, message) {var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''; /*eslint-disable no-console*/if (typeof window === 'undefined') {console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));} else {console[level](message, error);}}function deprecate(fn, deprecationWarning) {return function () {if (false) log('warn', deprecationWarning);return fn.apply(undefined, arguments);};
}

var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch((0, _defineProperty2.default)(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      } };

  };
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _io = __webpack_require__(509);Object.defineProperty(exports, 'take', { enumerable: true, get: function get() {return _io.take;} });Object.defineProperty(exports, 'takem', { enumerable: true, get: function get() {return _io.takem;} });Object.defineProperty(exports, 'put', { enumerable: true, get: function get() {return _io.put;} });Object.defineProperty(exports, 'all', { enumerable: true, get: function get() {return _io.all;} });Object.defineProperty(exports, 'race', { enumerable: true, get: function get() {return _io.race;} });Object.defineProperty(exports, 'call', { enumerable: true, get: function get() {return _io.call;} });Object.defineProperty(exports, 'apply', { enumerable: true, get: function get() {return _io.apply;} });Object.defineProperty(exports, 'cps', { enumerable: true, get: function get() {return _io.cps;} });Object.defineProperty(exports, 'fork', { enumerable: true, get: function get() {return _io.fork;} });Object.defineProperty(exports, 'spawn', { enumerable: true, get: function get() {return _io.spawn;} });Object.defineProperty(exports, 'join', { enumerable: true, get: function get() {return _io.join;} });Object.defineProperty(exports, 'cancel', { enumerable: true, get: function get() {return _io.cancel;} });Object.defineProperty(exports, 'select', { enumerable: true, get: function get() {return _io.select;} });Object.defineProperty(exports, 'actionChannel', { enumerable: true, get: function get() {return _io.actionChannel;} });Object.defineProperty(exports, 'cancelled', { enumerable: true, get: function get() {return _io.cancelled;} });Object.defineProperty(exports, 'flush', { enumerable: true, get: function get() {return _io.flush;} });Object.defineProperty(exports, 'getContext', { enumerable: true, get: function get() {return _io.getContext;} });Object.defineProperty(exports, 'setContext', { enumerable: true, get: function get() {return _io.setContext;} });Object.defineProperty(exports, 'takeEvery', { enumerable: true, get: function get() {return _io.takeEvery;} });Object.defineProperty(exports, 'takeLatest', { enumerable: true, get: function get() {return _io.takeLatest;} });Object.defineProperty(exports, 'throttle', { enumerable: true, get: function get() {return _io.throttle;} });

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(922);
} else {
  module.exports = require('./cjs/react.development.js');
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(117);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(5)(function () {
  return Object.defineProperty(__webpack_require__(118)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(6);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(15);
var toIObject = __webpack_require__(14);
var arrayIndexOf = __webpack_require__(87)(false);
var IE_PROTO = __webpack_require__(120)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(14);
var gOPN = __webpack_require__(52).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(12);
var isObject = __webpack_require__(4);
var invoke = __webpack_require__(125);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(63).trim;
var ws = __webpack_require__(126);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(63).trim;

module.exports = 1 / $parseFloat(__webpack_require__(126) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(27);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(4);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(129);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(12);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(71);
var toLength = __webpack_require__(9);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(51);
var toLength = __webpack_require__(9);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(7).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(94)
});


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(142);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(192);
var validate = __webpack_require__(64);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(97)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(7).f;
var create = __webpack_require__(37);
var redefineAll = __webpack_require__(57);
var ctx = __webpack_require__(26);
var anInstance = __webpack_require__(56);
var forOf = __webpack_require__(46);
var $iterDefine = __webpack_require__(90);
var step = __webpack_require__(139);
var setSpecies = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(8);
var fastKey = __webpack_require__(44).fastKey;
var validate = __webpack_require__(64);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(192);
var validate = __webpack_require__(64);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(97)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(33)(0);
var redefine = __webpack_require__(20);
var meta = __webpack_require__(44);
var assign = __webpack_require__(123);
var weak = __webpack_require__(195);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(5);
var validate = __webpack_require__(64);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(97)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(57);
var getWeak = __webpack_require__(44).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(4);
var anInstance = __webpack_require__(56);
var forOf = __webpack_require__(46);
var createArrayMethod = __webpack_require__(33);
var $has = __webpack_require__(15);
var validate = __webpack_require__(64);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(9);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(89);
var isObject = __webpack_require__(4);
var toLength = __webpack_require__(9);
var ctx = __webpack_require__(26);
var IS_CONCAT_SPREADABLE = __webpack_require__(6)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(9);
var repeat = __webpack_require__(128);
var defined = __webpack_require__(30);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(14);
var isEnum = __webpack_require__(72).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(53);
var from = __webpack_require__(201);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(46);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(53);
var ITERATOR = __webpack_require__(6)('iterator');
var Iterators = __webpack_require__(54);
module.exports = __webpack_require__(16).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(205);
var invoke = __webpack_require__(125);
var aFunction = __webpack_require__(12);
module.exports = function (/* ...pargs */) {
  var fn = aFunction(this);
  var length = arguments.length;
  var pargs = new Array(length);
  var i = 0;
  var _ = path._;
  var holder = false;
  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
  return function (/* ...args */) {
    var that = this;
    var aLen = arguments.length;
    var j = 0;
    var k = 0;
    var args;
    if (!holder && !aLen) return invoke(fn, pargs, that);
    args = pargs.slice();
    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
    while (aLen > k) args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var gOPD = __webpack_require__(21);
var ownKeys = __webpack_require__(144);
var toIObject = __webpack_require__(14);

module.exports = function define(target, mixin) {
  var keys = ownKeys(toIObject(mixin));
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) dP.f(target, key = keys[i++], gOPD.f(mixin, key));
  return target;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(42) && !__webpack_require__(70)(function () {
  return Object.defineProperty(__webpack_require__(149)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(48);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(58);
var toIObject = __webpack_require__(61);
var arrayIndexOf = __webpack_require__(466)(false);
var IE_PROTO = __webpack_require__(151)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(209);
var hiddenKeys = __webpack_require__(153).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(102);
var global = __webpack_require__(18);
var ctx = __webpack_require__(60);
var classof = __webpack_require__(159);
var $export = __webpack_require__(34);
var isObject = __webpack_require__(41);
var aFunction = __webpack_require__(81);
var anInstance = __webpack_require__(229);
var forOf = __webpack_require__(167);
var speciesConstructor = __webpack_require__(215);
var task = __webpack_require__(216).set;
var microtask = __webpack_require__(476)();
var newPromiseCapabilityModule = __webpack_require__(155);
var perform = __webpack_require__(217);
var promiseResolve = __webpack_require__(218);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(230)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(82)($Promise, PROMISE);
__webpack_require__(240)(PROMISE);
Wrapper = __webpack_require__(13)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(219)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(40);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(67);
var ITERATOR = __webpack_require__(17)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(40);
var aFunction = __webpack_require__(81);
var SPECIES = __webpack_require__(17)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(60);
var invoke = __webpack_require__(475);
var html = __webpack_require__(210);
var cel = __webpack_require__(149);
var global = __webpack_require__(18);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(75)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(40);
var isObject = __webpack_require__(41);
var newPromiseCapability = __webpack_require__(155);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(17)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _io = __webpack_require__(506);Object.defineProperty(exports, 'take', { enumerable: true, get: function get() {return _io.take;} });Object.defineProperty(exports, 'takem', { enumerable: true, get: function get() {return _io.takem;} });Object.defineProperty(exports, 'put', { enumerable: true, get: function get() {return _io.put;} });Object.defineProperty(exports, 'race', { enumerable: true, get: function get() {return _io.race;} });Object.defineProperty(exports, 'call', { enumerable: true, get: function get() {return _io.call;} });Object.defineProperty(exports, 'apply', { enumerable: true, get: function get() {return _io.apply;} });Object.defineProperty(exports, 'cps', { enumerable: true, get: function get() {return _io.cps;} });Object.defineProperty(exports, 'fork', { enumerable: true, get: function get() {return _io.fork;} });Object.defineProperty(exports, 'spawn', { enumerable: true, get: function get() {return _io.spawn;} });Object.defineProperty(exports, 'join', { enumerable: true, get: function get() {return _io.join;} });Object.defineProperty(exports, 'cancel', { enumerable: true, get: function get() {return _io.cancel;} });Object.defineProperty(exports, 'select', { enumerable: true, get: function get() {return _io.select;} });Object.defineProperty(exports, 'actionChannel', { enumerable: true, get: function get() {return _io.actionChannel;} });Object.defineProperty(exports, 'cancelled', { enumerable: true, get: function get() {return _io.cancelled;} });Object.defineProperty(exports, 'flush', { enumerable: true, get: function get() {return _io.flush;} });Object.defineProperty(exports, 'getContext', { enumerable: true, get: function get() {return _io.getContext;} });Object.defineProperty(exports, 'setContext', { enumerable: true, get: function get() {return _io.setContext;} });Object.defineProperty(exports, 'takeEvery', { enumerable: true, get: function get() {return _io.takeEvery;} });Object.defineProperty(exports, 'takeLatest', { enumerable: true, get: function get() {return _io.takeLatest;} });Object.defineProperty(exports, 'throttle', { enumerable: true, get: function get() {return _io.throttle;} });

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'undefined' ? 'undefined' : (0, _typeof3.default)(dep);
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if ((typeof selectors === 'undefined' ? 'undefined' : (0, _typeof3.default)(selectors)) !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + (typeof selectors === 'undefined' ? 'undefined' : (0, _typeof3.default)(selectors))));
  }
  var objectKeys = (0, _keys2.default)(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(676), __esModule: true };

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.questionsBatch = exports.questionsEditor = exports.questionsResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _selectors = __webpack_require__(78);
var _reduxSaga = __webpack_require__(47);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 10;break;}_context.next = 3;return (
                        (0, _reduxSaga.select)(_selectors.selectors.docId));case 3:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/questions';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 11;break;case 10:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/questions/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/questions/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/questions/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/questions';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/questions';
                        request.params = {};
                    }case 11:return _context.delegateYield(
                    next(), 't0', 12);case 12:case 'end':return _context.stop();}}}, _marked, this);}

var questionsJsonMiddleware = (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/questions', _resource.authMiddleware, customUrls);
var questionsResource = exports.questionsResource = (0, _reduxSagaResources.createResource)('questions', {}, questionsJsonMiddleware);
var questionsEditor = exports.questionsEditor = (0, _reduxSagaResources.createEditor)('questions', { createImmediately: false }, questionsResource);
var questionsBatch = exports.questionsBatch = (0, _reduxSagaResources.createBatch)('questions', {}, questionsResource);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(112);
var createDesc = __webpack_require__(74);
var toIObject = __webpack_require__(61);
var toPrimitive = __webpack_require__(150);
var has = __webpack_require__(58);
var IE8_DOM_DEFINE = __webpack_require__(207);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(161);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(75);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(42);
var $export = __webpack_require__(34);
var redefine = __webpack_require__(208);
var META = __webpack_require__(228).KEY;
var $fails = __webpack_require__(70);
var shared = __webpack_require__(152);
var setToStringTag = __webpack_require__(82);
var uid = __webpack_require__(103);
var wks = __webpack_require__(17);
var wksExt = __webpack_require__(116);
var wksDefine = __webpack_require__(154);
var enumKeys = __webpack_require__(471);
var isArray = __webpack_require__(239);
var anObject = __webpack_require__(40);
var isObject = __webpack_require__(41);
var toIObject = __webpack_require__(61);
var toPrimitive = __webpack_require__(150);
var createDesc = __webpack_require__(74);
var _create = __webpack_require__(158);
var gOPNExt = __webpack_require__(237);
var $GOPD = __webpack_require__(224);
var $DP = __webpack_require__(35);
var $keys = __webpack_require__(107);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(211).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(112).f = $propertyIsEnumerable;
  __webpack_require__(164).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(102)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(48)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(103)('meta');
var isObject = __webpack_require__(41);
var has = __webpack_require__(58);
var setDesc = __webpack_require__(35).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(70)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(48);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NodeTextNavigation = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);__webpack_require__(76);
var _domop = __webpack_require__(160);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var TEXT_NODE = 3;var
NodeTextNavigation = exports.NodeTextNavigation = function () {
    function NodeTextNavigation(node) {(0, _classCallCheck3.default)(this, NodeTextNavigation);
        this._currentOffset = 0;
        this._currentNodeText = this.getNodeText(node);
        this._currentDomNode = node;
    }(0, _createClass3.default)(NodeTextNavigation, [{ key: 'getNodeText', value: function getNodeText(
        domNode) {
            return domNode && domNode.nodeType === TEXT_NODE && domNode.textContent || '';
        } }, { key: 'next', value: function next()
        {
            return this.forward(this._currentNodeText.length - this._currentOffset);
        } }, { key: 'start', value: function start()
        {
            this._currentOffset = 0;
            return this;
        } }, { key: 'end', value: function end()
        {
            this._currentOffset = this._currentNodeText.length;
            return this;
        } }, { key: 'forward', value: function forward(
        characters) {
            var timeout = 1000000;
            while (this._currentDomNode && (characters > 0 || !this._currentNodeText)) {
                if (timeout-- < 0) {
                    console.error('NodeTextNavigation: Too many iterations.');
                    throw Error('NodeTextNavigation: Too many iterations.');
                }
                if (this._currentNodeText) {
                    var max = this._currentNodeText.length - this._currentOffset;
                    var advance = Math.min(max, characters);
                    if (advance > 0) {
                        characters -= advance;
                        this._currentOffset += advance;
                    }
                }
                if (this._currentOffset === this._currentNodeText.length) {
                    this._currentDomNode = (0, _domop.nextNode)(this._currentDomNode);
                    this._currentNodeText = this.getNodeText(this._currentDomNode);
                    this._currentOffset = 0;
                }
            }
            return this;
        } }, { key: 'backward', value: function backward(
        characters) {
            var timeout = 1000000;
            while (this._currentDomNode && (characters > 0 || !this._currentNodeText)) {
                if (timeout-- < 0) {
                    console.error('NodeTextNavigation: Too many iterations.');
                    throw Error('NodeTextNavigation: Too many iterations.');
                }
                if (this._currentNodeText) {
                    var max = this._currentOffset;
                    var advance = Math.min(max, characters);
                    if (advance > 0) {
                        characters -= advance;
                        this._currentOffset -= advance;
                    }
                }
                if (this._currentOffset === 0) {
                    this._currentDomNode = (0, _domop.prevNode)(this._currentDomNode);
                    this._currentNodeText = this.getNodeText(this._currentDomNode);
                    this._currentOffset = this._currentNodeText.length;
                }
            }
            return this;
        } }, { key: 'countBackwards', value: function countBackwards(
        node) {
            var count = 0;
            while (this._currentDomNode && this._currentDomNode !== node) {
                count += this._currentOffset;
                this._currentDomNode = (0, _domop.prevNode)(this._currentDomNode);
                this._currentNodeText = this.getNodeText(this._currentDomNode);
                this._currentOffset = this._currentNodeText.length;
            }
            if (this._currentDomNode === node) {
                count += this._currentOffset;
                this._currentOffset = 0;
            }
            return count;
        } }, { key: 'countForwards', value: function countForwards(
        node) {
            var count = 0;
            while (this._currentDomNode && this._currentDomNode !== node) {
                count += this._currentNodeText.length - this._currentOffset;
                this._currentDomNode = (0, _domop.prevNode)(this._currentDomNode);
                this._currentNodeText = this.getNodeText(this._currentDomNode);
                this._currentOffset = 0;
            }
            return count;
        } }, { key: 'domNode', value: function domNode()
        {
            return this._currentDomNode;
        } }, { key: 'offset', value: function offset()
        {
            return this._currentOffset;
        } }, { key: 'text', value: function text()
        {
            return this._currentNodeText;
        } }]);return NodeTextNavigation;}();

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(669), __esModule: true };

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.usergroupBatch = exports.usergroupEditor = exports.usergroupResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var create = _ref.create,request = _ref.request,read = _ref.read,update = _ref.update,list = _ref.list,remove = _ref.remove;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (create) {
                        request.url = _settings.noteServiceUserApi + '/usergroup';
                        request.params = {};
                    } else
                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/usergroup/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/usergroup/' + update.id;
                        request.params = {};
                    } else
                    if (list) {
                        request.url = _settings.noteServiceUserApi + '/usergroup/all';
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/usergroup/delete/' + remove.id;
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 2);case 2:case 'end':return _context.stop();}}}, _marked, this);}

var usergroupResource = exports.usergroupResource = (0, _reduxSagaResources.createResource)('userGroup', {}, (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/usergroup', _resource.authMiddleware, customUrls));
var usergroupEditor = exports.usergroupEditor = (0, _reduxSagaResources.createEditor)('userGroup', { createImmediately: false }, usergroupResource);
var usergroupBatch = exports.usergroupBatch = (0, _reduxSagaResources.createBatch)('userGroup', {}, usergroupResource);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.beheerBatch = exports.beheerEditor = exports.beheerResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);
var _effects = __webpack_require__(170);
var _selectors = __webpack_require__(78);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 10;break;}_context.next = 3;return (
                        (0, _effects.select)(_selectors.selectors.docId));case 3:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/admin';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 11;break;case 10:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/admin/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/admin/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/admin/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/admin';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/admin';
                        request.params = {};
                    }case 11:return _context.delegateYield(
                    next(), 't0', 12);case 12:case 'end':return _context.stop();}}}, _marked, this);}

var adminJsonMiddleware = (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/admin', _resource.authMiddleware, customUrls);
var beheerResource = exports.beheerResource = (0, _reduxSagaResources.createResource)('beheer', {}, adminJsonMiddleware);
var beheerEditor = exports.beheerEditor = (0, _reduxSagaResources.createEditor)('beheer', { createImmediately: false }, beheerResource);
var beheerBatch = exports.beheerBatch = (0, _reduxSagaResources.createBatch)('beheer', {}, beheerResource);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });exports.hack = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _browserProxy = __webpack_require__(744);
var _settings = __webpack_require__(83);
var _CHANGE = __webpack_require__(574);var _CHANGE2 = _interopRequireDefault(_CHANGE);
var _isOutOfDate = __webpack_require__(766);var _isOutOfDate2 = _interopRequireDefault(_isOutOfDate);
var _selectors = __webpack_require__(545);var _selectors2 = _interopRequireDefault(_selectors);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var hack = exports.hack = { store: null };
var warnElementCount = 10000;
function registerProxy(proxy) {
    var key = 'LiasNoteService';
    var keyReady = 'LiasNoteServiceReady';
    global[key] = proxy;
    var proxyCallback = global[keyReady];
    if (proxyCallback) {
        proxyCallback.forEach(function (x) {return x(proxy);});
    }
}
function subscribeProxy(proxy, store) {
    var wasVisible = false;
    store.subscribe(function () {
        var state = store.getState();
        var v = _selectors2.default.visible(state);
        if (wasVisible !== v) {
            if (v) {
                proxy.emit('shown');
            } else
            {
                proxy.emit('hidden');
            }
            wasVisible = v;
        }
    });
}
function createProxy(store) {
    var proxy = new _browserProxy.BrowserProxy(function () {return _selectors2.default.visible(store.getState());}, function (action) {return store.dispatch(action);});
    registerProxy(proxy);
    subscribeProxy(proxy, store);
    return proxy;
}
new Promise(function(resolve) { resolve(); }).then(((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {var _require, Store, _require2, DefaultPlaceHolder, RenderApp, RenderOutOfDate, store, proxy, loadMaterialIcons, elCount;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_require =
                    __webpack_require__(767), Store = _require.Store;_require2 =
                    __webpack_require__(919), DefaultPlaceHolder = _require2.DefaultPlaceHolder, RenderApp = _require2.RenderApp, RenderOutOfDate = _require2.RenderOutOfDate;if (!
                    (0, _isOutOfDate2.default)()) {_context.next = 6;break;}
                    RenderOutOfDate();_context.next = 22;break;case 6:


                    store = hack.store = Store.create();
                    proxy = createProxy(store);
                    store.dispatch((0, _CHANGE2.default)({
                        docId: (0, _settings.getDocumentId)(),
                        docName: (0, _settings.getDocumentName)(),
                        pageCount: (0, _settings.getPageCount)(),
                        pageId: (0, _settings.getPageId)(),
                        pageName: (0, _settings.getPageName)(),
                        pageNumber: (0, _settings.getPageNumber)(),
                        pageUrl: window.location.href,
                        tenantId: (0, _settings.getTenantId)(),
                        tenantName: (0, _settings.getTenantName)(),
                        breadcrumb: (0, _settings.getBreadcrumb)(),
                        mailToName: (0, _settings.getMailToName)(),
                        mailToAddress: (0, _settings.getMailToAddress)() }));

                    loadMaterialIcons = _selectors2.default.loadMaterialIcons(store.getState());if (!
                    loadMaterialIcons) {_context.next = 15;break;}_context.next = 13;return (
                        __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 972)));case 13:_context.next = 16;break;case 15:


                    console.log('[NoteService] Skipping Material Icons');case 16:

                    elCount = document.querySelectorAll('*').length;
                    if (elCount > warnElementCount) {
                        console.warn('[NoteService] Page contains ' + elCount.toLocaleString() + ' elements. May result in reduced performance of note highlights.');
                    }
                    DefaultPlaceHolder();_context.next = 21;return (
                        RenderApp(store));case 21:
                    proxy.emit('loaded');case 22:case 'end':return _context.stop();}}}, _callee, undefined);}))).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(58);
var toObject = __webpack_require__(111);
var IE_PROTO = __webpack_require__(151)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(61);
var gOPN = __webpack_require__(211).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(75);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var core = __webpack_require__(13);
var dP = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(42);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var requireOidcClientAsync = function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                            new _promise2.default(function (resolve, reject) {
                                __webpack_require__.e/* require.ensure */(0).then((function () {
                                    resolve(__webpack_require__(552));
                                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                            }));case 2:return _context.abrupt('return', _context.sent);case 3:case 'end':return _context.stop();}}}, _callee, this);}));return function requireOidcClientAsync() {return _ref.apply(this, arguments);};}();function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var userManager = void 0;exports.default = function () {var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(
    function _callee2(cb) {var _ref3, UserManager, WebStorageStateStore, publicRoot, hasPublisher, publisherUrl, auth;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!
                        userManager) {_context2.next = 4;break;}
                        cb(userManager);_context2.next = 15;break;case 4:_context2.next = 6;return (


                            requireOidcClientAsync());case 6:_ref3 = _context2.sent;UserManager = _ref3.UserManager;WebStorageStateStore = _ref3.WebStorageStateStore;
                        publicRoot = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        hasPublisher = (0, _from2.default)(document.querySelectorAll('meta')).filter(function (x) {return x.name.indexOf('lias-document-baseurl') >= 0;}).length > 0;
                        if (hasPublisher) {
                            publisherUrl = (0, _from2.default)(document.querySelectorAll('meta')).filter(function (x) {return x.name.indexOf('lias-document-baseurl') >= 0;}).qFirst().content;
                        }
                        auth = 'https://login.liasonline.nl';
                        userManager = new UserManager({
                            authority: auth,
                            automaticSilentRenew: true,
                            client_id: 'webpub-userdate-client',
                            filterProtocolClaims: true,
                            loadUserInfo: true,
                            monitorSession: false,
                            popup_redirect_uri: hasPublisher ? publisherUrl + '/login.html' : publicRoot + '/login.html',
                            post_logout_redirect_uri: hasPublisher ? '' + publisherUrl : publicRoot + '/',
                            redirect_uri: hasPublisher ? publisherUrl + '/login.html' : publicRoot + '/login.html',
                            response_type: 'id_token token',
                            scope: 'openid profile tenant-resource roles apps-resource webpub-userdata-user',
                            silent_redirect_uri: hasPublisher ? publisherUrl + '/silent-renew.html' : publicRoot + '/silent-renew.html',
                            stateStore: new WebStorageStateStore({
                                prefix: '__noteservice_oidcclient_',
                                store: window.sessionStorage }),

                            userStore: new WebStorageStateStore({
                                prefix: '__noteservice_oidc_',
                                store: window.sessionStorage }) });


                        cb(userManager);case 15:case 'end':return _context2.stop();}}}, _callee2, this);}));return function (_x) {return _ref2.apply(this, arguments);};}();

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.cloneableGenerator = exports.wrapSagaDispatch = exports.createSetContextWarning = exports.internalErr = exports.updateIncentive = exports.uid = exports.array = exports.object = exports.is = exports.ident = exports.noop = exports.kFalse = exports.kTrue = exports.konst = exports.SELF_CANCELLATION = exports.SAGA_ACTION = exports.CANCEL = exports.MATCH = exports.HELPER = exports.TASK = exports.sym = undefined;var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.

























check = check;exports.







hasOwn = hasOwn;exports.

































































remove = remove;exports.


















deferred = deferred;exports.











arrayOfDeffered = arrayOfDeffered;exports.







delay = delay;exports.
















createMockTask = createMockTask;exports.





















autoInc = autoInc;exports.















makeIterator = makeIterator;exports.






















log = log;exports.










deprecate = deprecate;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};var sym = exports.sym = function sym(id) {return '@@redux-saga/' + id;};var TASK = exports.TASK = sym('TASK');var HELPER = exports.HELPER = sym('HELPER');var MATCH = exports.MATCH = sym('MATCH');var CANCEL = exports.CANCEL = sym('CANCEL_PROMISE');var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');var konst = exports.konst = function konst(v) {return function () {return v;};};var kTrue = exports.kTrue = konst(true);var kFalse = exports.kFalse = konst(false);var noop = exports.noop = function noop() {};var ident = exports.ident = function ident(v) {return v;};function check(value, predicate, error) {if (!predicate(value)) {log('error', 'uncaught at check', error);throw new Error(error);}}var hasOwnProperty = Object.prototype.hasOwnProperty;function hasOwn(object, property) {return is.notUndef(object) && hasOwnProperty.call(object, property);}var is = exports.is = { undef: function undef(v) {return v === null || v === undefined;}, notUndef: function notUndef(v) {return v !== null && v !== undefined;}, func: function func(f) {return typeof f === 'function';}, number: function number(n) {return typeof n === 'number';}, string: function string(s) {return typeof s === 'string';}, array: Array.isArray, object: function object(obj) {return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';}, promise: function promise(p) {return p && is.func(p.then);}, iterator: function iterator(it) {return it && is.func(it.next) && is.func(it.throw);}, iterable: function iterable(it) {return it && is.func(_symbol2.default) ? is.func(it[_iterator2.default]) : is.array(it);}, task: function task(t) {return t && t[TASK];}, observable: function observable(ob) {return ob && is.func(ob.subscribe);}, buffer: function buffer(buf) {return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);}, pattern: function pattern(pat) {return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));}, channel: function channel(ch) {return ch && is.func(ch.take) && is.func(ch.close);}, helper: function helper(it) {return it && it[HELPER];}, stringableFunc: function stringableFunc(f) {return is.func(f) && hasOwn(f, 'toString');} };var object = exports.object = { assign: function assign(target, source) {for (var i in source) {if (hasOwn(source, i)) {target[i] = source[i];}}} };function remove(array, item) {var index = array.indexOf(item);if (index >= 0) {array.splice(index, 1);}}var array = exports.array = { from: function from(obj) {var arr = Array(obj.length);for (var i in obj) {if (hasOwn(obj, i)) {arr[i] = obj[i];}}return arr;} };function deferred() {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var def = _extends({}, props);var promise = new _promise2.default(function (resolve, reject) {def.resolve = resolve;def.reject = reject;});def.promise = promise;return def;}function arrayOfDeffered(length) {var arr = [];for (var i = 0; i < length; i++) {arr.push(deferred());}return arr;}function delay(ms) {var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var timeoutId = void 0;var promise = new _promise2.default(function (resolve) {timeoutId = setTimeout(function () {return resolve(val);}, ms);});promise[CANCEL] = function () {return clearTimeout(timeoutId);};return promise;}function createMockTask() {var _ref;var running = true;var _result = void 0,_error = void 0;return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {return running;}, _ref.result = function result() {return _result;}, _ref.error = function error() {return _error;}, _ref.setRunning = function setRunning(b) {return running = b;}, _ref.setResult = function setResult(r) {return _result = r;}, _ref.setError = function setError(e) {return _error = e;}, _ref;}function autoInc() {var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;return function () {return ++seed;};}var uid = exports.uid = autoInc();var kThrow = function kThrow(err) {throw err;};var kReturn = function kReturn(value) {return { value: value, done: true };};function makeIterator(next) {var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var isHelper = arguments[3];var iterator = { name: name, next: next, throw: thro, return: kReturn };if (isHelper) {iterator[HELPER] = true;}if (typeof _symbol2.default !== 'undefined') {iterator[_iterator2.default] = function () {return iterator;};}return iterator;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              Print error in a useful way whether in a browser environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              (with expandable error stack traces), or in a node.js environment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              (text-only log output)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             **/function log(level, message) {var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ''; /*eslint-disable no-console*/if (typeof window === 'undefined') {console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));} else {console[level](message, error);}}function deprecate(fn, deprecationWarning) {return function () {if (false) log('warn', deprecationWarning);return fn.apply(undefined, arguments);};
}

var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch((0, _defineProperty2.default)(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      } };

  };
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.resolvePathWithOffset = undefined;var _anchor = __webpack_require__(244);
var regexPathWithOffset = /^((([\#0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?)([\/]([\#0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?)*)([+](\d+))?$/i;
var parsePathWithOffset = function parsePathWithOffset(input) {
    var m = regexPathWithOffset.exec(input);
    if (m) {
        var selector = m[1];
        var offset = parseInt(m[11], 10);
        return { selector: selector, offset: offset };
    }
};
var resolvePathWithOffset = exports.resolvePathWithOffset = function resolvePathWithOffset(root, path) {
    var parsed = parsePathWithOffset(path);
    if (!parsed) {
        console.warn('[NoteService] invalid selector: ' + path);
        return null;
    }
    var resolved = (0, _anchor.resolveAnchorPath)(root, parsed.selector, false);
    if (!resolved || resolved.length === 0) {
        return null;
    }
    if (resolved.length !== 1) {
        console.warn('[NoteService] multiple matches from selector: ' + path);
    }
    var offset = parsed.offset;
    var selector = parsed.selector;
    var anchor = resolved[0];
    return { anchor: anchor, selector: selector, offset: offset };
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _AnchorNode = __webpack_require__(603);Object.defineProperty(exports, 'AnchorNode', { enumerable: true, get: function get() {return _AnchorNode.AnchorNode;} });var _findClosestAnchorNode = __webpack_require__(605);Object.defineProperty(exports, 'findClosestAnchorNode', { enumerable: true, get: function get() {return _findClosestAnchorNode.
    findClosestAnchorNode;} });var _findClosestDocumentContentNode = __webpack_require__(848);Object.defineProperty(exports, 'findClosestDocumentContentNode', { enumerable: true, get: function get() {return _findClosestDocumentContentNode.
    findClosestDocumentContentNode;} });var _getAnchorFromDocument = __webpack_require__(606);Object.defineProperty(exports, 'getAnchorFromDocument', { enumerable: true, get: function get() {return _getAnchorFromDocument.
    getAnchorFromDocument;} });var _resolveAnchorPath = __webpack_require__(849);Object.defineProperty(exports, 'resolveAnchorPath', { enumerable: true, get: function get() {return _resolveAnchorPath.
    resolveAnchorPath;} });

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NoteAndParticipant = exports.INoteAndParticipant = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);exports.









isNote = isNote;exports.


isQuestion = isQuestion;exports.


isSharedNote = isSharedNote;exports.


isCategory = isCategory;exports.


isEmail = isEmail;exports.


isParticipant = isParticipant;exports.


isUsergroup = isUsergroup;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var INoteAndParticipant = exports.INoteAndParticipant = function INoteAndParticipant() {(0, _classCallCheck3.default)(this, INoteAndParticipant);};var NoteAndParticipant = exports.NoteAndParticipant = function NoteAndParticipant(obj, user) {(0, _classCallCheck3.default)(this, NoteAndParticipant);this.id = obj.id;this.created = obj.created;this.item = obj;this.user = user;};function isNote(data) {return data && (data.startElementXPath || data.StartElementXPath);}function isQuestion(data) {return data && (!!data.isquestion || !!data.status);}function isSharedNote(data) {return data && data.isShared && (data.startElementXPath || data.StartElementXPath);}function isCategory(data) {return data && data.color;}function isEmail(data) {return data && data.emailtext;}function isParticipant(data) {return data && data.name && data.email;}function isUsergroup(data) {
    return data && data.name && data.userIDs;
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.participantsBatch = exports.participantsEditor = exports.participantsResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,list = _ref.list;var indentityserviceurl;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    indentityserviceurl = 'https://login.liasonline.nl';
                    if (list) {
                        request.url = indentityserviceurl + '/shared/users/' + list.id;
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 3);case 3:case 'end':return _context.stop();}}}, _marked, this);}

var participantsResource = exports.participantsResource = (0, _reduxSagaResources.createResource)('participant', {}, (0, _reduxSagaResources.JsonRestMiddleware)('' + _settings.noteServiceUserApi, _resource.authMiddleware, customUrls));
var participantsEditor = exports.participantsEditor = (0, _reduxSagaResources.createEditor)('participant', { createImmediately: false }, participantsResource);
var participantsBatch = exports.participantsBatch = (0, _reduxSagaResources.createBatch)('participant', {}, participantsResource);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(687), __esModule: true };

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(750), __esModule: true };

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SELECTION_RESET');

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(251);
__webpack_require__(448);
__webpack_require__(73);
__webpack_require__(450);
__webpack_require__(203);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
module.exports = __webpack_require__(16);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(252);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(138);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(188);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(191);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
module.exports = __webpack_require__(16);


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var META = __webpack_require__(44).KEY;
var $fails = __webpack_require__(5);
var shared = __webpack_require__(86);
var setToStringTag = __webpack_require__(62);
var uid = __webpack_require__(49);
var wks = __webpack_require__(6);
var wksExt = __webpack_require__(174);
var wksDefine = __webpack_require__(119);
var enumKeys = __webpack_require__(253);
var isArray = __webpack_require__(89);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(4);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(29);
var createDesc = __webpack_require__(43);
var _create = __webpack_require__(37);
var gOPNExt = __webpack_require__(177);
var $GOPD = __webpack_require__(21);
var $DP = __webpack_require__(7);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(52).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(72).f = $propertyIsEnumerable;
  __webpack_require__(88).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(50)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(88);
var pIE = __webpack_require__(72);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(37) });


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(7).f });


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperties: __webpack_require__(176) });


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(14);
var $getOwnPropertyDescriptor = __webpack_require__(21).f;

__webpack_require__(32)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(10);
var $getPrototypeOf = __webpack_require__(22);

__webpack_require__(32)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(10);
var $keys = __webpack_require__(36);

__webpack_require__(32)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(32)('getOwnPropertyNames', function () {
  return __webpack_require__(177).f;
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(44).onFreeze;

__webpack_require__(32)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(44).onFreeze;

__webpack_require__(32)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(44).onFreeze;

__webpack_require__(32)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(4);

__webpack_require__(32)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(4);

__webpack_require__(32)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(4);

__webpack_require__(32)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(123) });


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(269) });


/***/ }),
/* 269 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(124).set });


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(53);
var test = {};
test[__webpack_require__(6)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(178) });


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(22);
var HAS_INSTANCE = __webpack_require__(6)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(7).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(179);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(180);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(15);
var cof = __webpack_require__(27);
var inheritIfRequired = __webpack_require__(127);
var toPrimitive = __webpack_require__(29);
var fails = __webpack_require__(5);
var gOPN = __webpack_require__(52).f;
var gOPD = __webpack_require__(21).f;
var dP = __webpack_require__(7).f;
var $trim = __webpack_require__(63).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(37)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(8) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(20)(global, NUMBER, $Number);
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(31);
var aNumberValue = __webpack_require__(181);
var repeat = __webpack_require__(128);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(5)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(5);
var aNumberValue = __webpack_require__(181);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(182) });


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(182);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(180);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(179);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(183);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(129);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(130);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(184) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(5)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(183) });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(129) });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(130);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(5)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(130);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(51);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(14);
var toLength = __webpack_require__(9);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(63)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(131)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(90)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(131)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(132);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(133)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(132);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(133)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(128)
});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(132);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(133)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(23)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(23)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(23)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(23)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(23)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(23)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(23)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(23)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(23)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(23)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(23)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(23)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(23)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(29);

$export($export.P + $export.F * __webpack_require__(5)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(331);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(5);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(20)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(19)(proto, TO_PRIMITIVE, __webpack_require__(334));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(89) });


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(26);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var call = __webpack_require__(185);
var isArrayIter = __webpack_require__(134);
var toLength = __webpack_require__(9);
var createProperty = __webpack_require__(135);
var getIterFn = __webpack_require__(73);

$export($export.S + $export.F * !__webpack_require__(93)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(135);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(5)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(14);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(71) != Object || !__webpack_require__(28)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(122);
var cof = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(51);
var toLength = __webpack_require__(9);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(5)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var toObject = __webpack_require__(10);
var fails = __webpack_require__(5);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(28)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(33)(0);
var STRICT = __webpack_require__(28)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var isArray = __webpack_require__(89);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(33)(1);

$export($export.P + $export.F * !__webpack_require__(28)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(33)(2);

$export($export.P + $export.F * !__webpack_require__(28)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(33)(3);

$export($export.P + $export.F * !__webpack_require__(28)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(33)(4);

$export($export.P + $export.F * !__webpack_require__(28)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(186);

$export($export.P + $export.F * !__webpack_require__(28)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(186);

$export($export.P + $export.F * !__webpack_require__(28)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(87)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(14);
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(9);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(187) });

__webpack_require__(45)('copyWithin');


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(137) });

__webpack_require__(45)('fill');


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(45)(KEY);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(45)(KEY);


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('Array');


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(127);
var dP = __webpack_require__(7).f;
var gOPN = __webpack_require__(52).f;
var isRegExp = __webpack_require__(92);
var $flags = __webpack_require__(94);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(5)(function () {
  re2[__webpack_require__(6)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(20)(global, 'RegExp', $RegExp);
}

__webpack_require__(55)('RegExp');


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(188);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(8);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(20)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(5)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(95)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(95)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(95)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(95)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(92);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(50);
var global = __webpack_require__(3);
var ctx = __webpack_require__(26);
var classof = __webpack_require__(53);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var aFunction = __webpack_require__(12);
var anInstance = __webpack_require__(56);
var forOf = __webpack_require__(46);
var speciesConstructor = __webpack_require__(96);
var task = __webpack_require__(140).set;
var microtask = __webpack_require__(141)();
var newPromiseCapabilityModule = __webpack_require__(142);
var perform = __webpack_require__(189);
var promiseResolve = __webpack_require__(190);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(57)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(62)($Promise, PROMISE);
__webpack_require__(55)(PROMISE);
Wrapper = __webpack_require__(16)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(93)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(195);
var validate = __webpack_require__(64);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(97)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(98);
var buffer = __webpack_require__(143);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(51);
var toLength = __webpack_require__(9);
var isObject = __webpack_require__(4);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(96);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(5)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(55)(ARRAY_BUFFER);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(98).ABV, {
  DataView: __webpack_require__(143).DataView
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(5)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(37);
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(5);
var bind = __webpack_require__(178);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(7);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(5)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(21).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(91)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(21);
var getPrototypeOf = __webpack_require__(22);
var has = __webpack_require__(15);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(21);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(22);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(144) });


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(7);
var gOPD = __webpack_require__(21);
var getPrototypeOf = __webpack_require__(22);
var has = __webpack_require__(15);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(43);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(4);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(124);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(87)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(45)('includes');


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(197);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(9);
var aFunction = __webpack_require__(12);
var arraySpeciesCreate = __webpack_require__(136);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(45)('flatMap');


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(197);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(9);
var toInteger = __webpack_require__(31);
var arraySpeciesCreate = __webpack_require__(136);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(45)('flatten');


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(131)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(198);
var userAgent = __webpack_require__(145);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(198);
var userAgent = __webpack_require__(145);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(63)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(63)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var toLength = __webpack_require__(9);
var isRegExp = __webpack_require__(92);
var getFlags = __webpack_require__(94);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(91)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119)('asyncIterator');


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119)('observable');


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(144);
var toIObject = __webpack_require__(14);
var gOPD = __webpack_require__(21);
var createProperty = __webpack_require__(135);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(199)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(199)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(12);
var $defineProperty = __webpack_require__(7);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(8) && $export($export.P + __webpack_require__(99), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(12);
var $defineProperty = __webpack_require__(7);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(8) && $export($export.P + __webpack_require__(99), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(22);
var getOwnPropertyDescriptor = __webpack_require__(21).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(99), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(22);
var getOwnPropertyDescriptor = __webpack_require__(21).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(99), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(200)('Map') });


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(200)('Set') });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(100)('Map');


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(100)('Set');


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(100)('WeakMap');


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(100)('WeakSet');


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(101)('Map');


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(101)('Set');


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(101)('WeakMap');


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(101)('WeakSet');


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(3) });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(3) });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(27);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(202);
var fround = __webpack_require__(184);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(202) });


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(16);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(96);
var promiseResolve = __webpack_require__(190);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(142);
var perform = __webpack_require__(189);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(22);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(193);
var from = __webpack_require__(201);
var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(22);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(22);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(39);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(12);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(141)();
var process = __webpack_require__(3).process;
var isNode = __webpack_require__(27)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(3);
var core = __webpack_require__(16);
var microtask = __webpack_require__(141)();
var OBSERVABLE = __webpack_require__(6)('observable');
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(56);
var redefineAll = __webpack_require__(57);
var hide = __webpack_require__(19);
var forOf = __webpack_require__(46);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(55)('Observable');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(145);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(140);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(138);
var getKeys = __webpack_require__(36);
var redefine = __webpack_require__(20);
var global = __webpack_require__(3);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(54);
var wks = __webpack_require__(6);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(26);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(43);
var assign = __webpack_require__(123);
var create = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(22);
var getKeys = __webpack_require__(36);
var dP = __webpack_require__(7);
var keyOf = __webpack_require__(449);
var aFunction = __webpack_require__(12);
var forOf = __webpack_require__(46);
var isIterable = __webpack_require__(203);
var $iterCreate = __webpack_require__(91);
var step = __webpack_require__(139);
var isObject = __webpack_require__(4);
var toIObject = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(8);
var has = __webpack_require__(15);

// 0 -> Dict.forEach
// 1 -> Dict.map
// 2 -> Dict.filter
// 3 -> Dict.some
// 4 -> Dict.every
// 5 -> Dict.find
// 6 -> Dict.findKey
// 7 -> Dict.mapPairs
var createDictMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_EVERY = TYPE == 4;
  return function (object, callbackfn, that /* = undefined */) {
    var f = ctx(callbackfn, that, 3);
    var O = toIObject(object);
    var result = IS_MAP || TYPE == 7 || TYPE == 2
          ? new (typeof this == 'function' ? this : Dict)() : undefined;
    var key, val, res;
    for (key in O) if (has(O, key)) {
      val = O[key];
      res = f(val, key, object);
      if (TYPE) {
        if (IS_MAP) result[key] = res;          // map
        else if (res) switch (TYPE) {
          case 2: result[key] = val; break;     // filter
          case 3: return true;                  // some
          case 5: return val;                   // find
          case 6: return key;                   // findKey
          case 7: result[res[0]] = res[1];      // mapPairs
        } else if (IS_EVERY) return false;      // every
      }
    }
    return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
  };
};
var findKey = createDictMethod(6);

var createDictIter = function (kind) {
  return function (it) {
    return new DictIterator(it, kind);
  };
};
var DictIterator = function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._a = getKeys(iterated);   // keys
  this._i = 0;                   // next index
  this._k = kind;                // kind
};
$iterCreate(DictIterator, 'Dict', function () {
  var that = this;
  var O = that._t;
  var keys = that._a;
  var kind = that._k;
  var key;
  do {
    if (that._i >= keys.length) {
      that._t = undefined;
      return step(1);
    }
  } while (!has(O, key = keys[that._i++]));
  if (kind == 'keys') return step(0, key);
  if (kind == 'values') return step(0, O[key]);
  return step(0, [key, O[key]]);
});

function Dict(iterable) {
  var dict = create(null);
  if (iterable != undefined) {
    if (isIterable(iterable)) {
      forOf(iterable, true, function (key, value) {
        dict[key] = value;
      });
    } else assign(dict, iterable);
  }
  return dict;
}
Dict.prototype = null;

function reduce(object, mapfn, init) {
  aFunction(mapfn);
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var i = 0;
  var memo, key;
  if (arguments.length < 3) {
    if (!length) throw TypeError('Reduce of empty object with no initial value');
    memo = O[keys[i++]];
  } else memo = Object(init);
  while (length > i) if (has(O, key = keys[i++])) {
    memo = mapfn(memo, O[key], key, object);
  }
  return memo;
}

function includes(object, el) {
  // eslint-disable-next-line no-self-compare
  return (el == el ? keyOf(object, el) : findKey(object, function (it) {
    // eslint-disable-next-line no-self-compare
    return it != it;
  })) !== undefined;
}

function get(object, key) {
  if (has(object, key)) return object[key];
}
function set(object, key, value) {
  if (DESCRIPTORS && key in Object) dP.f(object, key, createDesc(0, value));
  else object[key] = value;
  return object;
}

function isDict(it) {
  return isObject(it) && getPrototypeOf(it) === Dict.prototype;
}

$export($export.G + $export.F, { Dict: Dict });

$export($export.S, 'Dict', {
  keys: createDictIter('keys'),
  values: createDictIter('values'),
  entries: createDictIter('entries'),
  forEach: createDictMethod(0),
  map: createDictMethod(1),
  filter: createDictMethod(2),
  some: createDictMethod(3),
  every: createDictMethod(4),
  find: createDictMethod(5),
  findKey: findKey,
  mapPairs: createDictMethod(7),
  reduce: reduce,
  keyOf: keyOf,
  includes: includes,
  has: has,
  get: get,
  set: set,
  isDict: isDict
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(14);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var get = __webpack_require__(73);
module.exports = __webpack_require__(16).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(16);
var $export = __webpack_require__(0);
var partial = __webpack_require__(204);
// https://esdiscuss.org/topic/promise-returning-delay-function
$export($export.G + $export.F, {
  delay: function delay(time) {
    return new (core.Promise || global.Promise)(function (resolve) {
      setTimeout(partial.call(resolve, true), time);
    });
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(205);
var $export = __webpack_require__(0);

// Placeholder
__webpack_require__(16)._ = path._ = path._ || {};

$export($export.P + $export.F, 'Function', { part: __webpack_require__(204) });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { isObject: __webpack_require__(4) });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { classof: __webpack_require__(53) });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var define = __webpack_require__(206);

$export($export.S + $export.F, 'Object', { define: define });


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var define = __webpack_require__(206);
var create = __webpack_require__(37);

$export($export.S + $export.F, 'Object', {
  make: function (proto, mixin) {
    return define(create(proto), mixin);
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(90)(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(146)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $re = __webpack_require__(146)(/[&<>"']/g, {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});

$export($export.P + $export.F, 'String', { escapeHTML: function escapeHTML() { return $re(this); } });


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $re = __webpack_require__(146)(/&(?:amp|lt|gt|quot|apos);/g, {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&apos;': "'"
});

$export($export.P + $export.F, 'String', { unescapeHTML: function unescapeHTML() { return $re(this); } });


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {if (!global.Promise) {
    global.Promise = __webpack_require__(474);
}
if (!Element.prototype.matches) {
    Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
    };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
__webpack_require__(80);
module.exports = __webpack_require__(116).f('iterator');


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(147);
var defined = __webpack_require__(148);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(158);
var descriptor = __webpack_require__(74);
var setToStringTag = __webpack_require__(82);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(48)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var anObject = __webpack_require__(40);
var getKeys = __webpack_require__(107);

module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(61);
var toLength = __webpack_require__(113);
var toAbsoluteIndex = __webpack_require__(467);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(147);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(469);
var step = __webpack_require__(238);
var Iterators = __webpack_require__(67);
var toIObject = __webpack_require__(61);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(166)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(227);
__webpack_require__(108);
__webpack_require__(472);
__webpack_require__(473);
module.exports = __webpack_require__(13).Symbol;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(107);
var gOPS = __webpack_require__(164);
var pIE = __webpack_require__(112);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('asyncIterator');


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('observable');


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(66);
__webpack_require__(80);
__webpack_require__(212);
module.exports = __webpack_require__(13).Promise;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var macrotask = __webpack_require__(216).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(75)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(478);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 478 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(66);
__webpack_require__(80);
__webpack_require__(212);
__webpack_require__(480);
__webpack_require__(481);
module.exports = __webpack_require__(13).Promise;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(34);
var core = __webpack_require__(13);
var global = __webpack_require__(18);
var speciesConstructor = __webpack_require__(215);
var promiseResolve = __webpack_require__(218);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(34);
var newPromiseCapability = __webpack_require__(155);
var perform = __webpack_require__(217);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
__webpack_require__(483);
module.exports = __webpack_require__(13).Array.from;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(60);
var $export = __webpack_require__(34);
var toObject = __webpack_require__(111);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(214);
var toLength = __webpack_require__(113);
var createProperty = __webpack_require__(484);
var getIterFn = __webpack_require__(165);

$export($export.S + $export.F * !__webpack_require__(219)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(35);
var createDesc = __webpack_require__(74);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _createResource = __webpack_require__(784);

Object.defineProperty(exports, 'createResource', {
  enumerable: true,
  get: function get() {
    return _createResource.createResource;
  } });


var _entityHasSameId = __webpack_require__(583);

Object.defineProperty(exports, 'entityHasSameId', {
  enumerable: true,
  get: function get() {
    return _entityHasSameId.entityHasSameId;
  } });


var _fields = __webpack_require__(503);

Object.defineProperty(exports, 'copyFields', {
  enumerable: true,
  get: function get() {
    return _fields.copyFields;
  } });

Object.defineProperty(exports, 'extractFields', {
  enumerable: true,
  get: function get() {
    return _fields.extractFields;
  } });

Object.defineProperty(exports, 'fields', {
  enumerable: true,
  get: function get() {
    return _fields.fields;
  } });

Object.defineProperty(exports, 'fieldsAll', {
  enumerable: true,
  get: function get() {
    return _fields.fieldsAll;
  } });

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _fields.selectors;
  } });

Object.defineProperty(exports, 'stripFields', {
  enumerable: true,
  get: function get() {
    return _fields.stripFields;
  } });


var _makeActions = __webpack_require__(584);

Object.defineProperty(exports, 'makeActions', {
  enumerable: true,
  get: function get() {
    return _makeActions.makeActions;
  } });


var _makeDataSelectors = __webpack_require__(585);

Object.defineProperty(exports, 'makeDataSelectors', {
  enumerable: true,
  get: function get() {
    return _makeDataSelectors.makeDataSelectors;
  } });


var _makeReducer = __webpack_require__(586);

Object.defineProperty(exports, 'makeReducer', {
  enumerable: true,
  get: function get() {
    return _makeReducer.makeReducer;
  } });


var _makeSaga = __webpack_require__(587);

Object.defineProperty(exports, 'makeSaga', {
  enumerable: true,
  get: function get() {
    return _makeSaga.makeSaga;
  } });


var _makeSelectors = __webpack_require__(591);

Object.defineProperty(exports, 'makeSelectors', {
  enumerable: true,
  get: function get() {
    return _makeSelectors.makeSelectors;
  } });

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getSelectionDetail = __webpack_require__(847);Object.defineProperty(exports, 'getSelectionDetail', { enumerable: true, get: function get() {return _getSelectionDetail.getSelectionDetail;} });var _getNodePathFromNodeOffset = __webpack_require__(533);Object.defineProperty(exports, 'getNodePathFromNodeOffset', { enumerable: true, get: function get() {return _getNodePathFromNodeOffset.
    getNodePathFromNodeOffset;} });var _extendToTextNode = __webpack_require__(851);Object.defineProperty(exports, 'extendToTextNode', { enumerable: true, get: function get() {return _extendToTextNode.
    extendToTextNode;} });var _extendToDocumentContent = __webpack_require__(853);Object.defineProperty(exports, 'extendToDocumentContent', { enumerable: true, get: function get() {return _extendToDocumentContent.
    extendToDocumentContent;} });var _removeHighlightElements = __webpack_require__(854);Object.defineProperty(exports, 'removeHighlightElements', { enumerable: true, get: function get() {return _removeHighlightElements.
    removeHighlightElements;} });var _applyHighlightSpan = __webpack_require__(855);Object.defineProperty(exports, 'applyHighlightSpan', { enumerable: true, get: function get() {return _applyHighlightSpan.
    applyHighlightSpan;} });var _resolvePathWithOffset = __webpack_require__(243);Object.defineProperty(exports, 'resolvePathWithOffset', { enumerable: true, get: function get() {return _resolvePathWithOffset.
    resolvePathWithOffset;} });var _clipSelectionRange = __webpack_require__(607);Object.defineProperty(exports, 'clipSelectionRange', { enumerable: true, get: function get() {return _clipSelectionRange.
    clipSelectionRange;} });var _RangeInternal = __webpack_require__(534);Object.defineProperty(exports, 'RangeInternal', { enumerable: true, get: function get() {return _RangeInternal.
    RangeInternal;} });var _getTextLengthByPath = __webpack_require__(858);Object.defineProperty(exports, 'getTextLengthByPath', { enumerable: true, get: function get() {return _getTextLengthByPath.
    getTextLengthByPath;} });

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FLYOVER_HIDE');

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_CREATED');

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_UPDATED');

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault(_stringify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /*
                                                                                                                                                                                                                                 	MIT License http://www.opensource.org/licenses/mit-license.php
                                                                                                                                                                                                                                 	Author Tobias Koppers @sokra
                                                                                                                                                                                                                                 */
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string")
		modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number")
			alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent((0, _stringify2.default)(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stylesInDom = {};

var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

function listToStyles(list, options) {
  var styles = [];
  var newStyles = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      css: css,
      media: media,
      sourceMap: sourceMap
    };

    if (!newStyles[id]) {
      styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });
    } else {
      newStyles[id].parts.push(part);
    }
  }

  return styles;
}

function addStylesToDom(styles, options) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i];
    var domStyle = stylesInDom[item.id];
    var j = 0;

    if (domStyle) {
      domStyle.refs++;

      for (; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j]);
      }

      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j], options));
      }
    } else {
      var parts = [];

      for (; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j], options));
      }

      stylesInDom[item.id] = {
        id: item.id,
        refs: 1,
        parts: parts
      };
    }
  }
}

function insertStyleElement(options) {
  var style = document.createElement('style');

  if (typeof options.attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : null;

    if (nonce) {
      options.attributes.nonce = nonce;
    }
  }

  Object.keys(options.attributes).forEach(function (key) {
    style.setAttribute(key, options.attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  }

  if (sourceMap && btoa) {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {};
  options.attributes = typeof options.attributes === 'object' ? options.attributes : {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  var styles = listToStyles(list, options);
  addStylesToDom(styles, options);
  return function update(newList) {
    var mayRemove = [];

    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];

      if (domStyle) {
        domStyle.refs--;
        mayRemove.push(domStyle);
      }
    }

    if (newList) {
      var newStyles = listToStyles(newList, options);
      addStylesToDom(newStyles, options);
    }

    for (var _i = 0; _i < mayRemove.length; _i++) {
      var _domStyle = mayRemove[_i];

      if (_domStyle.refs === 0) {
        for (var j = 0; j < _domStyle.parts.length; j++) {
          _domStyle.parts[j]();
        }

        delete stylesInDom[_domStyle.id];
      }
    }
  };
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(673), __esModule: true };

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.notesSharedBatch = exports.notesSharedEditor = exports.notesSharedResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,read = _ref.read,list = _ref.list;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/notes/' + read.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notes/1';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/notes/1';
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 2);case 2:case 'end':return _context.stop();}}}, _marked, this);}

var notesSharedResource = exports.notesSharedResource = (0, _reduxSagaResources.createResource)('notesShared', {}, (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notes', _resource.authMiddleware, customUrls));
var notesSharedEditor = exports.notesSharedEditor = (0, _reduxSagaResources.createEditor)('notesShared', { createImmediately: false }, notesSharedResource);
var notesSharedBatch = exports.notesSharedBatch = (0, _reduxSagaResources.createBatch)('notesShared', {}, notesSharedResource);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.useridBatch = exports.useridEditor = exports.useridResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,list = _ref.list;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (list) {
                        request.url = _settings.noteServiceUserApi + '/participant';
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 2);case 2:case 'end':return _context.stop();}}}, _marked, this);}

var useridResource = exports.useridResource = (0, _reduxSagaResources.createResource)('participantid', {}, (0, _reduxSagaResources.JsonRestMiddleware)('' + _settings.noteServiceUserApi, _resource.authMiddleware, customUrls));
var useridEditor = exports.useridEditor = (0, _reduxSagaResources.createEditor)('participantid', { createImmediately: false }, useridResource);
var useridBatch = exports.useridBatch = (0, _reduxSagaResources.createBatch)('participantid', {}, useridResource);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(34);
var core = __webpack_require__(13);
var fails = __webpack_require__(70);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(680), __esModule: true };

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_SHOW');

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FLYOVER_SHOW');

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SELECTION_REQUEST');

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SELECTION_SUCCESS');

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault2(_keys);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault2(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault2(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault2(_symbol);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });


var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};

exports.isAction = isAction;

var _isPlainObject = __webpack_require__(762);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function isAction(action) {
    var propsValid = (0, _keys2.default)(action || false).every(isValidProp);
    if (!propsValid) {
        return false;
    }
    var type = action.type,
    error = action.error,
    payload = action.payload,
    meta = action.meta;

    if (typeof type !== 'string' && (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol') {
        return false;
    }
    if (typeof error !== 'boolean' && 'error' in action) {
        return false;
    }
    if (!(0, _isPlainObject2.default)(payload) && !(error === true && payload instanceof Error)) {
        return false;
    }
    if (typeof meta !== 'undefined' && !(0, _isPlainObject2.default)(meta)) {
        return false;
    }
    return true;
}
function isValidProp(name) {
    return ['type', 'error', 'payload', 'meta'].includes(name);
}
//# sourceMappingURL=isAction.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.copyFields = exports.extractFields = exports.stripFields = exports.selectors = exports.fieldsAll = exports.fields = undefined;

var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(115);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _symbol = __webpack_require__(69);

var _symbol2 = _interopRequireDefault(_symbol);

var _utils = __webpack_require__(156);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var fields = exports.fields = {
    error: (0, _symbol2.default)((0, _utils.internal)('error')),
    id: (0, _symbol2.default)((0, _utils.internal)('id')),
    isCreated: (0, _symbol2.default)((0, _utils.internal)('isCreated')),
    isCreating: (0, _symbol2.default)((0, _utils.internal)('isCreating')),
    isModified: (0, _symbol2.default)((0, _utils.internal)('isModified')),
    isRead: (0, _symbol2.default)((0, _utils.internal)('isRead')),
    isReading: (0, _symbol2.default)((0, _utils.internal)('isReading')),
    isRemoved: (0, _symbol2.default)((0, _utils.internal)('isRemoved')),
    isRemoving: (0, _symbol2.default)((0, _utils.internal)('isRemoving')),
    isUpdated: (0, _symbol2.default)((0, _utils.internal)('isUpdated')),
    isUpdating: (0, _symbol2.default)((0, _utils.internal)('isUpdating')),
    tempId: (0, _symbol2.default)((0, _utils.internal)('tempId')) };

var fieldsAll = exports.fieldsAll = [fields.error, fields.id, fields.isCreated, fields.isCreating, fields.isModified, fields.isRead, fields.isReading, fields.isRemoved, fields.isRemoving, fields.isUpdated, fields.isUpdating, fields.tempId];
var selectors = exports.selectors = {
    error: function error(item) {return item[fields.error];},
    hasCommited: function hasCommited(item) {return item[fields.isRead] || item[fields.isCreated] || item[fields.isRemoved] || item[fields.isUpdated];},
    id: function id(item) {return item[fields.id];},
    isChanging: function isChanging(item) {return item[fields.isReading] || item[fields.isCreating] || item[fields.isRemoving] || item[fields.isUpdating];},
    isCreated: function isCreated(item) {return item[fields.isCreated];},
    isCreating: function isCreating(item) {return item[fields.isCreating];},
    isModified: function isModified(item) {return item[fields.isModified];},
    isRead: function isRead(item) {return item[fields.isRead];},
    isReading: function isReading(item) {return item[fields.isReading];},
    isRemoved: function isRemoved(item) {return item[fields.isRemoved];},
    isRemoving: function isRemoving(item) {return item[fields.isRemoving];},
    isUnchanged: function isUnchanged(item) {return !item[fields.isReading] && !item[fields.isCreating] && !item[fields.isRemoving] && !item[fields.isUpdating];},
    isUpdated: function isUpdated(item) {return item[fields.isUpdated];},
    isUpdating: function isUpdating(item) {return item[fields.isUpdating];},
    key: function key(item) {return item[fields.id] || item[fields.tempId];},
    neverCommited: function neverCommited(item) {return !item[fields.isRead] && !item[fields.isCreated] && !item[fields.isRemoved] && !item[fields.isUpdated];},
    tempId: function tempId(item) {return item[fields.tempId];} };

var stripFields = exports.stripFields = function (obj) {
    var copy = (0, _extends3.default)({}, obj);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(fieldsAll), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            delete copy[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return copy;
};
var extractFields = exports.extractFields = function (obj) {
    var _ref;

    return _ref = {}, (0, _defineProperty3.default)(_ref, fields.id, obj[fields.id]), (0, _defineProperty3.default)(_ref, fields.tempId, obj[fields.tempId]), (0, _defineProperty3.default)(_ref, fields.error, obj[fields.error]), (0, _defineProperty3.default)(_ref, fields.isModified, obj[fields.isModified]), (0, _defineProperty3.default)(_ref, fields.isReading, obj[fields.isReading]), (0, _defineProperty3.default)(_ref, fields.isRead, obj[fields.isRead]), (0, _defineProperty3.default)(_ref, fields.isCreating, obj[fields.isCreating]), (0, _defineProperty3.default)(_ref, fields.isCreated, obj[fields.isCreated]), (0, _defineProperty3.default)(_ref, fields.isRemoving, obj[fields.isRemoving]), (0, _defineProperty3.default)(_ref, fields.isRemoved, obj[fields.isRemoved]), (0, _defineProperty3.default)(_ref, fields.isUpdating, obj[fields.isUpdating]), (0, _defineProperty3.default)(_ref, fields.isUpdated, obj[fields.isUpdated]), _ref;
};
var copyFields = exports.copyFields = function (target, fieldsSource) {return (0, _extends3.default)({}, target, extractFields(fieldsSource));};
//# sourceMappingURL=fields.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _io = __webpack_require__(505);Object.defineProperty(exports, 'take', { enumerable: true, get: function get() {return _io.take;} });Object.defineProperty(exports, 'takem', { enumerable: true, get: function get() {return _io.takem;} });Object.defineProperty(exports, 'put', { enumerable: true, get: function get() {return _io.put;} });Object.defineProperty(exports, 'all', { enumerable: true, get: function get() {return _io.all;} });Object.defineProperty(exports, 'race', { enumerable: true, get: function get() {return _io.race;} });Object.defineProperty(exports, 'call', { enumerable: true, get: function get() {return _io.call;} });Object.defineProperty(exports, 'apply', { enumerable: true, get: function get() {return _io.apply;} });Object.defineProperty(exports, 'cps', { enumerable: true, get: function get() {return _io.cps;} });Object.defineProperty(exports, 'fork', { enumerable: true, get: function get() {return _io.fork;} });Object.defineProperty(exports, 'spawn', { enumerable: true, get: function get() {return _io.spawn;} });Object.defineProperty(exports, 'join', { enumerable: true, get: function get() {return _io.join;} });Object.defineProperty(exports, 'cancel', { enumerable: true, get: function get() {return _io.cancel;} });Object.defineProperty(exports, 'select', { enumerable: true, get: function get() {return _io.select;} });Object.defineProperty(exports, 'actionChannel', { enumerable: true, get: function get() {return _io.actionChannel;} });Object.defineProperty(exports, 'cancelled', { enumerable: true, get: function get() {return _io.cancelled;} });Object.defineProperty(exports, 'flush', { enumerable: true, get: function get() {return _io.flush;} });Object.defineProperty(exports, 'getContext', { enumerable: true, get: function get() {return _io.getContext;} });Object.defineProperty(exports, 'setContext', { enumerable: true, get: function get() {return _io.setContext;} });Object.defineProperty(exports, 'takeEvery', { enumerable: true, get: function get() {return _io.takeEvery;} });Object.defineProperty(exports, 'takeLatest', { enumerable: true, get: function get() {return _io.takeLatest;} });Object.defineProperty(exports, 'throttle', { enumerable: true, get: function get() {return _io.throttle;} });

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.asEffect = exports.takem = undefined;exports.



























take = take;exports.






















put = put;exports.




















all = all;exports.



race = race;exports.
























call = call;exports.







apply = apply;exports.





cps = cps;exports.







fork = fork;exports.







spawn = spawn;exports.









join = join;exports.















cancel = cancel;exports.

















select = select;exports.
















actionChannel = actionChannel;exports.








cancelled = cancelled;exports.



flush = flush;exports.




getContext = getContext;exports.




setContext = setContext;exports.




takeEvery = takeEvery;exports.







takeLatest = takeLatest;exports.







throttle = throttle;var _utils = __webpack_require__(242);var _sagaHelpers = __webpack_require__(789);var IO = (0, _utils.sym)('IO');var TAKE = 'TAKE';var PUT = 'PUT';var ALL = 'ALL';var RACE = 'RACE';var CALL = 'CALL';var CPS = 'CPS';var FORK = 'FORK';var JOIN = 'JOIN';var CANCEL = 'CANCEL';var SELECT = 'SELECT';var ACTION_CHANNEL = 'ACTION_CHANNEL';var CANCELLED = 'CANCELLED';var FLUSH = 'FLUSH';var GET_CONTEXT = 'GET_CONTEXT';var SET_CONTEXT = 'SET_CONTEXT';var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';var effect = function effect(type, payload) {var _ref;return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;};function take() {var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';if (arguments.length) {(0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');}if (_utils.is.pattern(patternOrChannel)) {return effect(TAKE, { pattern: patternOrChannel });}if (_utils.is.channel(patternOrChannel)) {return effect(TAKE, { channel: patternOrChannel });}throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');}take.maybe = function () {var eff = take.apply(undefined, arguments);eff[TAKE].maybe = true;return eff;};var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));function put(channel, action) {if (arguments.length > 1) {(0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');(0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');(0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');} else {(0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');action = channel;channel = null;}return effect(PUT, { channel: channel, action: action });}put.resolve = function () {var eff = put.apply(undefined, arguments);eff[PUT].resolve = true;return eff;};put.sync = (0, _utils.deprecate)(put.resolve, (0, _utils.updateIncentive)('put.sync', 'put.resolve'));function all(effects) {return effect(ALL, effects);}function race(effects) {return effect(RACE, effects);}function getFnCallDesc(meth, fn, args) {(0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');var context = null;if (_utils.is.array(fn)) {var _fn = fn;context = _fn[0];fn = _fn[1];} else if (fn.fn) {var _fn2 = fn;context = _fn2.context;fn = _fn2.fn;}if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {fn = context[fn];}(0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');return { context: context, fn: fn, args: args };}function call(fn) {for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}return effect(CALL, getFnCallDesc('call', fn, args));}function apply(context, fn) {var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));}function cps(fn) {for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}return effect(CPS, getFnCallDesc('cps', fn, args));}function fork(fn) {for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {args[_key3 - 1] = arguments[_key3];}return effect(FORK, getFnCallDesc('fork', fn, args));}function spawn(fn) {for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {args[_key4 - 1] = arguments[_key4];}var eff = fork.apply(undefined, [fn].concat(args));eff[FORK].detached = true;return eff;}function join() {for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {tasks[_key5] = arguments[_key5];}if (tasks.length > 1) {return all(tasks.map(function (t) {return join(t);}));}var task = tasks[0];(0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);return effect(JOIN, task);}function cancel() {for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {tasks[_key6] = arguments[_key6];}if (tasks.length > 1) {return all(tasks.map(function (t) {return cancel(t);}));}var task = tasks[0];if (tasks.length === 1) {(0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);}return effect(CANCEL, task || _utils.SELF_CANCELLATION);}function select(selector) {for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {args[_key7 - 1] = arguments[_key7];}if (arguments.length === 0) {selector = _utils.ident;} else {(0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');(0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');}return effect(SELECT, { selector: selector, args: args });} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        channel(pattern, [buffer])    => creates an event channel for store actions
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      **/function actionChannel(pattern, buffer) {(0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');if (arguments.length > 1) {(0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');(0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');}return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });}function cancelled() {return effect(CANCELLED, {});}function flush(channel) {(0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');return effect(FLUSH, channel);}function getContext(prop) {(0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');return effect(GET_CONTEXT, prop);}function setContext(props) {(0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));return effect(SET_CONTEXT, props);}function takeEvery(patternOrChannel, worker) {for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {args[_key8 - 2] = arguments[_key8];}return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));}function takeLatest(patternOrChannel, worker) {for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {args[_key9 - 2] = arguments[_key9];}return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));}function throttle(ms, pattern, worker) {for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = exports.asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT) };

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.asEffect = exports.takem = undefined;var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _isIterable2 = __webpack_require__(529);var _isIterable3 = _interopRequireDefault(_isIterable2);var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);exports.


































take = take;exports.






















put = put;exports.




















race = race;exports.
























call = call;exports.







apply = apply;exports.





cps = cps;exports.







fork = fork;exports.







spawn = spawn;exports.









join = join;exports.















cancel = cancel;exports.

















select = select;exports.
















actionChannel = actionChannel;exports.








cancelled = cancelled;exports.



flush = flush;exports.




getContext = getContext;exports.




setContext = setContext;exports.




takeEvery = takeEvery;exports.







takeLatest = takeLatest;exports.







throttle = throttle;var _utils = __webpack_require__(168);var _sagaHelpers = __webpack_require__(589);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _slicedToArray = function () {function sliceIterator(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"]) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}return function (arr, i) {if (Array.isArray(arr)) {return arr;} else if ((0, _isIterable3.default)(Object(arr))) {return sliceIterator(arr, i);} else {throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var IO = (0, _utils.sym)('IO');var TAKE = 'TAKE';var PUT = 'PUT';var RACE = 'RACE';var CALL = 'CALL';var CPS = 'CPS';var FORK = 'FORK';var JOIN = 'JOIN';var CANCEL = 'CANCEL';var SELECT = 'SELECT';var ACTION_CHANNEL = 'ACTION_CHANNEL';var CANCELLED = 'CANCELLED';var FLUSH = 'FLUSH';var GET_CONTEXT = 'GET_CONTEXT';var SET_CONTEXT = 'SET_CONTEXT';var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';var deprecationWarning = function deprecationWarning(deprecated, preferred) {return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';};var effect = function effect(type, payload) {var _ref;return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;};function take() {var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';if (arguments.length) {(0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');}if (_utils.is.pattern(patternOrChannel)) {return effect(TAKE, { pattern: patternOrChannel });}if (_utils.is.channel(patternOrChannel)) {return effect(TAKE, { channel: patternOrChannel });}throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');}take.maybe = function () {var eff = take.apply(undefined, arguments);eff[TAKE].maybe = true;return eff;};var takem = exports.takem = (0, _utils.deprecate)(take.maybe, deprecationWarning('takem', 'take.maybe'));function put(channel, action) {if (arguments.length > 1) {(0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');(0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');(0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');} else {(0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');action = channel;channel = null;}return effect(PUT, { channel: channel, action: action });}put.resolve = function () {var eff = put.apply(undefined, arguments);eff[PUT].resolve = true;return eff;};put.sync = (0, _utils.deprecate)(put.resolve, deprecationWarning('put.sync', 'put.resolve'));function race(effects) {return effect(RACE, effects);}function getFnCallDesc(meth, fn, args) {(0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');var context = null;if (_utils.is.array(fn)) {var _fn = fn;var _fn2 = _slicedToArray(_fn, 2);context = _fn2[0];fn = _fn2[1];} else if (fn.fn) {var _fn3 = fn;context = _fn3.context;fn = _fn3.fn;}(0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');return { context: context, fn: fn, args: args };}function call(fn) {for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}return effect(CALL, getFnCallDesc('call', fn, args));}function apply(context, fn) {var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));}function cps(fn) {for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}return effect(CPS, getFnCallDesc('cps', fn, args));}function fork(fn) {for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {args[_key3 - 1] = arguments[_key3];}return effect(FORK, getFnCallDesc('fork', fn, args));}function spawn(fn) {for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {args[_key4 - 1] = arguments[_key4];}var eff = fork.apply(undefined, [fn].concat(args));eff[FORK].detached = true;return eff;}function join() {for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {tasks[_key5] = arguments[_key5];}if (tasks.length > 1) {return tasks.map(function (t) {return join(t);});}var task = tasks[0];(0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);return effect(JOIN, task);}function cancel() {for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {tasks[_key6] = arguments[_key6];}if (tasks.length > 1) {return tasks.map(function (t) {return cancel(t);});}var task = tasks[0];if (tasks.length === 1) {(0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);}return effect(CANCEL, task || _utils.SELF_CANCELLATION);}function select(selector) {for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {args[_key7 - 1] = arguments[_key7];}if (arguments.length === 0) {selector = _utils.ident;} else {(0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');(0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');}return effect(SELECT, { selector: selector, args: args });} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    channel(pattern, [buffer])    => creates an event channel for store actions
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  **/function actionChannel(pattern, buffer) {(0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');if (arguments.length > 1) {(0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');(0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');}return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });}function cancelled() {return effect(CANCELLED, {});}function flush(channel) {(0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');return effect(FLUSH, channel);}function getContext(prop) {(0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');return effect(GET_CONTEXT, prop);}function setContext(props) {(0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));return effect(SET_CONTEXT, props);}function takeEvery(patternOrChannel, worker) {for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {args[_key8 - 2] = arguments[_key8];}return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));}function takeLatest(patternOrChannel, worker) {for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {args[_key9 - 2] = arguments[_key9];}return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));}function throttle(ms, pattern, worker) {for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = exports.asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT) };

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.











emitter = emitter;exports.





























channel = channel;exports.




















































































eventChannel = eventChannel;exports.







































stdChannel = stdChannel;var _utils = __webpack_require__(168);var _buffers = __webpack_require__(508);var _scheduler = __webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';var END = exports.END = { type: CHANNEL_END_TYPE };var isEnd = exports.isEnd = function isEnd(a) {return a && a.type === CHANNEL_END_TYPE;};function emitter() {var subscribers = [];function subscribe(sub) {subscribers.push(sub);return function () {return (0, _utils.remove)(subscribers, sub);};}function emit(item) {var arr = subscribers.slice();for (var i = 0, len = arr.length; i < len; i++) {arr[i](item);}}return { subscribe: subscribe, emit: emit };}var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';if (false) {exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';}function channel() {var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();var closed = false;var takers = [];(0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);function checkForbiddenStates() {if (closed && takers.length) {throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');}if (takers.length && !buffer.isEmpty()) {throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');}}function put(input) {checkForbiddenStates();(0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);if (closed) {return;}if (!takers.length) {return buffer.put(input);}for (var i = 0; i < takers.length; i++) {var cb = takers[i];if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {takers.splice(i, 1);return cb(input);}}}function take(cb) {checkForbiddenStates();(0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');if (closed && buffer.isEmpty()) {cb(END);} else if (!buffer.isEmpty()) {cb(buffer.take());} else {takers.push(cb);cb.cancel = function () {return (0, _utils.remove)(takers, cb);};}}function flush(cb) {checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');if (closed && buffer.isEmpty()) {cb(END);return;}cb(buffer.flush());}function close() {checkForbiddenStates();if (!closed) {closed = true;if (takers.length) {var arr = takers;takers = [];for (var i = 0, len = arr.length; i < len; i++) {arr[i](END);}}}}return { take: take, put: put, flush: flush, close: close, get __takers__() {return takers;}, get __closed__() {return closed;} };}function eventChannel(subscribe) {var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();var matcher = arguments[2]; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 should be if(typeof matcher !== undefined) instead?
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 see PR #273 for a background discussion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/if (arguments.length > 2) {(0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');}var chan = channel(buffer);var unsubscribe = subscribe(function (input) {if (isEnd(input)) {chan.close();return;}if (matcher && !matcher(input)) {return;}chan.put(input);});if (!_utils.is.func(unsubscribe)) {throw new Error('in eventChannel: subscribe should return a function to unsubscribe');}return { take: chan.take, flush: chan.flush, close: function close() {if (!chan.__closed__) {chan.close();unsubscribe();}} };}function stdChannel(subscribe) {var chan = eventChannel(function (cb) {return subscribe(function (input) {if (input[_utils.SAGA_ACTION]) {cb(input);
        return;
      }
      (0, _scheduler.asap)(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    } });

}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.buffers = exports.BUFFER_OVERFLOW = undefined;var _utils = __webpack_require__(168);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush };

}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  } };

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.asEffect = exports.takem = undefined;exports.



























take = take;exports.






















put = put;exports.




















all = all;exports.



race = race;exports.
























call = call;exports.







apply = apply;exports.





cps = cps;exports.







fork = fork;exports.







spawn = spawn;exports.









join = join;exports.















cancel = cancel;exports.

















select = select;exports.
















actionChannel = actionChannel;exports.








cancelled = cancelled;exports.



flush = flush;exports.




getContext = getContext;exports.




setContext = setContext;exports.




takeEvery = takeEvery;exports.







takeLatest = takeLatest;exports.







throttle = throttle;var _utils = __webpack_require__(169);var _sagaHelpers = __webpack_require__(600);var IO = (0, _utils.sym)('IO');var TAKE = 'TAKE';var PUT = 'PUT';var ALL = 'ALL';var RACE = 'RACE';var CALL = 'CALL';var CPS = 'CPS';var FORK = 'FORK';var JOIN = 'JOIN';var CANCEL = 'CANCEL';var SELECT = 'SELECT';var ACTION_CHANNEL = 'ACTION_CHANNEL';var CANCELLED = 'CANCELLED';var FLUSH = 'FLUSH';var GET_CONTEXT = 'GET_CONTEXT';var SET_CONTEXT = 'SET_CONTEXT';var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';var effect = function effect(type, payload) {var _ref;return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;};function take() {var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';if (arguments.length) {(0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');}if (_utils.is.pattern(patternOrChannel)) {return effect(TAKE, { pattern: patternOrChannel });}if (_utils.is.channel(patternOrChannel)) {return effect(TAKE, { channel: patternOrChannel });}throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');}take.maybe = function () {var eff = take.apply(undefined, arguments);eff[TAKE].maybe = true;return eff;};var takem = exports.takem = (0, _utils.deprecate)(take.maybe, (0, _utils.updateIncentive)('takem', 'take.maybe'));function put(channel, action) {if (arguments.length > 1) {(0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');(0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');(0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');} else {(0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');action = channel;channel = null;}return effect(PUT, { channel: channel, action: action });}put.resolve = function () {var eff = put.apply(undefined, arguments);eff[PUT].resolve = true;return eff;};put.sync = (0, _utils.deprecate)(put.resolve, (0, _utils.updateIncentive)('put.sync', 'put.resolve'));function all(effects) {return effect(ALL, effects);}function race(effects) {return effect(RACE, effects);}function getFnCallDesc(meth, fn, args) {(0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');var context = null;if (_utils.is.array(fn)) {var _fn = fn;context = _fn[0];fn = _fn[1];} else if (fn.fn) {var _fn2 = fn;context = _fn2.context;fn = _fn2.fn;}if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {fn = context[fn];}(0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');return { context: context, fn: fn, args: args };}function call(fn) {for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}return effect(CALL, getFnCallDesc('call', fn, args));}function apply(context, fn) {var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));}function cps(fn) {for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}return effect(CPS, getFnCallDesc('cps', fn, args));}function fork(fn) {for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {args[_key3 - 1] = arguments[_key3];}return effect(FORK, getFnCallDesc('fork', fn, args));}function spawn(fn) {for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {args[_key4 - 1] = arguments[_key4];}var eff = fork.apply(undefined, [fn].concat(args));eff[FORK].detached = true;return eff;}function join() {for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {tasks[_key5] = arguments[_key5];}if (tasks.length > 1) {return all(tasks.map(function (t) {return join(t);}));}var task = tasks[0];(0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);return effect(JOIN, task);}function cancel() {for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {tasks[_key6] = arguments[_key6];}if (tasks.length > 1) {return all(tasks.map(function (t) {return cancel(t);}));}var task = tasks[0];if (tasks.length === 1) {(0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');(0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);}return effect(CANCEL, task || _utils.SELF_CANCELLATION);}function select(selector) {for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {args[_key7 - 1] = arguments[_key7];}if (arguments.length === 0) {selector = _utils.ident;} else {(0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');(0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');}return effect(SELECT, { selector: selector, args: args });} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              channel(pattern, [buffer])    => creates an event channel for store actions
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            **/function actionChannel(pattern, buffer) {(0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');if (arguments.length > 1) {(0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');(0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');}return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });}function cancelled() {return effect(CANCELLED, {});}function flush(channel) {(0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');return effect(FLUSH, channel);}function getContext(prop) {(0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');return effect(GET_CONTEXT, prop);}function setContext(props) {(0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));return effect(SET_CONTEXT, props);}function takeEvery(patternOrChannel, worker) {for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {args[_key8 - 2] = arguments[_key8];}return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));}function takeLatest(patternOrChannel, worker) {for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {args[_key9 - 2] = arguments[_key9];}return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));}function throttle(ms, pattern, worker) {for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = exports.asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT) };

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.











emitter = emitter;exports.





























channel = channel;exports.




















































































eventChannel = eventChannel;exports.













































stdChannel = stdChannel;var _utils = __webpack_require__(169);var _buffers = __webpack_require__(511);var _scheduler = __webpack_require__(599);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';var END = exports.END = { type: CHANNEL_END_TYPE };var isEnd = exports.isEnd = function isEnd(a) {return a && a.type === CHANNEL_END_TYPE;};function emitter() {var subscribers = [];function subscribe(sub) {subscribers.push(sub);return function () {return (0, _utils.remove)(subscribers, sub);};}function emit(item) {var arr = subscribers.slice();for (var i = 0, len = arr.length; i < len; i++) {arr[i](item);}}return { subscribe: subscribe, emit: emit };}var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';if (false) {exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';}function channel() {var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();var closed = false;var takers = [];(0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);function checkForbiddenStates() {if (closed && takers.length) {throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');}if (takers.length && !buffer.isEmpty()) {throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');}}function put(input) {checkForbiddenStates();(0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);if (closed) {return;}if (!takers.length) {return buffer.put(input);}for (var i = 0; i < takers.length; i++) {var cb = takers[i];if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {takers.splice(i, 1);return cb(input);}}}function take(cb) {checkForbiddenStates();(0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');if (closed && buffer.isEmpty()) {cb(END);} else if (!buffer.isEmpty()) {cb(buffer.take());} else {takers.push(cb);cb.cancel = function () {return (0, _utils.remove)(takers, cb);};}}function flush(cb) {checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');if (closed && buffer.isEmpty()) {cb(END);return;}cb(buffer.flush());}function close() {checkForbiddenStates();if (!closed) {closed = true;if (takers.length) {var arr = takers;takers = [];for (var i = 0, len = arr.length; i < len; i++) {arr[i](END);}}}}return { take: take, put: put, flush: flush, close: close, get __takers__() {return takers;}, get __closed__() {return closed;} };}function eventChannel(subscribe) {var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();var matcher = arguments[2]; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 should be if(typeof matcher !== undefined) instead?
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 see PR #273 for a background discussion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/if (arguments.length > 2) {(0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');}var chan = channel(buffer);var close = function close() {if (!chan.__closed__) {if (unsubscribe) {unsubscribe();}chan.close();}};var unsubscribe = subscribe(function (input) {if (isEnd(input)) {close();return;}if (matcher && !matcher(input)) {return;}chan.put(input);});if (chan.__closed__) {unsubscribe();}if (!_utils.is.func(unsubscribe)) {throw new Error('in eventChannel: subscribe should return a function to unsubscribe');}return { take: chan.take, flush: chan.flush, close: close };}function stdChannel(subscribe) {var chan = eventChannel(function (cb) {return subscribe(function (input) {if (input[_utils.SAGA_ACTION]) {cb(input);
        return;
      }
      (0, _scheduler.asap)(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    } });

}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.buffers = exports.BUFFER_OVERFLOW = undefined;var _utils = __webpack_require__(169);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush };

}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  } };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('BROWSER_READY');

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.emailArchiveBatch = exports.emailArchiveEditor = exports.emailArchiveResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,update = _ref.update,remove = _ref.remove,list = _ref.list;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (create) {
                        request.url = _settings.noteServiceUserApi + '/sendmail/mail';
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/sendmail/mail/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/sendmail/mail/delete/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        request.url = _settings.noteServiceUserApi + '/sendmail/mail/' + (0, _settings.getDocumentId)() + '/all';
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 2);case 2:case 'end':return _context.stop();}}}, _marked, this);}

var sendEmailArchiveJsonMiddleware = (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/sendmail/mail/', _resource.authMiddleware, customUrls);
var emailArchiveResource = exports.emailArchiveResource = (0, _reduxSagaResources.createResource)('emailarchive', {}, sendEmailArchiveJsonMiddleware);
var emailArchiveEditor = exports.emailArchiveEditor = (0, _reduxSagaResources.createEditor)('emailarchive', { createImmediately: false }, emailArchiveResource);
var emailArchiveBatch = exports.emailArchiveBatch = (0, _reduxSagaResources.createBatch)('emailarchive', {}, emailArchiveResource);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;var _Provider = __webpack_require__(924);var _Provider2 = _interopRequireDefault(_Provider);
var _connectAdvanced = __webpack_require__(643);var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
var _connect = __webpack_require__(932);var _connect2 = _interopRequireDefault(_connect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.

Provider = _Provider2.default;exports.createProvider = _Provider.createProvider;exports.connectAdvanced = _connectAdvanced2.default;exports.connect = _connect2.default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(493);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(222);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.notechatBatch = exports.notechatEditor = exports.notechatResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _reduxSaga = __webpack_require__(47);
var _settings = __webpack_require__(83);
var _selectors = __webpack_require__(78);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(



customUrls);function preprocess(noteReaction) {return noteReaction;}function customUrls(_ref, next) {var request = _ref.request,create = _ref.create,read = _ref.read,update = _ref.update,remove = _ref.remove,list = _ref.list;var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    create) {_context.next = 11;break;}
                    preprocess(create);_context.next = 4;return (
                        (0, _reduxSaga.select)(_selectors.selectors.docId));case 4:selectionDocument = _context.sent;
                    selectionDocumentId = selectionDocument;
                    request.url = _settings.noteServiceUserApi + '/notechat';
                    request.params = {};
                    request.body.documentId = selectionDocumentId;_context.next = 12;break;case 11:

                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/notechat/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        preprocess(update);
                        request.url = _settings.noteServiceUserApi + '/notechat/' + update.id;
                        request.params = {};
                    } else
                    if (remove) {
                        request.url = _settings.noteServiceUserApi + '/notechat/' + remove.id;
                        request.params = {};
                    } else
                    if (list) {
                        if (list.documentId == null)
                        request.url = _settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notechat';else

                        request.url = _settings.noteServiceUserApi + '/documents/' + list.documentId + '/notechat';
                        request.params = {};
                    }case 12:return _context.delegateYield(
                    next(), 't0', 13);case 13:case 'end':return _context.stop();}}}, _marked, this);}

var notechatResource = exports.notechatResource = (0, _reduxSagaResources.createResource)('notechat', {}, (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/documents/' + (0, _settings.getDocumentId)() + '/notechat', _resource.authMiddleware, customUrls));
var notechatEditor = exports.notechatEditor = (0, _reduxSagaResources.createEditor)('notechat', { createImmediately: false }, notechatResource);
var notechatBatch = exports.notechatBatch = (0, _reduxSagaResources.createBatch)('notechat', {}, notechatResource);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.statusGearchiveerd = exports.statusGepubliceerd = exports.statusKlaarVoorPubliceren = exports.statusInBehandeling = exports.statusBehandelen = exports.statusNieuw = exports.typeFactions = exports.typeRolePracticioner = exports.typeRoleClerk = exports.typeRoleAdmin = exports.statusses = undefined;exports.


















statussesallowed = statussesallowed;exports.



















































changestatussesallowed = changestatussesallowed;exports.







































statussesallowedbatch = statussesallowedbatch;exports.







canAnswer = canAnswer;exports.













showAnswer = showAnswer;exports.


















showFaction = showFaction;exports.















factionOfNote = factionOfNote;exports.








canChangeQuestion = canChangeQuestion;exports.

























canCreateQuestion = canCreateQuestion;exports.













practicioners = practicioners;exports.











getPracticioner = getPracticioner;exports.










showPracticioner = showPracticioner;exports.
















showPracticionerViewModus = showPracticionerViewModus;exports.












getStatusString = getStatusString;var _types = __webpack_require__(245);var statusses = exports.statusses = [{ id: 1, name: 'Nieuw' }, { id: 2, name: 'Behandelen' }, { id: 3, name: 'In behandeling' }, { id: 4, name: 'Klaar voor publiceren' }, { id: 5, name: 'Gepubliceerd' }, { id: 6, name: 'Gearchiveerd' }];var typeRoleAdmin = exports.typeRoleAdmin = 1;var typeRoleClerk = exports.typeRoleClerk = 2;var typeRolePracticioner = exports.typeRolePracticioner = 3;var typeFactions = exports.typeFactions = 5;var statusNieuw = exports.statusNieuw = 1;var statusBehandelen = exports.statusBehandelen = 2;var statusInBehandeling = exports.statusInBehandeling = 3;var statusKlaarVoorPubliceren = exports.statusKlaarVoorPubliceren = 4;var statusGepubliceerd = exports.statusGepubliceerd = 5;var statusGearchiveerd = exports.statusGearchiveerd = 6;function statussesallowed(statusses, changeStatus, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions;}).qSelect(function (ug) {return ug.type;});var allowedids = [];if (types.includes(typeRoleAdmin)) {return statusses;}if (types.includes(typeRolePracticioner)) {if (changeStatus === statusBehandelen || changeStatus === statusInBehandeling) {if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);}if (changeStatus === statusInBehandeling || changeStatus === statusKlaarVoorPubliceren) {if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);}}if (types.includes(typeRoleClerk)) {if (changeStatus === statusNieuw || changeStatus === statusBehandelen) {if (!allowedids.includes(statusNieuw)) allowedids.push(statusNieuw);if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);}if (changeStatus === statusKlaarVoorPubliceren) {if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);}if (changeStatus === statusGepubliceerd) {if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);}}if (types.includes(typeRoleClerk) || types.includes(typeRolePracticioner)) {if (!allowedids.includes(statusGearchiveerd)) allowedids.push(statusGearchiveerd);}if (!allowedids.includes(changeStatus)) allowedids.push(changeStatus);return statusses.qWhere(function (stat) {return allowedids.includes(stat.id);});}function changestatussesallowed(statusses, changeStatus, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions;}).qSelect(function (ug) {return ug.type;});var allowedids = [];if (types.includes(typeRoleAdmin)) {return statusses;}if (types.includes(typeRolePracticioner)) {if (changeStatus === statusBehandelen) {if (!allowedids.includes(statusInBehandeling)) allowedids.push(statusInBehandeling);}if (changeStatus === statusInBehandeling) {if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);}}if (types.includes(typeRoleClerk)) {if (changeStatus === statusNieuw) {if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);}if (changeStatus === statusKlaarVoorPubliceren) {if (!allowedids.includes(statusBehandelen)) allowedids.push(statusBehandelen);if (!allowedids.includes(statusKlaarVoorPubliceren)) allowedids.push(statusKlaarVoorPubliceren);if (!allowedids.includes(statusGepubliceerd)) allowedids.push(statusGepubliceerd);}}if (types.includes(typeRoleClerk) || types.includes(typeRolePracticioner)) {if (!allowedids.includes(statusGearchiveerd)) allowedids.push(statusGearchiveerd);}if (!allowedids.includes(changeStatus)) allowedids.push(changeStatus);return statusses.qWhere(function (stat) {return allowedids.includes(stat.id);});}function statussesallowedbatch(statusses, items, userId, userGroups) {var allowedids = [];items.map(function (itm) {return changestatussesallowed(statusses, itm.status, userId, userGroups).map(function (itm) {if (!allowedids.includes(itm.id)) allowedids.push(itm.id);});});return statusses.qWhere(function (stat) {return allowedids.includes(stat.id);});}function canAnswer(statusses, changeStatus, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions;}).qSelect(function (ug) {return ug.type;});if (types.includes(typeRolePracticioner)) {if (changeStatus === statusBehandelen) {return true;}if (changeStatus === statusInBehandeling) {return true;}}return false;}function showAnswer(status, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions;}).qSelect(function (ug) {return ug.type;});if (types.includes(typeRolePracticioner) || types.includes(typeRoleClerk)) {if (status === statusBehandelen) {return true;}if (status === statusInBehandeling) {return true;}if (status === statusKlaarVoorPubliceren) {return true;}}if (status === statusGepubliceerd) {return true;}}function showFaction(status, noteUserId, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions || us.userIDs.includes(noteUserId) && us.userIDs.includes(userId) && !!us.type && us.type === typeFactions;}).qSelect(function (ug) {return ug.type;});if (types.includes(typeRoleAdmin) || types.includes(typeRolePracticioner) || types.includes(typeRoleClerk)) {return true;}if (types.includes(typeFactions)) {return true;}if (status === statusGepubliceerd) {return true;}return false;}function factionOfNote(item, userGroups) {var factionname = '';if (!!item && (0, _types.isNote)(item) && (0, _types.isQuestion)(item)) {var factionUserGroup = userGroups.qWhere(function (usg) {return usg.userIDs && usg.userIDs.includes(item.userId) && usg.type === typeFactions;});factionname = factionUserGroup && factionUserGroup.length ? factionUserGroup.qFirst().name : '';}return factionname;}function canChangeQuestion(statusses, currStatus, userId, usergroups, admin) {if (admin) {if (!admin.modquestion) return false;}var types = usergroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type !== typeFactions;}).qSelect(function (ug) {return ug.type;});if (currStatus === statusNieuw) {return true;}if (types.includes(typeRoleAdmin)) {return true;}if (types.includes(typeRolePracticioner)) {if (currStatus === statusBehandelen || currStatus === statusInBehandeling) {return true;}}if (types.includes(typeRoleClerk)) {if (currStatus === statusNieuw || currStatus === statusKlaarVoorPubliceren) {return true;}}return false;}function canCreateQuestion(statusses, userId, usergroups, admin) {if (admin) {if (!admin.modquestion) return false;if (admin && admin.factionvisible) {if (usergroups.qAny(function (ug) {return ug.userIDs.includes(userId) && ug.type === typeFactions;})) return true;}if (!admin || admin && !admin.factionvisible) return true;}return false;}function practicioners(allParticipants, userGroups) {var practicionerIds = userGroups.qWhere(function (us) {return !!us.type && us.type === typeRolePracticioner;}).qMapMany(function (ug) {return ug.userIDs;});var practicioners = [];if (practicionerIds) {if (allParticipants) {practicioners = allParticipants.qWhere(function (us) {return practicionerIds.includes(us.id);});}}return practicioners;}function getPracticioner(allParticipants, practicionerId) {if (practicionerId) {if (allParticipants) {var practicioner = allParticipants.qFirst(function (us) {return us.id === practicionerId;});if (practicioner) {return practicioner.name;}}}return '';}function showPracticioner(status, userId, userGroups) {var types = userGroups.qWhere(function (us) {return us.userIDs.includes(userId) && !!us.type && us.type === typeRolePracticioner;}).qSelect(function (ug) {return ug.type;});if (types.includes(typeRolePracticioner)) {if (status === statusBehandelen) {return true;}if (status === statusInBehandeling) {return true;}if (status === statusKlaarVoorPubliceren) {return true;}}return false;}function showPracticionerViewModus(status) {if (status === statusBehandelen) {return true;}if (status === statusInBehandeling) {return true;}if (status === statusKlaarVoorPubliceren) {return true;}return false;}var maxStatus = 6;function getStatusString(status) {
    var statusses = [
    { id: 1, name: 'Nieuw' },
    { id: 2, name: 'Behandelen' },
    { id: 3, name: 'In behandeling' },
    { id: 4, name: 'Klaar voor publiceren' },
    { id: 5, name: 'Gepubliceerd' },
    { id: 6, name: 'Gearchiveerd' }];

    if (!status || !statusses || status === undefined || status < 1 && status > maxStatus)
    return '';
    return statusses[status - 1].name;
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.originAdmin = exports.originFlyover = exports.originNoteMenu = exports.originUndefined = exports.noItemButton = exports.itemButtonTypeActionBewerkenUsergroup = exports.itemButtonTypeActionDeleteQuestion = exports.itemButtonTypeActionBewerkenQuestion = exports.itemButtonTypeActionBewerkenBookmark = exports.itemButtonTypeActionDeleteCategory = exports.itemButtonTypeActionBewerkenCategory = exports.itemButtonTypeActionDeleteItem = exports.itemButtonTypeActionBewerkenItem = exports.itemButtonMinNumber = exports.buttonUsergroupCreeerDeelnemers = exports.buttonUsergroupDeSelectieDeelnemers = exports.buttonUsergroupSelectieDeelnemers = exports.buttonUsergroupEditenDeelnemers = exports.buttonMenuButton = exports.buttonAdminNotitiesButton = exports.buttonDropDownSorting = exports.buttonDropDownCategory = exports.buttonMijnBoekwerkAddRemove = exports.buttonMijnBoekwerkCloseButton = exports.buttonMijnBoekwerk = exports.buttonLogin = exports.buttonLogout = exports.buttonNotitiesDeSelectieDeelnemers = exports.buttonNotitiesSelectieDeelnemers = exports.buttonNotitiesEditenDeelnemers = exports.buttonNotitiesEditenCategories = exports.buttonNotitiesEditenText = exports.buttonNotitiesToevoegenFlyover = exports.buttonBekijkItems = exports.buttonUitloggen = exports.buttonNotitiesVragenlijst = exports.buttonDeelnemersVragenlijst = exports.buttonVragenlijstRelatie = exports.buttonMijnItems = exports.buttonFavourietToevoegen = exports.buttonNotitiesToevoegen = exports.buttonNotitiesenFavorieten = exports.buttonNoSelection = undefined;exports.












































GetDelay = GetDelay;var _fsa = __webpack_require__(1);exports.default = (0, _fsa.Action)('UPDATE_BUTTON_NO');var buttonNoSelection = exports.buttonNoSelection = 0;var buttonNotitiesenFavorieten = exports.buttonNotitiesenFavorieten = 21;var buttonNotitiesToevoegen = exports.buttonNotitiesToevoegen = 1;var buttonFavourietToevoegen = exports.buttonFavourietToevoegen = 2;var buttonMijnItems = exports.buttonMijnItems = 3;var buttonVragenlijstRelatie = exports.buttonVragenlijstRelatie = 5;var buttonDeelnemersVragenlijst = exports.buttonDeelnemersVragenlijst = 6;var buttonNotitiesVragenlijst = exports.buttonNotitiesVragenlijst = 25;var buttonUitloggen = exports.buttonUitloggen = 7;var buttonBekijkItems = exports.buttonBekijkItems = 8;var buttonNotitiesToevoegenFlyover = exports.buttonNotitiesToevoegenFlyover = 9;var buttonNotitiesEditenText = exports.buttonNotitiesEditenText = 10;var buttonNotitiesEditenCategories = exports.buttonNotitiesEditenCategories = 11;var buttonNotitiesEditenDeelnemers = exports.buttonNotitiesEditenDeelnemers = 12;var buttonNotitiesSelectieDeelnemers = exports.buttonNotitiesSelectieDeelnemers = 13;var buttonNotitiesDeSelectieDeelnemers = exports.buttonNotitiesDeSelectieDeelnemers = 14;var buttonLogout = exports.buttonLogout = 15;var buttonLogin = exports.buttonLogin = 16;var buttonMijnBoekwerk = exports.buttonMijnBoekwerk = 17;var buttonMijnBoekwerkCloseButton = exports.buttonMijnBoekwerkCloseButton = 18;var buttonMijnBoekwerkAddRemove = exports.buttonMijnBoekwerkAddRemove = 20;var buttonDropDownCategory = exports.buttonDropDownCategory = 21;var buttonDropDownSorting = exports.buttonDropDownSorting = 22;var buttonAdminNotitiesButton = exports.buttonAdminNotitiesButton = 23;var buttonMenuButton = exports.buttonMenuButton = 24;var buttonUsergroupEditenDeelnemers = exports.buttonUsergroupEditenDeelnemers = 25;var buttonUsergroupSelectieDeelnemers = exports.buttonUsergroupSelectieDeelnemers = 26;var buttonUsergroupDeSelectieDeelnemers = exports.buttonUsergroupDeSelectieDeelnemers = 27;var buttonUsergroupCreeerDeelnemers = exports.buttonUsergroupCreeerDeelnemers = 28;var itemButtonMinNumber = exports.itemButtonMinNumber = 100;var itemButtonTypeActionBewerkenItem = exports.itemButtonTypeActionBewerkenItem = 'BI';var itemButtonTypeActionDeleteItem = exports.itemButtonTypeActionDeleteItem = 'DI';var itemButtonTypeActionBewerkenCategory = exports.itemButtonTypeActionBewerkenCategory = 'BC';var itemButtonTypeActionDeleteCategory = exports.itemButtonTypeActionDeleteCategory = 'DC';var itemButtonTypeActionBewerkenBookmark = exports.itemButtonTypeActionBewerkenBookmark = 'BB';var itemButtonTypeActionBewerkenQuestion = exports.itemButtonTypeActionBewerkenQuestion = 'BQ';var itemButtonTypeActionDeleteQuestion = exports.itemButtonTypeActionDeleteQuestion = 'DQ';var itemButtonTypeActionBewerkenUsergroup = exports.itemButtonTypeActionBewerkenUsergroup = 'BU';var noItemButton = exports.noItemButton = '';var originUndefined = exports.originUndefined = 0;var originNoteMenu = exports.originNoteMenu = 1;var originFlyover = exports.originFlyover = 2;var originAdmin = exports.originAdmin = 3;function GetDelay(buttonNo) {
    switch (buttonNo) {
        case buttonMenuButton:
            return 300;
        default:
            if (itemButtonMinNumber >= itemButtonMinNumber) {
                return 500;
            }
            return 0;}

}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(923), __esModule: true };

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.questionaddresseeBatch = exports.questionaddresseeEditor = exports.questionaddresseeResource = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _reduxSagaResources = __webpack_require__(109);
var _resource = __webpack_require__(114);
var _settings = __webpack_require__(83);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(
customUrls);function customUrls(_ref, next) {var create = _ref.create,request = _ref.request,read = _ref.read,update = _ref.update,list = _ref.list,remove = _ref.remove;return _regenerator2.default.wrap(function customUrls$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (create) {
                        request.url = _settings.noteServiceUserApi + '/questionaddressee';
                        request.params = {};
                    } else
                    if (read) {
                        request.url = _settings.noteServiceUserApi + '/questionaddressee/' + read.id;
                        request.params = {};
                    } else
                    if (update) {
                        request.url = _settings.noteServiceUserApi + '/questionaddressee/' + update.id;
                        request.params = {};
                    } else
                    if (list) {
                        request.url = _settings.noteServiceUserApi + '/questionaddressee/all';
                        request.params = {};
                    }return _context.delegateYield(
                    next(), 't0', 2);case 2:case 'end':return _context.stop();}}}, _marked, this);}

var questionaddresseeResource = exports.questionaddresseeResource = (0, _reduxSagaResources.createResource)('questionaddressee', {}, (0, _reduxSagaResources.JsonRestMiddleware)(_settings.noteServiceUserApi + '/questionaddressee', _resource.authMiddleware, customUrls));
var questionaddresseeEditor = exports.questionaddresseeEditor = (0, _reduxSagaResources.createEditor)('questionaddressee', { createImmediately: false }, questionaddresseeResource);
var questionaddresseeBatch = exports.questionaddresseeBatch = (0, _reduxSagaResources.createBatch)('questionaddressee', {}, questionaddresseeResource);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray2 = __webpack_require__(896);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _reselect = __webpack_require__(221);
var _getSelectionRangeDetail = __webpack_require__(608);
var _getAnchorFromDocument = __webpack_require__(606);
var _reducer = __webpack_require__(624);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var parseSelection = function parseSelection(text) {
    if (!text) {
        return null;
    }var _text$split$qSelect =
    text.split('|').qSelect(function (x) {return x.trim();}),_text$split$qSelect2 = (0, _slicedToArray3.default)(_text$split$qSelect, 2),start = _text$split$qSelect2[0],end = _text$split$qSelect2[1];
    return { start: start, end: end };
};exports.default =
{
    creating: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.creating;}),
    selection: (0, _reselect.createSelector)(_reducer.selector, function (state) {return parseSelection(state.selection);}),
    text: (0, _reselect.createSelector)(_reducer.selector, function (state) {
        if (state.selection) {
            var root = (0, _getAnchorFromDocument.getAnchorFromDocument)();
            var start = parseSelection(state.selection).start;
            var end = parseSelection(state.selection).end;
            var textInfo = (0, _getSelectionRangeDetail.getSelectionRangeDetail)(root, start, end);
            return textInfo && textInfo.textStart && textInfo.textStart.textContent ? textInfo.textStart.textContent : '';
        }
        return '';
    }),
    isnote: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.isnote;}) };

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('AUTH_LOGIN');

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





warning; /**
          * Prints a warning in the console if it exists.
          *
          * @param {String} message The warning message.
          * @returns {void}
          */function warning(message) {/* eslint-disable no-console */if (typeof console !== 'undefined' && typeof console.error === 'function') {console.error(message);} /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.qEnd = undefined;exports.




safeName = safeName;exports.default =











fsmIterator;var _utils = __webpack_require__(242);var done = { done: true, value: undefined };var qEnd = exports.qEnd = {};function safeName(patternOrChannel) {if (_utils.is.channel(patternOrChannel)) {return 'channel';} else if (Array.isArray(patternOrChannel)) {return String(patternOrChannel.map(function (entry) {return String(entry);}));} else {return String(patternOrChannel);}}function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
  qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
      q = _fsm$qNext[0],
      output = _fsm$qNext[1],
      _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.











emitter = emitter;exports.





























channel = channel;exports.
























































































eventChannel = eventChannel;exports.













































stdChannel = stdChannel;var _utils = __webpack_require__(242);var _buffers = __webpack_require__(588);var _scheduler = __webpack_require__(791);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';var END = exports.END = { type: CHANNEL_END_TYPE };var isEnd = exports.isEnd = function isEnd(a) {return a && a.type === CHANNEL_END_TYPE;};function emitter() {var subscribers = [];function subscribe(sub) {subscribers.push(sub);return function () {return (0, _utils.remove)(subscribers, sub);};}function emit(item) {var arr = subscribers.slice();for (var i = 0, len = arr.length; i < len; i++) {arr[i](item);}}return { subscribe: subscribe, emit: emit };}var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';if (false) {exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';}function channel() {var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();var closed = false;var takers = [];(0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);function checkForbiddenStates() {if (closed && takers.length) {throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');}if (takers.length && !buffer.isEmpty()) {throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');}}function put(input) {checkForbiddenStates();(0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);if (closed) {return;}if (!takers.length) {return buffer.put(input);}for (var i = 0; i < takers.length; i++) {var cb = takers[i];if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {takers.splice(i, 1);return cb(input);}}}function take(cb) {checkForbiddenStates();(0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");if (closed && buffer.isEmpty()) {cb(END);} else if (!buffer.isEmpty()) {cb(buffer.take());} else {takers.push(cb);cb.cancel = function () {return (0, _utils.remove)(takers, cb);};}}function flush(cb) {checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");if (closed && buffer.isEmpty()) {cb(END);return;}cb(buffer.flush());}function close() {checkForbiddenStates();if (!closed) {closed = true;if (takers.length) {var arr = takers;takers = [];for (var i = 0, len = arr.length; i < len; i++) {arr[i](END);}}}}return { take: take, put: put, flush: flush, close: close, get __takers__() {return takers;}, get __closed__() {return closed;} };}function eventChannel(subscribe) {var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();var matcher = arguments[2]; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                should be if(typeof matcher !== undefined) instead?
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                see PR #273 for a background discussion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              **/if (arguments.length > 2) {(0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');}var chan = channel(buffer);var close = function close() {if (!chan.__closed__) {if (unsubscribe) {unsubscribe();}chan.close();}};var unsubscribe = subscribe(function (input) {if (isEnd(input)) {close();return;}if (matcher && !matcher(input)) {return;}chan.put(input);});if (chan.__closed__) {unsubscribe();}if (!_utils.is.func(unsubscribe)) {throw new Error('in eventChannel: subscribe should return a function to unsubscribe');}return { take: chan.take, flush: chan.flush, close: close };}function stdChannel(subscribe) {var chan = eventChannel(function (cb) {return subscribe(function (input) {if (input[_utils.SAGA_ACTION]) {cb(input);
        return;
      }
      (0, _scheduler.asap)(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    } });

}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.transform = transform;
function transform(actions) {
    if (actions instanceof Array) {
        return actions.map(function (action) {
            return action.type;
        });
    } else {
        return actions.type;
    }
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(797), __esModule: true };

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);var _defineProperty2 = __webpack_require__(161);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);exports.default =


















































































































































































proc;var _utils = __webpack_require__(168);var _scheduler = __webpack_require__(590);var _io = __webpack_require__(506);var _channel = __webpack_require__(507);var _buffers = __webpack_require__(508);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};function _defineEnumerableProperties(obj, descs) {for (var key in descs) {var desc = descs[key];desc.configurable = desc.enumerable = true;if ("value" in desc) desc.writable = true;(0, _defineProperty3.default)(obj, key, desc);}return obj;}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return (0, _from2.default)(arr);}}function _defineProperty(obj, key, value) {if (key in obj) {(0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';var CHANNEL_END = exports.CHANNEL_END = { toString: function toString() {return '@@redux-saga/CHANNEL_END';} };var TASK_CANCEL = exports.TASK_CANCEL = { toString: function toString() {return '@@redux-saga/TASK_CANCEL';} };var matchers = { wildcard: function wildcard() {return _utils.kTrue;}, default: function _default(pattern) {return function (input) {return input.type === ((typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? pattern : String(pattern));};}, array: function array(patterns) {return function (input) {return patterns.some(function (p) {return matcher(p)(input);});};}, predicate: function predicate(_predicate) {return function (input) {return _predicate(input);};} };function matcher(pattern) {return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Used to track a parent task and its forks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        In the new fork model, forked tasks are attached by default to their parent
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        We model this using the concept of Parent task && main Task
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        main task is the main flow of the current Generator, the parent tasks is the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        aggregation of the main tasks + all its forked tasks.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Thus the whole model represents an execution tree with multiple branches (vs the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        linear execution tree in sequential (non parallel) programming)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        A parent tasks has the following semantics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        - It completes if all its forks either complete or all cancelled
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        - If it's cancelled, all forks are cancelled as well
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        - It aborts if any uncaught error bubbles up from forks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        - If it completes, the return value is the one returned by the main task
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      **/function forkQueue(name, mainTask, cb) {var tasks = [],result = void 0,completed = false;addTask(mainTask);function abort(err) {cancelAll();cb(err, true);}function addTask(task) {tasks.push(task);task.cont = function (res, isErr) {if (completed) {return;}(0, _utils.remove)(tasks, task);task.cont = _utils.noop;if (isErr) {abort(res);} else {if (task === mainTask) {result = res;}if (!tasks.length) {completed = true;cb(result);}}}; // task.cont.cancel = task.cancel
  }function cancelAll() {if (completed) {return;}completed = true;tasks.forEach(function (t) {t.cont = _utils.noop;t.cancel();});tasks = [];}return { addTask: addTask, cancelAll: cancelAll, abort: abort, getTasks: function getTasks() {return tasks;}, taskNames: function taskNames() {return tasks.map(function (t) {return t.name;});} };}function createTaskIterator(_ref) {var context = _ref.context,fn = _ref.fn,args = _ref.args;if (_utils.is.iterator(fn)) {return fn;} // catch synchronous failures; see #152 and #441
  var result = void 0,error = void 0;try {result = fn.apply(context, args);} catch (err) {error = err;} // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {return result;} // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {throw error;}) : (0, _utils.makeIterator)(function () {var pc = void 0;var eff = { done: false, value: result };var ret = function ret(value) {return { done: true, value: value };};return function (arg) {if (!pc) {pc = true;return eff;} else {return ret(arg);}};}());}var wrapHelper = function wrapHelper(helper) {return { fn: helper };};function proc(iterator) {var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {return _utils.noop;};var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';var cont = arguments[8];(0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);var sagaMonitor = options.sagaMonitor,logger = options.logger,onError = options.onError;var log = logger || _utils.log;var stdChannel = (0, _channel.stdChannel)(subscribe);
  var taskContext = (0, _create2.default)(parentContext);
  /**
                                                            Tracks the current effect cancellation
                                                            Each time the generator progresses. calling runEffect will set a new value
                                                            on it. It allows propagating cancellation to child effects
                                                          **/
  next.cancel = _utils.noop;

  /**
                               Creates a new task descriptor for this generator, We'll also create a main task
                               to track the main flow (besides other forked tasks)
                             **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
                                                    cancellation of the main task. We'll simply resume the Generator with a Cancel
                                                  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
      This may be called by a parent generator to trigger/propagate cancellation
      cancel all pending tasks (including the main task), then end the current task.
       Cancellation propagates down to the whole execution tree holded by this Parent task
      It's also propagated to all joiners of this task and their execution tree/joiners
       Cancellation is noop for terminated/Cancelled tasks tasks
    **/
  function cancel() {
    /**
                       We need to check both Running and Cancelled status
                       Tasks can be Cancelled but still Running
                     **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
                               Ending with a Never result will propagate the Cancellation to all joiners
                             **/
      end(TASK_CANCEL);
    }
  }
  /**
      attaches cancellation logic to this task's continuation
      this will permit cancellation to propagate down the call chain
    **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
                 This is the generator driver
                 It's a recursive async/continuation function which calls itself
                 until the generator terminates or throws
               **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
                                         getting TASK_CANCEL automatically cancels the main task
                                         We can get this value here
                                          - By cancelling the parent task manually
                                         - By joining a Cancelled task
                                       **/
        mainTask.isCancelled = true;
        /**
                                       Cancels the current effect; this will propagate the cancellation down to any called tasks
                                     **/
        next.cancel();
        /**
                         If this Generator has a `return` method then invokes it
                         Thill will jump to the finally block
                       **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
                This Generator has ended, terminate the main task and notify the fork queue
              **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && _utils.isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = (0, _utils.uid)();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
                                                                                                                                        completion callback and cancel callback are mutually exclusive
                                                                                                                                        We can't cancel an already completed effect
                                                                                                                                        And We can't complete an already cancelled effectId
                                                                                                                                      **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
                              propagates cancel downward
                              catch uncaught cancellations errors; since we can no longer call the completion
                              callback, log errors raised during cancellations into the console
                            **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
         each effect runner must attach its own logic of cancellation to the provided callback
         it allows this generator to propagate cancellation downward.
          ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
         And the setup must occur before calling the callback
          This is a sort of inversion of control: called async functions are responsible
         of completing the flow by calling the provided continuation; while caller functions
         are responsible for aborting the current flow by calling the attached cancel function
          Library users can attach their own cancellation logic to promises by defining a
         promise[CANCEL] method in their returned promises
         ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
       **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is        */currCb(effect));

  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
    pattern = _ref2.pattern,
    maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
    action = _ref3.action,
    resolve = _ref3.resolve;

    /**
                               Schedule the put in case another saga is holding a lock.
                               The put will be executed atomically. ie nested puts will execute after
                               this put has terminated.
                             **/
    (0, _scheduler.asap)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (resolve && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
    fn = _ref4.fn,
    args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
    fn = _ref5.fn,
    args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return _utils.is.undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
    fn = _ref6.fn,
    args = _ref6.args,
    detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      (0, _scheduler.suspend)();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      (0, _scheduler.flush)();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return (0, _utils.remove)(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === _utils.SELF_CANCELLATION) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = (0, _keys2.default)(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
    args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
    buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    _utils.object.assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineProperty(_ref9, 'setContext', function setContext(props) {
      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
      _utils.object.assign(taskContext, props);
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getCursorPositionFromEvent = exports.getSelectionPathFromPositions = exports.removeHighlights = exports.enterSelectionScope = exports.applyHighlights = undefined;var _dom = __webpack_require__(846);Object.defineProperty(exports, 'applyHighlights', { enumerable: true, get: function get() {return _dom.

        applyHighlights;} });var _interaction = __webpack_require__(859);Object.defineProperty(exports, 'enterSelectionScope', { enumerable: true, get: function get() {return _interaction.
        enterSelectionScope;} });Object.defineProperty(exports, 'removeHighlights', { enumerable: true, get: function get() {return _dom.
        removeHighlights;} });var _abstractselection = __webpack_require__(486);var _domop = __webpack_require__(160);
function isTouch(evt) {
    return evt.type === 'touchstart' || evt.type === 'touchmove' || evt.type === 'touchend';
}
function getTouchLocation(evt, id) {
    for (var i = 0, ii = evt.changedTouches.length; i < ii; i++) {
        var t = evt.changedTouches[i];
        if (!id || t.identifier === id) {
            return { type: evt.type, x: t.pageX, y: t.pageY, touchID: t.identifier };
        }
    }
    for (var _i = 0, _ii = evt.touches.length; _i < _ii; _i++) {
        var _t = evt.touches[_i];
        if (!id || _t.identifier === id) {
            return { type: evt.type, x: _t.pageX, y: _t.pageY, touchID: _t.identifier };
        }
    }
}
function isMouse(evt) {
    return evt.type === 'mousedown' || evt.type === 'mousemove' || evt.type === 'mouseup';
}
function getMouseLocation(evt) {
    return { type: evt.type, x: evt.pageX, y: evt.pageY, touchID: undefined };
}
var getSelectionPathFromPositions = exports.getSelectionPathFromPositions = function getSelectionPathFromPositions(root, cursorStart, cursorEnd) {
    if (!cursorStart || !cursorEnd) {
        return null;
    }
    var posStart = _domop.NodeTextPosition.fromPoint(cursorStart.x, cursorStart.y);
    if (!posStart) {
        return null;
    }
    var posEnd = _domop.NodeTextPosition.fromPoint(cursorEnd.x, cursorEnd.y);
    if (!posEnd) {
        return null;
    }
    var clipped = _abstractselection.RangeInternal.fromTextPositions(posStart, posEnd);
    if (!clipped) {
        return null;
    }
    var pathStart = (0, _abstractselection.getNodePathFromNodeOffset)(root, clipped.startContainer, clipped.startOffset);
    if (!pathStart) {
        return null;
    }
    var pathEnd = (0, _abstractselection.getNodePathFromNodeOffset)(root, clipped.endContainer, clipped.endOffset);
    if (!pathEnd) {
        return null;
    }
    return { pathStart: pathStart, pathEnd: pathEnd };
};
var getCursorPositionFromEvent = exports.getCursorPositionFromEvent = function getCursorPositionFromEvent(event, touchID) {
    if (isTouch(event)) {
        return getTouchLocation(event, touchID);
    }
    if (isMouse(event)) {
        return getMouseLocation(event);
    }
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.isDocumentContent = exports.isAnchor = undefined;var _index = __webpack_require__(160);
var _config = __webpack_require__(604);
var isAnchor = exports.isAnchor = function isAnchor(node) {return (0, _index.isElement)(node) && node.matches(_config.Settings.selectorStructure);};
var isDocumentContent = exports.isDocumentContent = function isDocumentContent(node) {return (0, _index.isElement)(node) && node.matches(_config.Settings.selectorDocumentContent);};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getNodePathFromNodeOffset = undefined;var _NodeTextNavigation = __webpack_require__(231);
var getNodePathFromNodeOffset = exports.getNodePathFromNodeOffset = function getNodePathFromNodeOffset(root, domNode, offset) {
    var structNode = root.findClosestByNode(domNode);
    if (!structNode) {
        return null;
    }
    var documentNode = structNode.selfOrAncestorDocumentContent();
    if (!documentNode) {
        return null;
    }
    var nodeOffset = new _NodeTextNavigation.NodeTextNavigation(domNode).forward(offset).countBackwards(structNode.node);
    return structNode.path + '+' + nodeOffset;
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.RangeInternal = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var RangeInternal = exports.RangeInternal = function () {
    function RangeInternal(startContainer, startOffset, endContainer, endOffset) {(0, _classCallCheck3.default)(this, RangeInternal);
        this.startContainer = startContainer;
        this.startOffset = startOffset;
        this.endContainer = endContainer;
        this.endOffset = endOffset;
    }(0, _createClass3.default)(RangeInternal, null, [{ key: "fromRange", value: function fromRange(
        range) {
            return new RangeInternal(range.startContainer, range.startOffset, range.endContainer, range.endOffset);
        } }, { key: "fromTextPosition", value: function fromTextPosition(
        cursor) {
            return new RangeInternal(cursor.container, cursor.offset, cursor.container, cursor.offset);
        } }, { key: "fromTextPositions", value: function fromTextPositions(
        start, end) {
            return new RangeInternal(start.container, start.offset, end.container, end.offset);
        } }]);return RangeInternal;}();

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FINGER_TOUCHEND');

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FINGER_TOUCHMOVE');

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FINGER_TOUCHSTART');

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('BROWSER_SESSION_RESTORED');

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CATEGORYSELECT_HIDE');

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USER_ID_LOADED');

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





warning; /**
          * Prints a warning in the console if it exists.
          *
          * @param {String} message The warning message.
          * @returns {void}
          */function warning(message) {/* eslint-disable no-console */if (typeof console !== 'undefined' && typeof console.error === 'function') {console.error(message);} /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.sortFunction = undefined;__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _types = __webpack_require__(245);
var _resource = __webpack_require__(163);
var _resource2 = __webpack_require__(162);
var _selectors = __webpack_require__(666);
var _selectors2 = __webpack_require__(894);
var _resource3 = __webpack_require__(106);
var _resource4 = __webpack_require__(494);
var _resource5 = __webpack_require__(513);
var _resource6 = __webpack_require__(246);
var _resource7 = __webpack_require__(233);
var _resource8 = __webpack_require__(223);
var _resource9 = __webpack_require__(234);
var _authcheck = __webpack_require__(518);
function wildcardMatcher(searchTerm) {
    if (searchTerm) {
        var term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, function (x) {return '\\' + x;});
        term = term.replace(/\*/g, function (x) {return '.*';});
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect(function (x) {return '(?=.*' + x + ')';}).join('');
        var rx = new RegExp(term, 'i');
        return function (text) {return rx.test(text);};
    } else
    {
        return function (text) {return true;};
    }
}
function createdSelector(time) {
    return new Date(time).getTime();
}
var typeFactions = 5;
var searchTermMatcherSelector = (0, _reselect.createSelector)(_selectors.searchTermSelector, wildcardMatcher);
var categoryMatcherSelector = (0, _reselect.createSelector)(_selectors.categoriesSelector, function (categories) {return categories.qEmpty() ? function () {return true;} : function (item) {return categories.qIncludes(item.categoryId || 0);};});
var participantMatcherSelector = (0, _reselect.createSelector)(_selectors.participantsSelector, function (participants) {return participants ? participants.qEmpty() ? function () {return true;} : function (item) {return (0, _types.isNote)(item) && participants.qIncludes(item.userId);} : function () {return true;};});
var participantGroupMatcherSelector = (0, _reselect.createSelector)(_selectors.participantgroupsSelector, function (participantgroups) {return participantgroups ? participantgroups.qEmpty() ? function () {return true;} : function (item) {
        var groupsOfitem = (0, _types.isNote)(item) && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.map(function (itm) {return itm.toString();});
        var selectedGroups = participantgroups && participantgroups.map(function (itm) {return itm.toString();});
        return groupsOfitem && selectedGroups && groupsOfitem.filter(function (obj) {
            return selectedGroups.indexOf(obj.toString()) !== -1;
        }).qAny();
    } : function () {return true;};});
var factionMatcherSelector = (0, _reselect.createSelector)(_selectors.factiongroupsSelector, _resource7.usergroupResource.selectors.items, function (factiongroups, usergroups) {return factiongroups ? factiongroups.qEmpty() ? function () {return true;} : function (item) {
        var groupsOfitem = usergroups.qWhere(function (ug) {return ug.userIDs.includes(item.userId) &&
            ug.type === typeFactions;}).map(function (itm) {return itm.id.toString();});
        var selectedGroups = factiongroups && factiongroups.map(function (itm) {return itm.toString();});
        return groupsOfitem && selectedGroups && groupsOfitem.filter(function (obj) {
            return selectedGroups.indexOf(obj.toString()) !== -1;
        }).qAny();
    } : function () {return true;};});
var categoryMatcherQuestionsSelector = (0, _reselect.createSelector)(_selectors.categoriesSelector, function (categories) {return categories.qEmpty() ? function () {return true;} : function () {return false;};});
var statusMatcherSelector = (0, _reselect.createSelector)(_selectors.statusSelector, function (statuses) {return statuses === undefined || statuses.qEmpty() ? function () {return true;} : function (item) {return (0, _types.isQuestion)(item) && statuses.map(function (z) {return z.valueOf();}).qIncludes(item.status);};});
var originMatcherSelector = (0, _reselect.createSelector)(_selectors.originSelector, _selectors2.participantIdSelector, function (origins, userid) {return origins.qEmpty() ? function () {return true;} : function (item) {
        return (0, _types.isNote)(item) && origins.qIncludes('mine') && item.userId === (userid ? userid.toString() : '') ||
        (0, _types.isNote)(item) && origins.qIncludes('others') && item.userId !== (userid ? userid.toString() : '') && (userid ? userid.toString() : '') !== '';
    };});
var sortFuncSelector = (0, _reselect.createSelector)(_selectors.sortingSelector, function (order) {
    if (order === 'createdAsc') {
        return function (a, b) {
            if (createdSelector(a.created) !== createdSelector(b.created)) {
                return createdSelector(b.created) - createdSelector(a.created);
            }
            return a.id - b.id;
        };
    } else
    if (order === 'pageNumber') {
        return function (a, b) {
            if (a.pageNumber !== b.pageNumber) {
                return a.pageNumber - b.pageNumber;
            }
            if (createdSelector(a.created) !== createdSelector(b.created)) {
                return createdSelector(b.created) - createdSelector(b.created);
            }
            return a.id - b.id;
        };
    } else
    {
        return function (a, b) {
            if (createdSelector(a.created) !== createdSelector(b.created)) {
                return createdSelector(a.created) - createdSelector(b.created);
            }
            return b.id - a.id;
        };
    }
});
var sortFuncEmailsSelector = (0, _reselect.createSelector)(_selectors.sortingSelector, function (order) {
    if (order === 'createdAsc') {
        return function (a, b) {
            if (createdSelector(a.dateEmail) !== createdSelector(b.dateEmail)) {
                return createdSelector(b.dateEmail) - createdSelector(a.dateEmail);
            }
            return a.id - b.id;
        };
    } else
    {
        return function (a, b) {
            if (createdSelector(a.dateEmail) !== createdSelector(b.dateEmail)) {
                return createdSelector(a.dateEmail) - createdSelector(b.dateEmail);
            }
            return b.id - a.id;
        };
    }
});
var sortFunction = exports.sortFunction = function sortFunction(order) {
    if (order === 'createdAsc') {
        return function (a, b) {
            if (createdSelector(a['created']) !== createdSelector(b['created'])) {
                return createdSelector(b['created']) - createdSelector(a['created']);
            }
            return a['id'] - b['id'];
        };
    } else
    if (order === 'pageNumber') {
        return function (a, b) {
            if (a['pageNumber'] !== b['pageNumber']) {
                return a['pageNumber'] - b['pageNumber'];
            }
            if (createdSelector(a['created']) !== createdSelector(b['created'])) {
                return createdSelector(b['created']) - createdSelector(b['created']);
            }
            return a['id'] - b['id'];
        };
    } else
    {
        return function (a, b) {
            if (createdSelector(a['created']) !== createdSelector(b['created'])) {
                return createdSelector(a['created']) - createdSelector(b['created']);
            }
            return b['id'] - a['id'];
        };
    }
};exports.default =
{
    bookmarksItemsSelector: (0, _reselect.createSelector)(_resource.bookmarksResource.selectors.items, searchTermMatcherSelector, categoryMatcherSelector, sortFuncSelector, function (items, searchTermMatcher, categoryMatcher, sort) {
        return items.qWhere(function (x) {return searchTermMatcher(x.name);}).qWhere(categoryMatcher).sort(sort);
    }),
    categoriesItemsSelector: (0, _reselect.createSelector)(_resource2.categoriesResource.selectors.items, searchTermMatcherSelector, function (items, searchTermMatcher) {
        return items.qWhere(function (x) {return searchTermMatcher(x.name);});
    }),
    notesItemsSelector: (0, _reselect.createSelector)(_resource3.notesResource.selectors.items, searchTermMatcherSelector, categoryMatcherSelector, participantMatcherSelector, participantGroupMatcherSelector, sortFuncSelector, originMatcherSelector, function (items, searchTermMatcher, categoryMatcher, participantMatcher, participantgroupMatcher, sort, originMatcher) {
        return items.qWhere(function (x) {return searchTermMatcher(x.text);}).qWhere(categoryMatcher).qWhere(participantMatcher).qWhere(participantgroupMatcher).qWhere(originMatcher).sort(sort).qWhere(function (z) {return !z.isquestion;});
    }),
    notesSharedSelector: (0, _reselect.createSelector)(_resource4.notesSharedResource.selectors.items, searchTermMatcherSelector, categoryMatcherSelector, participantMatcherSelector, participantGroupMatcherSelector, sortFuncSelector, originMatcherSelector, function (items, searchTermMatcher, categoryMatcher, participantMatcher, participantgroupMatcher, sort, originMatcher) {
        return items.qWhere(function (x) {return searchTermMatcher(x.text);}).qWhere(categoryMatcher).qWhere(participantMatcher).qWhere(participantgroupMatcher).qWhere(originMatcher).sort(sort).qWhere(function (z) {return !z.isquestion;});
    }),
    questionsItemsSelector: (0, _reselect.createSelector)(_resource3.notesResource.selectors.items, _resource4.notesSharedResource.selectors.items, _resource8.questionsResource.selectors.items, _resource9.beheerResource.selectors.items, _resource7.usergroupResource.selectors.items, factionMatcherSelector, _selectors2.participantIdSelector, searchTermMatcherSelector, statusMatcherSelector, function (itemsNotes, itemsNotesShared, itemsQuestions, beheer, usergroups, factionMatcher, userId, searchTermMatcher, statusMatcher) {
        var arr = [];
        var admin = beheer && beheer.qFirst();
        if (admin && admin.factionvisible) {
            arr = itemsNotes.concat(itemsNotesShared).qWhere(function (itm) {return itm.isquestion;}).map(function (note) {return itemsQuestions.some(function (q) {return q.noteId === note.id;}) ?
                itemsQuestions.filter(function (q) {return q.noteId === note.id;}).map(function (q) {return { q: q, note: note };}) :
                [{ q: {}, note: note }];}).qWhere(function (z) {return !!z;}).
            qSelect(function (v) {
                var combined = v[0];
                var question = combined.note;
                question.status = combined.q ? combined.q.status : 1;
                question.antwoordConcern = combined.q ? combined.q.antwoordConcern : '';
                question.parentId = combined.q ? combined.q.parentId : undefined;
                question.practicionerId = combined.q ? combined.q.practicionerId : undefined;
                return question;
            }).
            qWhere(function (question) {return usergroups.qAny(function (ug) {return ug.userIDs.includes(question.userId) &&
                    ug.userIDs.includes(!!userId ? userId.toString() : '') && ug.type === typeFactions ||
                    ug.userIDs.includes(!!userId ? userId.toString() : '') && ug.type === _authcheck.typeRoleAdmin ||
                    ug.userIDs.includes(!!userId ? userId.toString() : '') && ug.type === _authcheck.typeRolePracticioner ||
                    ug.userIDs.includes(!!userId ? userId.toString() : '') && ug.type === _authcheck.typeRoleClerk ||
                    question.status === _authcheck.statusGepubliceerd;});}).
            sort(function (a, b) {
                if (a && b) {
                    if (!a.parentId && !b.parentId && a.id > b.id) {
                        return 1;
                    }
                    if (!a.parentId && !b.parentId && a.id < b.id) {
                        return -1;
                    }
                    if (!!a.parentId && !!b.parentId && a.parentId > b.parentId) {
                        return 1;
                    }
                    if (!!a.parentId && !!b.parentId && a.parentId < b.parentId) {
                        return -1;
                    }
                    if (!!a.parentId && a.parentId >= b.id) {
                        return 1;
                    }
                    if (!!a.parentId && a.parentId < b.id) {
                        return -1;
                    }
                    if (!!b.parentId && a.id <= b.parentId) {
                        return -1;
                    }
                    if (!!b.parentId && a.id > b.parentId) {
                        return 1;
                    }
                    return 0;
                }
            });
            return arr.qWhere(function (x) {return searchTermMatcher(x.text);}).qWhere(statusMatcher).qWhere(factionMatcher).qWhere(function (z) {return z.isquestion;});
        } else
        {
            arr = itemsNotes.concat(itemsNotesShared).qWhere(function (itm) {return itm.isquestion;}).map(function (note) {return itemsQuestions.some(function (q) {return q.noteId === note.id;}) ?
                itemsQuestions.filter(function (q) {return q.noteId === note.id;}).map(function (q) {return { q: q, note: note };}) :
                [{ q: {}, note: note }];}).qWhere(function (z) {return !!z;}).
            qSelect(function (v) {
                var combined = v[0];
                var question = combined.note;
                question.status = combined.q ? combined.q.status : 1;
                question.antwoordConcern = combined.q ? combined.q.antwoordConcern : '';
                question.parentId = combined.q ? combined.q.parentId : undefined;
                question.practicionerId = combined.q ? combined.q.practicionerId : undefined;
                return question;
            }).
            sort(function (a, b) {
                if (a && b) {
                    if (!a.parentId && !b.parentId && a.id > b.id) {
                        return 1;
                    }
                    if (!a.parentId && !b.parentId && a.id < b.id) {
                        return -1;
                    }
                    if (!!a.parentId && !!b.parentId && a.parentId > b.parentId) {
                        return 1;
                    }
                    if (!!a.parentId && !!b.parentId && a.parentId < b.parentId) {
                        return -1;
                    }
                    if (!!a.parentId && a.parentId >= b.id) {
                        return 1;
                    }
                    if (!!a.parentId && a.parentId < b.id) {
                        return -1;
                    }
                    if (!!b.parentId && a.id <= b.parentId) {
                        return -1;
                    }
                    if (!!b.parentId && a.id > b.parentId) {
                        return 1;
                    }
                    return 0;
                }
            });
            return arr.qWhere(function (x) {return searchTermMatcher(x.text);}).qWhere(statusMatcher).qWhere(factionMatcher).qWhere(function (z) {return z.isquestion;});
        }
    }),
    participantsSelector: _resource6.participantsResource.selectors.items,
    EmailsSelector: (0, _reselect.createSelector)(_resource5.emailArchiveResource.selectors.items, searchTermMatcherSelector, sortFuncEmailsSelector, categoryMatcherQuestionsSelector, function (items, searchTermMatcher, sort, categoryMatcherQuestion) {
        return items.qWhere(function (x) {return searchTermMatcher(x.htmlMail) || searchTermMatcher(x.subject);}).
        qWhere(categoryMatcherQuestion).
        sort(sort);
    }),
    usergroupSelector: (0, _reselect.createSelector)(_resource7.usergroupResource.selectors.items, searchTermMatcherSelector, function (items, searchTermMatcher) {
        return items.qWhere(function (x) {return searchTermMatcher(x.name);});
    }),
    usergroupWitMeInItSelector: (0, _reselect.createSelector)(_resource7.usergroupResource.selectors.items, _resource6.participantsResource.selectors.items, searchTermMatcherSelector, function (items, participants, searchTermMatcher) {
        var currentUser = participants.qWhere(function (i) {return i.isUser;}).qFirst();
        var currentUserId = currentUser ? currentUser.id : '';
        return items.qWhere(function (x) {return searchTermMatcher(x.name) && x.userIDs && x.userIDs.includes(currentUserId);});
    }) };

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_HIDE');

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_INSPECT');

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
    loadMaterialIcons: function loadMaterialIcons(state) {return state.browser.config.skipMaterialIcons !== true;},
    ready: function ready(state) {return state.browser.ready;},
    restoringSession: function restoringSession(state) {return state.browser.restoringSession;},
    visible: function visible(state) {return state.auth.accessToken || state.browser.config.hideWhenLoggedOut !== true;} };

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_INITIALIZE');

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('START_CHAT');

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CATEGORYSELECT_SELECT');

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANT_SELECT_CANCEL');

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_SAVE');

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('AUTH_LOGOUT');

/***/ }),
/* 552 */,
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_CREATE');

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_UPDATE');

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_ITEM_LAST_TOUCHED');

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_DELETE_BATCH');

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FLYOVER_TAB_ACTIVATE');

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTEMENU_ERASE');

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REFRESH_BOOKMARKUPDATE');

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_SHOW');

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('STATUS_HIDE');

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_REMOVE');

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_CHANGE_STATUS_BATCH');

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = '6.2.0';

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(752), __esModule: true };

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(35).f;
var create = __webpack_require__(158);
var redefineAll = __webpack_require__(230);
var ctx = __webpack_require__(60);
var anInstance = __webpack_require__(229);
var forOf = __webpack_require__(167);
var $iterDefine = __webpack_require__(166);
var step = __webpack_require__(238);
var setSpecies = __webpack_require__(240);
var DESCRIPTORS = __webpack_require__(42);
var fastKey = __webpack_require__(228).fastKey;
var validate = __webpack_require__(524);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var $export = __webpack_require__(34);
var meta = __webpack_require__(228);
var fails = __webpack_require__(70);
var hide = __webpack_require__(48);
var redefineAll = __webpack_require__(230);
var forOf = __webpack_require__(167);
var anInstance = __webpack_require__(229);
var isObject = __webpack_require__(41);
var setToStringTag = __webpack_require__(82);
var dP = __webpack_require__(35).f;
var each = __webpack_require__(754)(0);
var DESCRIPTORS = __webpack_require__(42);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(159);
var from = __webpack_require__(758);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(34);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(34);
var aFunction = __webpack_require__(81);
var ctx = __webpack_require__(60);
var forOf = __webpack_require__(167);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.Factory = Factory;
function Factory(type) {
    var c = function c(payload, meta) {
        return meta === undefined ? { type: type, payload: payload } : { type: type, payload: payload, meta: meta };
    };
    var e = function e(error, meta) {
        return meta === undefined ? { type: type, payload: error, error: true } : { type: type, payload: error, error: true, meta: meta };
    };
    c.type = type;
    c.error = e;
    return c;
}
//# sourceMappingURL=Factory.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CONFIG');

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_REDRAW');

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('METADATA_CHANGE');

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;var _createStore = __webpack_require__(576);var _createStore2 = _interopRequireDefault(_createStore);
var _combineReducers = __webpack_require__(779);var _combineReducers2 = _interopRequireDefault(_combineReducers);
var _bindActionCreators = __webpack_require__(780);var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
var _applyMiddleware = __webpack_require__(781);var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
var _compose = __webpack_require__(580);var _compose2 = _interopRequireDefault(_compose);
var _warning = __webpack_require__(525);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/*
                                                                                                                                                                                         * This is a dummy function to check if the function name has been altered by minification.
                                                                                                                                                                                         * If the function has been minified and NODE_ENV !== 'production', warn the user.
                                                                                                                                                                                         */
function isCrushed() {}

if (false) {
  (0, _warning2.default)('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}exports.

createStore = _createStore2.default;exports.combineReducers = _combineReducers2.default;exports.bindActionCreators = _bindActionCreators2.default;exports.applyMiddleware = _applyMiddleware2.default;exports.compose = _compose2.default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.ActionTypes = undefined;var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);exports.default =




































createStore;var _isPlainObject = __webpack_require__(577);var _isPlainObject2 = _interopRequireDefault(_isPlainObject);var _symbolObservable = __webpack_require__(776);var _symbolObservable2 = _interopRequireDefault(_symbolObservable);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                                                                                        * These are private action types reserved by Redux.
                                                                                                                                                                                                                                                                                                                                                        * For any unknown actions, you must return the current state.
                                                                                                                                                                                                                                                                                                                                                        * If the current state is undefined, you must return the initial state.
                                                                                                                                                                                                                                                                                                                                                        * Do not reference these action types directly in your code.
                                                                                                                                                                                                                                                                                                                                                        */var ActionTypes = exports.ActionTypes = { INIT: '@@redux/INIT' /**
                                                                                                                                                                                                                                                                                                                                                                                                                          * Creates a Redux store that holds the state tree.
                                                                                                                                                                                                                                                                                                                                                                                                                          * The only way to change the data in the store is to call `dispatch()` on it.
                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                          * There should only be a single store in your app. To specify how different
                                                                                                                                                                                                                                                                                                                                                                                                                          * parts of the state tree respond to actions, you may combine several reducers
                                                                                                                                                                                                                                                                                                                                                                                                                          * into a single reducer function by using `combineReducers`.
                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                          * @param {Function} reducer A function that returns the next state tree, given
                                                                                                                                                                                                                                                                                                                                                                                                                          * the current state tree and the action to handle.
                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                          * @param {any} [preloadedState] The initial state. You may optionally specify it
                                                                                                                                                                                                                                                                                                                                                                                                                          * to hydrate the state from the server in universal apps, or to restore a
                                                                                                                                                                                                                                                                                                                                                                                                                          * previously serialized user session.
                                                                                                                                                                                                                                                                                                                                                                                                                          * If you use `combineReducers` to produce the root reducer function, this must be
                                                                                                                                                                                                                                                                                                                                                                                                                          * an object with the same shape as `combineReducers` keys.
                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                          * @param {Function} [enhancer] The store enhancer. You may optionally specify it
                                                                                                                                                                                                                                                                                                                                                                                                                          * to enhance the store with third-party capabilities such as middleware,
                                                                                                                                                                                                                                                                                                                                                                                                                          * time travel, persistence, etc. The only store enhancer that ships with Redux
                                                                                                                                                                                                                                                                                                                                                                                                                          * is `applyMiddleware()`.
                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                          * @returns {Store} A Redux store that lets you read the state, dispatch actions
                                                                                                                                                                                                                                                                                                                                                                                                                          * and subscribe to changes.
                                                                                                                                                                                                                                                                                                                                                                                                                          */ };function createStore(reducer, preloadedState, enhancer) {var _ref2;if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {enhancer = preloadedState;preloadedState = undefined;}if (typeof enhancer !== 'undefined') {if (typeof enhancer !== 'function') {throw new Error('Expected the enhancer to be a function.');}return enhancer(createStore)(reducer, preloadedState);}if (typeof reducer !== 'function') {throw new Error('Expected the reducer to be a function.');}var currentReducer = reducer;var currentState = preloadedState;var currentListeners = [];var nextListeners = currentListeners;var isDispatching = false;function ensureCanMutateNextListeners() {if (nextListeners === currentListeners) {nextListeners = currentListeners.slice();}
  }

  /**
     * Reads the state tree managed by the store.
     *
     * @returns {any} The current state tree of your application.
     */
  function getState() {
    return currentState;
  }

  /**
     * Adds a change listener. It will be called any time an action is dispatched,
     * and some part of the state tree may potentially have changed. You may then
     * call `getState()` to read the current state tree inside the callback.
     *
     * You may call `dispatch()` from a change listener, with the following
     * caveats:
     *
     * 1. The subscriptions are snapshotted just before every `dispatch()` call.
     * If you subscribe or unsubscribe while the listeners are being invoked, this
     * will not have any effect on the `dispatch()` that is currently in progress.
     * However, the next `dispatch()` call, whether nested or not, will use a more
     * recent snapshot of the subscription list.
     *
     * 2. The listener should not expect to see all state changes, as the state
     * might have been updated multiple times during a nested `dispatch()` before
     * the listener is called. It is, however, guaranteed that all subscribers
     * registered before the `dispatch()` started will be called with the latest
     * state by the time it exits.
     *
     * @param {Function} listener A callback to be invoked on every dispatch.
     * @returns {Function} A function to remove this change listener.
     */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
     * Dispatches an action. It is the only way to trigger a state change.
     *
     * The `reducer` function, used to create the store, will be called with the
     * current state tree and the given `action`. Its return value will
     * be considered the **next** state of the tree, and the change listeners
     * will be notified.
     *
     * The base implementation only supports plain object actions. If you want to
     * dispatch a Promise, an Observable, a thunk, or something else, you need to
     * wrap your store creating function into the corresponding middleware. For
     * example, see the documentation for the `redux-thunk` package. Even the
     * middleware will eventually dispatch plain object actions using this method.
     *
     * @param {Object} action A plain object representing “what changed”. It is
     * a good idea to keep actions serializable so you can record and replay user
     * sessions, or use the time travelling `redux-devtools`. An action must have
     * a `type` property which may not be `undefined`. It is a good idea to use
     * string constants for action types.
     *
     * @returns {Object} For convenience, the same action object you dispatched.
     *
     * Note that, if you use a custom middleware, it may wrap `dispatch()` to
     * return something else (for example, a Promise you can await).
     */
  function dispatch(action) {
    if (!(0, _isPlainObject2.default)(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
     * Replaces the reducer currently used by the store to calculate the state.
     *
     * You might need this if your app implements code splitting and you want to
     * load some of the reducers dynamically. You might also need this if you
     * implement a hot reloading mechanism for Redux.
     *
     * @param {Function} nextReducer The reducer for the store to use instead.
     * @returns {void}
     */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
     * Interoperability point for observable/reactive libraries.
     * @returns {observable} A minimal observable of state changes.
     * For more information, see the observable proposal:
     * https://github.com/tc39/proposal-observable
     */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
                     * The minimal observable subscription method.
                     * @param {Object} observer Any object that can be used as an observer.
                     * The observer object should have a `next` method.
                     * @returns {subscription} An object with an `unsubscribe` method that can
                     * be used to unsubscribe the observable from the store, and prevent further
                     * emission of values from the observable.
                     */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : (0, _typeof3.default)(observer)) !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      } },
    _ref[_symbolObservable2.default] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer },
  _ref2[_symbolObservable2.default] = observable, _ref2;
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _baseGetTag = __webpack_require__(768);var _baseGetTag2 = _interopRequireDefault(_baseGetTag);
var _getPrototype = __webpack_require__(773);var _getPrototype2 = _interopRequireDefault(_getPrototype);
var _isObjectLike = __webpack_require__(775);var _isObjectLike2 = _interopRequireDefault(_isObjectLike);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
                                                   * Checks if `value` is a plain object, that is, an object created by the
                                                   * `Object` constructor or one with a `[[Prototype]]` of `null`.
                                                   *
                                                   * @static
                                                   * @memberOf _
                                                   * @since 0.8.0
                                                   * @category Lang
                                                   * @param {*} value The value to check.
                                                   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                                                   * @example
                                                   *
                                                   * function Foo() {
                                                   *   this.a = 1;
                                                   * }
                                                   *
                                                   * _.isPlainObject(new Foo);
                                                   * // => false
                                                   *
                                                   * _.isPlainObject([1, 2, 3]);
                                                   * // => false
                                                   *
                                                   * _.isPlainObject({ 'x': 0, 'y': 0 });
                                                   * // => true
                                                   *
                                                   * _.isPlainObject(Object.create(null));
                                                   * // => true
                                                   */
function isPlainObject(value) {
  if (!(0, _isObjectLike2.default)(value) || (0, _baseGetTag2.default)(value) != objectTag) {
    return false;
  }
  var proto = (0, _getPrototype2.default)(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
  funcToString.call(Ctor) == objectCtorString;
}exports.default =

isPlainObject;module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _root = __webpack_require__(769);var _root2 = _interopRequireDefault(_root);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Built-in value references. */
var _Symbol = _root2.default.Symbol;exports.default =

_Symbol;module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			} });

		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			} });

		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










compose; /**
          * Composes single-argument functions from right to left. The rightmost
          * function can take multiple arguments as it provides the signature for
          * the resulting composite function.
          *
          * @param {...Function} funcs The functions to compose.
          * @returns {Function} A function obtained by composing the argument functions
          * from right to left. For example, compose(f, g, h) is identical to doing
          * (...args) => f(g(h(...args))).
          */function compose() {for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {funcs[_key] = arguments[_key];}if (funcs.length === 0) {return function (arg) {return arg;};}

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}module.exports = exports["default"];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('AUTH_ACCOUNDMANAGER');

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });

var internal = exports.internal = function (id) {return "@@saga-resources/" + id;};
var isInternal = exports.isInternal = function (id) {return (/^@@saga-resources\//.test(id));};
//# sourceMappingURL=internal.js.map

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.entityHasSameId = entityHasSameId;

var _fields = __webpack_require__(503);

function entityHasSameId(options) {
    var internalId = _fields.fields.id,
    tempId = _fields.fields.tempId;
    var id = options.id;

    var leftId = void 0;
    var rightId = void 0;
    return function (left, right) {
        if (left === right) {
            return true;
        }
        if (left && right) {
            leftId = left[internalId];
            rightId = right[internalId];
            if (leftId && leftId === rightId) {
                return true;
            }
            if (id) {
                leftId = left[id];
                rightId = right[id];
                if (leftId && leftId === rightId) {
                    return true;
                }
            }
            leftId = left[tempId];
            rightId = right[tempId];
            if (leftId && leftId === rightId) {
                return true;
            }
        }
        return false;
    };
}
//# sourceMappingURL=entityHasSameId.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.makeActions = makeActions;

var _es = __webpack_require__(1);

var _utils = __webpack_require__(156);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeActions(name) {
    var res = {
        CREATE: (0, _es.Action)((0, _utils.internal)('RESOURCE/CREATE_' + name.toUpperCase())),
        CREATE_CANCEL: (0, _es.Action)((0, _utils.internal)('RESOURCE/CREATE_' + name.toUpperCase() + '_CANCEL')),
        CREATE_FAILURE: (0, _es.Action)((0, _utils.internal)('RESOURCE/CREATE_' + name.toUpperCase() + '_FAILURE')),
        CREATE_SUCCESS: (0, _es.Action)((0, _utils.internal)('RESOURCE/CREATE_' + name.toUpperCase() + '_SUCCESS')),
        DELETE: (0, _es.Action)((0, _utils.internal)('RESOURCE/DELETE_' + name.toUpperCase())),
        DELETE_CANCEL: (0, _es.Action)((0, _utils.internal)('RESOURCE/DELETE_' + name.toUpperCase() + '_CANCEL')),
        DELETE_FAILURE: (0, _es.Action)((0, _utils.internal)('RESOURCE/DELETE_' + name.toUpperCase() + '_FAILURE')),
        DELETE_SUCCESS: (0, _es.Action)((0, _utils.internal)('RESOURCE/DELETE_' + name.toUpperCase() + '_SUCCESS')),
        LIST: (0, _es.Action)((0, _utils.internal)('RESOURCE/LIST_' + name.toUpperCase())),
        LIST_CANCEL: (0, _es.Action)((0, _utils.internal)('RESOURCE/LIST_' + name.toUpperCase() + '_CANCEL')),
        LIST_FAILURE: (0, _es.Action)((0, _utils.internal)('RESOURCE/LIST_' + name.toUpperCase() + '_FAILURE')),
        LIST_SUCCESS: (0, _es.Action)((0, _utils.internal)('RESOURCE/LIST_' + name.toUpperCase() + '_SUCCESS')),
        READ: (0, _es.Action)((0, _utils.internal)('RESOURCE/READ_' + name.toUpperCase())),
        READ_CANCEL: (0, _es.Action)((0, _utils.internal)('RESOURCE/READ_' + name.toUpperCase() + '_CANCEL')),
        READ_FAILURE: (0, _es.Action)((0, _utils.internal)('RESOURCE/READ_' + name.toUpperCase() + '_FAILURE')),
        READ_SUCCESS: (0, _es.Action)((0, _utils.internal)('RESOURCE/READ_' + name.toUpperCase() + '_SUCCESS')),
        RESET: (0, _es.Action)((0, _utils.internal)('RESOURCE/RESET_' + name.toUpperCase())),
        UPDATE: (0, _es.Action)((0, _utils.internal)('RESOURCE/UPDATE_' + name.toUpperCase())),
        UPDATE_CANCEL: (0, _es.Action)((0, _utils.internal)('RESOURCE/UPDATE_' + name.toUpperCase() + '_CANCEL')),
        UPDATE_FAILURE: (0, _es.Action)((0, _utils.internal)('RESOURCE/UPDATE_' + name.toUpperCase() + '_FAILURE')),
        UPDATE_SUCCESS: (0, _es.Action)((0, _utils.internal)('RESOURCE/UPDATE_' + name.toUpperCase() + '_SUCCESS')) };

    var all = [res.CREATE, res.CREATE_CANCEL, res.CREATE_FAILURE, res.CREATE_SUCCESS, res.DELETE, res.DELETE_CANCEL, res.DELETE_FAILURE, res.DELETE_SUCCESS, res.LIST, res.LIST_CANCEL, res.LIST_FAILURE, res.LIST_SUCCESS, res.READ, res.READ_CANCEL, res.READ_FAILURE, res.READ_SUCCESS, res.RESET, res.UPDATE, res.UPDATE_CANCEL, res.UPDATE_FAILURE, res.UPDATE_SUCCESS];
    return (0, _extends3.default)({}, res, { all: all });
}
//# sourceMappingURL=makeActions.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.makeDataSelectors = makeDataSelectors;
function makeDataSelectors(options) {
    return {
        id: function id(item) {return item[options.id];} };

}
//# sourceMappingURL=makeDataSelectors.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends13 = __webpack_require__(24);

var _extends14 = _interopRequireDefault(_extends13);

exports.makeReducer = makeReducer;

var _es = __webpack_require__(1);

var _utils = __webpack_require__(156);

var _fields = __webpack_require__(503);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var requireId = function requireId(item) {
    if (!item) {
        throw new Error('Expecting item.');
    }
    var id = item[_fields.fields.id];

    if (!id) {
        throw new Error('Expecting id to be filled, use resource.create({ ... }) to create a new instance.');
    }
    return id;
};
var requireTempId = function requireTempId(item) {
    if (!item) {
        throw new Error('Expecting item.');
    }
    var tempId = item[_fields.fields.tempId];

    if (!tempId) {
        throw new Error('Expecting tempId to be filled, use resource.create({ ... }) to create a new instance.');
    }
    return tempId;
};
function makeReducer(descriptor) {
    var emptyState = {
        error: null,
        list: [],
        loading: false,
        params: null };

    var actions = descriptor.actions;

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
        var action = arguments[1];

        if ((0, _es.isType)(action, actions.CREATE)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends2;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _fields.fields.error, null), (0, _defineProperty3.default)(_extends2, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends2, _fields.fields.isCreating, { time: Date.now() }), _extends2));
                }) });

        } else if ((0, _es.isType)(action, actions.CREATE_SUCCESS)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends3;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, _fields.fields.error, null), (0, _defineProperty3.default)(_extends3, _fields.fields.isModified, false), (0, _defineProperty3.default)(_extends3, _fields.fields.isCreating, false), (0, _defineProperty3.default)(_extends3, _fields.fields.isCreated, { time: Date.now() }), _extends3));
                }) });

        } else if ((0, _es.isType)(action, actions.CREATE_FAILURE)) {
            requireTempId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends4;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends4 = {}, (0, _defineProperty3.default)(_extends4, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends4, _fields.fields.isCreating, false), _extends4));
                }) });

        } else if ((0, _es.isType)(action, actions.READ)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends5;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends5 = {}, (0, _defineProperty3.default)(_extends5, _fields.fields.error, null), (0, _defineProperty3.default)(_extends5, _fields.fields.isReading, false), _extends5));
                }) });

        } else if ((0, _es.isType)(action, actions.UPDATE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends6;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends6 = {}, (0, _defineProperty3.default)(_extends6, _fields.fields.error, null), (0, _defineProperty3.default)(_extends6, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends6, _fields.fields.isUpdating, { time: Date.now() }), _extends6));
                }) });

        } else if ((0, _es.isType)(action, actions.UPDATE_CANCEL)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _ref;

                    return _ref = {}, (0, _defineProperty3.default)(_ref, _fields.fields.error, null), (0, _defineProperty3.default)(_ref, _fields.fields.isUpdating, false), _ref;
                }) });

        } else if ((0, _es.isType)(action, actions.UPDATE_SUCCESS)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends7;

                    return (0, _extends14.default)({}, item, action.payload.item, (_extends7 = {}, (0, _defineProperty3.default)(_extends7, _fields.fields.error, null), (0, _defineProperty3.default)(_extends7, _fields.fields.isModified, false), (0, _defineProperty3.default)(_extends7, _fields.fields.isUpdating, false), (0, _defineProperty3.default)(_extends7, _fields.fields.isUpdated, { time: Date.now() }), _extends7));
                }) });

        } else if ((0, _es.isType)(action, actions.UPDATE_FAILURE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends8;

                    return (0, _extends14.default)({}, item, (_extends8 = {}, (0, _defineProperty3.default)(_extends8, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends8, _fields.fields.isUpdating, false), _extends8));
                }) });

        } else if ((0, _es.isType)(action, actions.DELETE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends9;

                    return (0, _extends14.default)({}, item, (_extends9 = {}, (0, _defineProperty3.default)(_extends9, _fields.fields.error, null), (0, _defineProperty3.default)(_extends9, _fields.fields.isModified, { time: Date.now() }), (0, _defineProperty3.default)(_extends9, _fields.fields.isRemoving, { time: Date.now() }), _extends9));
                }) });

        } else if ((0, _es.isType)(action, actions.DELETE_CANCEL)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends10;

                    return (0, _extends14.default)({}, item, (_extends10 = {}, (0, _defineProperty3.default)(_extends10, _fields.fields.error, null), (0, _defineProperty3.default)(_extends10, _fields.fields.isRemoving, false), _extends10));
                }) });

        } else if ((0, _es.isType)(action, actions.DELETE_SUCCESS)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listRemove)(descriptor, state.list, action.payload.item) });

        } else if ((0, _es.isType)(action, actions.DELETE_FAILURE)) {
            requireId(action.payload.item);
            return (0, _extends14.default)({}, state, {
                list: (0, _utils.listAddOrUpdate)(descriptor, state.list, action.payload.item, function (item) {
                    var _extends11;

                    return (0, _extends14.default)({}, item, (_extends11 = {}, (0, _defineProperty3.default)(_extends11, _fields.fields.error, action.payload.reason), (0, _defineProperty3.default)(_extends11, _fields.fields.isRemoving, false), _extends11));
                }) });

        } else if ((0, _es.isType)(action, actions.LIST)) {
            return (0, _extends14.default)({}, state, { loading: { time: Date.now() } });
        } else if ((0, _es.isType)(action, actions.LIST_CANCEL)) {
            return (0, _extends14.default)({}, state, { loading: false, error: null });
        } else if ((0, _es.isType)(action, actions.LIST_SUCCESS)) {
            return (0, _extends14.default)({}, state, {
                error: null,
                list: action.payload.list.map(function (item) {
                    return (0, _extends14.default)({}, item, (0, _defineProperty3.default)({}, _fields.fields.isRead, true));
                }),
                loading: false,
                params: action.payload.params });

        } else if ((0, _es.isType)(action, actions.LIST_FAILURE)) {
            return (0, _extends14.default)({}, state, { loading: false, error: Error(action.payload.reason) });
        } else if ((0, _es.isType)(action, actions.RESET)) {
            return (0, _extends14.default)({}, state, { loading: false, error: null, list: [], params: {} });
        }
        return state;
    };
}
//# sourceMappingURL=makeReducer.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(












noop);Object.defineProperty(exports, "__esModule", { value: true });exports.makeSaga = makeSaga;var _fsaSaga = __webpack_require__(59);var _effects = __webpack_require__(220);var _utils = __webpack_require__(156);function noop(param) {return _regenerator2.default.wrap(function noop$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:case 'end':return _context.stop();}}}, _marked, this);}
function makeSaga(descriptor) {
    var actions = [].concat((0, _toConsumableArray3.default)(descriptor.actions.all));

    for (var _len = arguments.length, middlewares = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        middlewares[_key - 1] = arguments[_key];
    }

    var f = (0, _utils.applyMiddlewares).apply(undefined, (0, _toConsumableArray3.default)(middlewares));
    return (/*#__PURE__*/_regenerator2.default.mark(function internal() {return _regenerator2.default.wrap(function internal$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                                (0, _fsaSaga.takeEvery)(actions, /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                                                        (0, _effects.fork)(function () {return f({ action: action, descriptor: descriptor }, noop);}));case 2:case 'end':return _context2.stop();}}}, _callee, this);})));case 2:case 'end':return _context3.stop();}}}, internal, this);}));


}
//# sourceMappingURL=makeSaga.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.buffers = exports.BUFFER_OVERFLOW = undefined;var _utils = __webpack_require__(242);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush };

}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  } };

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.throttle = exports.takeLatest = exports.takeEvery = undefined;var _isIterable2 = __webpack_require__(529);var _isIterable3 = _interopRequireDefault(_isIterable2);var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);exports.























































takeEveryHelper = takeEveryHelper;exports.
























takeLatestHelper = takeLatestHelper;exports.


































throttleHelper = throttleHelper;var _channel = __webpack_require__(507);var _utils = __webpack_require__(168);var _io = __webpack_require__(506);var _buffers = __webpack_require__(508);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _slicedToArray = function () {function sliceIterator(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"]) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}return function (arr, i) {if (Array.isArray(arr)) {return arr;} else if ((0, _isIterable3.default)(Object(arr))) {return sliceIterator(arr, i);} else {throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var done = { done: true, value: undefined };var qEnd = {};function fsmIterator(fsm, q0) {var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';var updateState = void 0,qNext = q0;function next(arg, error) {if (qNext === qEnd) {return done;}if (error) {qNext = qEnd;throw error;} else {updateState && updateState(arg);var _fsm$qNext = fsm[qNext](),_fsm$qNext2 = _slicedToArray(_fsm$qNext, 3),q = _fsm$qNext2[0],output = _fsm$qNext2[1],_updateState = _fsm$qNext2[2];qNext = q;updateState = _updateState;return qNext === qEnd ? done : output;}}return (0, _utils.makeIterator)(next, function (error) {return next(null, error);}, name, true);}function safeName(patternOrChannel) {if (_utils.is.channel(patternOrChannel)) {return 'channel';} else if (Array.isArray(patternOrChannel)) {return String(patternOrChannel.map(function (entry) {return String(entry);}));} else {return String(patternOrChannel);}}function takeEveryHelper(patternOrChannel, worker) {for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {args[_key - 2] = arguments[_key];}var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };var yFork = function yFork(ac) {return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };};var action = void 0,setAction = function setAction(ac) {return action = ac;};return fsmIterator({ q1: function q1() {return ['q2', yTake, setAction];}, q2: function q2() {return action === _channel.END ? [qEnd] : ['q1', yFork(action)];} }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');}function takeLatestHelper(patternOrChannel, worker) {for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {args[_key2 - 2] = arguments[_key2];}var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };var yFork = function yFork(ac) {return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };};var yCancel = function yCancel(task) {return { done: false, value: (0, _io.cancel)(task) };};var task = void 0,action = void 0;var setTask = function setTask(t) {return task = t;};var setAction = function setAction(ac) {return action = ac;};return fsmIterator({ q1: function q1() {return ['q2', yTake, setAction];}, q2: function q2() {return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];}, q3: function q3() {return ['q1', yFork(action), setTask];} }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');}function throttleHelper(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
  channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    } },
  'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}

var deprecationWarning = function deprecationWarning(helperName) {
  return 'import ' + helperName + ' from \'redux-saga\' has been deprecated in favor of import ' + helperName + ' from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};
var takeEvery = exports.takeEvery = (0, _utils.deprecate)(takeEveryHelper, deprecationWarning('takeEvery'));
var takeLatest = exports.takeLatest = (0, _utils.deprecate)(takeLatestHelper, deprecationWarning('takeLatest'));
var throttle = exports.throttle = (0, _utils.deprecate)(throttleHelper, deprecationWarning('throttle'));

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.



























asap = asap;exports.












suspend = suspend;exports.













flush = flush;var queue = []; /**
                                Variable to hold a counting semaphore
                                - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
                                  already suspended)
                                - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
                                  triggers flushing the queued tasks.
                              **/var semaphore = 0; /**
                                                      Executes a task 'atomically'. Tasks scheduled during this execution will be queued
                                                      and flushed after this task has finished (assuming the scheduler endup in a released
                                                      state).
                                                    **/function exec(task) {try {suspend();task();} finally {release();}} /**
                                                                                                                            Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
                                                                                                                          **/function asap(task) {queue.push(task);if (!semaphore) {suspend();flush();}} /**
                                                                                                                                                                                                           Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
                                                                                                                                                                                                           scheduler is released.
                                                                                                                                                                                                         **/function suspend() {semaphore++;} /**
                                                                                                                                                                                                                                                Puts the scheduler in a `released` state.
                                                                                                                                                                                                                                              **/function release() {semaphore--;} /**
                                                                                                                                                                                                                                                                                     Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
                                                                                                                                                                                                                                                                                   **/function flush() {release();var task = void 0;while (!semaphore && (task = queue.shift()) !== undefined) {exec(task);}}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.makeSelectors = makeSelectors;

__webpack_require__(76);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeSelectors(name, options, hasSameId) {
    var scope = function scope(state) {
        var s = state[name + 'Resource'];
        if (!s) {
            throw new Error('Register reducer of resource ' + name + ' in the store under: "' + name + 'Resource"');
        }
        return s;
    };
    return {
        error: function error(state) {return scope(state).error;},
        itemById: function itemById(id) {return function (state) {return scope(state).list.qFirst(function (item) {return hasSameId(item, (0, _defineProperty3.default)({}, options.id, id));});};},
        itemByItem: function itemByItem(item) {return function (state) {return scope(state).list.qFirst(function (existing) {return hasSameId(item, existing);});};},
        items: function items(state) {return scope(state).list;},
        loading: function loading(state) {return scope(state).loading;},
        params: function params(state) {return scope(state).params;} };

}
//# sourceMappingURL=makeSelectors.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault2(_regenerator);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(























FetchMiddleware),_marked2 = /*#__PURE__*/_regenerator2.default.mark(
























safeFetch);Object.defineProperty(exports, "__esModule", { value: true });var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);exports.FetchMiddleware = FetchMiddleware;var _isomorphicFetch = __webpack_require__(593);var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);var _effects = __webpack_require__(220);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function FetchMiddleware(_ref, next) {var request, response, paramKeys, params, baseUrl, url, result;return _regenerator2.default.wrap(function FetchMiddleware$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:request = _ref.request, response = _ref.response;paramKeys = (0, _keys2.default)(request.params);params = paramKeys.map(function (key) {return encodeURIComponent(key) + '=' + encodeURIComponent(request.params[key]);}).join('&');baseUrl = request.url;url = params ? baseUrl + '?' + params : baseUrl;_context.next = 7;return safeFetch(url, { body: request.body, credentials: request.credentials, headers: request.headers, method: request.method });case 7:result = _context.sent;response.statusText = result.statusText;response.statusCode = result.status;response.url = result.url;response.headers = headersToObject(result.headers);_context.prev = 12;_context.next = 15;return (0, _effects.call)(function () {return result.json();});case 15:response.body = _context.sent;_context.next = 21;break;case 18:_context.prev = 18;_context.t0 = _context['catch'](12);response.bodyError = _context.t0;case 21:return _context.delegateYield(next(), 't1', 22);case 22:case 'end':return _context.stop();}}}, _marked, this, [[12, 18]]);}function safeFetch(url, options) {return _regenerator2.default.wrap(function safeFetch$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.prev = 0;_context2.next = 3;return (

                        (0, _effects.call)(function () {return (0, _isomorphicFetch2.default)(url, options);}));case 3:return _context2.abrupt('return', _context2.sent);case 6:_context2.prev = 6;_context2.t0 = _context2['catch'](0);return _context2.abrupt('return',

                    {
                        statusCode: 0,
                        statusText: 'error' });case 9:case 'end':return _context2.stop();}}}, _marked2, this, [[0, 6]]);}



function headersToObject(headers) {
    if (headers.get && headers.keys) {
        var keys = headers.keys();
        var res = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                res[key] = headers.get(key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return res;
    }
    return headers;
}
//# sourceMappingURL=FetchMiddleware.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 // the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(832);
module.exports = self.fetch.bind(self);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });

exports.RestMiddleware = RestMiddleware;

var _RestErrors = __webpack_require__(838);

function RestMiddleware(options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function internal(context, next) {var request, response, list, create, read, update, remove;return _regenerator2.default.wrap(function internal$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                            request = context.request = {
                                body: undefined,
                                headers: {},
                                method: 'GET',
                                params: {},
                                url: '' + options.url };

                            response = context.response = {
                                body: undefined,
                                headers: {},
                                statusCode: undefined,
                                statusText: undefined,
                                url: undefined };

                            list = context.list,
                            create = context.create,
                            read = context.read,
                            update = context.update,
                            remove = context.remove;if (!

                            list) {_context.next = 13;break;}
                            request.method = 'GET';
                            request.url = '' + options.url;
                            request.params = list;return _context.delegateYield(
                            next(), 't0', 8);case 8:
                            context.ok = _RestErrors.RestErrors.list(response.statusCode) === false;
                            context.error = _RestErrors.RestErrors.list(response.statusCode);
                            context.listed = response.body;_context.next = 52;break;case 13:if (!
                            read) {_context.next = 22;break;}
                            request.method = 'GET';
                            request.url = options.url + '/' + read[options.id];return _context.delegateYield(
                            next(), 't1', 17);case 17:
                            context.ok = _RestErrors.RestErrors.read(response.statusCode) === false;
                            context.error = _RestErrors.RestErrors.read(response.statusCode);
                            context.readed = response.body;_context.next = 52;break;case 22:if (!
                            create) {_context.next = 32;break;}
                            request.method = 'POST';
                            request.url = '' + options.url;
                            request.body = create;return _context.delegateYield(
                            next(), 't2', 27);case 27:
                            context.ok = _RestErrors.RestErrors.create(response.statusCode) === false;
                            context.error = _RestErrors.RestErrors.create(response.statusCode);
                            context.created = response.body;_context.next = 52;break;case 32:if (!
                            update) {_context.next = 42;break;}
                            request.method = 'PUT';
                            request.url = options.url + '/' + update[options.id];
                            request.body = update;return _context.delegateYield(
                            next(), 't3', 37);case 37:
                            context.ok = _RestErrors.RestErrors.update(response.statusCode) === false;
                            context.error = _RestErrors.RestErrors.update(response.statusCode);
                            context.updated = response.body;_context.next = 52;break;case 42:if (!
                            remove) {_context.next = 51;break;}
                            request.method = 'DELETE';
                            request.url = options.url + '/' + remove[options.id];return _context.delegateYield(
                            next(), 't4', 46);case 46:
                            context.ok = _RestErrors.RestErrors.remove(response.statusCode) === false;
                            context.error = _RestErrors.RestErrors.remove(response.statusCode);
                            context.removed = response.body;_context.next = 52;break;case 51:throw (

                                new Error('Expecting list, create, read, update or remove'));case 52:case 'end':return _context.stop();}}}, internal, this);}));


}
//# sourceMappingURL=RestMiddleware.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault2(_regenerator);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault2(_typeof2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(














JsonTransportMiddleware);Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault(_stringify);exports.JsonTransportMiddleware = JsonTransportMiddleware;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var http204 = 204;function JsonTransportMiddleware(_ref, next) {var request, response;return _regenerator2.default.wrap(function JsonTransportMiddleware$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    request = _ref.request,
                    response = _ref.response;

                    request.headers.accept = 'application/json';
                    if (request.body) {
                        request.headers['content-type'] = 'application/json';
                        request.body = (0, _stringify2.default)(request.body);
                    }return _context.delegateYield(
                    next(), 't0', 4);case 4:
                    if (response.statusCode === http204) {} else {
                        if (/^application\/json/.test(response.headers['content-type'])) {
                            if ((0, _typeof3.default)(response.body) !== 'object' && response.body !== undefined) {
                                response.body = JSON.parse(response.body);
                            }
                        }
                    }case 5:case 'end':return _context.stop();}}}, _marked, this);}

//# sourceMappingURL=JsonTransportMiddleware.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;var _runSaga = __webpack_require__(597);Object.defineProperty(exports, 'runSaga', { enumerable: true, get: function get() {return _runSaga.


    runSaga;} });var _channel = __webpack_require__(510);Object.defineProperty(exports, 'END', { enumerable: true, get: function get() {return _channel.
    END;} });Object.defineProperty(exports, 'eventChannel', { enumerable: true, get: function get() {return _channel.eventChannel;} });Object.defineProperty(exports, 'channel', { enumerable: true, get: function get() {return _channel.channel;} });var _buffers = __webpack_require__(511);Object.defineProperty(exports, 'buffers', { enumerable: true, get: function get() {return _buffers.
    buffers;} });var _sagaHelpers = __webpack_require__(600);Object.defineProperty(exports, 'takeEvery', { enumerable: true, get: function get() {return _sagaHelpers.
    takeEvery;} });Object.defineProperty(exports, 'takeLatest', { enumerable: true, get: function get() {return _sagaHelpers.takeLatest;} });Object.defineProperty(exports, 'throttle', { enumerable: true, get: function get() {return _sagaHelpers.throttle;} });var _utils = __webpack_require__(169);Object.defineProperty(exports, 'delay', { enumerable: true, get: function get() {return _utils.
    delay;} });Object.defineProperty(exports, 'CANCEL', { enumerable: true, get: function get() {return _utils.CANCEL;} });var _middleware = __webpack_require__(841);var _middleware2 = _interopRequireDefault(_middleware);

var _effects = __webpack_require__(170);var effects = _interopRequireWildcard(_effects);
var _utils2 = __webpack_require__(842);var utils = _interopRequireWildcard(_utils2);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = _middleware2.default;exports.

effects = effects;exports.utils = utils;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.





runSaga = runSaga;var _utils = __webpack_require__(169);var _proc = __webpack_require__(598);var _proc2 = _interopRequireDefault(_proc);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (_utils.is.iterator(storeInterface)) {
    if (false) {
      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
  subscribe = _storeInterface.subscribe,
  dispatch = _storeInterface.dispatch,
  getState = _storeInterface.getState,
  context = _storeInterface.context,
  sagaMonitor = _storeInterface.sagaMonitor,
  logger = _storeInterface.logger,
  onError = _storeInterface.onError;


  var effectId = (0, _utils.uid)();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.default =


















































































































































































proc;var _utils = __webpack_require__(169);var _scheduler = __webpack_require__(599);var _io = __webpack_require__(509);var _channel = __webpack_require__(510);var _buffers = __webpack_require__(511);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};function _defineEnumerableProperties(obj, descs) {for (var key in descs) {var desc = descs[key];desc.configurable = desc.enumerable = true;if ("value" in desc) desc.writable = true;(0, _defineProperty2.default)(obj, key, desc);}return obj;}var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';var CHANNEL_END = exports.CHANNEL_END = { toString: function toString() {return '@@redux-saga/CHANNEL_END';} };var TASK_CANCEL = exports.TASK_CANCEL = { toString: function toString() {return '@@redux-saga/TASK_CANCEL';} };var matchers = { wildcard: function wildcard() {return _utils.kTrue;}, default: function _default(pattern) {return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {return input.type === pattern;} : function (input) {return input.type === String(pattern);};}, array: function array(patterns) {return function (input) {return patterns.some(function (p) {return matcher(p)(input);});};}, predicate: function predicate(_predicate) {return function (input) {return _predicate(input);};} };function matcher(pattern) {return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Used to track a parent task and its forks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     In the new fork model, forked tasks are attached by default to their parent
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     We model this using the concept of Parent task && main Task
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     main task is the main flow of the current Generator, the parent tasks is the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     aggregation of the main tasks + all its forked tasks.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     Thus the whole model represents an execution tree with multiple branches (vs the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     linear execution tree in sequential (non parallel) programming)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     A parent tasks has the following semantics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     - It completes if all its forks either complete or all cancelled
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     - If it's cancelled, all forks are cancelled as well
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     - It aborts if any uncaught error bubbles up from forks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     - If it completes, the return value is the one returned by the main task
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   **/function forkQueue(name, mainTask, cb) {var tasks = [],result = void 0,completed = false;addTask(mainTask);function abort(err) {cancelAll();cb(err, true);}function addTask(task) {tasks.push(task);task.cont = function (res, isErr) {if (completed) {return;}(0, _utils.remove)(tasks, task);task.cont = _utils.noop;if (isErr) {abort(res);} else {if (task === mainTask) {result = res;}if (!tasks.length) {completed = true;cb(result);}}}; // task.cont.cancel = task.cancel
  }function cancelAll() {if (completed) {return;}completed = true;tasks.forEach(function (t) {t.cont = _utils.noop;t.cancel();});tasks = [];}return { addTask: addTask, cancelAll: cancelAll, abort: abort, getTasks: function getTasks() {return tasks;}, taskNames: function taskNames() {return tasks.map(function (t) {return t.name;});} };}function createTaskIterator(_ref) {var context = _ref.context,fn = _ref.fn,args = _ref.args;if (_utils.is.iterator(fn)) {return fn;} // catch synchronous failures; see #152 and #441
  var result = void 0,error = void 0;try {result = fn.apply(context, args);} catch (err) {error = err;} // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {return result;} // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {throw error;}) : (0, _utils.makeIterator)(function () {var pc = void 0;var eff = { done: false, value: result };var ret = function ret(value) {return { done: true, value: value };};return function (arg) {if (!pc) {pc = true;return eff;} else {return ret(arg);}};}());}var wrapHelper = function wrapHelper(helper) {return { fn: helper };};function proc(iterator) {var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {return _utils.noop;};var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';var cont = arguments[8];(0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);var effectsString = '[...effects]';var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));var sagaMonitor = options.sagaMonitor,logger = options.logger,onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  var taskContext = (0, _create2.default)(parentContext);
  /**
                                                            Tracks the current effect cancellation
                                                            Each time the generator progresses. calling runEffect will set a new value
                                                            on it. It allows propagating cancellation to child effects
                                                          **/
  next.cancel = _utils.noop;

  /**
                               Creates a new task descriptor for this generator, We'll also create a main task
                               to track the main flow (besides other forked tasks)
                             **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
                                                    cancellation of the main task. We'll simply resume the Generator with a Cancel
                                                  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
      This may be called by a parent generator to trigger/propagate cancellation
      cancel all pending tasks (including the main task), then end the current task.
       Cancellation propagates down to the whole execution tree holded by this Parent task
      It's also propagated to all joiners of this task and their execution tree/joiners
       Cancellation is noop for terminated/Cancelled tasks tasks
    **/
  function cancel() {
    /**
                       We need to check both Running and Cancelled status
                       Tasks can be Cancelled but still Running
                     **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
                               Ending with a Never result will propagate the Cancellation to all joiners
                             **/
      end(TASK_CANCEL);
    }
  }
  /**
      attaches cancellation logic to this task's continuation
      this will permit cancellation to propagate down the call chain
    **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
                 This is the generator driver
                 It's a recursive async/continuation function which calls itself
                 until the generator terminates or throws
               **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
                                         getting TASK_CANCEL automatically cancels the main task
                                         We can get this value here
                                          - By cancelling the parent task manually
                                         - By joining a Cancelled task
                                       **/
        mainTask.isCancelled = true;
        /**
                                       Cancels the current effect; this will propagate the cancellation down to any called tasks
                                     **/
        next.cancel();
        /**
                         If this Generator has a `return` method then invokes it
                         This will jump to the finally block
                       **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
                This Generator has ended, terminate the main task and notify the fork queue
              **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (false) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = (0, _utils.uid)();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
                                                                                                                                        completion callback and cancel callback are mutually exclusive
                                                                                                                                        We can't cancel an already completed effect
                                                                                                                                        And We can't complete an already cancelled effectId
                                                                                                                                      **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
                              propagates cancel downward
                              catch uncaught cancellations errors; since we can no longer call the completion
                              callback, log errors raised during cancellations into the console
                            **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
         each effect runner must attach its own logic of cancellation to the provided callback
         it allows this generator to propagate cancellation downward.
          ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
         And the setup must occur before calling the callback
          This is a sort of inversion of control: called async functions are responsible
         for completing the flow by calling the provided continuation; while caller functions
         are responsible for aborting the current flow by calling the attached cancel function
          Library users can attach their own cancellation logic to promises by defining a
         promise[CANCEL] method in their returned promises
         ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
       **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is        */currCb(effect));

  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
    pattern = _ref2.pattern,
    maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
    action = _ref3.action,
    resolve = _ref3.resolve;

    /**
                               Schedule the put in case another saga is holding a lock.
                               The put will be executed atomically. ie nested puts will execute after
                               this put has terminated.
                             **/
    (0, _scheduler.asap)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (resolve && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
    fn = _ref4.fn,
    args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
    fn = _ref5.fn,
    args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return _utils.is.undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
    fn = _ref6.fn,
    args = _ref6.args,
    detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      (0, _scheduler.suspend)();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      (0, _scheduler.flush)();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return (0, _utils.remove)(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === _utils.SELF_CANCELLATION) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = (0, _keys2.default)(effects);

    if (!keys.length) {
      return cb(_utils.is.array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = (0, _keys2.default)(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _cb;

          cb.cancel();
          completed = true;
          cb((_cb = {}, _cb[key] = res, _cb));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
    args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
    buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    _utils.object.assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
      _utils.object.assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.



























asap = asap;exports.












suspend = suspend;exports.













flush = flush;var queue = []; /**
                                Variable to hold a counting semaphore
                                - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
                                  already suspended)
                                - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
                                  triggers flushing the queued tasks.
                              **/var semaphore = 0; /**
                                                      Executes a task 'atomically'. Tasks scheduled during this execution will be queued
                                                      and flushed after this task has finished (assuming the scheduler endup in a released
                                                      state).
                                                    **/function exec(task) {try {suspend();task();} finally {release();}} /**
                                                                                                                            Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
                                                                                                                          **/function asap(task) {queue.push(task);if (!semaphore) {suspend();flush();}} /**
                                                                                                                                                                                                           Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
                                                                                                                                                                                                           scheduler is released.
                                                                                                                                                                                                         **/function suspend() {semaphore++;} /**
                                                                                                                                                                                                                                                Puts the scheduler in a `released` state.
                                                                                                                                                                                                                                              **/function release() {semaphore--;} /**
                                                                                                                                                                                                                                                                                     Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
                                                                                                                                                                                                                                                                                   **/function flush() {release();var task = void 0;while (!semaphore && (task = queue.shift()) !== undefined) {exec(task);}}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.throttle = exports.takeLatest = exports.takeEvery = undefined;exports.




















































takeEveryHelper = takeEveryHelper;exports.
























takeLatestHelper = takeLatestHelper;exports.


































throttleHelper = throttleHelper;var _channel = __webpack_require__(510);var _utils = __webpack_require__(169);var _io = __webpack_require__(509);var _buffers = __webpack_require__(511);var done = { done: true, value: undefined };var qEnd = {};function fsmIterator(fsm, q0) {var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';var updateState = void 0,qNext = q0;function next(arg, error) {if (qNext === qEnd) {return done;}if (error) {qNext = qEnd;throw error;} else {updateState && updateState(arg);var _fsm$qNext = fsm[qNext](),q = _fsm$qNext[0],output = _fsm$qNext[1],_updateState = _fsm$qNext[2];qNext = q;updateState = _updateState;return qNext === qEnd ? done : output;}}return (0, _utils.makeIterator)(next, function (error) {return next(null, error);}, name, true);}function safeName(patternOrChannel) {if (_utils.is.channel(patternOrChannel)) {return 'channel';} else if (Array.isArray(patternOrChannel)) {return String(patternOrChannel.map(function (entry) {return String(entry);}));} else {return String(patternOrChannel);}}function takeEveryHelper(patternOrChannel, worker) {for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {args[_key - 2] = arguments[_key];}var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };var yFork = function yFork(ac) {return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };};var action = void 0,setAction = function setAction(ac) {return action = ac;};return fsmIterator({ q1: function q1() {return ['q2', yTake, setAction];}, q2: function q2() {return action === _channel.END ? [qEnd] : ['q1', yFork(action)];} }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');}function takeLatestHelper(patternOrChannel, worker) {for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {args[_key2 - 2] = arguments[_key2];}var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };var yFork = function yFork(ac) {return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };};var yCancel = function yCancel(task) {return { done: false, value: (0, _io.cancel)(task) };};var task = void 0,action = void 0;var setTask = function setTask(t) {return task = t;};var setAction = function setAction(ac) {return action = ac;};return fsmIterator({ q1: function q1() {return ['q2', yTake, setAction];}, q2: function q2() {return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];}, q3: function q3() {return ['q1', yFork(action), setTask];} }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');}function throttleHelper(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
  channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    } },
  'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}

var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};
var takeEvery = exports.takeEvery = (0, _utils.deprecate)(takeEveryHelper, deprecationWarning('takeEvery'));
var takeLatest = exports.takeLatest = (0, _utils.deprecate)(takeLatestHelper, deprecationWarning('takeLatest'));
var throttle = exports.throttle = (0, _utils.deprecate)(throttleHelper, deprecationWarning('throttle'));

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _ACCOUNDMANAGER = __webpack_require__(581);var _ACCOUNDMANAGER2 = _interopRequireDefault(_ACCOUNDMANAGER);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var selector = exports.selector = function selector(state) {return state.auth;};exports.default =
function () {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { accessToken: null, user: {}, accountmanager: false };var action = arguments[1];
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { accessToken: null, user: {} });
    }
    if ((0, _fsa.isType)(action, _AUTHENTICATED2.default)) {
        return (0, _extends3.default)({}, state, { accessToken: action.payload.token, user: action.payload.user });
    }
    if ((0, _fsa.isType)(action, _ACCOUNDMANAGER2.default)) {
        return (0, _extends3.default)({}, state, { accountmanager: action.payload.accountmanager });
    }
    return state;
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.NodeTextPosition = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _IEInsanity = __webpack_require__(845);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
NodeTextPosition = exports.NodeTextPosition = function () {
    function NodeTextPosition(container, offset) {(0, _classCallCheck3.default)(this, NodeTextPosition);
        this.container = container;
        this.offset = offset;
    }(0, _createClass3.default)(NodeTextPosition, null, [{ key: 'fromPoint', value: function fromPoint(
        x, y) {
            if (x || y) {
                return getCursorPointByCaretPositionFromPoint(x, y) ||
                getCursorPointByCaretRangeFromPoint(x, y) ||
                getCursorPointByIETextRangeFromPoint(x, y);
            }
        } }]);return NodeTextPosition;}();

function scrollX() {
    if (window.scrollX) {
        return window.scrollX;
    }
    if (window.document.documentElement.scrollLeft) {
        return window.document.documentElement.scrollLeft;
    }
    return 0;
}
function scrollY() {
    if (window.scrollY) {
        return window.scrollY;
    }
    if (window.document.documentElement.scrollTop) {
        return window.document.documentElement.scrollTop;
    }
    return 0;
}
function getCursorPointByCaretPositionFromPoint(x, y) {
    if (document.caretPositionFromPoint) {
        var pos = document.caretPositionFromPoint(x - scrollX(), y - scrollY());
        if (pos) {
            return new NodeTextPosition(pos.offsetNode, pos.offset);
        }
    }
}
function getCursorPointByCaretRangeFromPoint(x, y) {
    if (document.caretRangeFromPoint) {
        var pos = document.caretRangeFromPoint(x - scrollX(), y - scrollY());
        if (pos) {
            return new NodeTextPosition(pos.startContainer, pos.startOffset);
        }
    }
}
function getCursorPointByIETextRangeFromPoint(pageX, pageY) {
    if (document.body.createTextRange && pageX > 0 && pageY > 0) {
        try {
            var viewX = pageX - scrollX();
            var viewY = pageY - scrollY();
            var find = new _IEInsanity.IEInsanity(viewX, viewY);
            var rough = find.calcTextPositionRough();
            if (!rough) {
                return;
            }
            var exact = find.calcTextPositionExact(rough.offset);
            return exact;
        }
        catch (ex) {
            console.error('DOMOP: Problem resolving IE fallback text position ' + pageX + ':' + pageY + ', due to "' + ex.message + '"');
        }
    }
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.AnchorNode = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _domUtils = __webpack_require__(532);
var _findClosestAnchorNode = __webpack_require__(605);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
AnchorNode = exports.AnchorNode = function () {
    function AnchorNode(parent, node, children) {(0, _classCallCheck3.default)(this, AnchorNode);
        this.parent = parent;
        this.node = node;
        this.children = children;
        this._identifier = '';
        this._index = -1;
        this._documentContent = -1;
    }(0, _createClass3.default)(AnchorNode, [{ key: 'all', value: function all()
        {
            var results = [];
            var nodeCurrent = this;
            var idxChild = 0;
            for (;;) {
                results.push(nodeCurrent);
                for (; nodeCurrent !== this && idxChild >= nodeCurrent.children.length; nodeCurrent = nodeCurrent.parent) {
                    idxChild = nodeCurrent.parent.children.indexOf(nodeCurrent) + 1;
                }
                if (idxChild >= nodeCurrent.children.length) {
                    break;
                }
                nodeCurrent = nodeCurrent.children[idxChild];
                idxChild = 0;
            }
            return results;
        } }, { key: 'findClosestByNode', value: function findClosestByNode(
        node) {
            return this.findByNode((0, _findClosestAnchorNode.findClosestAnchorNode)(node));
        } }, { key: 'findByNode', value: function findByNode(
        node) {
            if (!node) {
                return;
            }
            var nodeCurrent = this;
            var idxChild = 0;
            for (;;) {
                if (nodeCurrent.node === node) {
                    return nodeCurrent;
                }
                for (; nodeCurrent !== this && idxChild >= nodeCurrent.children.length; nodeCurrent = nodeCurrent.parent) {
                    idxChild = nodeCurrent.parent.children.indexOf(nodeCurrent) + 1;
                }
                if (idxChild >= nodeCurrent.children.length) {
                    break;
                }
                nodeCurrent = nodeCurrent.children[idxChild];
                idxChild = 0;
            }
        } }, { key: 'selfOrAncestorDocumentContent', value: function selfOrAncestorDocumentContent()
        {
            for (var node = this; node; node = node.parent) {
                if (node.documentContent) {
                    return node;
                }
            }
        } }, { key: 'hasIdenticalSiblings', value: function hasIdenticalSiblings()
















        {var _this = this;
            return !this.parent ?
            false :
            this.parent.children.some(function (cur) {return cur.identifier === _this.identifier && cur !== _this;});
        } }, { key: 'selectorId', value: function selectorId()











        {return this.node.id && '#' + this.node.id;} }, { key: 'selectorCss', value: function selectorCss()
        {return this.node.className && '.' + this.node.className.replace(/[ ]+/g, '.');} }, { key: 'selectorName', value: function selectorName()
        {return this.node.localName;} }, { key: 'selectorNum', value: function selectorNum()
        {
            var counter = 0;
            for (var i = 0, ii = this.parent.children.length; i < ii; i++) {
                if (this.parent.children[i] === this) {
                    return counter + 1;
                }
                if (this.parent.children[i].identifier === this.identifier) {
                    counter++;
                }
            }
            throw new Error('selectorNum unable to find parent-child');
        } }, { key: 'documentContent', get: function get() {return this._documentContent !== -1 ? this._documentContent === 1 : (this._documentContent = (0, _domUtils.isDocumentContent)(this.node) ? 1 : 0) === 1;} }, { key: 'num', get: function get() {if (this._index !== -1) {return this._index;} else if (!this.parent) {return this._index = 1;} else {return this._index = this.selectorNum();}} }, { key: 'identifier', get: function get() {return this._identifier !== '' ? this._identifier : this._identifier = this.selectorId() || this.selectorCss() || this.selectorName() || 'unknown';} }, { key: 'path', get: function get() {if (this.hasIdenticalSiblings()) {return '' + (this.identifier[0] !== '#' && this.parent ? this.parent.path + '/' : '') + this.identifier + '[' + this.num + ']';} else {return '' + (this.identifier[0] !== '#' && this.parent ? this.parent.path + '/' : '') + this.identifier;}} }]);return AnchorNode;}();

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var Settings = exports.Settings = {
    selectorDocumentContent: '.document-content, .blockContent',
    selectorStructure: 'body, .document-content, .blockContent, [id]:not([id^=dx-])' };

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.findClosestAnchorNode = undefined;var _domUtils = __webpack_require__(532);
var findClosestAnchorNode = exports.findClosestAnchorNode = function findClosestAnchorNode(node) {var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    for (; node && node !== stop; node = node.parentNode) {
        if ((0, _domUtils.isAnchor)(node)) {
            return node;
        }
    }
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getAnchorFromDocument = undefined;var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);var _AnchorNode = __webpack_require__(603);
var _config = __webpack_require__(604);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var findIndexOfNode = function findIndexOfNode(node, list, max) {
    for (node = node.parentNode; node; node = node.parentNode) {
        for (var i = 0; i < max; i++) {
            if (list[i] === node) {
                return i;
            }
        }
    }
    return -1;
};
var getAnchorFromDocument = exports.getAnchorFromDocument = function getAnchorFromDocument() {
    var nodes = (0, _from2.default)(document.querySelectorAll(_config.Settings.selectorStructure));
    var entries = [];
    var result = [];
    for (var i = 0, ii = nodes.length; i < ii; i++) {
        var idxParent = findIndexOfNode(nodes[i], nodes, i);
        var parent = idxParent === -1 ? null : entries[idxParent];
        var current = new _AnchorNode.AnchorNode(parent, nodes[i], []);
        if (current.parent) {
            current.parent.children.push(current);
            entries.push(current);
        } else
        {
            result.push(current);
            entries.push(current);
        }
    }
    if (result.length > 1) {
        console.warn('[NoteService] searchNodes result > 1');
    }
    return result[0];
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.clipSelectionRange = undefined;var _domop = __webpack_require__(160);
var _getTextLengthByNode = __webpack_require__(852);
var _RangeInternal = __webpack_require__(534);
var clipSelectionRange = exports.clipSelectionRange = function clipSelectionRange(root, range) {
    var startContainer = void 0;
    var startOffset = void 0;
    var endContainer = void 0;
    var endOffset = void 0;
    var startContainerSearch = range.startContainer;
    var startOffsetSearch = range.startOffset;
    for (; startContainerSearch;) {
        var anchorStart = root.findClosestByNode(startContainerSearch);
        if (anchorStart && anchorStart.selfOrAncestorDocumentContent()) {
            startContainer = startContainerSearch;
            startOffset = startOffsetSearch;
            break;
        }
        startContainerSearch = (0, _domop.nextNode)(startContainerSearch);
        startOffsetSearch = 0;
    }
    var endContainerSearch = range.endContainer;
    var endOffsetSearch = range.endOffset;
    for (; endContainerSearch;) {
        var anchorEnd = root.findClosestByNode(endContainerSearch);
        if (anchorEnd && anchorEnd.selfOrAncestorDocumentContent()) {
            endContainer = endContainerSearch;
            endOffset = endOffsetSearch;
            break;
        }
        endContainerSearch = (0, _domop.prevNode)(endContainerSearch);
        endOffsetSearch = (0, _getTextLengthByNode.getTextLengthByNode)(endContainerSearch);
    }
    if (startContainerSearch && endContainerSearch) {
        return new _RangeInternal.RangeInternal(startContainerSearch, startOffsetSearch, endContainerSearch, endOffsetSearch);
    }
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.


getSelectionRangeDetail = getSelectionRangeDetail;var _isContainerFirst = __webpack_require__(857);var _NodeTextNavigation = __webpack_require__(231);var _resolvePathWithOffset = __webpack_require__(243);function getSelectionRangeDetail(root, start, end) {
    var matchStart = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, start);
    if (!matchStart) {
        return null;
    }
    var matchEnd = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, end);
    if (!matchEnd) {
        return null;
    }
    var textStart = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).domNode();
    var textEnd = new _NodeTextNavigation.NodeTextNavigation(matchEnd.anchor.node).forward(matchEnd.offset).domNode();
    var offsetStart = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).countBackwards(textStart);
    var offsetEnd = new _NodeTextNavigation.NodeTextNavigation(matchEnd.anchor.node).forward(matchEnd.offset).countBackwards(textEnd);
    var isStartToEnd = (0, _isContainerFirst.isContainerFirst)(textStart, offsetStart, textEnd, offsetEnd);
    return isStartToEnd ?
    {
        offsetEnd: offsetEnd,
        offsetStart: offsetStart,
        textEnd: textEnd,
        textStart: textStart } :

    {
        offsetEnd: offsetStart,
        offsetStart: offsetEnd,
        textEnd: textStart,
        textStart: textEnd };

}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_INIT');

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('STOP_CHAT');

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_CHANGE_STATUS_BATCH_COMPLETE');

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_DELETE_BATCH_FAILURE');

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANT_SELECT_HIDE');

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _CATEGORIES = __webpack_require__(716);var _CATEGORIES2 = _interopRequireDefault(_CATEGORIES);
var _HIDE = __webpack_require__(873);var _HIDE2 = _interopRequireDefault(_HIDE);
var _KINDS = __webpack_require__(874);var _KINDS2 = _interopRequireDefault(_KINDS);
var _ORIGINS = __webpack_require__(717);var _ORIGINS2 = _interopRequireDefault(_ORIGINS);
var _PARTICIPANTGROUPS = __webpack_require__(718);var _PARTICIPANTGROUPS2 = _interopRequireDefault(_PARTICIPANTGROUPS);
var _PARTICIPANTS = __webpack_require__(719);var _PARTICIPANTS2 = _interopRequireDefault(_PARTICIPANTS);
var _REMOVEALL = __webpack_require__(697);var _REMOVEALL2 = _interopRequireDefault(_REMOVEALL);
var _REMOVEALL_ALL_CATEGORIES = __webpack_require__(720);var _REMOVEALL_ALL_CATEGORIES2 = _interopRequireDefault(_REMOVEALL_ALL_CATEGORIES);
var _REMOVEALL_ALL_GROUPS = __webpack_require__(721);var _REMOVEALL_ALL_GROUPS2 = _interopRequireDefault(_REMOVEALL_ALL_GROUPS);
var _REMOVE_ALL_KINDS = __webpack_require__(722);var _REMOVE_ALL_KINDS2 = _interopRequireDefault(_REMOVE_ALL_KINDS);
var _REMOVE_ALL_ORIGINS = __webpack_require__(723);var _REMOVE_ALL_ORIGINS2 = _interopRequireDefault(_REMOVE_ALL_ORIGINS);
var _REMOVE_ALL_PARTICIPANTS = __webpack_require__(724);var _REMOVE_ALL_PARTICIPANTS2 = _interopRequireDefault(_REMOVE_ALL_PARTICIPANTS);
var _SHOW = __webpack_require__(875);var _SHOW2 = _interopRequireDefault(_SHOW);
var _SORT = __webpack_require__(725);var _SORT2 = _interopRequireDefault(_SORT);
var _TERM = __webpack_require__(726);var _TERM2 = _interopRequireDefault(_TERM);
var _STATUSES = __webpack_require__(727);var _STATUSES2 = _interopRequireDefault(_STATUSES);
var _FACTIONGROUPS = __webpack_require__(728);var _FACTIONGROUPS2 = _interopRequireDefault(_FACTIONGROUPS);
var _REMOVE_ALL_FACTIONS = __webpack_require__(729);var _REMOVE_ALL_FACTIONS2 = _interopRequireDefault(_REMOVE_ALL_FACTIONS);
var _REMOVE_ALL_STATUSES = __webpack_require__(730);var _REMOVE_ALL_STATUSES2 = _interopRequireDefault(_REMOVE_ALL_STATUSES);
var _REMOVE_ALL_STATUSES_AND_FACTIONS = __webpack_require__(731);var _REMOVE_ALL_STATUSES_AND_FACTIONS2 = _interopRequireDefault(_REMOVE_ALL_STATUSES_AND_FACTIONS);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = { visible: false, categories: [], kinds: [], origins: [], statuses: [], participants: [], participantgroups: [], factiongroups: [], sorting: 'createdAsc', searchTerm: '', userId: '' };
var selector = exports.selector = function selector(state) {return state.filter;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _TERM2.default)) {
        return (0, _extends3.default)({}, state, { searchTerm: action.payload.searchTerm });
    }
    if ((0, _fsa.isType)(action, _SORT2.default)) {
        return (0, _extends3.default)({}, state, { sorting: action.payload.sorting });
    }
    if ((0, _fsa.isType)(action, _CATEGORIES2.default)) {
        return (0, _extends3.default)({}, state, { categories: action.payload.categories });
    }
    if ((0, _fsa.isType)(action, _KINDS2.default)) {
        return (0, _extends3.default)({}, state, { kinds: action.payload.kinds });
    }
    if ((0, _fsa.isType)(action, _ORIGINS2.default)) {
        return (0, _extends3.default)({}, state, { origins: action.payload.origins });
    }
    if ((0, _fsa.isType)(action, _STATUSES2.default)) {
        return (0, _extends3.default)({}, state, { statuses: action.payload.statuses });
    }
    if ((0, _fsa.isType)(action, _PARTICIPANTS2.default)) {
        return (0, _extends3.default)({}, state, { participants: action.payload.participants });
    }
    if ((0, _fsa.isType)(action, _PARTICIPANTGROUPS2.default)) {
        return (0, _extends3.default)({}, state, { participantgroups: action.payload.participantgroups });
    }
    if ((0, _fsa.isType)(action, _FACTIONGROUPS2.default)) {
        return (0, _extends3.default)({}, state, { factiongroups: action.payload.factiongroups });
    }
    if ((0, _fsa.isType)(action, _REMOVEALL2.default)) {
        return (0, _extends3.default)({}, state, {
            searchTerm: '',
            categories: [],
            kinds: [],
            origins: [],
            participants: undefined,
            participantgroups: undefined });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_STATUSES_AND_FACTIONS2.default)) {
        return (0, _extends3.default)({}, state, {
            statuses: [],
            factiongroups: undefined });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_STATUSES2.default)) {
        return (0, _extends3.default)({}, state, {
            statuses: [] });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_KINDS2.default)) {
        return (0, _extends3.default)({}, state, {
            kinds: [] });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_ORIGINS2.default)) {
        return (0, _extends3.default)({}, state, {
            origins: [] });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_PARTICIPANTS2.default)) {
        return (0, _extends3.default)({}, state, {
            participants: undefined });

    }
    if ((0, _fsa.isType)(action, _REMOVEALL_ALL_GROUPS2.default)) {
        return (0, _extends3.default)({}, state, {
            participantgroups: undefined });

    }
    if ((0, _fsa.isType)(action, _REMOVE_ALL_FACTIONS2.default)) {
        return (0, _extends3.default)({}, state, {
            factiongroups: undefined });

    }
    if ((0, _fsa.isType)(action, _REMOVEALL_ALL_CATEGORIES2.default)) {
        return (0, _extends3.default)({}, state, {
            categories: [] });

    }
    return state;
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.CLEAR = exports.MISSING = exports.FOUND = undefined;var _fsa = __webpack_require__(1);
var FOUND = exports.FOUND = (0, _fsa.Factory)('NOTE_LOCATOR_FOUND');
var MISSING = exports.MISSING = (0, _fsa.Factory)('NOTE_LOCATOR_MISSING');
var CLEAR = exports.CLEAR = (0, _fsa.Factory)('NOTE_LOCATOR_CLEAR');

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTEMENU_HIDE');

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTEMENU_SHOW');

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('RELEASE_BUTTON_LOCK');

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _READY = __webpack_require__(512);var _READY2 = _interopRequireDefault(_READY);
var _CHANGE_CATEGORY = __webpack_require__(620);var _CHANGE_CATEGORY2 = _interopRequireDefault(_CHANGE_CATEGORY);
var _CHANGE_SORTING = __webpack_require__(621);var _CHANGE_SORTING2 = _interopRequireDefault(_CHANGE_SORTING);
var _HIDE = __webpack_require__(733);var _HIDE2 = _interopRequireDefault(_HIDE);
var _SHOW = __webpack_require__(560);var _SHOW2 = _interopRequireDefault(_SHOW);
var _PAGEFILTER_TOGGLE_CATEGORY = __webpack_require__(622);var _PAGEFILTER_TOGGLE_CATEGORY2 = _interopRequireDefault(_PAGEFILTER_TOGGLE_CATEGORY);
var _PAGEFILTER_TOGGLE_SORTING = __webpack_require__(623);var _PAGEFILTER_TOGGLE_SORTING2 = _interopRequireDefault(_PAGEFILTER_TOGGLE_SORTING);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    categoryId: undefined,
    categoryvisible: false,
    sorting: 'createdDesc',
    visible: false };

var selector = exports.selector = function selector(state) {return state.pageFilter;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _CHANGE_CATEGORY2.default)) {
        return (0, _extends3.default)({}, state, { categoryId: action.payload.categoryId });
    }
    if ((0, _fsa.isType)(action, _PAGEFILTER_TOGGLE_CATEGORY2.default)) {
        return (0, _extends3.default)({}, state, { categoryId: action.payload.categoryId });
    }
    if ((0, _fsa.isType)(action, _CHANGE_SORTING2.default)) {
        return (0, _extends3.default)({}, state, { sorting: action.payload.sorting });
    }
    if ((0, _fsa.isType)(action, _PAGEFILTER_TOGGLE_SORTING2.default)) {
        return (0, _extends3.default)({}, state, { sorting: action.payload.sorting });
    }
    if ((0, _fsa.isType)(action, _READY2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    return state;
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_CHANGE_CATEGORY');

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_CHANGE_SORTING');

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_TOGGLE_CATEGORY');

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_TOGGLE_SORTING');

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _CHANGE = __webpack_require__(625);var _CHANGE2 = _interopRequireDefault(_CHANGE);
var _REQUEST = __webpack_require__(500);var _REQUEST2 = _interopRequireDefault(_REQUEST);
var _RESET = __webpack_require__(249);var _RESET2 = _interopRequireDefault(_RESET);
var _SUCCESS = __webpack_require__(501);var _SUCCESS2 = _interopRequireDefault(_SUCCESS);
var _CHANGE_ISNOTE = __webpack_require__(734);var _CHANGE_ISNOTE2 = _interopRequireDefault(_CHANGE_ISNOTE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = { creating: false, selection: null, isnote: true };
var selector = exports.selector = function selector(state) {return state.selection;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _REQUEST2.default)) {
        return (0, _extends3.default)({}, state, { creating: true, selection: null });
    }
    if ((0, _fsa.isType)(action, _SUCCESS2.default)) {
        return (0, _extends3.default)({}, state, { creating: false, selection: null });
    }
    if ((0, _fsa.isType)(action, _CHANGE2.default)) {
        return (0, _extends3.default)({}, state, { creating: true, selection: action.payload.selection });
    }
    if ((0, _fsa.isType)(action, _CHANGE_ISNOTE2.default)) {
        return (0, _extends3.default)({}, state, { creating: true, isnote: action.payload.isnote });
    }
    if ((0, _fsa.isType)(action, _RESET2.default)) {
        return (0, _extends3.default)({}, state, { creating: false, selection: null });
    }
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { creating: false, selection: null });
    }
    return state;
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SELECTION_CHANGE');

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('STATUS_SHOW');

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANTS_LOADED');

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _USER_ID_NOT_LOADED = __webpack_require__(629);var _USER_ID_NOT_LOADED2 = _interopRequireDefault(_USER_ID_NOT_LOADED);
var _USER_ID_LOADED = __webpack_require__(540);var _USER_ID_LOADED2 = _interopRequireDefault(_USER_ID_LOADED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    id: undefined };

var selector = exports.selector = function selector(state) {return state.participantid;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _USER_ID_LOADED2.default)) {
        return (0, _extends3.default)({}, state, { id: action.payload.id });
    }
    if ((0, _fsa.isType)(action, _USER_ID_NOT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    return state;
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USER_ID_NOT_LOADED');

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_LOADED');

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_NOT_LOADED');

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTECHAT_LOADED');

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADDRESSEE_LOADED');

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADDRESSEE_NOT_LOADED');

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADDRESSEE_CREATED');

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADDRESSEE_UPDATED');

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_INSPECT');

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_DELETE_BATCH_COMPLETE');

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_CHANGE_STATUS_BATCH_FAILURE');

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _getOwnPropertyNames = __webpack_require__(497);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var getOwnPropertySymbols = _getOwnPropertySymbols2.default;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!_assign2.default) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if ((0, _getOwnPropertyNames2.default)(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = (0, _getOwnPropertyNames2.default)(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if ((0, _keys2.default)((0, _assign2.default)({}, test3)).join('') !==
		'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? _assign2.default : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                                                                                                                                                        * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                        * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                        */

if (false) {
  var REACT_ELEMENT_TYPE = typeof _symbol2.default === 'function' && _for2.default &&

  (0, _for2.default)('react.element') ||
  0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' &&
    object !== null &&
    object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(925)();
}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.storeShape = exports.subscriptionShape = undefined;var _propTypes = __webpack_require__(641);var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
  trySubscribe: _propTypes2.default.func.isRequired,
  tryUnsubscribe: _propTypes2.default.func.isRequired,
  notifyNestedSubs: _propTypes2.default.func.isRequired,
  isSubscribed: _propTypes2.default.func.isRequired });


var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired });

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault(_stringify);var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.default =








































connectAdvanced;var _hoistNonReactStatics = __webpack_require__(929);var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);var _invariant = __webpack_require__(930);var _invariant2 = _interopRequireDefault(_invariant);var _react = __webpack_require__(171);var _Subscription = __webpack_require__(931);var _Subscription2 = _interopRequireDefault(_Subscription);var _PropTypes = __webpack_require__(642);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var hotReloadingVersion = 0;var dummyState = {};function noop() {}function makeSelectorStateful(sourceSelector, store) {// wrap the selector in an object that tracks its results between runs.
  var selector = { run: function runComponentSelector(props) {try {var nextProps = sourceSelector(store.getState(), props);if (nextProps !== selector.props || selector.error) {selector.shouldComponentUpdate = true;selector.props = nextProps;selector.error = null;}} catch (error) {selector.shouldComponentUpdate = true;selector.error = error;}} };return selector;}function connectAdvanced( /*
                                                                                                                                                                                                                                                                                                                                                                                                        selectorFactory is a func that is responsible for returning the selector function used to
                                                                                                                                                                                                                                                                                                                                                                                                        compute new props from state, props, and dispatch. For example:
                                                                                                                                                                                                                                                                                                                                                                                                           export default connectAdvanced((dispatch, options) => (state, props) => ({
                                                                                                                                                                                                                                                                                                                                                                                                            thing: state.things[props.thingId],
                                                                                                                                                                                                                                                                                                                                                                                                            saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
                                                                                                                                                                                                                                                                                                                                                                                                          }))(YourComponent)
                                                                                                                                                                                                                                                                                                                                                                                                         Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
                                                                                                                                                                                                                                                                                                                                                                                                        outside of their selector as an optimization. Options passed to connectAdvanced are passed to
                                                                                                                                                                                                                                                                                                                                                                                                        the selectorFactory, along with displayName and WrappedComponent, as the second argument.
                                                                                                                                                                                                                                                                                                                                                                                                         Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
                                                                                                                                                                                                                                                                                                                                                                                                        props. Do not use connectAdvanced directly without memoizing results between calls to your
                                                                                                                                                                                                                                                                                                                                                                                                        selector, otherwise the Connect component will re-render on every state or props change.
                                                                                                                                                                                                                                                                                                                                                                                                      */
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
  _ref$getDisplayName = _ref.getDisplayName,
  getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
  _ref$methodName = _ref.methodName,
  methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
  _ref$renderCountProp = _ref.renderCountProp,
  renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
  _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
  shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
  _ref$storeKey = _ref.storeKey,
  storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
  _ref$withRef = _ref.withRef,
  withRef = _ref$withRef === undefined ? false : _ref$withRef,
  connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + (0, _stringify2.default)(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent });


    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(_react.Component);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}module.exports = exports["default"];

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.

wrapMapToPropsConstant = wrapMapToPropsConstant;exports.


















getDependsOnOwnProps = getDependsOnOwnProps;exports.















wrapMapToPropsFunc = wrapMapToPropsFunc;var _verifyPlainObject = __webpack_require__(645);var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function wrapMapToPropsConstant(getConstant) {return function initConstantSelector(dispatch, options) {var constant = getConstant(dispatch, options);function constantSelector() {return constant;}constantSelector.dependsOnOwnProps = false;return constantSelector;};} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {return function initProxySelector(dispatch, _ref) {var displayName = _ref.displayName;var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);}; // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {proxy.mapToProps = mapToProps;proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);var props = proxy(stateOrDispatch, ownProps);if (typeof props === 'function') {proxy.mapToProps = props;proxy.dependsOnOwnProps = getDependsOnOwnProps(props);props = proxy(stateOrDispatch, ownProps);}

      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =


verifyPlainObject;var _isPlainObject = __webpack_require__(935);var _isPlainObject2 = _interopRequireDefault(_isPlainObject);var _warning = __webpack_require__(541);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function verifyPlainObject(value, displayName, methodName) {
  if (!(0, _isPlainObject2.default)(value)) {
    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}module.exports = exports['default'];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _root = __webpack_require__(937);var _root2 = _interopRequireDefault(_root);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Built-in value references. */
var _Symbol = _root2.default.Symbol;exports.default =

_Symbol;module.exports = exports['default'];

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.nameFunction = function (name, fn) {
    var f = fn.bind(null);
    f.displayName = name;
    return f;
};
//# sourceMappingURL=nameFunction.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.PureFunctional = exports.PureConnect = exports.Connect = exports.Component = exports.render = exports.React = undefined;var _react = __webpack_require__(171);var _React = _interopRequireWildcard(_react);
var _reactDom = __webpack_require__(658);var _ReactDOM = _interopRequireWildcard(_reactDom);
var _reactRedux = __webpack_require__(514);var _ReactRedux = _interopRequireWildcard(_reactRedux);
var _reactReduxPure = __webpack_require__(956);var _ReactReduxPure = _interopRequireWildcard(_reactReduxPure);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}
var React = exports.React = _React;
var render = exports.render = _ReactDOM.render;
var Component = exports.Component = _React.Component;
var Connect = exports.Connect = _ReactRedux.connect;
var PureConnect = exports.PureConnect = _ReactReduxPure.PureConnect;
var PureFunctional = exports.PureFunctional = _ReactReduxPure.PureFunctional;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(601);exports.default =
{
    loggedIn: (0, _reselect.createSelector)(_reducer.selector, function (auth) {return !!auth.accessToken;}),
    token: (0, _reselect.createSelector)(_reducer.selector, function (auth) {return auth.accessToken;}),
    user: (0, _reselect.createSelector)(_reducer.selector, function (auth) {return auth.user;}),
    accountmanager: (0, _reselect.createSelector)(_reducer.selector, function (auth) {return auth.accountmanager;}) };

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(897);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
    currentitem: function currentitem(state) {return state.notesReducer.noteselected;},
    isminimized: function isminimized(state) {return state ? state.notesReducer.minimized : false;},
    inspect: function inspect(state) {return state ? state.notesReducer.inspect : {};} };

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(688), __esModule: true };

/***/ }),
/* 653 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('TOGGLE_NOTEMENU');

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANT_SELECT_SHOW');

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CATEGORYSELECT_SHOW');

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_MAXIMIZE');

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function')
  {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(948);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(949), __esModule: true };

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('HOVER_ITEM');

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);exports.default =








function () {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _MEASURED2.default)) {
        return (0, _extends3.default)({}, state, action.payload);
    }
    return state;
};var _fsa = __webpack_require__(1);var _MEASURED = __webpack_require__(736);var _MEASURED2 = _interopRequireDefault(_MEASURED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var emptyState = { height: 0, scrollLeft: 0, scrollTop: 0, width: 0 };var selector = exports.selector = function selector(state) {return state.window;};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('OPEN_DROPDOWN_STATUS');

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_LINK');

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_SHOWLINKS');

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('UPDATED_BUTTON_LOCK');

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.visibleSelector = exports.statusSelector = exports.originSelector = exports.kindSelector = exports.factiongroupsSelector = exports.participantgroupsSelector = exports.participantsSelector = exports.categoriesSelector = exports.sortingSelector = exports.searchTermSelector = undefined;var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(614);
var searchTermSelector = exports.searchTermSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.searchTerm;});
var sortingSelector = exports.sortingSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.sorting;});
var categoriesSelector = exports.categoriesSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.categories;});
var participantsSelector = exports.participantsSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.participants;});
var participantgroupsSelector = exports.participantgroupsSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.participantgroups;});
var factiongroupsSelector = exports.factiongroupsSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.factiongroups;});
var kindSelector = exports.kindSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.kinds;});
var originSelector = exports.originSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.origins;});
var statusSelector = exports.statusSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.statuses;});
var visibleSelector = exports.visibleSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.visible;});

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = {
  constrain: __webpack_require__(899),
  map: __webpack_require__(900),
  map_constrain: __webpack_require__(901),
  round_dec: __webpack_require__(902) };

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTE_DELETE_WITH_CHAT');

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(670);
module.exports = __webpack_require__(13).Object.getPrototypeOf;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(111);
var $getPrototypeOf = __webpack_require__(236);

__webpack_require__(496)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(672);
var $Object = __webpack_require__(13).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(34);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperty: __webpack_require__(35).f });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(674);
module.exports = __webpack_require__(13).Object.setPrototypeOf;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(34);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(675).set });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(41);
var anObject = __webpack_require__(40);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(60)(Function.call, __webpack_require__(224).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(677);
var $Object = __webpack_require__(13).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(34);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(158) });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(679);
module.exports = __webpack_require__(13).Object.keys;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(111);
var $keys = __webpack_require__(107);

__webpack_require__(496)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(681);
var $Object = __webpack_require__(13).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(496)('getOwnPropertyNames', function () {
  return __webpack_require__(237).f;
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(683);
module.exports = __webpack_require__(13).Object.assign;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(34);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(684) });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(107);
var gOPS = __webpack_require__(164);
var pIE = __webpack_require__(112);
var toObject = __webpack_require__(111);
var IObject = __webpack_require__(226);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(70)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80);
__webpack_require__(66);
module.exports = __webpack_require__(686);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(40);
var get = __webpack_require__(165);
module.exports = __webpack_require__(13).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(689);
var $Object = __webpack_require__(13).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(61);
var $getOwnPropertyDescriptor = __webpack_require__(224).f;

__webpack_require__(496)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _CANCEL = __webpack_require__(691);var _CANCEL2 = _interopRequireDefault(_CANCEL);
var _SELECT = __webpack_require__(548);var _SELECT2 = _interopRequireDefault(_SELECT);
var _SHOW = __webpack_require__(656);var _SHOW2 = _interopRequireDefault(_SHOW);
var _HIDE = __webpack_require__(539);var _HIDE2 = _interopRequireDefault(_HIDE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    categoryId: 0,
    visible: false };

var selector = exports.selector = function selector(state) {return state.categorySelectPopup;};exports.default =
function () {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, categoryId: 0 });
    }
    if ((0, _fsa.isType)(action, _SELECT2.default)) {
        return (0, _extends3.default)({}, state, { visible: false, categoryId: action.payload.categoryId });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _CANCEL2.default)) {
        return (0, _extends3.default)({}, state, { visible: false, categoryId: 0 });
    }
    return state;
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CATEGORYSELECT_CANCEL');

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _HIDE = __webpack_require__(613);var _HIDE2 = _interopRequireDefault(_HIDE);
var _CANCEL = __webpack_require__(549);var _CANCEL2 = _interopRequireDefault(_CANCEL);
var _SELECT = __webpack_require__(693);var _SELECT2 = _interopRequireDefault(_SELECT);
var _SHOW = __webpack_require__(655);var _SHOW2 = _interopRequireDefault(_SHOW);
var _SEARCH_TERM = __webpack_require__(694);var _SEARCH_TERM2 = _interopRequireDefault(_SEARCH_TERM);
var _SELECT_USERGROUP = __webpack_require__(695);var _SELECT_USERGROUP2 = _interopRequireDefault(_SELECT_USERGROUP);
var _SEARCH_TERM_USERGROUP = __webpack_require__(696);var _SEARCH_TERM_USERGROUP2 = _interopRequireDefault(_SEARCH_TERM_USERGROUP);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    participants: [],
    usergroups: [],
    visible: false,
    itemno: -1,
    searchTermParticipant: '',
    searchTermUsergroup: '' };

var selector = exports.selector = function selector(state) {return state.noteParticipantSelectPopup;};exports.default =
function () {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, itemno: action.payload.itemno });
    }
    if ((0, _fsa.isType)(action, _SELECT2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, participants: action.payload.participants });
    }
    if ((0, _fsa.isType)(action, _SELECT_USERGROUP2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, usergroups: action.payload.usergroups });
    }
    if ((0, _fsa.isType)(action, _CANCEL2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _SEARCH_TERM2.default)) {
        return (0, _extends3.default)({}, state, { searchTermParticipant: action.payload.searchTermParticipant });
    }
    if ((0, _fsa.isType)(action, _SEARCH_TERM_USERGROUP2.default)) {
        return (0, _extends3.default)({}, state, { searchTermUsergroup: action.payload.searchTermUsergroup });
    }
    return state;
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANT_SELECT_SELECT');

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SEARCH_TERM');

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_SELECT_SELECT');

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('SEARCH_TERM_USERGROUP ');

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVEALL_FILTER');

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('USERGROUP_INSPECT');

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTECHAT_TOGGLE_MENU');

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTECHATATTACHED_TOGGLE_MENU');

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _OPEN_DROPDOWN_STATUS = __webpack_require__(662);var _OPEN_DROPDOWN_STATUS2 = _interopRequireDefault(_OPEN_DROPDOWN_STATUS);
var _QUESTION_ITEM_LAST_TOUCHED = __webpack_require__(884);var _QUESTION_ITEM_LAST_TOUCHED2 = _interopRequireDefault(_QUESTION_ITEM_LAST_TOUCHED);
var _QUESTION_INSPECT = __webpack_require__(637);var _QUESTION_INSPECT2 = _interopRequireDefault(_QUESTION_INSPECT);
var _QUESTION_LINK = __webpack_require__(663);var _QUESTION_LINK2 = _interopRequireDefault(_QUESTION_LINK);
var _QUESTION_CHANGE_STATUS_BATCH = __webpack_require__(563);var _QUESTION_CHANGE_STATUS_BATCH2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH);
var _QUESTION_CHANGE_STATUS_BATCH_CANCEL = __webpack_require__(738);var _QUESTION_CHANGE_STATUS_BATCH_CANCEL2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_CANCEL);
var _QUESTION_CHANGE_STATUS_BATCH_COMPLETE = __webpack_require__(638);var _QUESTION_CHANGE_STATUS_BATCH_COMPLETE2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_COMPLETE);
var _QUESTION_CHANGE_STATUS_BATCH_FAILURE = __webpack_require__(639);var _QUESTION_CHANGE_STATUS_BATCH_FAILURE2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_FAILURE);
var _QUESTION_CHANGE_STATUS_BATCH_START = __webpack_require__(739);var _QUESTION_CHANGE_STATUS_BATCH_START2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_START);
var _authcheck = __webpack_require__(518);
var _QUESTION_APPLY_STATUS_BATCH = __webpack_require__(740);var _QUESTION_APPLY_STATUS_BATCH2 = _interopRequireDefault(_QUESTION_APPLY_STATUS_BATCH);
var _QUESTION_SAVE = __webpack_require__(550);var _QUESTION_SAVE2 = _interopRequireDefault(_QUESTION_SAVE);
var _QUESTION_SHOWLINKS = __webpack_require__(664);var _QUESTION_SHOWLINKS2 = _interopRequireDefault(_QUESTION_SHOWLINKS);
var _QUESTION_MAXIMIZE = __webpack_require__(657);var _QUESTION_MAXIMIZE2 = _interopRequireDefault(_QUESTION_MAXIMIZE);
var _QUESTION_SEARCH_TERM_LINK = __webpack_require__(741);var _QUESTION_SEARCH_TERM_LINK2 = _interopRequireDefault(_QUESTION_SEARCH_TERM_LINK);
var _OPEN_DROPDOWN_PRACTICIONER = __webpack_require__(702);var _OPEN_DROPDOWN_PRACTICIONER2 = _interopRequireDefault(_OPEN_DROPDOWN_PRACTICIONER);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    dropdownopen: false,
    dropdownopenPracticioner: false,
    questionselected: {},
    inspect: {},
    linkvisible: false,
    linkitem: {},
    showlinks: false,
    showitem: {},
    searchTermLinking: '',
    batchchange: false,
    batchstatus: _authcheck.statusses.qFirst(function (itm) {return itm.id === _authcheck.statusNieuw;}),
    maximized: false };

var selector = exports.selector = function selector(state) {return state.questionReducer;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _OPEN_DROPDOWN_STATUS2.default)) {
        return (0, _extends3.default)({}, state, { dropdownopen: action.payload.dropdownopen });
    }
    if ((0, _fsa.isType)(action, _OPEN_DROPDOWN_PRACTICIONER2.default)) {
        return (0, _extends3.default)({}, state, { dropdownopenPracticioner: action.payload.dropdownopenPracticioner });
    }
    if ((0, _fsa.isType)(action, _QUESTION_ITEM_LAST_TOUCHED2.default)) {
        return (0, _extends3.default)({}, state, { questionselected: action.payload.item });
    }
    if ((0, _fsa.isType)(action, _QUESTION_INSPECT2.default)) {
        return (0, _extends3.default)({}, state, { inspect: action.payload.item });
    }
    if ((0, _fsa.isType)(action, _QUESTION_LINK2.default)) {
        return (0, _extends3.default)({}, state, { linkvisible: action.payload.linkvisible,
            linkitem: action.payload.linkitem });
    }
    if ((0, _fsa.isType)(action, _QUESTION_SHOWLINKS2.default)) {
        return (0, _extends3.default)({}, state, { showlinks: action.payload.showlinks,
            showitem: action.payload.showitem });
    }
    if ((0, _fsa.isType)(action, _QUESTION_SAVE2.default)) {
        return (0, _extends3.default)({}, state, { saveitem: action.payload.saveitem });
    }
    if ((0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH2.default)) {
        return (0, _extends3.default)({}, state, { items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: action.payload.batchchange });
    }
    if ((0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH_COMPLETE2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchstatus: action.payload.batchstatus, batchchange: false });
    }
    if ((0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH_FAILURE2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchstatus: action.payload.batchstatus, batchchange: false });
    }
    if ((0, _fsa.isType)(action, _QUESTION_APPLY_STATUS_BATCH2.default)) {
        return (0, _extends3.default)({}, state, { items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: true });
    }
    if ((0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH_CANCEL2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchstatus: action.payload.batchstatus, batchchange: false });
    }
    if ((0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH_START2.default)) {
        return (0, _extends3.default)({}, state, { items: action.payload.items, batchstatus: action.payload.batchstatus, batchchange: true });
    }
    if ((0, _fsa.isType)(action, _QUESTION_MAXIMIZE2.default)) {
        return (0, _extends3.default)({}, state, { maximized: action.payload.maximized });
    }
    if ((0, _fsa.isType)(action, _QUESTION_SEARCH_TERM_LINK2.default)) {
        return (0, _extends3.default)({}, state, { searchTermLinking: action.payload.searchTermLinking });
    }
    return state;
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('OPEN_DROPDOWN_PRACTICIONER');

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.bookmarksSelector = exports.notesSelector = exports.questionsCurrentPageSelector = exports.notesSharedCurrentPageSelector = exports.notesCurrentPageSelector = exports.notesAndQuestionsPageSelector = exports.selectors = undefined;__webpack_require__(76);
var _reselect = __webpack_require__(221);
var _resource = __webpack_require__(163);
var _reducer = __webpack_require__(619);
var _reselectors = __webpack_require__(542);var _reselectors2 = _interopRequireDefault(_reselectors);
var _selectors = __webpack_require__(78);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var selectors = exports.selectors = {
    active: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.categoryId !== undefined || state.sorting !== 'createdDesc';}),
    categoryId: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.categoryId;}),
    sorting: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.sorting;}),
    visible: (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.visible;}) };

var createdSelector = function createdSelector(item) {return new Date(item.created).getTime();};
var sortFuncSelector = (0, _reselect.createSelector)(selectors.sorting, function (order) {
    if (order === 'createdAsc') {
        return function (a, b) {
            if (createdSelector(a) !== createdSelector(b)) {
                return createdSelector(b) - createdSelector(a);
            }
            return a.id - b.id;
        };
    } else
    if (order === 'pageNumber') {
        return function (a, b) {
            if (a.pageNumber !== b.pageNumber) {
                return a.pageNumber - b.pageNumber;
            }
            if (createdSelector(a) !== createdSelector(b)) {
                return createdSelector(b) - createdSelector(b);
            }
            return a.id - b.id;
        };
    } else
    {
        return function (a, b) {
            if (createdSelector(a) !== createdSelector(b)) {
                return createdSelector(a) - createdSelector(b);
            }
            return b.id - a.id;
        };
    }
});
var notesCurrentPage = (0, _reselect.createSelector)(_reselectors2.default.notesItemsSelector, _selectors.selectors.pageId, function (notes, pageId) {return notes.qWhere(function (x) {return x.pageId === pageId && !x.isquestion;});});
var notesSharedCurrentPage = (0, _reselect.createSelector)(_reselectors2.default.notesSharedSelector, _selectors.selectors.pageId, function (notes, pageId) {return notes.qWhere(function (x) {return x.pageId === pageId && !x.isquestion;});});
var questionsCurrentPage = (0, _reselect.createSelector)(_reselectors2.default.questionsItemsSelector, _selectors.selectors.pageId, function (questions, pageId) {return questions.qWhere(function (x) {return x.pageId === pageId;});});
var notesAndQuestionsCurrentPage = (0, _reselect.createSelector)(_reselectors2.default.notesItemsSelector, _reselectors2.default.notesSharedSelector, _reselectors2.default.questionsItemsSelector, _selectors.selectors.pageId, function (notes, sharednotes, questions, pageId) {return notes.concat(sharednotes).concat(questions).qWhere(function (x) {return x.pageId === pageId;});});
var notesAndQuestionsPageSelector = exports.notesAndQuestionsPageSelector = notesAndQuestionsCurrentPage;
var notesCurrentPageSelector = exports.notesCurrentPageSelector = notesCurrentPage;
var notesSharedCurrentPageSelector = exports.notesSharedCurrentPageSelector = notesSharedCurrentPage;
var questionsCurrentPageSelector = exports.questionsCurrentPageSelector = questionsCurrentPage;
var notesSelector = exports.notesSelector = (0, _reselect.createSelector)(_reselectors2.default.notesItemsSelector, _reselectors2.default.notesSharedSelector, _reselectors2.default.questionsItemsSelector, function (items, itemsshared, questions) {return items.concat(itemsshared).concat(questions);});
var bookmarksSelector = exports.bookmarksSelector = (0, _reselect.createSelector)(_resource.bookmarksResource.selectors.items, selectors.categoryId, sortFuncSelector, function (items, categoryId, sort) {return categoryId !== undefined ? items.qWhere(function (x) {return (x.categoryId || 0) === categoryId;}).sort(sort) : items.slice(0).sort(sort);});

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(907);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('BUTTON_HIDE_FLYOVER');

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ERRORCONTROL_RETRY');

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = exports.emptyState = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _ADMIN_CREATE = __webpack_require__(553);var _ADMIN_CREATE2 = _interopRequireDefault(_ADMIN_CREATE);
var _ADMIN_UPDATE = __webpack_require__(554);var _ADMIN_UPDATE2 = _interopRequireDefault(_ADMIN_UPDATE);
var _ADMIN_INIT = __webpack_require__(609);var _ADMIN_INIT2 = _interopRequireDefault(_ADMIN_INIT);
var _DEADLINE_QUESTIONS = __webpack_require__(708);var _DEADLINE_QUESTIONS2 = _interopRequireDefault(_DEADLINE_QUESTIONS);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = exports.emptyState = {
    item: { documentId: '', deadlineanswer: 0, factionvisible: false, modquestion: false } };

var selector = exports.selector = function selector(state) {return state.beheer;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _ADMIN_INIT2.default)) {
        return (0, _extends3.default)({}, state, { item: action.payload.item, busy: action.payload.busy, sendingenabled: false, answerenabled: false });
    }
    if ((0, _fsa.isType)(action, _ADMIN_CREATE2.default)) {
        return (0, _extends3.default)({}, state, { item: action.payload.item, busy: action.payload.busy });
    }
    if ((0, _fsa.isType)(action, _ADMIN_UPDATE2.default)) {
        return (0, _extends3.default)({}, state, { item: action.payload.item, busy: action.payload.busy });
    }
    if ((0, _fsa.isType)(action, _DEADLINE_QUESTIONS2.default)) {
        return (0, _extends3.default)({}, state, { sendingenabled: action.payload.sendingenabled, answerenabled: action.payload.answerenabled });
    }
    return state;
};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('DEADLINE_QUESTIONS');

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _HIDE = __webpack_require__(543);var _HIDE2 = _interopRequireDefault(_HIDE);
var _SHOW = __webpack_require__(498);var _SHOW2 = _interopRequireDefault(_SHOW);
var _TAB_ACTIVATE = __webpack_require__(710);var _TAB_ACTIVATE2 = _interopRequireDefault(_TAB_ACTIVATE);
var _HOVER = __webpack_require__(660);var _HOVER2 = _interopRequireDefault(_HOVER);
var _LIST_PRESENTATION = __webpack_require__(711);var _LIST_PRESENTATION2 = _interopRequireDefault(_LIST_PRESENTATION);
var _TILE_PRESENTATION = __webpack_require__(712);var _TILE_PRESENTATION2 = _interopRequireDefault(_TILE_PRESENTATION);
var _LOGIN = __webpack_require__(523);var _LOGIN2 = _interopRequireDefault(_LOGIN);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    tabIndex: 0,
    visible: false,
    hoveredId: '',
    listpresentation: true };

var selector = exports.selector = function selector(state) {return state.admin;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { tabIndex: 0, visible: true });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _TAB_ACTIVATE2.default)) {
        return (0, _extends3.default)({}, state, { tabIndex: action.payload.tabIndex });
    }
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _HOVER2.default)) {
        return (0, _extends3.default)({}, state, { hoveredId: action.payload.hoveredId });
    }
    if ((0, _fsa.isType)(action, _LOGIN2.default)) {
        return (0, _extends3.default)({}, state, { listpresentation: true });
    }
    if ((0, _fsa.isType)(action, _LIST_PRESENTATION2.default)) {
        return (0, _extends3.default)({}, state, { listpresentation: true });
    }
    if ((0, _fsa.isType)(action, _TILE_PRESENTATION2.default)) {
        return (0, _extends3.default)({}, state, { listpresentation: false });
    }
    return state;
};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ADMIN_TAB_ACTIVATE');

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('LIST_PRESENTATION');

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('TILE_PRESENTATION');

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_MINIMIZE');

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_DELETE_BATCH_START');

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTES_DELETE_BATCH_CANCEL');

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FILTER_CATEGORIES');

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('ORIGIN');

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANTSGROUPS');

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANTS');

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVEALL_ALL_CATEGORIES');

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVEALL_ALL_GROUPS');

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVE_ALL_KINDS');

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVE_ALL_ORIGINS');

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVE_ALL_PARTICIPANTS');

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FILTER_SORT');

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FILTER_TERM');

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('STATUSES');

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FACTIONGROUPS');

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVE_ALL_FACTIONS');

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVEALL_STATUSES');

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('REMOVE_ALL_STATUSES_AND_FACTIONS');

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _HIDE = __webpack_require__(487);var _HIDE2 = _interopRequireDefault(_HIDE);
var _SHOW = __webpack_require__(499);var _SHOW2 = _interopRequireDefault(_SHOW);
var _TAB_ACTIVATE = __webpack_require__(557);var _TAB_ACTIVATE2 = _interopRequireDefault(_TAB_ACTIVATE);
var _SHOW3 = __webpack_require__(498);var _SHOW4 = _interopRequireDefault(_SHOW3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    tabIndex: 0,
    visible: false };

var selector = exports.selector = function selector(state) {return state.flyover;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _TAB_ACTIVATE2.default)) {
        return (0, _extends3.default)({}, state, { tabIndex: action.payload.index });
    }
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _SHOW4.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    return state;
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PAGEFILTER_HIDE');

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('CHANGE_ISNOTE');

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _HIDE = __webpack_require__(561);var _HIDE2 = _interopRequireDefault(_HIDE);
var _SHOW = __webpack_require__(626);var _SHOW2 = _interopRequireDefault(_SHOW);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = { visible: false, message: '', status: null };
var selector = exports.selector = function selector(state) {return state.statusDialog;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, message: action.payload.message, status: action.payload.status });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    return state;
};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('WINDOW_MEASURED');

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = exports.emptyInspectUser = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _USERGROUP_LOADED = __webpack_require__(630);var _USERGROUP_LOADED2 = _interopRequireDefault(_USERGROUP_LOADED);
var _USERGROUP_NOT_LOADED = __webpack_require__(631);var _USERGROUP_NOT_LOADED2 = _interopRequireDefault(_USERGROUP_NOT_LOADED);
var _USERGROUP_CREATED = __webpack_require__(488);var _USERGROUP_CREATED2 = _interopRequireDefault(_USERGROUP_CREATED);
var _USERGROUP_UPDATED = __webpack_require__(489);var _USERGROUP_UPDATED2 = _interopRequireDefault(_USERGROUP_UPDATED);
var _USERGROUP_INSPECT = __webpack_require__(698);var _USERGROUP_INSPECT2 = _interopRequireDefault(_USERGROUP_INSPECT);
var _USERGROUP_REMOVE = __webpack_require__(562);var _USERGROUP_REMOVE2 = _interopRequireDefault(_USERGROUP_REMOVE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    usergroup: { userIDs: [''], key: '', userId: '', name: '', id: 0 },
    allTenantUsers: false,
    inspect: { userIDs: [''], key: '', userId: '', name: '', id: 0 } };

var emptyInspectUser = exports.emptyInspectUser = emptyState.inspect;
var selector = exports.selector = function selector(state) {return state.usergroup;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _USERGROUP_NOT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _USERGROUP_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _USERGROUP_CREATED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _USERGROUP_UPDATED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _USERGROUP_INSPECT2.default)) {
        return (0, _extends3.default)({}, state, { inspect: action.payload.usergroup });
    }
    if ((0, _fsa.isType)(action, _USERGROUP_REMOVE2.default)) {
        return (0, _extends3.default)({}, state, { remove: action.payload.usergroup });
    }
    return state;
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_CHANGE_STATUS_BATCH_CANCEL');

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_CHANGE_STATUS_BATCH_START');

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_APPLY_STATUS_BATCH');

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_SEARCH_TERM_LINK');

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(250);
__webpack_require__(461);
module.exports = __webpack_require__(743);


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _appversion = __webpack_require__(564);var _appversion2 = _interopRequireDefault(_appversion);
__webpack_require__(235);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
console.log('[NoteService] Client Version ' + _appversion2.default);

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _BrowserProxy = __webpack_require__(745);Object.defineProperty(exports, 'BrowserProxy', { enumerable: true, get: function get() {return _BrowserProxy.BrowserProxy;} });

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.BrowserProxy = undefined;var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _events = __webpack_require__(746);
var _appversion = __webpack_require__(564);var _appversion2 = _interopRequireDefault(_appversion);
var _LOGIN = __webpack_require__(523);var _LOGIN2 = _interopRequireDefault(_LOGIN);
var _LOGOUT = __webpack_require__(551);var _LOGOUT2 = _interopRequireDefault(_LOGOUT);
var _CONFIG = __webpack_require__(572);var _CONFIG2 = _interopRequireDefault(_CONFIG);
var _NOTES_REDRAW = __webpack_require__(573);var _NOTES_REDRAW2 = _interopRequireDefault(_NOTES_REDRAW);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
BrowserProxy = function (_EventEmitter) {(0, _inherits3.default)(BrowserProxy, _EventEmitter);
    function BrowserProxy(_isVisible, _dispatch) {(0, _classCallCheck3.default)(this, BrowserProxy);var _this = (0, _possibleConstructorReturn3.default)(this, (BrowserProxy.__proto__ || (0, _getPrototypeOf2.default)(BrowserProxy)).call(this));

        _this._isVisible = _isVisible;
        _this._dispatch = _dispatch;return _this;
    }(0, _createClass3.default)(BrowserProxy, [{ key: 'login', value: function login()






        {
            this._dispatch((0, _LOGIN2.default)({}));
        } }, { key: 'logout', value: function logout()
        {
            this._dispatch((0, _LOGOUT2.default)({}));
        } }, { key: 'config', value: function config(
        _config) {
            this._dispatch((0, _CONFIG2.default)(_config));
        } }, { key: 'redrawNotes', value: function redrawNotes()
        {
            this._dispatch((0, _NOTES_REDRAW2.default)({}));
        } }, { key: 'version', get: function get() {return _appversion2.default;} }, { key: 'visible', get: function get() {return this._isVisible();} }]);return BrowserProxy;}(_events.EventEmitter);exports.BrowserProxy = BrowserProxy;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _isNan = __webpack_require__(747);var _isNan2 = _interopRequireDefault(_isNan);var _getOwnPropertyNames = __webpack_require__(497);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var R = (typeof Reflect === 'undefined' ? 'undefined' : (0, _typeof3.default)(Reflect)) === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ?
R.apply :
function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (_getOwnPropertySymbols2.default) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return (0, _getOwnPropertyNames2.default)(target).
    concat((0, _getOwnPropertySymbols2.default)(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return (0, _getOwnPropertyNames2.default)(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = _isNan2.default || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === 'undefined' ? 'undefined' : (0, _typeof3.default)(listener)));
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  } });


EventEmitter.init = function () {

  if (this._events === undefined ||
  this._events === (0, _getPrototypeOf2.default)(this)._events) {
    this._events = (0, _create2.default)(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
  return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {args.push(arguments[i]);}
  var doError = type === 'error';

  var events = this._events;
  if (events !== undefined)
  doError = doError && events.error === undefined;else
  if (!doError)
  return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
    er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
  return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);}
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = (0, _create2.default)(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
      listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
      prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
      existing.length + ' ' + String(type) + ' listeners ' +
      'added. Use emitter.setMaxListeners() to ' +
      'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
    return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
function removeListener(type, listener) {
  var list, events, position, i, originalListener;

  checkListener(listener);

  events = this._events;
  if (events === undefined)
  return this;

  list = events[type];
  if (list === undefined)
  return this;

  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
    this._events = (0, _create2.default)(null);else
    {
      delete events[type];
      if (events.removeListener)
      this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0)
    return this;

    if (position === 0)
    list.shift();else
    {
      spliceOne(list, position);
    }

    if (list.length === 1)
    events[type] = list[0];

    if (events.removeListener !== undefined)
    this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
function removeAllListeners(type) {
  var listeners, events, i;

  events = this._events;
  if (events === undefined)
  return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = (0, _create2.default)(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0)
      this._events = (0, _create2.default)(null);else

      delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = (0, _keys2.default)(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = (0, _create2.default)(null);
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }

  return this;
};

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
  return [];

  var evlistener = events[type];
  if (evlistener === undefined)
  return [];

  if (typeof evlistener === 'function')
  return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
  unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];}
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];}
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new _promise2.default(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === 'undefined' ? 'undefined' : (0, _typeof3.default)(emitter)));
  }
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(748), __esModule: true };

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(749);
module.exports = __webpack_require__(13).Number.isNaN;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(34);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(227);
module.exports = __webpack_require__(13).Object.getOwnPropertySymbols;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _set = __webpack_require__(565);var _set2 = _interopRequireDefault(_set);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });

exports.Action = Action;

var _Factory = __webpack_require__(571);

var registered = new _set2.default();
function Action(type) {
    if (registered.has(type)) {
        throw Error('action ' + type + ' has already been defined');
    }
    registered.add(type);
    return (0, _Factory.Factory)(type);
}
//# sourceMappingURL=Action.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(66);
__webpack_require__(80);
__webpack_require__(753);
__webpack_require__(757);
__webpack_require__(759);
__webpack_require__(760);
module.exports = __webpack_require__(13).Set;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(566);
var validate = __webpack_require__(524);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(567)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(60);
var IObject = __webpack_require__(226);
var toObject = __webpack_require__(111);
var toLength = __webpack_require__(113);
var asc = __webpack_require__(755);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(756);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);
var isArray = __webpack_require__(239);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(34);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(568)('Set') });


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(167);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(569)('Set');


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(570)('Set');


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.isType = isType;

var _isAction = __webpack_require__(502);

function isType(action, factory) {
    return (0, _isAction.isAction)(action) ? action.type === factory.type : false;
}
//# sourceMappingURL=isType.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(763);

function isObjectObject(o) {
  return isObject(o) === true &&
  Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor, prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

module.exports = function isObject(val) {
  return val != null && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && Array.isArray(val) === false;
};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.isTypeOneOf = isTypeOneOf;

var _isAction = __webpack_require__(502);

function isTypeOneOf(action) {
    for (var _len = arguments.length, factories = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        factories[_key - 1] = arguments[_key];
    }

    return (0, _isAction.isAction)(action) ? factories.some(function (factory) {
        return action.type === factory.type;
    }) : false;
}
//# sourceMappingURL=isTypeOneOf.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.isError = isError;

var _isAction = __webpack_require__(502);

function isError(action) {
    return (0, _isAction.isAction)(action) ? action.error === true : false;
}
//# sourceMappingURL=isError.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function () {
    return typeof window.requestAnimationFrame !== 'function';
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.Store = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _redux = __webpack_require__(575);
var _setup = __webpack_require__(782);
var _middleware = __webpack_require__(783);var _middleware2 = _interopRequireDefault(_middleware);
var _middleware3 = __webpack_require__(843);var _middleware4 = _interopRequireDefault(_middleware3);
var _reduxSaga = __webpack_require__(47);
var _persistent = __webpack_require__(866);var _persistent2 = _interopRequireDefault(_persistent);
var _reducer = __webpack_require__(867);
var _saga = __webpack_require__(885);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
Store = exports.Store = function () {function Store() {(0, _classCallCheck3.default)(this, Store);}(0, _createClass3.default)(Store, null, [{ key: 'create', value: function create(
        preloadedState) {
            var sagaMiddleware = (0, _reduxSaga.createSagaMiddleware)();
            var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
            var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_middleware4.default, sagaMiddleware, _middleware2.default), (0, _persistent2.default)())(_redux.createStore);
            var store = createStoreWithMiddleware((0, _redux.combineReducers)(_reducer.reducer), preloadedState);
            sagaMiddleware.run(_saga.storeRootSaga);
            (0, _setup.setupStore)(store);
            return store;
        } }]);return Store;}();

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _Symbol2 = __webpack_require__(578);var _Symbol3 = _interopRequireDefault(_Symbol2);
var _getRawTag = __webpack_require__(771);var _getRawTag2 = _interopRequireDefault(_getRawTag);
var _objectToString = __webpack_require__(772);var _objectToString2 = _interopRequireDefault(_objectToString);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
                                                                                   * The base implementation of `getTag` without fallbacks for buggy environments.
                                                                                   *
                                                                                   * @private
                                                                                   * @param {*} value The value to query.
                                                                                   * @returns {string} Returns the `toStringTag`.
                                                                                   */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ?
  (0, _getRawTag2.default)(value) :
  (0, _objectToString2.default)(value);
}exports.default =

baseGetTag;module.exports = exports['default'];

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _freeGlobal = __webpack_require__(770);var _freeGlobal2 = _interopRequireDefault(_freeGlobal);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : (0, _typeof3.default)(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal2.default || freeSelf || Function('return this')();exports.default =

root;module.exports = exports['default'];

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) == 'object' && global && global.Object === Object && global;exports.default =

freeGlobal;module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _Symbol2 = __webpack_require__(578);var _Symbol3 = _interopRequireDefault(_Symbol2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
                                                  * Used to resolve the
                                                  * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                                                  * of values.
                                                  */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
                                                                                   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                                                                                   *
                                                                                   * @private
                                                                                   * @param {*} value The value to query.
                                                                                   * @returns {string} Returns the raw `toStringTag`.
                                                                                   */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
  tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}exports.default =

getRawTag;module.exports = exports['default'];

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true }); /** Used for built-in method references. */
var objectProto = Object.prototype;

/**
                                     * Used to resolve the
                                     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                                     * of values.
                                     */
var nativeObjectToString = objectProto.toString;

/**
                                                  * Converts `value` to a string using `Object.prototype.toString`.
                                                  *
                                                  * @private
                                                  * @param {*} value The value to convert.
                                                  * @returns {string} Returns the converted string.
                                                  */
function objectToString(value) {
  return nativeObjectToString.call(value);
}exports.default =

objectToString;module.exports = exports["default"];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _overArg = __webpack_require__(774);var _overArg2 = _interopRequireDefault(_overArg);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Built-in value references. */
var getPrototype = (0, _overArg2.default)(_getPrototypeOf2.default, Object);exports.default =

getPrototype;module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                             * Creates a unary function that invokes `func` with its argument transformed.
                                                                             *
                                                                             * @private
                                                                             * @param {Function} func The function to wrap.
                                                                             * @param {Function} transform The argument transform.
                                                                             * @returns {Function} Returns the new function.
                                                                             */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}exports.default =

overArg;module.exports = exports["default"];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                 * Checks if `value` is object-like. A value is object-like if it's not `null`
                                                                                                                                                                                                                                                                                 * and has a `typeof` result of "object".
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * @static
                                                                                                                                                                                                                                                                                 * @memberOf _
                                                                                                                                                                                                                                                                                 * @since 4.0.0
                                                                                                                                                                                                                                                                                 * @category Lang
                                                                                                                                                                                                                                                                                 * @param {*} value The value to check.
                                                                                                                                                                                                                                                                                 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                                                                                                                                                                                                                                                                                 * @example
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike({});
                                                                                                                                                                                                                                                                                 * // => true
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike([1, 2, 3]);
                                                                                                                                                                                                                                                                                 * // => true
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike(_.noop);
                                                                                                                                                                                                                                                                                 * // => false
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike(null);
                                                                                                                                                                                                                                                                                 * // => false
                                                                                                                                                                                                                                                                                 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object';
}exports.default =

isObjectLike;module.exports = exports['default'];

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__(777);

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true });


var _ponyfill = __webpack_require__(778);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { 'default': obj };}

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157), __webpack_require__(579)(module)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true });

exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);exports.default =



































































combineReducers;var _createStore = __webpack_require__(576);var _isPlainObject = __webpack_require__(577);var _isPlainObject2 = _interopRequireDefault(_isPlainObject);var _warning = __webpack_require__(525);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function getUndefinedStateErrorMessage(key, action) {var actionType = action && action.type;var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';}function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {var reducerKeys = (0, _keys2.default)(reducers);var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';if (reducerKeys.length === 0) {return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';}if (!(0, _isPlainObject2.default)(inputState)) {return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');}var unexpectedKeys = (0, _keys2.default)(inputState).filter(function (key) {return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];});unexpectedKeys.forEach(function (key) {unexpectedKeyCache[key] = true;});if (unexpectedKeys.length > 0) {return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');}}function assertReducerShape(reducers) {(0, _keys2.default)(reducers).forEach(function (key) {var reducer = reducers[key];var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });if (typeof initialState === 'undefined') {throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');}var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');if (typeof reducer(undefined, { type: type }) === 'undefined') {throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');}});} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * Turns an object whose values are different reducer functions, into a single
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * reducer function. It will call every child reducer, and gather their results
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * into a single state object, whose keys correspond to the keys of the passed
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * reducer functions.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * @param {Object} reducers An object whose values correspond to different
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * reducer functions that need to be combined into one. One handy way to obtain
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * it is to use ES6 `import * as reducers` syntax. The reducers may never return
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * undefined for any action. Instead, they should return their initial state
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * if the state passed to them was undefined, and the current state for any
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * unrecognized action.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * @returns {Function} A reducer function that invokes every reducer inside the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * passed object, and builds a state object with the same shape.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       */function combineReducers(reducers) {var reducerKeys = (0, _keys2.default)(reducers);var finalReducers = {};for (var i = 0; i < reducerKeys.length; i++) {var key = reducerKeys[i];if (false) {if (typeof reducers[key] === 'undefined') {(0, _warning2.default)('No reducer provided for key "' + key + '"');}}if (typeof reducers[key] === 'function') {finalReducers[key] = reducers[key];}}
  var finalReducerKeys = (0, _keys2.default)(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        (0, _warning2.default)(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}module.exports = exports['default'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);exports.default =




























bindActionCreators;var _warning = __webpack_require__(525);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function bindActionCreator(actionCreator, dispatch) {return function () {return dispatch(actionCreator.apply(undefined, arguments));};} /**
                                                                                                                                                                                                                                                                                                                                                    * Turns an object whose values are action creators, into an object with the
                                                                                                                                                                                                                                                                                                                                                    * same keys, but with every function wrapped into a `dispatch` call so they
                                                                                                                                                                                                                                                                                                                                                    * may be invoked directly. This is just a convenience method, as you can call
                                                                                                                                                                                                                                                                                                                                                    * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
                                                                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                                                                    * For convenience, you can also pass a single function as the first argument,
                                                                                                                                                                                                                                                                                                                                                    * and get a function in return.
                                                                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                                                                    * @param {Function|Object} actionCreators An object whose values are action
                                                                                                                                                                                                                                                                                                                                                    * creator functions. One handy way to obtain it is to use ES6 `import * as`
                                                                                                                                                                                                                                                                                                                                                    * syntax. You may also pass a single function.
                                                                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                                                                    * @param {Function} dispatch The `dispatch` function available on your Redux
                                                                                                                                                                                                                                                                                                                                                    * store.
                                                                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                                                                    * @returns {Function|Object} The object mimicking the original object, but with
                                                                                                                                                                                                                                                                                                                                                    * every action creator wrapped into the `dispatch` call. If you passed a
                                                                                                                                                                                                                                                                                                                                                    * function as `actionCreators`, the return value will also be a single
                                                                                                                                                                                                                                                                                                                                                    * function.
                                                                                                                                                                                                                                                                                                                                                    */function bindActionCreators(actionCreators, dispatch) {if (typeof actionCreators === 'function') {return bindActionCreator(actionCreators, dispatch);}if ((typeof actionCreators === 'undefined' ? 'undefined' : (0, _typeof3.default)(actionCreators)) !== 'object' || actionCreators === null) {throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : (0, _typeof3.default)(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');}var keys = (0, _keys2.default)(actionCreators);var boundActionCreators = {};for (var i = 0; i < keys.length; i++) {var key = keys[i];var actionCreator = actionCreators[key];if (typeof actionCreator === 'function') {boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);} else {(0, _warning2.default)('bindActionCreators expected a function actionCreator for key \'' + key + '\', instead received type \'' + (typeof actionCreator === 'undefined' ? 'undefined' : (0, _typeof3.default)(actionCreator)) + '\'.');}}return boundActionCreators;
}module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.default =



















applyMiddleware;var _compose = __webpack_require__(580);var _compose2 = _interopRequireDefault(_compose);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * Creates a store enhancer that applies middleware to the dispatch method
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * of the Redux store. This is handy for a variety of tasks, such as expressing
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * asynchronous actions in a concise manner, or logging every action payload.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              *
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * See `redux-thunk` package as an example of the Redux middleware.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              *
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * Because middleware is potentially asynchronous, this should be the first
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * store enhancer in the composition chain.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              *
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * Note that each middleware will be given the `dispatch` and `getState` functions
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * as named arguments.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              *
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * @param {...Function} middlewares The middleware chain to be applied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * @returns {Function} A store enhancer applying the middleware.
                                                                                                                                                                                                                                                                                                                                                                                                                                                              */function applyMiddleware() {for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {middlewares[_key] = arguments[_key];}return function (createStore) {return function (reducer, preloadedState, enhancer) {var store = createStore(reducer, preloadedState, enhancer);var _dispatch = store.dispatch;var chain = [];var middlewareAPI = { getState: store.getState, dispatch: function dispatch(action) {return _dispatch(action);} };

      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = _compose2.default.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch });

    };
  };
}module.exports = exports['default'];

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);exports.



setupStore = setupStore;var _userManager = __webpack_require__(241);var _userManager2 = _interopRequireDefault(_userManager);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _ACCOUNDMANAGER = __webpack_require__(581);var _ACCOUNDMANAGER2 = _interopRequireDefault(_ACCOUNDMANAGER);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function setupStore(store) {var _this = this;
    (0, _userManager2.default)(function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(um) {var























            acceptUser,












            recentLogin;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:recentLogin = function recentLogin(user) {
                                if (user && !user.expired) {
                                }
                            };acceptUser = function acceptUser(user) {if (user && !user.expired) {store.dispatch((0, _AUTHENTICATED2.default)({ token: user.access_token, user: { name: getUsername(user), email: getUserEmail(user), tenant: getUserTenant(user) } }));var base64Url = user.access_token.split('.')[1];var base64 = base64Url.replace('-', '+').replace('_', '/');var res = JSON.parse(window.atob(base64));var accountmanager = false;if (res['app-admin']) {accountmanager = res['app-admin'].indexOf('accntman') !== -1;}store.dispatch((0, _ACCOUNDMANAGER2.default)({ accountmanager: accountmanager }));}};um.events.addUserLoaded((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.t0 = acceptUser;_context.next = 3;return um.getUser();case 3:_context.t1 = _context.sent;(0, _context.t0)(_context.t1);case 5:case 'end':return _context.stop();}}}, _callee, _this);})));um.events.addUserUnloaded(function () {store.dispatch((0, _LOGGEDOUT2.default)({}));});um.events.addUserSignedOut(function () {store.dispatch((0, _LOGGEDOUT2.default)({}));});um.events.addAccessTokenExpiring(function () {console.warn('[Auth] Acces token expiring');});um.events.addAccessTokenExpired(function () {store.dispatch((0, _LOGGEDOUT2.default)({}));console.warn('[Auth] Acces token expired');});um.events.addSilentRenewError(function () {store.dispatch((0, _LOGGEDOUT2.default)({}));console.warn('[Auth] Silent renew error');});_context2.next = 10;return um.clearStaleState();case 10:_context2.t0 = acceptUser;_context2.next = 13;return um.getUser();case 13:_context2.t1 = _context2.sent;(0, _context2.t0)(_context2.t1);_context2.t2 = recentLogin;_context2.next = 18;return um.getUser();case 18:_context2.t3 = _context2.sent;(0, _context2.t2)(_context2.t3);case 20:case 'end':return _context2.stop();}}}, _callee2, _this);}));return function (_x) {return _ref.apply(this, arguments);};}());

}
function getUsername(user) {
    if (user.profile.preferred_username) {
        return lastOrValue(user.profile.preferred_username);
    }
    if (user.profile.name) {
        return '' + user.profile.name;
    }
    if (user.profile.given_name && user.profile.family_name) {
        return user.profile.given_name + ' ' + user.profile.family_name;
    }
    if (user.profile.email) {
        return '' + user.profile.email;
    }
    return '?';
}
function getUserEmail(user) {
    if (user.profile.email) {
        return '' + user.profile.email;
    }
    return '';
}
function getUserTenant(user) {
    if (user.profile.tenant) {
        return '' + user.profile.tenant;
    }
    return '';
}
function lastOrValue(arg) {
    if (arg instanceof Array) {
        return arg[arg.length - 1];
    } else
    {
        return arg;
    }
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _fsa = __webpack_require__(1);
var _resource = __webpack_require__(163);
var _resource2 = __webpack_require__(162);
var _resource3 = __webpack_require__(106);
var _RETRY = __webpack_require__(706);var _RETRY2 = _interopRequireDefault(_RETRY);
var _resource4 = __webpack_require__(234);
var _resource5 = __webpack_require__(223);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
function (store) {return function (next) {return function (action) {
            if ((0, _fsa.isType)(action, _RETRY2.default)) {
                var notes = _resource3.notesResource.selectors.items(store.getState()).filter(function (x) {return _resource3.notesResource.fields.error(x);});var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
                    for (var _iterator = (0, _getIterator3.default)(notes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var note = _step.value;
                        if (_resource3.notesResource.fields.neverCommited(note)) {
                            store.dispatch(_resource3.notesResource.actions.CREATE({ item: note }));
                        } else
                        {
                            store.dispatch(_resource3.notesResource.actions.UPDATE({ item: note }));
                        }
                    }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
                var bookmarks = _resource.bookmarksResource.selectors.items(store.getState()).filter(function (x) {return _resource.bookmarksResource.fields.error(x);});var _iteratorNormalCompletion2 = true;var _didIteratorError2 = false;var _iteratorError2 = undefined;try {
                    for (var _iterator2 = (0, _getIterator3.default)(bookmarks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {var bookmark = _step2.value;
                        if (_resource.bookmarksResource.fields.neverCommited(bookmark)) {
                            store.dispatch(_resource.bookmarksResource.actions.CREATE({ item: bookmark }));
                        } else
                        {
                            store.dispatch(_resource.bookmarksResource.actions.UPDATE({ item: bookmark }));
                        }
                    }} catch (err) {_didIteratorError2 = true;_iteratorError2 = err;} finally {try {if (!_iteratorNormalCompletion2 && _iterator2.return) {_iterator2.return();}} finally {if (_didIteratorError2) {throw _iteratorError2;}}}
                var categories = _resource2.categoriesResource.selectors.items(store.getState()).filter(function (x) {return _resource2.categoriesResource.fields.error(x);});var _iteratorNormalCompletion3 = true;var _didIteratorError3 = false;var _iteratorError3 = undefined;try {
                    for (var _iterator3 = (0, _getIterator3.default)(categories), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {var category = _step3.value;
                        if (_resource2.categoriesResource.fields.neverCommited(category)) {
                            store.dispatch(_resource2.categoriesResource.actions.CREATE({ item: category }));
                        } else
                        {
                            store.dispatch(_resource2.categoriesResource.actions.UPDATE({ item: category }));
                        }
                    }} catch (err) {_didIteratorError3 = true;_iteratorError3 = err;} finally {try {if (!_iteratorNormalCompletion3 && _iterator3.return) {_iterator3.return();}} finally {if (_didIteratorError3) {throw _iteratorError3;}}}
                var admins = _resource4.beheerResource.selectors.items(store.getState()).filter(function (x) {return _resource4.beheerResource.fields.error(x);});var _iteratorNormalCompletion4 = true;var _didIteratorError4 = false;var _iteratorError4 = undefined;try {
                    for (var _iterator4 = (0, _getIterator3.default)(admins), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {var admin = _step4.value;
                        if (_resource4.beheerResource.fields.neverCommited(admin)) {
                            store.dispatch(_resource4.beheerResource.actions.CREATE({ item: admin }));
                        } else
                        {
                            store.dispatch(_resource4.beheerResource.actions.UPDATE({ item: admin }));
                        }
                    }} catch (err) {_didIteratorError4 = true;_iteratorError4 = err;} finally {try {if (!_iteratorNormalCompletion4 && _iterator4.return) {_iterator4.return();}} finally {if (_didIteratorError4) {throw _iteratorError4;}}}
                var questions = _resource5.questionsResource.selectors.items(store.getState()).filter(function (x) {return _resource5.questionsResource.fields.error(x);});var _iteratorNormalCompletion5 = true;var _didIteratorError5 = false;var _iteratorError5 = undefined;try {
                    for (var _iterator5 = (0, _getIterator3.default)(questions), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {var question = _step5.value;
                        if (_resource5.questionsResource.fields.neverCommited(question)) {
                            store.dispatch(_resource5.questionsResource.actions.CREATE({ item: question }));
                        } else
                        {
                            store.dispatch(_resource5.questionsResource.actions.UPDATE({ item: question }));
                        }
                    }} catch (err) {_didIteratorError5 = true;_iteratorError5 = err;} finally {try {if (!_iteratorNormalCompletion5 && _iterator5.return) {_iterator5.return();}} finally {if (_didIteratorError5) {throw _iteratorError5;}}}
            }
            return next(action);
        };};};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault2(_toConsumableArray2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });


var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(24);

var _extends4 = _interopRequireDefault(_extends3);

exports.createResource = createResource;

var _utils = __webpack_require__(156);

var _entityHasSameId = __webpack_require__(583);

var _fields = __webpack_require__(503);

var _makeActions = __webpack_require__(584);

var _makeDataSelectors = __webpack_require__(585);

var _makeReducer = __webpack_require__(586);

var _makeSaga = __webpack_require__(587);

var _makeSelectors = __webpack_require__(591);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function createResource(name, options) {
    if (!name) {
        throw new Error('resource requires a name');
    }
    if (!options) {
        throw new Error('resource requires options');
    }
    options = (0, _extends4.default)({
        id: 'id' },
    options);
    var descriptor = {
        actions: (0, _makeActions.makeActions)(name),
        data: (0, _makeDataSelectors.makeDataSelectors)(options),
        fields: _fields.selectors,
        hasSameId: (0, _entityHasSameId.entityHasSameId)(options),
        name: name,
        options: options,
        selectors: (0, _makeSelectors.makeSelectors)(name, options, (0, _entityHasSameId.entityHasSameId)(options)) };


    for (var _len = arguments.length, middlewares = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        middlewares[_key - 2] = arguments[_key];
    }

    return (0, _extends4.default)({}, descriptor, {
        create: function create(props) {return (0, _extends4.default)({}, (0, _fields.stripFields)(props), (0, _defineProperty3.default)({}, _fields.fields.tempId, (0, _utils.makeTempKey)()));},
        hasSameId: descriptor.hasSameId,
        reducer: (0, _makeReducer.makeReducer)(descriptor),
        saga: (0, _makeSaga.makeSaga).apply(undefined, [descriptor].concat((0, _toConsumableArray3.default)(middlewares.map(function (f) {return f(descriptor);})))) });

}
//# sourceMappingURL=createResource.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(























noop);Object.defineProperty(exports, "__esModule", { value: true });exports.applyMiddlewares = applyMiddlewares;function applyMiddlewares() {for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {middlewares[_key] = arguments[_key];}var compiled = middlewares.reduceRight(function (next, current) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(param, last) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:return _context2.delegateYield(current(param, /*#__PURE__*/_regenerator2.default.mark(function _callee(additional) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:return _context.delegateYield(next(param, last), "t0", 1);case 1:case "end":return _context.stop();}}}, _callee, this);})), "t0", 1);case 1:case "end":return _context2.stop();}}}, _callee2, this);}));}, /*#__PURE__*/_regenerator2.default.mark(function _callee3(param) {var last,_args3 = arguments;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:last = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : noop;return _context3.delegateYield(last(param, noop), "t0", 2);case 2:case "end":return _context3.stop();}}}, _callee3, this);}));return compiled;}function noop(param, next) {return _regenerator2.default.wrap(function noop$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:case "end":return _context4.stop();}}}, _marked, this);}
//# sourceMappingURL=applyMiddlewares.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.listAddOrUpdate = listAddOrUpdate;
exports.listRemove = listRemove;

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function listAddOrUpdate(descriptor, list, bareItem, transform) {
    var hasSameId = descriptor.hasSameId;

    var count = 0;
    var res = list.map(function (item) {
        if (!hasSameId(item, bareItem)) {
            return item;
        }
        ++count;
        var updated = transform(item);
        return updated;
    });
    if (count === 0) {
        res.push(transform((0, _extends3.default)({}, bareItem)));
    }
    return res;
}
function listRemove(descriptor, list, bareItem) {
    return list.filter(function (item) {return !descriptor.hasSameId(item, bareItem);});
}
//# sourceMappingURL=list.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });

exports.isTempKey = exports.makeTempKey = undefined;

var _internal = __webpack_require__(582);

var tempKeyCounter = 0;
var makeTempKey = exports.makeTempKey = function () {return (0, _internal.internal)(Date.now() + '_' + ++tempKeyCounter + '_TEMP');};
var isTempKey = exports.isTempKey = function (key) {return (0, _internal.isInternal)(key) && /_TEMP$/.test(key);};
//# sourceMappingURL=tempKey.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.put = put;

var _effects = __webpack_require__(504);

var saga = _interopRequireWildcard(_effects);

function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

function put(action) {
    return saga.put(action);
}
//# sourceMappingURL=put.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;var _takeEvery = __webpack_require__(790);var _takeEvery2 = _interopRequireDefault(_takeEvery);
var _takeLatest = __webpack_require__(792);var _takeLatest2 = _interopRequireDefault(_takeLatest);
var _throttle = __webpack_require__(793);var _throttle2 = _interopRequireDefault(_throttle);

var _utils = __webpack_require__(242);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));exports.

takeEvery = takeEvery;exports.takeLatest = takeLatest;exports.throttle = throttle;exports.takeEveryHelper = _takeEvery2.default;exports.takeLatestHelper = _takeLatest2.default;exports.throttleHelper = _throttle2.default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



takeEvery;var _fsmIterator = __webpack_require__(526);var _fsmIterator2 = _interopRequireDefault(_fsmIterator);var _io = __webpack_require__(505);var _channel = __webpack_require__(527);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
  setAction = function setAction(ac) {
    return action = ac;
  };

  return (0, _fsmIterator2.default)({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
    } },
  'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
}module.exports = exports['default'];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.


























asap = asap;exports.












suspend = suspend;exports.













flush = flush;var queue = []; /**
                                Variable to hold a counting semaphore
                                - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
                                  already suspended)
                                - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
                                  triggers flushing the queued tasks.
                              **/var semaphore = 0; /**
                                                      Executes a task 'atomically'. Tasks scheduled during this execution will be queued
                                                      and flushed after this task has finished (assuming the scheduler endup in a released
                                                      state).
                                                    **/function exec(task) {try {suspend();task();} finally {release();}} /**
                                                                                                                            Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
                                                                                                                          **/function asap(task) {queue.push(task);if (!semaphore) {suspend();flush();}} /**
                                                                                                                                                                                                           Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
                                                                                                                                                                                                           scheduler is released.
                                                                                                                                                                                                         **/function suspend() {semaphore++;} /**
                                                                                                                                                                                                                                                Puts the scheduler in a `released` state.
                                                                                                                                                                                                                                              **/function release() {semaphore--;} /**
                                                                                                                                                                                                                                                                                     Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
                                                                                                                                                                                                                                                                                   **/function flush() {release();var task = void 0;while (!semaphore && (task = queue.shift()) !== undefined) {exec(task);}}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



takeLatest;var _fsmIterator = __webpack_require__(526);var _fsmIterator2 = _interopRequireDefault(_fsmIterator);var _io = __webpack_require__(505);var _channel = __webpack_require__(527);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
  action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return (0, _fsmIterator2.default)({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    } },
  'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
}module.exports = exports['default'];

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





throttle;var _fsmIterator = __webpack_require__(526);var _fsmIterator2 = _interopRequireDefault(_fsmIterator);var _io = __webpack_require__(505);var _channel = __webpack_require__(527);var _buffers = __webpack_require__(588);var _utils = __webpack_require__(242);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
  channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return (0, _fsmIterator2.default)({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    } },
  'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
}module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.take = take;

var _effects = __webpack_require__(504);

var saga = _interopRequireWildcard(_effects);

var _transform = __webpack_require__(528);

function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

function take(pattern) {
    return saga.take((0, _transform.transform)(pattern));
}
//# sourceMappingURL=take.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.takeEvery = takeEvery;

var _effects = __webpack_require__(504);

var effects = _interopRequireWildcard(_effects);

var _transform = __webpack_require__(528);

function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

function takeEvery(pattern, worker) {
    return effects.takeEvery((0, _transform.transform)(pattern), worker);
}
//# sourceMappingURL=takeEvery.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.takeLatest = takeLatest;

var _effects = __webpack_require__(504);

var effects = _interopRequireWildcard(_effects);

var _transform = __webpack_require__(528);

function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

function takeLatest(pattern, worker) {
    return effects.takeLatest((0, _transform.transform)(pattern), worker);
}
//# sourceMappingURL=takeLatest.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80);
__webpack_require__(66);
module.exports = __webpack_require__(798);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(159);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(67);
module.exports = __webpack_require__(13).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var contains_1 = __webpack_require__(800);
exports.contains = contains_1.default;
var intersect_1 = __webpack_require__(801);
exports.intersect = intersect_1.default;
var same_1 = __webpack_require__(802);
exports.same = same_1.default;
var empty_1 = __webpack_require__(803);
exports.empty = empty_1.default;
var first_1 = __webpack_require__(804);
exports.first = first_1.default;
var last_1 = __webpack_require__(805);
exports.last = last_1.default;
var rotate_1 = __webpack_require__(806);
exports.rotate = rotate_1.default;
var mapMany_1 = __webpack_require__(807);
exports.mapMany = mapMany_1.default;
var mapManyNative_1 = __webpack_require__(808);
exports.mapManyNative = mapManyNative_1.default;
var distinct_1 = __webpack_require__(809);
exports.distinct = distinct_1.default;
var select_1 = __webpack_require__(810);
exports.select = select_1.default;
var any_1 = __webpack_require__(811);
exports.any = any_1.default;
var all_1 = __webpack_require__(812);
exports.all = all_1.default;
var none_1 = __webpack_require__(813);
exports.none = none_1.default;
var where_1 = __webpack_require__(814);
exports.where = where_1.default;
var count_1 = __webpack_require__(815);
exports.count = count_1.default;
var includes_1 = __webpack_require__(816);
exports.includes = includes_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function contains(l, r, comparer) {
    var found, i, ii, j, jj;
    if (comparer) {
        for (i = 0, ii = r.length; i < ii; i++) {
            found = false;
            for (j = 0, jj = l.length; j < jj; j++) {
                if (found = comparer(l[j], r[i])) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                return false;
            }
        }
    } else
    {
        for (i = 0, ii = r.length; i < ii; i++) {
            found = false;
            for (j = 0, jj = l.length; j < jj; j++) {
                if (found = l[j] === r[i]) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                return false;
            }
        }
    }
    return true;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = contains;
//# sourceMappingURL=contains.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function intersect(l, r, comparer) {
    var i, ii, j, jj;
    l = l.slice(0);
    r = r.slice(0);
    var len = Math.min(l.length, r.length);
    var res = new Array(len);
    var pos = 0;
    var x = 0;
    if (comparer) {
        for (i = 0, ii = l.length; i < ii; i++) {
            for (j = 0, jj = r.length; j < jj; j++) {
                if (r[j] === undefined)
                continue;
                if (comparer(l[i], r[j])) {
                    res[pos++] = l[i];
                    r[j] = undefined;
                    break;
                }
            }
        }
    } else
    {
        for (i = 0, ii = l.length; i < ii; i++) {
            for (j = 0, jj = r.length; j < jj; j++) {
                if (r[j] === undefined)
                continue;
                if (l[i] === r[j]) {
                    res[pos++] = l[i];
                    r[j] = undefined;
                    break;
                }
            }
        }
    }
    res.length = pos;
    return res;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = intersect;
//# sourceMappingURL=intersect.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function same(l, r, comparer) {
    var i, ii, j, jj;
    if (l.length !== r.length)
    return false;
    if (comparer) {
        for (i = 0, ii = l.length; i < ii; i++) {
            if (!comparer(l[i], r[i])) {
                return false;
            }
        }
    } else
    {
        for (i = 0, ii = l.length; i < ii; i++) {
            if (l[i] !== r[i]) {
                return false;
            }
        }
    }
    return true;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = same;
//# sourceMappingURL=same.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function empty(items) {
    return items.length === 0;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = empty;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function first(items, predicate) {
    if (predicate) {
        for (var i = 0, ii = items.length; i < ii; i++) {
            if (predicate(items[i], i, items)) {
                return items[i];
            }
        }
    } else
    {
        return items[0];
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function last(items, predicate) {
    var i = items.length;
    if (predicate) {
        while (i--) {
            if (predicate(items[i], i, items)) {
                return items[i];
            }
        }
    } else
    {
        return items[--i];
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function rotate(items, offset) {
    var end = items.length;
    if (offset === 0 || end === 0)
    return items.slice(0);
    var start = end - offset;
    while (start >= end) {
        start -= end;}
    while (start < 0) {
        start += end;}
    if (offset === 0)
    return items.slice(0);
    return [].concat((0, _toConsumableArray3.default)(
    items.slice(start, end)), (0, _toConsumableArray3.default)(
    items.slice(0, start)));

}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = rotate;
//# sourceMappingURL=rotate.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function mapMany(items, selector) {
    if (selector) {
        var ii = items.length;
        var res = Array(ii);
        var count = 0;
        for (var i = 0; i < ii; i++) {
            var deep = selector(items[i], i, items);
            if (deep === undefined)
            continue;
            for (var j = 0, jj = deep.length; j < jj; j++) {
                res[count++] = deep[j];
            }
        }
        res.length = count;
        return res;
    } else
    {
        var _ii = items.length;
        var res = Array(_ii);
        var count = 0;
        for (var _i = 0; _i < _ii; _i++) {
            var _deep = items[_i];
            for (var _j = 0, _jj = _deep.length; _j < _jj; _j++) {
                res[count++] = _deep[_j];
            }
        }
        res.length = count;
        return res;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = mapMany;
//# sourceMappingURL=mapMany.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function mapMany(items, selector) {
    if (selector) {
        return Array.prototype.concat.apply([], items.map(selector));
    } else
    {
        return Array.prototype.concat.apply([], items);
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = mapMany;
//# sourceMappingURL=mapManyNative.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function distinct(items, selector) {
    var ii = items.length;
    var res = new Array(ii);
    var tmp = new Array();
    var tmpPos = 0;
    var pos = 0,key = void 0;
    if (selector) {
        for (var i = 0; i < ii; i++) {
            key = selector(items[i], i, items);
            if (tmp.indexOf(key) === -1) {
                tmp[tmpPos++] = key;
                res[pos++] = items[i];
            }
        }
    } else
    {
        for (var i = 0; i < ii; i++) {
            if (tmp.indexOf(items[i]) === -1) {
                res[pos++] = tmp[tmpPos++] = items[i];
            }
        }
    }
    res.length = pos;
    return res;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function select(items, selector) {
    var ii = items.length;
    var r = Array(ii);
    for (var i = 0; i < ii; i++) {
        r[i] = selector(items[i], i, items);
    }
    return r;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = select;
//# sourceMappingURL=select.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function any(items, predicate) {
    if (predicate) {
        for (var i = 0, ii = items.length; i < ii; i++) {
            if (predicate(items[i], i, items)) {
                return true;
            }
        }
        return false;
    } else
    {
        return items.length > 0;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = any;
//# sourceMappingURL=any.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function all(items, predicate) {
    for (var i = 0, ii = items.length; i < ii; i++) {
        if (!predicate(items[i], i, items)) {
            return false;
        }
    }
    return true;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = all;
//# sourceMappingURL=all.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function none(items, predicate) {
    if (items.length === 0) {
        return true;
    }
    if (predicate) {
        for (var i = 0, ii = items.length; i < ii; i++) {
            if (predicate(items[i], i, items)) {
                return false;
            }
        }
        return true;
    } else
    {
        return false;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = none;
//# sourceMappingURL=none.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function where(items, predicate) {
    var r = Array();
    var i,ii,j = 0;
    for (i = 0, ii = items.length; i < ii; i++) {
        if (predicate(items[i], i, items)) {
            r[j++] = items[i];
        }
    }
    return r;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = where;
//# sourceMappingURL=where.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function count(items, predicate) {
    if (predicate) {
        var _count = 0;
        for (var i = 0, ii = items.length; i < ii; i++) {
            _count = _count + (predicate(items[i], i, items) ? 1 : 0);
        }
        return _count;
    } else
    {
        return items.length;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function includes(items, value) {
    for (var i = 0, ii = items.length; i < ii; i++) {
        if (items[i] === value) {
            return true;
        }
    }
    return false;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = includes;
//# sourceMappingURL=includes.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                   * UAParser.js v0.7.17
                                                                                                                                                                                                                   * Lightweight JavaScript-based User-Agent string parser
                                                                                                                                                                                                                   * https://github.com/faisalman/ua-parser-js
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
                                                                                                                                                                                                                   * Dual licensed under GPLv2 & MIT
                                                                                                                                                                                                                   */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION = '0.7.17',
    EMPTY = '',
    UNKNOWN = '?',
    FUNC_TYPE = 'function',
    UNDEF_TYPE = 'undefined',
    OBJ_TYPE = 'object',
    STR_TYPE = 'string',
    MAJOR = 'major', // deprecated
    MODEL = 'model',
    NAME = 'name',
    TYPE = 'type',
    VENDOR = 'vendor',
    VERSION = 'version',
    ARCHITECTURE = 'architecture',
    CONSOLE = 'console',
    MOBILE = 'mobile',
    TABLET = 'tablet',
    SMARTTV = 'smarttv',
    WEARABLE = 'wearable',
    EMBEDDED = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend: function extend(regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has: function has(str1, str2) {
            if (typeof str1 === "string") {
                return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
            } else {
                return false;
            }
        },
        lowerize: function lowerize(str) {
            return str.toLowerCase();
        },
        major: function major(version) {
            return (typeof version === 'undefined' ? 'undefined' : (0, _typeof3.default)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
        },
        trim: function trim(str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        } };



    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx: function rgx(ua, arrays) {

            //var result = {},
            var i = 0,j,k,p,q,matches,match; //, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i], // even sequence (0,2,4,..)
                props = arrays[i + 1]; // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if ((typeof q === 'undefined' ? 'undefined' : (0, _typeof3.default)(q)) === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if ((0, _typeof3.default)(q[1]) == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if ((0, _typeof3.default)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str: function str(_str, map) {

            for (var i in map) {
                // check if array
                if ((0, _typeof3.default)(map[i]) === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], _str)) {
                            return i === UNKNOWN ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], _str)) {
                    return i === UNKNOWN ? undefined : i;
                }
            }
            return _str;
        } };



    ///////////////
    // String map
    //////////////


    var maps = {

        browser: {
            oldsafari: {
                version: {
                    '1.0': '/8',
                    '1.2': '/1',
                    '1.3': '/3',
                    '2.0': '/412',
                    '2.0.2': '/416',
                    '2.0.3': '/417',
                    '2.0.4': '/419',
                    '?': '/' } } },




        device: {
            amazon: {
                model: {
                    'Fire Phone': ['SD', 'KF'] } },


            sprint: {
                model: {
                    'Evo Shift 4G': '7373KT' },

                vendor: {
                    'HTC': 'APA',
                    'Sprint': 'Sprint' } } },




        os: {
            windows: {
                version: {
                    'ME': '4.90',
                    'NT 3.11': 'NT3.51',
                    'NT 4.0': 'NT4.0',
                    '2000': 'NT 5.0',
                    'XP': ['NT 5.1', 'NT 5.2'],
                    'Vista': 'NT 6.0',
                    '7': 'NT 6.1',
                    '8': 'NT 6.2',
                    '8.1': 'NT 6.3',
                    '10': ['NT 6.4', 'NT 10.0'],
                    'RT': 'ARM' } } } };






    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser: [[

        // Presto based
        /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
        /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
        /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
        /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
        ], [NAME, VERSION], [

        /(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
        ], [[NAME, 'Opera Mini'], VERSION], [

        /\s(opr)\/([\w\.]+)/i // Opera Webkit
        ], [[NAME, 'Opera'], VERSION], [

        // Mixed
        /(kindle)\/([\w\.]+)/i, // Kindle
        /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
        // Lunascape/Maxthon/Netfront/Jasmine/Blazer

        // Trident based
        /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
        // Avant/IEMobile/SlimBrowser/Baidu
        /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer

        // Webkit/KHTML based
        /(rekonq)\/([\w\.]+)*/i, // Rekonq
        /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
        // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
        ], [NAME, VERSION], [

        /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
        ], [[NAME, 'IE'], VERSION], [

        /(edge)\/((\d+)?[\w\.]+)/i // Microsoft Edge
        ], [NAME, VERSION], [

        /(yabrowser)\/([\w\.]+)/i // Yandex
        ], [[NAME, 'Yandex'], VERSION], [

        /(puffin)\/([\w\.]+)/i // Puffin
        ], [[NAME, 'Puffin'], VERSION], [

        /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
        // UCBrowser
        ], [[NAME, 'UCBrowser'], VERSION], [

        /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
        ], [[NAME, /_/g, ' '], VERSION], [

        /(micromessenger)\/([\w\.]+)/i // WeChat
        ], [[NAME, 'WeChat'], VERSION], [

        /(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
        ], [NAME, VERSION], [

        /m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
        ], [NAME, VERSION], [

        /xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
        ], [VERSION, [NAME, 'MIUI Browser']], [

        /;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
        ], [VERSION, [NAME, 'Facebook']], [

        /headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
        ], [VERSION, [NAME, 'Chrome Headless']], [

        /\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
        ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

        /((?:oculus|samsung)browser)\/([\w\.]+)/i],
        [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [// Oculus / Samsung Browser

        /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
        ], [VERSION, [NAME, 'Android Browser']], [

        /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
        // Chrome/OmniWeb/Arora/Tizen/Nokia
        ], [NAME, VERSION], [

        /(dolfin)\/([\w\.]+)/i // Dolphin
        ], [[NAME, 'Dolphin'], VERSION], [

        /((?:android.+)crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
        ], [[NAME, 'Chrome'], VERSION], [

        /(coast)\/([\w\.]+)/i // Opera Coast
        ], [[NAME, 'Opera Coast'], VERSION], [

        /fxios\/([\w\.-]+)/i // Firefox for iOS
        ], [VERSION, [NAME, 'Firefox']], [

        /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
        ], [VERSION, [NAME, 'Mobile Safari']], [

        /version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
        ], [VERSION, NAME], [

        /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
        ], [[NAME, 'GSA'], VERSION], [

        /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
        ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

        /(konqueror)\/([\w\.]+)/i, // Konqueror
        /(webkit|khtml)\/([\w\.]+)/i],
        [NAME, VERSION], [

        // Gecko based
        /(navigator|netscape)\/([\w\.-]+)/i // Netscape
        ], [[NAME, 'Netscape'], VERSION], [
        /(swiftfox)/i, // Swiftfox
        /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
        /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
        /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla

        // Other
        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
        /(links)\s\(([\w\.]+)/i, // Links
        /(gobrowser)\/?([\w\.]+)*/i, // GoBrowser
        /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
        /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
        ], [NAME, VERSION]

        /* /////////////////////
                           // Media players BEGIN
                           ////////////////////////
                            , [
                            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
                           /(coremedia) v((\d+)[\w\._]+)/i
                           ], [NAME, VERSION], [
                            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
                           ], [NAME, VERSION], [
                            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
                           ], [NAME, VERSION], [
                            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                               // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                               // NSPlayer/PSP-InternetRadioPlayer/Videos
                           /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
                           /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
                           /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
                           ], [NAME, VERSION], [
                           /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
                           ], [NAME, VERSION], [
                            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
                           ], [[NAME, 'Flip Player'], VERSION], [
                            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                               // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
                           ], [NAME], [
                            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                               // Gstreamer
                           ], [NAME, VERSION], [
                            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
                           /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                               // Java/urllib/requests/wget/cURL
                           /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
                           ], [NAME, VERSION], [
                            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
                           ], [[NAME, /_/g, ' '], VERSION], [
                            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                               // MPlayer SVN
                           ], [NAME, VERSION], [
                            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
                           ], [NAME, VERSION], [
                            /(mplayer)/i,                                                       // MPlayer (no other info)
                           /(yourmuze)/i,                                                      // YourMuze
                           /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
                           ], [NAME], [
                            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
                           ], [NAME, VERSION], [
                            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
                           ], [NAME, VERSION], [
                            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
                           ], [NAME, VERSION], [
                            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
                           /(winamp)\s((\d+)[\w\.-]+)/i,
                           /(winamp)mpeg\/((\d+)[\w\.-]+)/i
                           ], [NAME, VERSION], [
                            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                               // inlight radio
                           ], [NAME], [
                            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                               // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                               // SoundTap/Totem/Stagefright/Streamium
                           ], [NAME, VERSION], [
                            /(smp)((\d+)[\d\.]+)/i                                              // SMP
                           ], [NAME, VERSION], [
                            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
                           /(vlc)\/((\d+)[\w\.-]+)/i,
                           /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
                           /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
                           /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
                           ], [NAME, VERSION], [
                            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
                           /(windows-media-player)\/((\d+)[\w\.-]+)/i
                           ], [[NAME, /-/g, ' '], VERSION], [
                            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                               // Windows Media Server
                           ], [VERSION, [NAME, 'Windows']], [
                            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
                           ], [NAME, VERSION], [
                            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
                           /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
                           ], [[NAME, 'rad.io'], VERSION]
                            //////////////////////
                           // Media players END
                           ////////////////////*/],





























        cpu: [[

        /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
        ], [[ARCHITECTURE, 'amd64']], [

        /(ia32(?=;))/i // IA32 (quicktime)
        ], [[ARCHITECTURE, util.lowerize]], [

        /((?:i[346]|x)86)[;\)]/i // IA32
        ], [[ARCHITECTURE, 'ia32']], [

        // PocketPC mistakenly identified as PowerPC
        /windows\s(ce|mobile);\sppc;/i],
        [[ARCHITECTURE, 'arm']], [

        /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
        ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

        /(sun4\w)[;\)]/i // SPARC
        ], [[ARCHITECTURE, 'sparc']], [

        /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
        // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ], [[ARCHITECTURE, util.lowerize]]],


        device: [[

        /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i // iPad/PlayBook
        ], [MODEL, VENDOR, [TYPE, TABLET]], [

        /applecoremedia\/[\w\.]+ \((ipad)/ // iPad
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

        /(apple\s{0,1}tv)/i // Apple TV
        ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

        /(archos)\s(gamepad2?)/i, // Archos
        /(hp).+(touchpad)/i, // HP TouchPad
        /(hp).+(tablet)/i, // HP Tablet
        /(kindle)\/([\w\.]+)/i, // Kindle
        /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
        /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
        ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i // Kindle Fire HD
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
        /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i // Fire Phone
        ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

        /\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
        ], [MODEL, VENDOR, [TYPE, MOBILE]], [
        /\((ip[honed|\s\w*]+);/i // iPod/iPhone
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

        /(blackberry)[\s-]?(\w+)/i, // BlackBerry
        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
        // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
        /(hp)\s([\w\s]+\w)/i, // HP iPAQ
        /(asus)-?(\w+)/i // Asus
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
        /\(bb10;\s(\w+)/i // BlackBerry 10
        ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
        // Asus Tablets
        /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],
        [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

        /(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
        /(sony)?(?:sgp.+)\sbuild\//i],
        [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
        /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],
        [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

        /\s(ouya)\s/i, // Ouya
        /(nintendo)\s([wids3u]+)/i // Nintendo
        ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

        /android.+;\s(shield)\sbuild/i // Nvidia
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

        /(playstation\s[34portablevi]+)/i // Playstation
        ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

        /(sprint\s(\w+))/i // Sprint Phones
        ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

        /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i // Lenovo tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, // HTC
        /(zte)-(\w+)*/i, // ZTE
        /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
        // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
        ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

        /(nexus\s9)/i // HTC Nexus 9
        ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

        /d\/huawei([\w\s-]+)[;\)]/i,
        /(nexus\s6p)/i // Huawei
        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

        /(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [

        /[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
        ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
        /(kin\.[onetw]{3})/i // Microsoft Kin
        ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

        // Motorola
        /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
        /mot[\s-]?(\w+)*/i,
        /(XT\d{3,4}) build\//i,
        /(nexus\s6)/i],
        [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
        /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
        [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

        /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
        ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

        /hbbtv.+maple;(\d+)/i],
        [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

        /\(dtv[\);].+(aquos)/i // Sharp
        ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

        /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
        /((SM-T\w+))/i],
        [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [// Samsung
        /smart-tv.+(samsung)/i],
        [VENDOR, [TYPE, SMARTTV], MODEL], [
        /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
        /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
        /sec-((sgh\w+))/i],
        [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

        /sie-(\w+)*/i // Siemens
        ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

        /(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
        /(nokia)[\s_-]?([\w-]+)*/i],
        [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

        /android\s3\.[\s\w;-]{10}(a\d{3})/i // Acer
        ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

        /android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
        ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
        /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
        ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
        /(lg) netcast\.tv/i // LG SmartTV
        ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
        /(nexus\s[45])/i, // LG
        /lg[e;\s\/-]+(\w+)*/i,
        /android.+lg(\-?[\d\w]+)\s+build/i],
        [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

        /android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
        ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

        /linux;.+((jolla));/i // Jolla
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [

        /((pebble))app\/[\d\.]+\s/i // Pebble
        ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

        /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [

        /crkey/i // Google Chromecast
        ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

        /android.+;\s(glass)\s\d/i // Google Glass
        ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

        /android.+;\s(pixel c)\s/i // Google Pixel C
        ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

        /android.+;\s(pixel xl|pixel)\s/i // Google Pixel
        ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

        /android.+(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
        /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
        /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Mi
        /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i // Redmi Phones
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
        /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i // Mi Pad tablets
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
        /android.+;\s(m[1-5]\snote)\sbuild/i // Meizu Tablet
        ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

        /android.+a000(1)\s+build/i // OnePlus
        ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

        /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
        ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i // Dell Venue Tablets
        ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
        ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

        /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
        ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

        /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
        ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i // ZTE K Series Tablet
        ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

        /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

        /android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

        /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
        ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

        /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
        /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i // Dragon Touch Tablet
        ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

        /android.+[;\/]\s*(NS-?.+)\s+build/i // Insignia Tablets
        ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

        /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i // NextBook Tablets
        ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],
        [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones

        /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i // LvTel Phones
        ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

        /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
        ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i // Le Pan Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
        ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

        /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
        ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

        /android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

        /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i // Gigaset Tablets
        ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
        /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
        ], [[TYPE, util.lowerize], VENDOR, MODEL], [

        /(android.+)[;\/].+build/i // Generic Android Device
        ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
                                            // TODO: move to string map
                                            ////////////////////////////
                                             /(C6603)/i                                                          // Sony Xperia Z C6603
                                            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
                                            /(C6903)/i                                                          // Sony Xperia Z 1
                                            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
                                             /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
                                            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
                                            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
                                            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
                                            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
                                            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
                                            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
                                            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
                                            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
                                            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
                                            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
                                            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
                                            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
                                            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
                                             /(T3C)/i                                                            // Advan Vandroid T3C
                                            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
                                            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
                                            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
                                            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
                                            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
                                             /(V972M)/i                                                          // ZTE V972M
                                            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
                                             /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
                                            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
                                            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
                                            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
                                            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
                                            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
                                            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
                                            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
                                             /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
                                            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
                                             /////////////
                                            // END TODO
                                            ///////////*/],










        engine: [[

        /windows.+\sedge\/([\w\.]+)/i // EdgeHTML
        ], [VERSION, [NAME, 'EdgeHTML']], [

        /(presto)\/([\w\.]+)/i, // Presto
        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
        /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
        /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
        ], [NAME, VERSION], [

        /rv\:([\w\.]+).*(gecko)/i // Gecko
        ], [VERSION, NAME]],


        os: [[

        // Windows based
        /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
        ], [NAME, VERSION], [
        /(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
        /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i, // Windows Phone
        /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],
        [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
        /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
        [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

        // Mobile/Embedded OS
        /\((bb)(10);/i // BlackBerry 10
        ], [[NAME, 'BlackBerry'], VERSION], [
        /(blackberry)\w*\/?([\w\.]+)*/i, // Blackberry
        /(tizen)[\/\s]([\w\.]+)/i, // Tizen
        /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
        // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
        /linux;.+(sailfish);/i // Sailfish OS
        ], [NAME, VERSION], [
        /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i // Symbian
        ], [[NAME, 'Symbian'], VERSION], [
        /\((series40);/i // Series 40
        ], [NAME], [
        /mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
        ], [[NAME, 'Firefox OS'], VERSION], [

        // Console
        /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation

        // GNU/Linux based
        /(mint)[\/\s\(]?(\w+)*/i, // Mint
        /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
        /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
        // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
        // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
        /(hurd|linux)\s?([\w\.]+)*/i, // Hurd/Linux
        /(gnu)\s?([\w\.]+)*/i // GNU
        ], [NAME, VERSION], [

        /(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
        ], [[NAME, 'Chromium OS'], VERSION], [

        // Solaris
        /(sunos)\s?([\w\.]+\d)*/i // Solaris
        ], [[NAME, 'Solaris'], VERSION], [

        // BSD based
        /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
        ], [NAME, VERSION], [

        /(haiku)\s(\w+)/i // Haiku
        ], [NAME, VERSION], [

        /cfnetwork\/.+darwin/i,
        /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
        ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

        /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
        /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
        ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

        // Other
        /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i, // Solaris
        /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i, // AIX
        /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
        // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
        /(unix)\s?([\w\.]+)*/i // UNIX
        ], [NAME, VERSION]] };




    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function UAParser(uastring, extensions) {

        if ((typeof uastring === 'undefined' ? 'undefined' : (0, _typeof3.default)(uastring)) === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU() };

        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME: NAME,
        MAJOR: MAJOR, // deprecated
        VERSION: VERSION };

    UAParser.CPU = {
        ARCHITECTURE: ARCHITECTURE };

    UAParser.DEVICE = {
        MODEL: MODEL,
        VENDOR: VENDOR,
        TYPE: TYPE,
        CONSOLE: CONSOLE,
        MOBILE: MOBILE,
        SMARTTV: SMARTTV,
        TABLET: TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED };

    UAParser.ENGINE = {
        NAME: NAME,
        VERSION: VERSION };

    UAParser.OS = {
        NAME: NAME,
        VERSION: VERSION };

    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (( false ? 'undefined' : (0, _typeof3.default)(exports)) !== UNDEF_TYPE) {
        // nodejs env
        if (( false ? 'undefined' : (0, _typeof3.default)(module)) !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (( false ? 'undefined' : (0, _typeof3.default)(__webpack_require__(818))) === FUNC_TYPE && __webpack_require__(653)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if ((typeof $ === 'undefined' ? 'undefined' : (0, _typeof3.default)($)) !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' ? window : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(579)(module)))

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.createEditor = createEditor;

var _makeEditorActions = __webpack_require__(820);

var _makeEditorReducer = __webpack_require__(821);

var _makeEditorSaga = __webpack_require__(822);

var _makeEditorSelectors = __webpack_require__(823);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function createEditor(name, options, resource) {
    if (!name) {
        throw new Error('editor requires a name');
    }
    if (!options) {
        throw new Error('editor requires options');
    }
    if (!resource) {
        throw new Error('editor requires resource');
    }
    options = (0, _extends3.default)({
        createImmediately: true,
        id: 'id' },
    options);
    var descriptor = {
        actions: (0, _makeEditorActions.makeEditorActions)(name),
        name: name,
        options: options,
        resource: resource,
        selectors: (0, _makeEditorSelectors.makeEditorSelectors)(name, options, resource) };


    for (var _len = arguments.length, middlewares = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        middlewares[_key - 3] = arguments[_key];
    }

    return (0, _extends3.default)({}, descriptor, {
        reducer: (0, _makeEditorReducer.makeEditorReducer)(descriptor, options),
        resource: resource,
        saga: (0, _makeEditorSaga.makeEditorSaga)(descriptor, options, middlewares) });

}
//# sourceMappingURL=index.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.makeEditorActions = makeEditorActions;

var _fsa = __webpack_require__(1);

var _utils = __webpack_require__(156);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeEditorActions(name) {
    var res = {
        APPLY: (0, _fsa.Action)((0, _utils.internal)('EDITOR/APPLY_' + name.toUpperCase())),
        CREATE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/CREATE_' + name.toUpperCase())),
        CREATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('EDITOR/CREATE_' + name.toUpperCase() + '_CANCEL')),
        CREATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/CREATE_' + name.toUpperCase() + '_CONTINUE')),
        DELETE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/DELETE_' + name.toUpperCase())),
        DELETE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('EDITOR/DELETE_' + name.toUpperCase() + '_CANCEL')),
        DELETE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/DELETE_' + name.toUpperCase() + '_CONTINUE')),
        READ: (0, _fsa.Action)((0, _utils.internal)('EDITOR/READ_' + name.toUpperCase())),
        READ_CANCEL: (0, _fsa.Action)((0, _utils.internal)('EDITOR/READ_' + name.toUpperCase() + '_CANCEL')),
        READ_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/READ_' + name.toUpperCase() + '_SUCCESS')),
        RESET: (0, _fsa.Action)((0, _utils.internal)('EDITOR/RESET_' + name.toUpperCase())),
        UPDATE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/UPDATE_' + name.toUpperCase())),
        UPDATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('EDITOR/UPDATE_' + name.toUpperCase() + '_CANCEL')),
        UPDATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('EDITOR/UPDATE_' + name.toUpperCase() + '_CONTINUE')) };

    var all = [res.APPLY, res.CREATE, res.CREATE_CANCEL, res.CREATE_CONTINUE, res.DELETE, res.DELETE_CANCEL, res.DELETE_CONTINUE, res.READ, res.READ_CANCEL, res.READ_CONTINUE, res.RESET, res.UPDATE, res.UPDATE_CANCEL, res.UPDATE_CONTINUE];
    return (0, _extends3.default)({}, res, { all: all });
}
//# sourceMappingURL=makeEditorActions.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.makeEditorReducer = makeEditorReducer;

var _es = __webpack_require__(1);

var _resource = __webpack_require__(485);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeEditorReducer(descriptor, options) {
    var emptyState = {
        creating: false,
        deleting: false,
        error: null,
        item: {},
        reading: false,
        updating: false };

    var actions = descriptor.actions;

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
        var action = arguments[1];

        if ((0, _es.isType)(action, actions.APPLY)) {
            return (0, _extends3.default)({}, state, { item: (0, _extends3.default)({}, state.item, (0, _resource.stripFields)(action.payload.item)) });
        } else if ((0, _es.isType)(action, actions.CREATE)) {
            return (0, _extends3.default)({}, state, { creating: true, reading: false, updating: false, deleting: false, item: descriptor.resource.create(action.payload.item) });
        } else if ((0, _es.isType)(action, actions.CREATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { creating: false, item: {} });
        } else if ((0, _es.isType)(action, actions.CREATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { creating: false, item: (0, _extends3.default)({}, state.item, action.payload.item) });
        } else if ((0, _es.isType)(action, actions.READ)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: true, updating: false, deleting: false, item: action.payload.item });
        } else if ((0, _es.isType)(action, actions.READ_CANCEL)) {
            return (0, _extends3.default)({}, state, { reading: false, item: {} });
        } else if ((0, _es.isType)(action, actions.READ_CONTINUE)) {
            return (0, _extends3.default)({}, state, { reading: false, item: (0, _extends3.default)({}, state.item, action.payload.item) });
        } else if ((0, _es.isType)(action, actions.UPDATE)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: false, updating: true, deleting: false, item: action.payload.item });
        } else if ((0, _es.isType)(action, actions.UPDATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { updating: false, item: {} });
        } else if ((0, _es.isType)(action, actions.UPDATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { updating: false, item: (0, _extends3.default)({}, state.item, action.payload.item) });
        } else if ((0, _es.isType)(action, actions.DELETE)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: false, updating: false, deleting: true, item: action.payload.item });
        } else if ((0, _es.isType)(action, actions.DELETE_CANCEL)) {
            return (0, _extends3.default)({}, state, { deleting: false, item: {} });
        } else if ((0, _es.isType)(action, actions.DELETE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { deleting: false, item: (0, _extends3.default)({}, state.item, action.payload.item) });
        } else if ((0, _es.isType)(action, actions.RESET)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: false, updating: false, deleting: false, error: null, item: {} });
        } else {
            return state;
        }
    };
}
//# sourceMappingURL=makeEditorReducer.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });

exports.makeEditorSaga = makeEditorSaga;

var _fsaSaga = __webpack_require__(59);

var _es = __webpack_require__(1);

var _effects = __webpack_require__(220);

var _utils = __webpack_require__(156);

function interceptor(descriptor, actionType, cb) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee(action, next) {var item;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                            (0, _es.isType)(action, actionType)) {_context.next = 5;break;}_context.next = 3;return (
                                (0, _effects.select)(descriptor.selectors.item));case 3:item = _context.sent;return _context.delegateYield(
                            cb(action, item), 't0', 5);case 5:return _context.delegateYield(

                            next(action), 't1', 6);case 6:case 'end':return _context.stop();}}}, _callee, this);}));

}
function stopMiddleware(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(action, next) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:case 'end':return _context2.stop();}}}, _callee2, this);}));
}
function resourceCreateImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE, /*#__PURE__*/_regenerator2.default.mark(function _callee3(action, item) {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                            (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item })));case 2:case 'end':return _context3.stop();}}}, _callee3, this);}));

}
function resourceCreateDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE, function (action, item) {});
}
function resourceCreateContinueImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE_CONTINUE, /*#__PURE__*/_regenerator2.default.mark(function _callee4(action, item) {return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
                            (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item })));case 2:case 'end':return _context4.stop();}}}, _callee4, this);}));

}
function resourceCreateContinueDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE_CONTINUE, /*#__PURE__*/_regenerator2.default.mark(function _callee5(action, item) {return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (
                            (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item })));case 2:case 'end':return _context5.stop();}}}, _callee5, this);}));

}
function resourceRead(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.READ, /*#__PURE__*/_regenerator2.default.mark(function _callee6(action, item) {var storeItem;return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (
                            (0, _effects.select)(descriptor.resource.selectors.itemByItem(item)));case 2:storeItem = _context6.sent;_context6.next = 5;return (
                            (0, _effects.put)(descriptor.actions.APPLY({ item: storeItem })));case 5:case 'end':return _context6.stop();}}}, _callee6, this);}));

}
function resourceUpdate(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE, /*#__PURE__*/_regenerator2.default.mark(function _callee7(action, item) {return _regenerator2.default.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
                            (0, _effects.put)(descriptor.actions.APPLY({ item: item })));case 2:case 'end':return _context7.stop();}}}, _callee7, this);}));

}
function resourceUpdateContinueImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE_CONTINUE, /*#__PURE__*/_regenerator2.default.mark(function _callee8(action, item) {return _regenerator2.default.wrap(function _callee8$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (
                            (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item })));case 2:case 'end':return _context8.stop();}}}, _callee8, this);}));

}
function resourceUpdateContinueDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE_CONTINUE, /*#__PURE__*/_regenerator2.default.mark(function _callee9(action, item) {var storeItem;return _regenerator2.default.wrap(function _callee9$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (
                            (0, _effects.select)(descriptor.resource.selectors.itemByItem(item)));case 2:storeItem = _context9.sent;if (!(
                        storeItem && descriptor.resource.fields.hasCommited(storeItem))) {_context9.next = 8;break;}_context9.next = 6;return (
                            (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item })));case 6:_context9.next = 10;break;case 8:_context9.next = 10;return (

                            (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item })));case 10:case 'end':return _context9.stop();}}}, _callee9, this);}));


}
function resourceDelete(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.DELETE, /*#__PURE__*/_regenerator2.default.mark(function _callee10(action, item) {var storeItem;return _regenerator2.default.wrap(function _callee10$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (
                            (0, _effects.select)(descriptor.resource.selectors.itemByItem(item)));case 2:storeItem = _context10.sent;_context10.next = 5;return (
                            (0, _effects.put)(descriptor.actions.APPLY({ item: storeItem })));case 5:case 'end':return _context10.stop();}}}, _callee10, this);}));

}
function resourceDeleteContinue(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.DELETE_CONTINUE, /*#__PURE__*/_regenerator2.default.mark(function _callee11(action, item) {return _regenerator2.default.wrap(function _callee11$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (
                            (0, _effects.put)(descriptor.resource.actions.DELETE({ item: item })));case 2:case 'end':return _context11.stop();}}}, _callee11, this);}));

}
function makeEditorSaga(descriptor, options, middlewares) {
    var resource = descriptor.resource;

    var actions = [].concat((0, _toConsumableArray3.default)(descriptor.actions.all), (0, _toConsumableArray3.default)(resource.actions.all));
    var factories = [].concat((0, _toConsumableArray3.default)(middlewares), [options.createImmediately ? resourceCreateImmediately : resourceCreateDelayed, options.createImmediately ? resourceCreateContinueImmediately : resourceCreateContinueDelayed, resourceRead, resourceUpdate, options.createImmediately ? resourceUpdateContinueImmediately : resourceUpdateContinueDelayed, resourceDelete, resourceDeleteContinue, stopMiddleware]);
    var f = (0, _utils.applyMiddlewares).apply(undefined, (0, _toConsumableArray3.default)(factories.map(function (mw) {return mw(descriptor, options);})));
    return (/*#__PURE__*/_regenerator2.default.mark(function internal() {return _regenerator2.default.wrap(function internal$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (
                                (0, _fsaSaga.takeEvery)(actions, f));case 2:case 'end':return _context12.stop();}}}, internal, this);}));

}
//# sourceMappingURL=makeEditorSaga.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.makeEditorSelectors = makeEditorSelectors;
function makeEditorSelectors(name, options, resource) {
    var scope = function scope(state) {
        var scopeName = state[name + "Editor"];
        if (!scopeName) {
            throw new Error("Register reducer of resource " + name + " in the store under: \"" + name + "Editor\"");
        }
        return scopeName;
    };
    return {
        creating: function creating(state) {return scope(state).creating;},
        deleting: function deleting(state) {return scope(state).deleting;},
        error: function error(state) {return scope(state).error;},
        isItem: function isItem(item) {return function (state) {return resource.hasSameId(item, scope(state).item);};},
        item: function item(state) {return scope(state).item;},
        original: function original(item) {return resource.selectors.itemByItem(item);},
        reading: function reading(state) {return scope(state).reading;},
        updating: function updating(state) {return scope(state).updating;} };

}
//# sourceMappingURL=makeEditorSelectors.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _createBatch = __webpack_require__(825);

Object.defineProperty(exports, 'createBatch', {
  enumerable: true,
  get: function get() {
    return _createBatch.createBatch;
  } });

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.createBatch = createBatch;

var _makeBatchActions = __webpack_require__(826);

var _makeBatchReducer = __webpack_require__(827);

var _makeBatchSaga = __webpack_require__(828);

var _makeBatchSelectors = __webpack_require__(829);

var _merger = __webpack_require__(830);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function createBatch(name, options, resource) {
    if (!name) {
        throw new Error('batch requires a name');
    }
    if (!options) {
        throw new Error('batch requires options');
    }
    if (!resource) {
        throw new Error('batch requires resource');
    }
    options = (0, _extends3.default)({
        createImmediately: true,
        id: 'id' },
    options);
    var descriptor = {
        actions: (0, _makeBatchActions.makeBatchActions)(name),
        merger: options.merger || new _merger.Merger(),
        name: name,
        options: options,
        resource: resource,
        selectors: (0, _makeBatchSelectors.makeBatchSelectors)(name, options, resource) };


    for (var _len = arguments.length, middlewares = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        middlewares[_key - 3] = arguments[_key];
    }

    return (0, _extends3.default)({}, descriptor, {
        reducer: (0, _makeBatchReducer.makeBatchReducer)(descriptor, options),
        resource: resource,
        saga: (0, _makeBatchSaga.makeBatchSaga)(descriptor, options, middlewares) });

}
//# sourceMappingURL=createBatch.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.makeBatchActions = makeBatchActions;

var _fsa = __webpack_require__(1);

var _utils = __webpack_require__(156);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeBatchActions(name) {
    var res = {
        APPLY: (0, _fsa.Action)((0, _utils.internal)('BATCH/APPLY_' + name.toUpperCase())),
        CREATE: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase())),
        CREATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase() + '_CANCEL')),
        CREATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase() + '_CONTINUE')),
        DELETE: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase())),
        DELETE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase() + '_CANCEL')),
        DELETE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase() + '_CONTINUE')),
        READ: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase())),
        READ_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase() + '_CANCEL')),
        READ_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase() + '_SUCCESS')),
        RESET: (0, _fsa.Action)((0, _utils.internal)('BATCH/RESET_' + name.toUpperCase())),
        UPDATE: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase())),
        UPDATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase() + '_CANCEL')),
        UPDATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase() + '_CONTINUE')) };

    var all = [res.APPLY, res.CREATE, res.CREATE_CANCEL, res.CREATE_CONTINUE, res.DELETE, res.DELETE_CANCEL, res.DELETE_CONTINUE, res.READ, res.READ_CANCEL, res.READ_CONTINUE, res.RESET, res.UPDATE, res.UPDATE_CANCEL, res.UPDATE_CONTINUE];
    return (0, _extends3.default)({}, res, { all: all });
}
//# sourceMappingURL=makeBatchActions.js.map

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });


var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

exports.makeBatchReducer = makeBatchReducer;

var _fsa = __webpack_require__(1);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function makeBatchReducer(descriptor, options) {
    var actions = descriptor.actions;

    var emptyState = {
        creating: false,
        deleting: false,
        error: null,
        item: {},
        items: [],
        reading: false,
        updating: false };

    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
        var action = arguments[1];

        if ((0, _fsa.isType)(action, actions.APPLY)) {
            return (0, _extends3.default)({}, state, { item: (0, _extends3.default)({}, state.item, action.payload.item) });

        } else if ((0, _fsa.isType)(action, actions.CREATE)) {
            return (0, _extends3.default)({}, state, { creating: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.CREATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { creating: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.CREATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { creating: false });
        } else if ((0, _fsa.isType)(action, actions.READ)) {
            return (0, _extends3.default)({}, state, { reading: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.READ_CANCEL)) {
            return (0, _extends3.default)({}, state, { reading: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.READ_CONTINUE)) {
            return (0, _extends3.default)({}, state, { reading: false });
        } else if ((0, _fsa.isType)(action, actions.UPDATE)) {
            return (0, _extends3.default)({}, state, { updating: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.UPDATE_CANCEL)) {
            return (0, _extends3.default)({}, state, { updating: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.UPDATE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { updating: false });
        } else if ((0, _fsa.isType)(action, actions.DELETE)) {
            return (0, _extends3.default)({}, state, { deleting: true, items: action.payload.items, item: {} });
        } else if ((0, _fsa.isType)(action, actions.DELETE_CANCEL)) {
            return (0, _extends3.default)({}, state, { deleting: false, items: [], item: {} });
        } else if ((0, _fsa.isType)(action, actions.DELETE_CONTINUE)) {
            return (0, _extends3.default)({}, state, { deleting: false });
        } else if ((0, _fsa.isType)(action, actions.RESET)) {
            return (0, _extends3.default)({}, state, { creating: false, reading: false, updating: false, deleting: false, items: [], item: {} });
        } else {
            return state;
        }
    };
}
//# sourceMappingURL=makeBatchReducer.js.map

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault2(_toConsumableArray2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault2(_regenerator);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });


var _getIterator2 = __webpack_require__(115);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.makeBatchSaga = makeBatchSaga;

var _fsa = __webpack_require__(1);

var _fsaSaga = __webpack_require__(59);

var _effects = __webpack_require__(220);

var _utils = __webpack_require__(156);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function stopMiddleware(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee(action, next) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:case 'end':return _context.stop();}}}, _callee, this);}));
}
function resourceUpdate(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(action, next) {var item;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!
                            (0, _fsa.isType)(action, descriptor.actions.UPDATE)) {_context2.next = 4;break;}
                            item = descriptor.merger.combine(action.payload.items);_context2.next = 4;return (
                                (0, _effects.put)(descriptor.actions.APPLY({ item: item })));case 4:return _context2.delegateYield(

                            next(action), 't0', 5);case 5:case 'end':return _context2.stop();}}}, _callee2, this);}));

}
function resourceUpdateContinueImmediately(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee3(action, next) {var items, i, ii;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (!
                            (0, _fsa.isType)(action, descriptor.actions.UPDATE_CONTINUE)) {_context3.next = 9;break;}
                            items = descriptor.merger.merge(action.payload.item, action.payload.items);
                            i = 0, ii = items.length;case 3:if (!(i < ii)) {_context3.next = 9;break;}_context3.next = 6;return (
                                (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: items[i] })));case 6:i++;_context3.next = 3;break;case 9:return _context3.delegateYield(


                            next(action), 't0', 10);case 10:case 'end':return _context3.stop();}}}, _callee3, this);}));

}
function resourceUpdateContinueDelayed(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee4(action, next) {var items, i, ii, storeItem;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (!
                            (0, _fsa.isType)(action, descriptor.actions.UPDATE_CONTINUE)) {_context4.next = 17;break;}
                            items = descriptor.merger.merge(action.payload.item, action.payload.items);
                            i = 0, ii = items.length;case 3:if (!(i < ii)) {_context4.next = 17;break;}_context4.next = 6;return (
                                (0, _effects.select)(descriptor.resource.selectors.itemByItem(items[i])));case 6:storeItem = _context4.sent;if (!(
                            storeItem && descriptor.resource.fields.hasCommited(storeItem))) {_context4.next = 12;break;}_context4.next = 10;return (
                                (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: items[i] })));case 10:_context4.next = 14;break;case 12:_context4.next = 14;return (

                                (0, _effects.put)(descriptor.resource.actions.CREATE({ item: items[i] })));case 14:i++;_context4.next = 3;break;case 17:return _context4.delegateYield(



                            next(action), 't0', 18);case 18:case 'end':return _context4.stop();}}}, _callee4, this);}));

}
function resourceDelete(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee5(action, next) {var item;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:if (!
                            (0, _fsa.isType)(action, descriptor.actions.DELETE)) {_context5.next = 4;break;}
                            item = descriptor.merger.combine(action.payload.items);_context5.next = 4;return (
                                (0, _effects.put)(descriptor.actions.APPLY({ item: item })));case 4:return _context5.delegateYield(

                            next(action), 't0', 5);case 5:case 'end':return _context5.stop();}}}, _callee5, this);}));

}
function resourceDeleteContinue(descriptor, options) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee6(action, next) {var items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (!
                            (0, _fsa.isType)(action, descriptor.actions.DELETE_CONTINUE)) {_context6.next = 28;break;}
                            items = action.payload.items;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;_context6.prev = 5;


                            _iterator = (0, _getIterator3.default)(items);case 7:if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {_context6.next = 14;break;}
                            item = _step.value;_context6.next = 11;return (

                                (0, _effects.put)(descriptor.resource.actions.DELETE({ item: item })));case 11:_iteratorNormalCompletion = true;_context6.next = 7;break;case 14:_context6.next = 20;break;case 16:_context6.prev = 16;_context6.t0 = _context6['catch'](5);


                            _didIteratorError = true;
                            _iteratorError = _context6.t0;case 20:_context6.prev = 20;_context6.prev = 21;


                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }case 23:_context6.prev = 23;if (!

                            _didIteratorError) {_context6.next = 26;break;}throw (
                                _iteratorError);case 26:return _context6.finish(23);case 27:return _context6.finish(20);case 28:return _context6.delegateYield(




                            next(action), 't1', 29);case 29:case 'end':return _context6.stop();}}}, _callee6, this, [[5, 16, 20, 28], [21,, 23, 27]]);}));

}
function makeBatchSaga(descriptor, options, middlewares) {
    var resource = descriptor.resource;

    var actions = [].concat((0, _toConsumableArray3.default)(descriptor.actions.all), (0, _toConsumableArray3.default)(resource.actions.all));
    var wares = [].concat((0, _toConsumableArray3.default)(middlewares), [resourceUpdate, options.createImmediately ? resourceUpdateContinueImmediately : resourceUpdateContinueDelayed, resourceDelete, resourceDeleteContinue, stopMiddleware]);
    var compiled = wares.map(function (mw) {return mw(descriptor, options);});
    var f = (0, _utils.applyMiddlewares).apply(undefined, (0, _toConsumableArray3.default)(compiled));
    return (/*#__PURE__*/_regenerator2.default.mark(function internal() {return _regenerator2.default.wrap(function internal$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
                                (0, _fsaSaga.takeEvery)(actions, f));case 2:case 'end':return _context7.stop();}}}, internal, this);}));

}
//# sourceMappingURL=makeBatchSaga.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.makeBatchSelectors = makeBatchSelectors;
function makeBatchSelectors(name, options, resource) {
    var scope = function scope(state) {
        var scopeName = state[name + "Batch"];
        if (!scopeName) {
            throw new Error("Register reducer of batch " + name + " in the store under: \"" + name + "Batch\"");
        }
        return scopeName;
    };
    return {
        creating: function creating(state) {return scope(state).creating;},
        deleting: function deleting(state) {return scope(state).deleting;},
        item: function item(state) {return scope(state).item;},
        reading: function reading(state) {return scope(state).reading;},
        sourceItems: function sourceItems(state) {return scope(state).items;},
        updating: function updating(state) {return scope(state).updating;} };

}
//# sourceMappingURL=makeBatchSelectors.js.map

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault2(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault2(_createClass2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });

exports.Merger = undefined;

var _keys = __webpack_require__(85);

var _keys2 = _interopRequireDefault(_keys);

__webpack_require__(76);

var _resource = __webpack_require__(485);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

Merger = function () {function Merger() {(0, _classCallCheck3.default)(this, Merger);}(0, _createClass3.default)(Merger, [{ key: 'combine', value: function combine(
        items) {
            return items.reduce(function (item, cur) {return !item ? cur : combineObj(item, cur);}, null);
        } }, { key: 'merge', value: function merge(
        item, items) {
            return items.map(function (x) {return mergeObj(item, x);});
        } }]);return Merger;}();

exports.Merger = Merger;
function combineObj(a, b) {
    var keys = (0, _keys2.default)(a).qIntersect((0, _keys2.default)(b));
    var res = {};
    keys.forEach(function (key) {
        var prop = combineProp(a, b, key);
        if (prop !== undefined) {
            res[key] = prop;
        }
    });
    return res;
}
function combineProp(a, b, key) {
    if (a[key] === b[key]) {
        return a[key];
    }
}
function mergeObj(input, fallback) {
    var keys = (0, _keys2.default)(input).concat((0, _keys2.default)(fallback)).qDistinct();
    var res = (0, _resource.copyFields)({}, fallback);
    keys.forEach(function (key) {
        var prop = mergeProp(input, fallback, key);
        if (prop !== undefined) {
            res[key] = prop;
        }
    });
    return res;
}
function mergeProp(input, fallback, key) {
    if (input[key] === undefined) {
        return fallback[key];
    } else {
        return input[key];
    }
}
//# sourceMappingURL=merger.js.map

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true });


var _FetchMiddleware = __webpack_require__(592);

Object.defineProperty(exports, 'FetchMiddleware', {
  enumerable: true,
  get: function get() {
    return _FetchMiddleware.FetchMiddleware;
  } });


var _HttpMiddleware = __webpack_require__(833);

Object.defineProperty(exports, 'HttpMiddleware', {
  enumerable: true,
  get: function get() {
    return _HttpMiddleware.HttpMiddleware;
  } });


var _RestMiddleware = __webpack_require__(594);

Object.defineProperty(exports, 'RestMiddleware', {
  enumerable: true,
  get: function get() {
    return _RestMiddleware.RestMiddleware;
  } });


var _AuthBearerMiddleware = __webpack_require__(839);

Object.defineProperty(exports, 'AuthBearerMiddleware', {
  enumerable: true,
  get: function get() {
    return _AuthBearerMiddleware.AuthBearerMiddleware;
  } });


var _JsonRestMiddleware = __webpack_require__(840);

Object.defineProperty(exports, 'JsonRestMiddleware', {
  enumerable: true,
  get: function get() {
    return _JsonRestMiddleware.JsonRestMiddleware;
  } });


var _JsonTransportMiddleware = __webpack_require__(595);

Object.defineProperty(exports, 'JsonTransportMiddleware', {
  enumerable: true,
  get: function get() {
    return _JsonTransportMiddleware.JsonTransportMiddleware;
  } });

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _getOwnPropertyNames = __webpack_require__(497);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}(function (self) {
  'use strict';

  if (self.fetch) {
    return;
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in _symbol2.default,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self };


  if (support.arrayBuffer) {
    var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'];


    var isDataView = function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj);
    };

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return { done: value === undefined, value: value };
      } };


    if (support.iterable) {
      iterator[_iterator2.default] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      (0, _getOwnPropertyNames2.default)(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ',' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {items.push(name);});
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {items.push(value);});
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {items.push([name, value]);});
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[_iterator2.default] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return _promise2.default.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new _promise2.default(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type');
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return _promise2.default.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return _promise2.default.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return _promise2.default.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || _promise2.default.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return _promise2.default.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return _promise2.default.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    rawHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = 'status' in options ? options.status : 200;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url });

  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function (input, init) {
    return new _promise2.default(function (resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '') };

        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };
  self.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : undefined);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault2(_regenerator);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });


var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = __webpack_require__(24);

var _extends7 = _interopRequireDefault(_extends6);

exports.HttpMiddleware = HttpMiddleware;

var _fsa = __webpack_require__(1);

var _fsaSaga = __webpack_require__(59);

var _reduxSaga = __webpack_require__(834);

var _effects = __webpack_require__(220);

var _resource = __webpack_require__(485);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var configTimeout = 8000;
var http404 = 404;
function HttpMiddleware(api, path) {
    return function (descriptor) {
        var _descriptor$actions = descriptor.actions;
        var CREATE = _descriptor$actions.CREATE,
        READ = _descriptor$actions.READ,
        UPDATE = _descriptor$actions.UPDATE,
        DELETE = _descriptor$actions.DELETE,
        LIST = _descriptor$actions.LIST;

        var fnCreate = sagaCreate(api, path, descriptor);
        var fnRead = sagaRead(api, path, descriptor);
        var fnUpdate = sagaUpdate(api, path, descriptor);
        var fnDelete = sagaDelete(api, path, descriptor);
        var fnList = sagaList(api, path, descriptor);
        return (/*#__PURE__*/_regenerator2.default.mark(function _callee(action, next) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                                (0, _fsa.isType)(action, CREATE)) {_context.next = 4;break;}return _context.delegateYield(
                                fnCreate(next)(action), 't0', 2);case 2:_context.next = 18;break;case 4:if (!
                                (0, _fsa.isType)(action, READ)) {_context.next = 8;break;}return _context.delegateYield(
                                fnRead(next)(action), 't1', 6);case 6:_context.next = 18;break;case 8:if (!
                                (0, _fsa.isType)(action, UPDATE)) {_context.next = 12;break;}return _context.delegateYield(
                                fnUpdate(next)(action), 't2', 10);case 10:_context.next = 18;break;case 12:if (!
                                (0, _fsa.isType)(action, DELETE)) {_context.next = 16;break;}return _context.delegateYield(
                                fnDelete(next)(action), 't3', 14);case 14:_context.next = 18;break;case 16:if (!
                                (0, _fsa.isType)(action, LIST)) {_context.next = 18;break;}return _context.delegateYield(
                                fnList(next)(action), 't4', 18);case 18:case 'end':return _context.stop();}}}, _callee, this);}));


    };
}
function sagaCreate(api, path, descriptor) {
    return function (next) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {var item, _ref, res, cancel, timeout, data;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                                item = (0, _resource.stripFields)(action.payload.item);
                                delete item[descriptor.options.id];_context2.next = 4;return (

                                    (0, _effects.race)({
                                        cancel: (0, _fsaSaga.take)([descriptor.actions.CREATE_CANCEL, descriptor.actions.RESET]),
                                        res: api.post('' + path, item),
                                        timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout) }));case 4:_ref = _context2.sent;


                                res = _ref.res,
                                cancel = _ref.cancel,
                                timeout = _ref.timeout;if (!(

                                res && res.ok)) {_context2.next = 15;break;}_context2.next = 9;return (
                                    (0, _effects.call)(function () {return res.json();}));case 9:data = _context2.sent;_context2.next = 12;return (
                                    (0, _fsaSaga.put)(descriptor.actions.CREATE_SUCCESS({
                                        item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, descriptor.data.id(data))) })));case 12:return _context2.delegateYield(

                                next(), 't0', 13);case 13:_context2.next = 28;break;case 15:if (!
                                cancel) {_context2.next = 19;break;}return _context2.delegateYield(
                                next(), 't1', 17);case 17:_context2.next = 28;break;case 19:if (!
                                timeout) {_context2.next = 25;break;}_context2.next = 22;return (
                                    (0, _fsaSaga.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: 'timedout' })));case 22:return _context2.delegateYield(
                                next(), 't2', 23);case 23:_context2.next = 28;break;case 25:_context2.next = 27;return (

                                    (0, _fsaSaga.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText })));case 27:return _context2.delegateYield(
                                next(), 't3', 28);case 28:case 'end':return _context2.stop();}}}, _callee2, this);}));};


}
function sagaRead(api, path, descriptor) {
    return function (next) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {var key, _ref2, res, cancel, timeout, data;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                                key = descriptor.data.id(action.payload.item);_context3.next = 3;return (

                                    (0, _effects.race)({
                                        cancel: (0, _fsaSaga.take)([descriptor.actions.READ_CANCEL, descriptor.actions.RESET]),
                                        res: api.get(path + '/' + key),
                                        timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout) }));case 3:_ref2 = _context3.sent;


                                res = _ref2.res,
                                cancel = _ref2.cancel,
                                timeout = _ref2.timeout;if (!(

                                res && res.ok)) {_context3.next = 14;break;}_context3.next = 8;return (
                                    (0, _effects.call)(function () {return res.json();}));case 8:data = _context3.sent;_context3.next = 11;return (
                                    (0, _fsaSaga.put)(descriptor.actions.READ_SUCCESS({
                                        item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, key)) })));case 11:return _context3.delegateYield(

                                next(), 't0', 12);case 12:_context3.next = 27;break;case 14:if (!
                                cancel) {_context3.next = 18;break;}return _context3.delegateYield(
                                next(), 't1', 16);case 16:_context3.next = 27;break;case 18:if (!
                                timeout) {_context3.next = 24;break;}_context3.next = 21;return (
                                    (0, _fsaSaga.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: 'timedout' })));case 21:return _context3.delegateYield(
                                next(), 't2', 22);case 22:_context3.next = 27;break;case 24:_context3.next = 26;return (

                                    (0, _fsaSaga.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText })));case 26:return _context3.delegateYield(
                                next(), 't3', 27);case 27:case 'end':return _context3.stop();}}}, _callee3, this);}));};


}
function sagaUpdate(api, path, descriptor) {
    return function (next) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var key, item, _ref3, res, cancel, timeout, data;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                                key = descriptor.data.id(action.payload.item);
                                item = (0, _resource.stripFields)(action.payload.item);_context4.next = 4;return (

                                    (0, _effects.race)({
                                        cancel: (0, _fsaSaga.take)([descriptor.actions.UPDATE_CANCEL, descriptor.actions.RESET]),
                                        res: api.put(path + '/' + key, (0, _extends7.default)({}, item, { id: key })),
                                        timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout) }));case 4:_ref3 = _context4.sent;


                                res = _ref3.res,
                                cancel = _ref3.cancel,
                                timeout = _ref3.timeout;if (!(

                                res && res.ok)) {_context4.next = 15;break;}_context4.next = 9;return (
                                    (0, _effects.call)(function () {return res.json();}));case 9:data = _context4.sent;_context4.next = 12;return (
                                    (0, _fsaSaga.put)(descriptor.actions.UPDATE_SUCCESS({
                                        item: (0, _extends7.default)({}, action.payload.item, data, (0, _defineProperty3.default)({}, _resource.fields.id, data.id)) })));case 12:return _context4.delegateYield(

                                next(), 't0', 13);case 13:_context4.next = 28;break;case 15:if (!
                                cancel) {_context4.next = 19;break;}return _context4.delegateYield(
                                next(), 't1', 17);case 17:_context4.next = 28;break;case 19:if (!
                                timeout) {_context4.next = 25;break;}_context4.next = 22;return (
                                    (0, _fsaSaga.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: 'timedout' })));case 22:return _context4.delegateYield(
                                next(), 't2', 23);case 23:_context4.next = 28;break;case 25:_context4.next = 27;return (

                                    (0, _fsaSaga.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText })));case 27:return _context4.delegateYield(
                                next(), 't3', 28);case 28:case 'end':return _context4.stop();}}}, _callee4, this);}));};


}
function sagaDelete(api, path, descriptor) {
    return function (next) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {var key, item, _ref4, res, timeout, cancel;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:if (!
                                descriptor.fields.neverCommited(action.payload.item)) {_context5.next = 5;break;}_context5.next = 3;return (
                                    (0, _fsaSaga.put)(descriptor.actions.DELETE_SUCCESS(action.payload.item)));case 3:return _context5.delegateYield(
                                next(), 't0', 4);case 4:return _context5.abrupt('return');case 5:


                                key = descriptor.data.id(action.payload.item);
                                item = (0, _resource.stripFields)(action.payload.item);_context5.next = 9;return (

                                    (0, _effects.race)({
                                        cancel: (0, _fsaSaga.take)([descriptor.actions.DELETE_CANCEL, descriptor.actions.RESET]),
                                        res: api.del(path + '/' + key, item),
                                        timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout) }));case 9:_ref4 = _context5.sent;


                                res = _ref4.res,
                                timeout = _ref4.timeout,
                                cancel = _ref4.cancel;if (!(

                                res && (res.ok || res.status === http404))) {_context5.next = 17;break;}_context5.next = 14;return (
                                    (0, _fsaSaga.put)(descriptor.actions.DELETE_SUCCESS(action.payload.item)));case 14:return _context5.delegateYield(
                                next(), 't1', 15);case 15:_context5.next = 30;break;case 17:if (!
                                cancel) {_context5.next = 21;break;}return _context5.delegateYield(
                                next(), 't2', 19);case 19:_context5.next = 30;break;case 21:if (!
                                timeout) {_context5.next = 27;break;}_context5.next = 24;return (
                                    (0, _fsaSaga.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: 'timedout' })));case 24:return _context5.delegateYield(
                                next(), 't3', 25);case 25:_context5.next = 30;break;case 27:_context5.next = 29;return (

                                    (0, _fsaSaga.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: res.status + ' ' + res.statusText })));case 29:return _context5.delegateYield(
                                next(), 't4', 30);case 30:case 'end':return _context5.stop();}}}, _callee5, this);}));};


}
function sagaList(api, path, descriptor) {
    return function (next) {return (/*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {var _ref5, res, cancel, timeout, data;return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.prev = 0;_context6.next = 3;return (

                                    (0, _effects.race)({
                                        cancel: (0, _fsaSaga.take)([descriptor.actions.LIST_CANCEL, descriptor.actions.RESET]),
                                        res: api.get('' + path),
                                        timeout: (0, _effects.call)(_reduxSaga.delay, configTimeout) }));case 3:_ref5 = _context6.sent;


                                res = _ref5.res,
                                cancel = _ref5.cancel,
                                timeout = _ref5.timeout;if (!(

                                res && res.ok)) {_context6.next = 14;break;}_context6.next = 8;return (
                                    (0, _effects.call)(function () {return res.json();}));case 8:data = _context6.sent;_context6.next = 11;return (
                                    (0, _fsaSaga.put)(descriptor.actions.LIST_SUCCESS({
                                        list: data.map(function (item) {
                                            var _extends5;

                                            return (0, _extends7.default)((_extends5 = {}, (0, _defineProperty3.default)(_extends5, _resource.fields.id, descriptor.data.id(item)), (0, _defineProperty3.default)(_extends5, _resource.fields.isRead, true), _extends5), item);
                                        }),
                                        params: action.payload.params })));case 11:return _context6.delegateYield(

                                next(), 't0', 12);case 12:_context6.next = 27;break;case 14:if (!
                                cancel) {_context6.next = 18;break;}return _context6.delegateYield(
                                next(), 't1', 16);case 16:_context6.next = 27;break;case 18:if (!
                                timeout) {_context6.next = 24;break;}_context6.next = 21;return (
                                    (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: 'timedout' })));case 21:return _context6.delegateYield(
                                next(), 't2', 22);case 22:_context6.next = 27;break;case 24:_context6.next = 26;return (

                                    (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: res.status + ' ' + res.statusText })));case 26:return _context6.delegateYield(
                                next(), 't3', 27);case 27:_context6.next = 33;break;case 29:_context6.prev = 29;_context6.t4 = _context6['catch'](0);_context6.next = 33;return (


                                    (0, _fsaSaga.put)(descriptor.actions.LIST_FAILURE({ params: action.payload.params, reason: '' + _context6.t4.message })));case 33:case 'end':return _context6.stop();}}}, _callee6, this, [[0, 29]]);}));};


}
//# sourceMappingURL=HttpMiddleware.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;var _runSaga = __webpack_require__(835);Object.defineProperty(exports, 'runSaga', { enumerable: true, get: function get() {return _runSaga.


    runSaga;} });var _channel = __webpack_require__(507);Object.defineProperty(exports, 'END', { enumerable: true, get: function get() {return _channel.
    END;} });Object.defineProperty(exports, 'eventChannel', { enumerable: true, get: function get() {return _channel.eventChannel;} });Object.defineProperty(exports, 'channel', { enumerable: true, get: function get() {return _channel.channel;} });var _buffers = __webpack_require__(508);Object.defineProperty(exports, 'buffers', { enumerable: true, get: function get() {return _buffers.
    buffers;} });var _sagaHelpers = __webpack_require__(589);Object.defineProperty(exports, 'takeEvery', { enumerable: true, get: function get() {return _sagaHelpers.
    takeEvery;} });Object.defineProperty(exports, 'takeLatest', { enumerable: true, get: function get() {return _sagaHelpers.takeLatest;} });Object.defineProperty(exports, 'throttle', { enumerable: true, get: function get() {return _sagaHelpers.throttle;} });var _utils = __webpack_require__(168);Object.defineProperty(exports, 'delay', { enumerable: true, get: function get() {return _utils.
    delay;} });Object.defineProperty(exports, 'CANCEL', { enumerable: true, get: function get() {return _utils.CANCEL;} });var _middleware = __webpack_require__(836);var _middleware2 = _interopRequireDefault(_middleware);

var _effects = __webpack_require__(220);var effects = _interopRequireWildcard(_effects);
var _utils2 = __webpack_require__(837);var utils = _interopRequireWildcard(_utils2);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = _middleware2.default;exports.

effects = effects;exports.utils = utils;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.


runSaga = runSaga;var _utils = __webpack_require__(168);var _proc = __webpack_require__(530);var _proc2 = _interopRequireDefault(_proc);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe,
  dispatch = _ref.dispatch,
  getState = _ref.getState,
  context = _ref.context,
  sagaMonitor = _ref.sagaMonitor,
  logger = _ref.logger,
  onError = _ref.onError;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  var effectId = (0, _utils.uid)();
  if (sagaMonitor) {
    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: iterator, args: [] } });
  }
  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, iterator.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);exports.default =








sagaMiddlewareFactory;var _utils = __webpack_require__(168);var _proc = __webpack_require__(530);var _proc2 = _interopRequireDefault(_proc);var _channel = __webpack_require__(507);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return (0, _from2.default)(arr);}}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
  context = _ref$context === undefined ? {} : _ref$context,
  options = _objectWithoutProperties(_ref, ['context']);

  var runSagaDynamically = void 0;
  var sagaMonitor = options.sagaMonitor;

  // monitors are expected to have a certain interface, let's fill-in any missing ones

  if (sagaMonitor) {
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
  }

  if (_utils.is.func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror) {
    if (_utils.isDev) (0, _utils.log)('warn', '`options.onerror` is deprecated. Use `options.onError` instead.');
    options.onError = options.onerror;
    delete options.onerror;
  }

  if (options.onError && !_utils.is.func(options.onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !_utils.is.func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
    dispatch = _ref2.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();
    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
    var sagaDispatch = (0, _utils.wrapSagaDispatch)(dispatch);

    function runSaga(saga, args, sagaId) {
      return (0, _proc2.default)(saga.apply(undefined, _toConsumableArray(args)), sagaEmitter.subscribe, sagaDispatch, getState, context, options, sagaId, saga.name);
    }

    return function (next) {
      return function (action) {
        if (sagaMonitor) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');

    var effectId = (0, _utils.uid)();
    if (sagaMonitor) {
      sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
    }
    var task = runSagaDynamically(saga, args, effectId);
    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }
    return task;
  };

  sagaMiddleware.setContext = function (props) {
    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
    _utils.object.assign(context, props);
  };

  return sagaMiddleware;
}module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _utils = __webpack_require__(168);Object.defineProperty(exports, 'TASK', { enumerable: true, get: function get() {return _utils.TASK;} });Object.defineProperty(exports, 'SAGA_ACTION', { enumerable: true, get: function get() {return _utils.SAGA_ACTION;} });Object.defineProperty(exports, 'noop', { enumerable: true, get: function get() {return _utils.noop;} });Object.defineProperty(exports, 'is', { enumerable: true, get: function get() {return _utils.is;} });Object.defineProperty(exports, 'deferred', { enumerable: true, get: function get() {return _utils.deferred;} });Object.defineProperty(exports, 'arrayOfDeffered', { enumerable: true, get: function get() {return _utils.arrayOfDeffered;} });Object.defineProperty(exports, 'createMockTask', { enumerable: true, get: function get() {return _utils.createMockTask;} });var _io = __webpack_require__(506);Object.defineProperty(exports, 'asEffect', { enumerable: true, get: function get() {return _io.
    asEffect;} });var _proc = __webpack_require__(530);Object.defineProperty(exports, 'CHANNEL_END', { enumerable: true, get: function get() {return _proc.
    CHANNEL_END;} });

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true });

exports.RestErrors = undefined;

var _extends5 = __webpack_require__(24);

var _extends6 = _interopRequireDefault(_extends5);

var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _commonErrors, _extends2, _extends3;

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getErrorByStatus = function getErrorByStatus(res) {return function (code) {return res[code] === false ? false : res[code] ? res[code] : 'unknown error';};};
var http200 = 200;
var http201 = 201;
var http204 = 204;
var http404 = 404;
var http500 = 500;
var commonErrors = (_commonErrors = {}, (0, _defineProperty3.default)(_commonErrors, http200, false), (0, _defineProperty3.default)(_commonErrors, http404, 'communication error'), (0, _defineProperty3.default)(_commonErrors, http500, 'server issue'), _commonErrors);
var create = getErrorByStatus((0, _extends6.default)({}, commonErrors, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, http201, false), (0, _defineProperty3.default)(_extends2, http204, false), _extends2)));
var list = getErrorByStatus((0, _extends6.default)({}, commonErrors));
var read = getErrorByStatus((0, _extends6.default)({}, commonErrors));
var remove = getErrorByStatus((0, _extends6.default)({}, commonErrors, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, http204, false), (0, _defineProperty3.default)(_extends3, http404, false), _extends3)));
var update = getErrorByStatus((0, _extends6.default)({}, commonErrors, (0, _defineProperty3.default)({}, http204, false)));
var RestErrors = exports.RestErrors = {
    create: create,
    list: list,
    read: read,
    remove: remove,
    update: update };

//# sourceMappingURL=RestErrors.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });

exports.AuthBearerMiddleware = AuthBearerMiddleware;

var _effects = __webpack_require__(220);

function AuthBearerMiddleware(selector) {
    return (/*#__PURE__*/_regenerator2.default.mark(function internal(_ref, next) {var request, token;return _regenerator2.default.wrap(function internal$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                            request = _ref.request;_context.next = 3;return (

                                (0, _effects.select)(selector));case 3:token = _context.sent;
                            if (token) {
                                request.headers.authorization = 'Bearer ' + token;
                            }return _context.delegateYield(
                            next(), 't0', 6);case 6:case 'end':return _context.stop();}}}, internal, this);}));

}
//# sourceMappingURL=AuthBearerMiddleware.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault2(_regenerator);var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault2(_toConsumableArray2);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

Object.defineProperty(exports, "__esModule", {
    value: true });


var _defineProperty2 = __webpack_require__(225);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(24);

var _extends5 = _interopRequireDefault(_extends4);

exports.JsonRestMiddleware = JsonRestMiddleware;

var _es = __webpack_require__(1);

var _effects = __webpack_require__(220);

var _resource = __webpack_require__(485);

var _utils = __webpack_require__(156);

var _FetchMiddleware = __webpack_require__(592);

var _JsonTransportMiddleware = __webpack_require__(595);

var _RestMiddleware = __webpack_require__(594);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function JsonRestMiddleware(url) {
    for (var _len = arguments.length, middlewares = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        middlewares[_key - 1] = arguments[_key];
    }

    return function (descriptor) {
        return connectMiddleware.apply(undefined, [(0, _RestMiddleware.RestMiddleware)({ id: descriptor.options.id, url: url })].concat((0, _toConsumableArray3.default)(middlewares), [_JsonTransportMiddleware.JsonTransportMiddleware, _FetchMiddleware.FetchMiddleware]));
    };
}
function connectMiddleware() {
    var middleware = (0, _utils.applyMiddlewares).apply(undefined, arguments);
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {var action, descriptor, context, _context, _context2, _context3, _context4;return _regenerator2.default.wrap(function _callee$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:
                            action = _ref.action,
                            descriptor = _ref.descriptor;if (!

                            (0, _es.isType)(action, descriptor.actions.CREATE)) {_context5.next = 21;break;}
                            context = { create: (0, _resource.stripFields)(action.payload.item) };_context5.prev = 3;_context5.next = 6;return (

                                (0, _effects.call)(middleware, context));case 6:if (!
                            context.ok) {_context5.next = 11;break;}_context5.next = 9;return (
                                (0, _effects.put)(descriptor.actions.CREATE_SUCCESS({
                                    item: (0, _extends5.default)({}, action.payload.item, context.created, (0, _defineProperty3.default)({}, _resource.fields.id, context.created[descriptor.options.id])) })));case 9:_context5.next = 13;break;case 11:_context5.next = 13;return (


                                (0, _effects.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: context.error })));case 13:_context5.next = 19;break;case 15:_context5.prev = 15;_context5.t0 = _context5['catch'](3);_context5.next = 19;return (


                                (0, _effects.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: _context5.t0 })));case 19:_context5.next = 99;break;case 21:if (!

                            (0, _es.isType)(action, descriptor.actions.READ)) {_context5.next = 41;break;}
                            _context = { read: (0, _resource.stripFields)(action.payload.item) };_context5.prev = 23;_context5.next = 26;return (

                                (0, _effects.call)(middleware, _context));case 26:if (!
                            _context.ok) {_context5.next = 31;break;}_context5.next = 29;return (
                                (0, _effects.put)(descriptor.actions.READ_SUCCESS({
                                    item: (0, _extends5.default)({}, action.payload.item, _context.readed) })));case 29:_context5.next = 33;break;case 31:_context5.next = 33;return (


                                (0, _effects.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: _context.error })));case 33:_context5.next = 39;break;case 35:_context5.prev = 35;_context5.t1 = _context5['catch'](23);_context5.next = 39;return (


                                (0, _effects.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: _context5.t1 })));case 39:_context5.next = 99;break;case 41:if (!

                            (0, _es.isType)(action, descriptor.actions.UPDATE)) {_context5.next = 61;break;}
                            _context2 = { update: (0, _resource.stripFields)(action.payload.item) };_context5.prev = 43;_context5.next = 46;return (

                                (0, _effects.call)(middleware, _context2));case 46:if (!
                            _context2.ok) {_context5.next = 51;break;}_context5.next = 49;return (
                                (0, _effects.put)(descriptor.actions.UPDATE_SUCCESS({
                                    item: (0, _extends5.default)({}, action.payload.item, _context2.updated) })));case 49:_context5.next = 53;break;case 51:_context5.next = 53;return (


                                (0, _effects.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: _context2.error })));case 53:_context5.next = 59;break;case 55:_context5.prev = 55;_context5.t2 = _context5['catch'](43);_context5.next = 59;return (


                                (0, _effects.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: _context5.t2 })));case 59:_context5.next = 99;break;case 61:if (!

                            (0, _es.isType)(action, descriptor.actions.DELETE)) {_context5.next = 81;break;}
                            _context3 = { remove: (0, _resource.stripFields)(action.payload.item) };_context5.prev = 63;_context5.next = 66;return (

                                (0, _effects.call)(middleware, _context3));case 66:if (!
                            _context3.ok) {_context5.next = 71;break;}_context5.next = 69;return (
                                (0, _effects.put)(descriptor.actions.DELETE_SUCCESS({
                                    item: (0, _extends5.default)({}, action.payload.item, _context3.deleted) })));case 69:_context5.next = 73;break;case 71:_context5.next = 73;return (


                                (0, _effects.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: _context3.error })));case 73:_context5.next = 79;break;case 75:_context5.prev = 75;_context5.t3 = _context5['catch'](63);_context5.next = 79;return (


                                (0, _effects.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: _context5.t3 })));case 79:_context5.next = 99;break;case 81:if (!

                            (0, _es.isType)(action, descriptor.actions.LIST)) {_context5.next = 99;break;}
                            _context4 = { list: action.payload.params || {} };_context5.prev = 83;_context5.next = 86;return (

                                (0, _effects.call)(middleware, _context4));case 86:if (!
                            _context4.ok) {_context5.next = 91;break;}_context5.next = 89;return (
                                (0, _effects.put)(descriptor.actions.LIST_SUCCESS({
                                    list: _context4.listed.map(function (item) {return (0, _extends5.default)({}, item, (0, _defineProperty3.default)({}, _resource.fields.id, item[descriptor.options.id]));}),
                                    params: action.payload.params || {} })));case 89:_context5.next = 93;break;case 91:_context5.next = 93;return (


                                (0, _effects.put)(descriptor.actions.LIST_FAILURE({ reason: _context4.error, params: action.payload.params || {} })));case 93:_context5.next = 99;break;case 95:_context5.prev = 95;_context5.t4 = _context5['catch'](83);_context5.next = 99;return (


                                (0, _effects.put)(descriptor.actions.LIST_FAILURE({ reason: _context5.t4, params: action.payload.params || {} })));case 99:case 'end':return _context5.stop();}}}, _callee, this, [[3, 15], [23, 35], [43, 55], [63, 75], [83, 95]]);}));



}
//# sourceMappingURL=JsonRestMiddleware.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






sagaMiddlewareFactory;var _utils = __webpack_require__(169);var _channel = __webpack_require__(510);var _runSaga = __webpack_require__(597);function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
  context = _ref$context === undefined ? {} : _ref$context,
  options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
  logger = options.logger,
  onError = options.onError;


  if (_utils.is.func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !_utils.is.func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !_utils.is.func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !_utils.is.func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
    dispatch = _ref2.dispatch;

    var sagaEmitter = (0, _channel.emitter)();
    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);

    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError });


    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
    _utils.object.assign(context, props);
  };

  return sagaMiddleware;
}module.exports = exports['default'];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _utils = __webpack_require__(169);Object.defineProperty(exports, 'TASK', { enumerable: true, get: function get() {return _utils.TASK;} });Object.defineProperty(exports, 'SAGA_ACTION', { enumerable: true, get: function get() {return _utils.SAGA_ACTION;} });Object.defineProperty(exports, 'noop', { enumerable: true, get: function get() {return _utils.noop;} });Object.defineProperty(exports, 'is', { enumerable: true, get: function get() {return _utils.is;} });Object.defineProperty(exports, 'deferred', { enumerable: true, get: function get() {return _utils.deferred;} });Object.defineProperty(exports, 'arrayOfDeffered', { enumerable: true, get: function get() {return _utils.arrayOfDeffered;} });Object.defineProperty(exports, 'createMockTask', { enumerable: true, get: function get() {return _utils.createMockTask;} });Object.defineProperty(exports, 'cloneableGenerator', { enumerable: true, get: function get() {return _utils.cloneableGenerator;} });var _io = __webpack_require__(509);Object.defineProperty(exports, 'asEffect', { enumerable: true, get: function get() {return _io.
    asEffect;} });var _proc = __webpack_require__(598);Object.defineProperty(exports, 'CHANNEL_END', { enumerable: true, get: function get() {return _proc.
    CHANNEL_END;} });

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _domop = __webpack_require__(160);
var _highlight = __webpack_require__(531);
var _TOUCHEND = __webpack_require__(535);var _TOUCHEND2 = _interopRequireDefault(_TOUCHEND);
var _TOUCHMOVE = __webpack_require__(536);var _TOUCHMOVE2 = _interopRequireDefault(_TOUCHMOVE);
var _TOUCHSTART = __webpack_require__(537);var _TOUCHSTART2 = _interopRequireDefault(_TOUCHSTART);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var ignore = function ignore(e) {
    var el = e.srcElement || e.target;
    if ((0, _domop.isElement)(el) && (0, _domop.closest)(el, null, '#ls-userdata')) {
        return true;
    }
    return false;
};exports.default =
function (store) {
    var _touchId = void 0;
    document.addEventListener('mousedown', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId) || (0, _highlight.getCursorPositionFromEvent)(e, null);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHSTART2.default)({}));
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
    }, true);
    document.addEventListener('mousemove', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
    }, true);
    document.addEventListener('mouseup', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
        store.dispatch((0, _TOUCHEND2.default)({}));
    }, true);
    document.addEventListener('touchstart', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId) || (0, _highlight.getCursorPositionFromEvent)(e, null);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHSTART2.default)({}));
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
    }, true);
    document.addEventListener('touchmove', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
    }, true);
    document.addEventListener('touchend', function (e) {
        if (ignore(e)) {
            return;
        }
        var pos = (0, _highlight.getCursorPositionFromEvent)(e, _touchId);
        if (!pos) {
            return;
        }var
        x = pos.x,y = pos.y,touchID = pos.touchID;
        _touchId = touchID;
        store.dispatch((0, _TOUCHMOVE2.default)({ x: x, y: y }));
        store.dispatch((0, _TOUCHEND2.default)({}));
    }, true);
    return function (next) {return function (action) {return next(action);};};
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.
normalizeTextNodes = normalizeTextNodes;var _ = __webpack_require__(160);function normalizeTextNodes(domNode) {
    var end = (0, _.followingNode)(domNode);
    while (domNode && domNode !== end) {
        if ((0, _.isText)(domNode)) {
            while ((0, _.isText)(domNode.nextSibling)) {
                domNode.textContent += domNode.nextSibling.textContent;
                domNode.parentNode.removeChild(domNode.nextSibling);
            }
        }
        domNode = (0, _.nextNode)(domNode);
    }
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.IEInsanity = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _NodeTextPosition = __webpack_require__(602);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
IEInsanity = exports.IEInsanity = function () {
    function IEInsanity(viewX, viewY) {(0, _classCallCheck3.default)(this, IEInsanity);
        this.viewX = viewX;
        this.viewY = viewY;
        this._iterations = 0;
        this.element = IEInsanity.getUsableAnchorElement(document.elementFromPoint(viewX, viewY));
        this._textRange = document.body.createTextRange();
        this._textRange.moveToElementText(this.element);
        this._characters = this._textRange.text;
    }(0, _createClass3.default)(IEInsanity, [{ key: 'calcTextPositionRough', value: function calcTextPositionRough()






        {
            var stepLarge = 100;
            for (var idxCharacter = 0; idxCharacter < this._characters.length; idxCharacter += stepLarge) {
                this._iterations++;
                var rects = this.boundsOfCharacter(idxCharacter);
                if (!rects) {
                    continue;
                }
                for (var j = 0, jj = rects.length; j < jj; j++) {
                    if (rects[j].top <= this.viewY) {
                        return new _NodeTextPosition.NodeTextPosition(this.element, Math.max(0, idxCharacter - stepLarge));
                    }
                }
            }
        } }, { key: 'calcTextPositionExact', value: function calcTextPositionExact(
        idxStart) {
            for (var idxCharacter = idxStart; idxCharacter < this._characters.length; idxCharacter++) {
                this._iterations++;
                var rects = this.boundsOfCharacter(idxCharacter);
                if (!rects) {
                    continue;
                }
                for (var j = 0, jj = rects.length; j < jj; j++) {
                    if (this.inside(rects[j])) {
                        return new _NodeTextPosition.NodeTextPosition(this.element, this.getCrossBrowserOffset(idxCharacter));
                    }
                    if (rects[j].top > this.viewY) {
                        return;
                    }
                }
            }
        } }, { key: 'inside', value: function inside(
        rect) {
            return this.viewX >= rect.left &&
            this.viewX < rect.right &&
            this.viewY >= rect.top &&
            this.viewY < rect.bottom;
        } }, { key: 'boundsOfCharacter', value: function boundsOfCharacter(
        idxCharacter) {
            this._textRange.moveToElementText(this.element);
            this._textRange.move('character', idxCharacter);
            this._textRange.moveEnd('character', 1);
            var rect = this._textRange.getClientRects();
            return rect;
        } }, { key: 'getCrossBrowserOffset', value: function getCrossBrowserOffset(
        idxCharacter) {
            var ieSkipsTheseDuringMove = '\r\n';
            var cntCharacterCleaned = 0;
            for (var i = 0; i < idxCharacter; i++) {
                if (ieSkipsTheseDuringMove.indexOf(this._characters[i]) === -1) {
                    cntCharacterCleaned++;
                }
            }
            return cntCharacterCleaned;
        } }], [{ key: 'getUsableAnchorElement', value: function getUsableAnchorElement(element) {while (element.matches('.js-highlight')) {element = element.parentNode;}return element;} }]);return IEInsanity;}();

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.removeHighlights = exports.applyHighlights = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);__webpack_require__(76);
var _index = __webpack_require__(486);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var applyHighlights = exports.applyHighlights = function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(doc, start, end, created) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                            new _promise2.default(function (resolve, reject) {
                                var count = 0;
                                (0, _index.applyHighlightSpan)(doc, start, end, function (n) {++count;created(n);});
                                if (count) {
                                    resolve();
                                } else
                                {
                                    reject(Error('No matching node: ' + start + ' - ' + end));
                                }
                            }));case 2:return _context.abrupt('return', _context.sent);case 3:case 'end':return _context.stop();}}}, _callee, undefined);}));return function applyHighlights(_x, _x2, _x3, _x4) {return _ref.apply(this, arguments);};}();

var removeHighlights = exports.removeHighlights = function removeHighlights(baseNode, selector) {
    (0, _index.removeHighlightElements)(baseNode, selector);
};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getSelectionDetail = undefined;var _NodeTextNavigation = __webpack_require__(231);
var _resolvePathWithOffset = __webpack_require__(243);
var getSelectionDetail = exports.getSelectionDetail = function getSelectionDetail(root, path) {
    var matchStart = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, path);
    if (!matchStart) {
        return null;
    }
    var textStart = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).domNode();
    var offsetStart = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node).forward(matchStart.offset).countBackwards(textStart);
    return {
        offsetStart: offsetStart,
        textStart: textStart };

};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.findClosestDocumentContentNode = undefined;var _domUtils = __webpack_require__(532);
var findClosestDocumentContentNode = exports.findClosestDocumentContentNode = function findClosestDocumentContentNode(node) {var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    for (; node && node !== stop; node = node.parentNode) {
        if ((0, _domUtils.isDocumentContent)(node)) {
            return node;
        }
    }
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.resolveAnchorPath = undefined;var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _Selector = __webpack_require__(850);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var resolveAnchorPath = exports.resolveAnchorPath = function resolveAnchorPath(root, path) {var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var selectorPath = _Selector.Selector.parsePath(path);
    var matches = root.all();var _loop = function _loop(
    curLevel, maxLevel) {
        matches = matches.filter(function (anchor) {
            for (var i = 0; i < curLevel && anchor; i++) {
                anchor = anchor.parent;
            }
            if (anchor) {
                return anchor.identifier === selectorPath[maxLevel - curLevel - 1].identifier &&
                anchor.num === selectorPath[maxLevel - curLevel - 1].num;
            }
        });
        if (!strict && matches.length === 1) {
            return { v: matches };
        }};for (var curLevel = 0, maxLevel = selectorPath.length; curLevel < maxLevel; curLevel++) {var _ret = _loop(curLevel, maxLevel);if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
    }
    return matches;
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.Selector = undefined;var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var regexPaths = /[^|\/]([\#]?[0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?/g;
var regexPath = /^([\#]?[0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?$/;var
Selector = exports.Selector = function () {(0, _createClass3.default)(Selector, null, [{ key: "parsePath", value: function parsePath(
        path) {
            return path.match(regexPaths).map(function (p) {return new Selector(p);});
        } }]);
    function Selector(selector) {(0, _classCallCheck3.default)(this, Selector);
        var parsed = regexPath.exec(selector);
        this.identifier = parsed[1];
        this.num = parsed[3] ? parseInt(parsed[3], 10) : 1;
    }return Selector;}();

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.




extendToTextNode = extendToTextNode;var _clipSelectionRange = __webpack_require__(607);var _getNodePathFromNodeOffset = __webpack_require__(533);var _NodeTextNavigation = __webpack_require__(231);var _RangeInternal = __webpack_require__(534);var _resolvePathWithOffset = __webpack_require__(243);function extendToTextNode(root, path) {
    var match = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, path);
    if (!match) {
        return null;
    }
    var start = new _NodeTextNavigation.NodeTextNavigation(match.anchor.node).forward(match.offset).start();
    var end = new _NodeTextNavigation.NodeTextNavigation(match.anchor.node).forward(match.offset).end();
    var clipped = (0, _clipSelectionRange.clipSelectionRange)(root, new _RangeInternal.RangeInternal(start.domNode(), start.offset(), end.domNode(), end.offset()));
    if (!clipped) {
        return null;
    }
    var pathStart = (0, _getNodePathFromNodeOffset.getNodePathFromNodeOffset)(root, clipped.startContainer, clipped.startOffset);
    if (!pathStart) {
        return null;
    }
    var pathEnd = (0, _getNodePathFromNodeOffset.getNodePathFromNodeOffset)(root, clipped.endContainer, clipped.endOffset);
    if (!pathEnd) {
        return null;
    }
    return { pathEnd: pathEnd, pathStart: pathStart };
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.

getTextLengthByNode = getTextLengthByNode;var _domop = __webpack_require__(160);var _NodeTextNavigation = __webpack_require__(231);function getTextLengthByNode(node) {
    return new _NodeTextNavigation.NodeTextNavigation(node).countForwards((0, _domop.followingNode)(node));
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.



extendToDocumentContent = extendToDocumentContent;var _anchor = __webpack_require__(244);var _getNodePathFromNodeOffset = __webpack_require__(533);var _NodeTextNavigation = __webpack_require__(231);var _resolvePathWithOffset = __webpack_require__(243);function extendToDocumentContent(root, path) {
    var match = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, path);
    if (!match) {
        return null;
    }
    var node = (0, _anchor.findClosestDocumentContentNode)(match.anchor.node);
    var start = new _NodeTextNavigation.NodeTextNavigation(node.firstChild).start();
    var end = new _NodeTextNavigation.NodeTextNavigation(node.lastChild).end();
    var length = new _NodeTextNavigation.NodeTextNavigation(node.lastChild).end().countBackwards(node.firstChild);
    if (!length) {
        return null;
    }
    var pathStart = (0, _getNodePathFromNodeOffset.getNodePathFromNodeOffset)(root, start.domNode(), start.offset());
    if (!pathStart) {
        return null;
    }
    var pathEnd = (0, _getNodePathFromNodeOffset.getNodePathFromNodeOffset)(root, end.domNode(), end.offset());
    if (!pathEnd) {
        return null;
    }
    return { pathEnd: pathEnd, pathStart: pathStart };
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);exports.
removeHighlightElements = removeHighlightElements;var _domop = __webpack_require__(160);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function removeHighlightElements(baseNode, selector) {
    var nodes = (0, _from2.default)(baseNode.querySelectorAll(selector));
    for (var i = 0, ii = nodes.length; i < ii; i++) {
        var fragment = document.createDocumentFragment();
        var node = nodes[i];
        var container = node.parentNode;
        while (node.firstChild) {
            fragment.appendChild(node.firstChild);
        }
        container.replaceChild(fragment, node);
        (0, _domop.normalizeTextNodes)(container);
    }
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.










































applyHighlightSpan = applyHighlightSpan;var _anchor = __webpack_require__(244);var _domop = __webpack_require__(160);var _config = __webpack_require__(856);var _getSelectionRangeDetail = __webpack_require__(608);var makeTextNode = function makeTextNode(parent, text) {if (text) {var node = document.createTextNode(text);parent.appendChild(node);}};var factoryMakeHighlightNode = function factoryMakeHighlightNode(parent, text) {if (text) {var node = document.createElement('span');node.appendChild(document.createTextNode(text));parent.appendChild(node);return node;}};var isValidTextNode = function isValidTextNode(node) {if (!node.parentNode) {return false;}if (!(0, _domop.isText)(node)) {return false;}if ((0, _domop.isElement)(node.parentNode) && !_config.Settings.elementWhitelist.includes(node.parentNode.localName)) {return false;}return true;};var textNodesBetween = function textNodesBetween(nodeStart, nodeEnd) {var result = [];for (var node = nodeStart; node; node = (0, _domop.nextNode)(node)) {if (isValidTextNode(node) && (0, _anchor.findClosestDocumentContentNode)(node)) {result.push(node);}if (node === nodeEnd) {return result;}}console.error('[NoteService] Couldn\'t find end node');return [];};function applyHighlightSpan(root, start, end, created) {
    var selectionDetails = (0, _getSelectionRangeDetail.getSelectionRangeDetail)(root, start, end);
    if (!selectionDetails) {
        return;
    }var
    textStart = selectionDetails.textStart,offsetStart = selectionDetails.offsetStart,textEnd = selectionDetails.textEnd,offsetEnd = selectionDetails.offsetEnd;
    var nodeTexts = textNodesBetween(textStart, textEnd);
    var highlight = makeHighlightNode(textStart, offsetStart, textEnd, offsetEnd, created);
    for (var i = 0, ii = nodeTexts.length; i < ii; i++) {
        highlight(nodeTexts[i]);
    }
}
function makeHighlightNode(textStart, offsetStart, textEnd, offsetEnd, created) {
    var fragmentShared = document.createDocumentFragment();
    return function (textNode) {
        var fragment = fragmentShared;
        if (textNode === textStart && textNode === textEnd) {var
            textContent = textNode.textContent;
            if (offsetEnd - offsetStart) {
                var text = textContent.substring(offsetStart, offsetEnd);
                makeTextNode(fragment, textContent.substring(0, offsetStart));
                created(factoryMakeHighlightNode(fragment, text));
                makeTextNode(fragment, textContent.substring(offsetEnd, textContent.length));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else
        if (textNode === textStart) {var
            _textContent = textNode.textContent;
            if (_textContent.length) {
                makeTextNode(fragment, _textContent.substring(0, offsetStart));
                created(factoryMakeHighlightNode(fragment, _textContent.substring(offsetStart, _textContent.length)));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else
        if (textNode === textEnd) {var
            _textContent2 = textNode.textContent;
            if (offsetEnd) {
                created(factoryMakeHighlightNode(fragment, _textContent2.substring(0, offsetEnd)));
                makeTextNode(fragment, _textContent2.substring(offsetEnd, _textContent2.length));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else
        {var
            _textContent3 = textNode.textContent;
            if (_textContent3) {
                created(factoryMakeHighlightNode(fragment, _textContent3));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        }
    };
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var Settings = exports.Settings = {
    elementWhitelist: ['a', 'i', 'b', 'u', 'strong', 'th', 'td', 'p', 'div', 'span', 'em', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'sub', 'sup'] };

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var isContainerFirst = exports.isContainerFirst = function isContainerFirst(startContainer, startOffset, endContainer, endOffset) {
    if (startContainer === endContainer) {
        return startOffset <= endOffset;
    } else
    {
        var DOCUMENT_POSITION_PRECEDING = 2;
        var compared = startContainer.compareDocumentPosition(endContainer);
        return compared !== DOCUMENT_POSITION_PRECEDING;
    }
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.

getTextLengthByPath = getTextLengthByPath;var _NodeTextNavigation = __webpack_require__(231);var _resolvePathWithOffset = __webpack_require__(243);function getTextLengthByPath(root, start, end) {
    var matchStart = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, start);
    var matchEnd = (0, _resolvePathWithOffset.resolvePathWithOffset)(root, end);
    if (!matchStart || !matchEnd) {
        return -1;
    }
    var textStart = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node).domNode();
    var textEnd = new _NodeTextNavigation.NodeTextNavigation(matchEnd.anchor.node).domNode();
    var backwards = new _NodeTextNavigation.NodeTextNavigation(matchEnd.anchor.node);
    var countBackwards = backwards.countBackwards(textStart);
    if (backwards.domNode()) {
        return countBackwards - matchStart.offset + matchEnd.offset;
    }
    var forwards = new _NodeTextNavigation.NodeTextNavigation(matchStart.anchor.node);
    var countFowards = forwards.countBackwards(textEnd);
    if (forwards.domNode()) {
        return (countFowards - matchEnd.offset + matchStart.offset) * -1;
    }
    return -1;
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.










enterSelectionScope = enterSelectionScope;__webpack_require__(76);var _elementClass = __webpack_require__(860);var _elementClass2 = _interopRequireDefault(_elementClass);var _customStylesheet = __webpack_require__(861);var _domop = __webpack_require__(160);var _settings = __webpack_require__(862);var _style = __webpack_require__(863);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function selectionCss(classes) {var styles = classes.qSelect(function (name) {return '.' + (0, _style2.default)('selection-scope') + ' .' + name + ', .' + (0, _style2.default)('selection-scope') + ' .' + name + ' * { cursor: text!important; }';});var reg = (0, _customStylesheet.customStylesheet)(styles.join(''));return reg;}function enterSelectionScope() {
    var interactionEvents = ['click', 'mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchend', 'keypress', 'keydown', 'keyup'];
    var preventDefaultInSelectable = function preventDefaultInSelectable(e) {
        var isSelectable = (0, _domop.parents)(e.target, document.body).qAny(function (el) {return _settings.rxClassWhitelist.test(el.className);});
        if (isSelectable) {
            e.preventDefault();
        }
    };
    var css = selectionCss(_settings.classWhitelist);
    (0, _elementClass2.default)(document.body).add((0, _style2.default)('selection-scope'));
    interactionEvents.forEach(function (name) {return document.body.addEventListener(name, preventDefaultInSelectable, true);});
    if (!_domop.NodeTextPosition.fromPoint(0, 0)) {
        (0, _elementClass2.default)(document.body).add((0, _style2.default)('selection-scope--compat'));
    }
    return function () {
        css.remove();
        (0, _elementClass2.default)(document.body).remove((0, _style2.default)('selection-scope'));
        interactionEvents.forEach(function (name) {return document.body.removeEventListener(name, preventDefaultInSelectable, true);});
    };
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}module.exports = function (opts) {
  return new ElementClass(opts);
};

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop);
  for (var i = 0, len = arr.length; i < len; i++) {
    if (arr[i] === prop) return i;}
  return -1;
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts);
  var self = this;
  if (!opts) opts = {};

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = { el: opts };

  this.opts = opts;
  this.el = opts.el || document.body;
  if ((0, _typeof3.default)(this.el) !== 'object') this.el = document.querySelector(this.el);
}

ElementClass.prototype.add = function (className) {
  var el = this.el;
  if (!el) return;
  if (el.className === "") return el.className = className;
  var classes = el.className.split(' ');
  if (indexOf(classes, className) > -1) return classes;
  classes.push(className);
  el.className = classes.join(' ');
  return classes;
};

ElementClass.prototype.remove = function (className) {
  var el = this.el;
  if (!el) return;
  if (el.className === "") return;
  var classes = el.className.split(' ');
  var idx = indexOf(classes, className);
  if (idx > -1) classes.splice(idx, 1);
  el.className = classes.join(' ');
  return classes;
};

ElementClass.prototype.has = function (className) {
  var el = this.el;
  if (!el) return;
  var classes = el.className.split(' ');
  return indexOf(classes, className) > -1;
};

ElementClass.prototype.toggle = function (className) {
  var el = this.el;
  if (!el) return;
  if (this.has(className)) this.remove(className);else
  this.add(className);
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.customStylesheet = customStylesheet;function customStylesheet(css) {
    var head = document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else
    {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
    return {
        remove: function remove() {return head.removeChild(style);} };

}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var classWhitelist = exports.classWhitelist = ['blockContent', 'document-content'];
var rxClassWhitelist = exports.rxClassWhitelist = new RegExp(classWhitelist.qSelect(function (x) {return '\\b' + x + '\\b';}).join('|'));

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(864);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(865);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._2m2dg-iH{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-khtml-user-select:none;-ms-touch-action:none;touch-action:none;-webkit-touch-callout:none}._2m2dg-iH::selection,._2m2dg-iH ::selection{background:transparent}._2m2dg-iH::-moz-selection,._2m2dg-iH ::-moz-selection{background:transparent}._2UOykHa4{-webkit-user-select:initial;-moz-user-select:initial;-ms-user-select:initial;user-select:auto;-khtml-user-select:initial;-webkit-touch-callout:initial}", ""]);

// exports
exports.locals = {
	"selection-scope": "_2m2dg-iH",
	"selection-scope--compat": "_2UOykHa4"
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault(_stringify);var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);exports.default = enhancer;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function enhancer() {
    return function (createStore) {return function (reducer, preloadedState) {
            var local = window.localStorage.getItem('__state');
            var session = window.sessionStorage.getItem('__state');
            if (session) {
                preloadedState = (0, _extends3.default)({}, preloadedState, JSON.parse(session));
            }
            if (local) {
                preloadedState = (0, _extends3.default)({}, preloadedState, JSON.parse(local));
            }
            var store = createStore(reducer, preloadedState);
            window.addEventListener('unload', function (event) {var _store$getState =
                store.getState(),pageFilter = _store$getState.pageFilter,notemenu = _store$getState.notemenu;
                window.localStorage.setItem('__state', (0, _stringify2.default)({ notemenu: notemenu }));var _store$getState2 =
                store.getState(),notesEditor = _store$getState2.notesEditor,flyover = _store$getState2.flyover,admin = _store$getState2.admin,beheer = _store$getState2.beheer,beheerEditor = _store$getState2.beheerEditor,bookmarksEditor = _store$getState2.bookmarksEditor,categoriesEditor = _store$getState2.categoriesEditor,filter = _store$getState2.filter,selectionrelation = _store$getState2.selectionrelation,noteParticipantSelectPopup = _store$getState2.noteParticipantSelectPopup,questionNoteSelectPopup = _store$getState2.questionNoteSelectPopup,questionsEditor = _store$getState2.questionsEditor,questionReducer = _store$getState2.questionReducer,notesReducer = _store$getState2.notesReducer,usergroupEditor = _store$getState2.usergroupEditor,notechatEditor = _store$getState2.notechatEditor,questionaddresseeEditor = _store$getState2.questionaddresseeEditor;
                window.sessionStorage.setItem('__state', (0, _stringify2.default)({ notesEditor: notesEditor, flyover: flyover, admin: admin, beheer: beheer, beheerEditor: beheerEditor, bookmarksEditor: bookmarksEditor, categoriesEditor: categoriesEditor,
                    filter: filter, pageFilter: pageFilter, selectionrelation: selectionrelation, noteParticipantSelectPopup: noteParticipantSelectPopup, questionNoteSelectPopup: questionNoteSelectPopup, questionsEditor: questionsEditor, questionReducer: questionReducer, notesReducer: notesReducer, usergroupEditor: usergroupEditor, notechatEditor: notechatEditor, questionaddresseeEditor: questionaddresseeEditor }));
            });
            return store;
        };};
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _reducer = __webpack_require__(601);var _reducer2 = _interopRequireDefault(_reducer);
var _reducer3 = __webpack_require__(868);var _reducer4 = _interopRequireDefault(_reducer3);
var _reducer5 = __webpack_require__(869);
var _reducer6 = __webpack_require__(870);
var _reducer7 = __webpack_require__(707);
var _reducer8 = __webpack_require__(709);
var _resource = __webpack_require__(234);
var _reducer9 = __webpack_require__(872);
var _resource2 = __webpack_require__(163);
var _resource3 = __webpack_require__(162);
var _resource4 = __webpack_require__(246);
var _resource5 = __webpack_require__(494);
var _resource6 = __webpack_require__(513);
var _resource7 = __webpack_require__(223);
var _reducer10 = __webpack_require__(690);var _reducer11 = _interopRequireDefault(_reducer10);
var _reducer12 = __webpack_require__(692);var _reducer13 = _interopRequireDefault(_reducer12);
var _reducer14 = __webpack_require__(614);
var _reducer15 = __webpack_require__(732);
var _reducer16 = __webpack_require__(876);
var _reducer17 = __webpack_require__(877);
var _resource8 = __webpack_require__(106);
var _reducer18 = __webpack_require__(619);
var _reducer19 = __webpack_require__(624);
var _reducer20 = __webpack_require__(735);
var _reducer21 = __webpack_require__(661);var _reducer22 = _interopRequireDefault(_reducer21);
var _reducer23 = __webpack_require__(878);
var _reducer24 = __webpack_require__(879);
var _resource9 = __webpack_require__(495);
var _reducer25 = __webpack_require__(628);
var _reducer26 = __webpack_require__(737);
var _resource10 = __webpack_require__(233);
var _resource11 = __webpack_require__(517);
var _reducer27 = __webpack_require__(881);
var _reducer28 = __webpack_require__(883);
var _resource12 = __webpack_require__(521);
var _reducer29 = __webpack_require__(701);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var debug = Object({"NODE_ENV":'production',"IDENTITYSERVICEURL":'https://login.liasonline.nl',"NOTESERVICEUSERAPI":'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user'}).NODE_STAGE === 'test' || Object({"NODE_ENV":'production',"IDENTITYSERVICEURL":'https://login.liasonline.nl',"NOTESERVICEUSERAPI":'https://lias-webpub-noteservice-redesign.azurewebsites.net/api/user'}).NODE_STAGE === 'productie' ? {} : { debug: _reducer5.reducer };
var reducer = exports.reducer = (0, _extends3.default)({},
debug, {
    admin: _reducer8.reducer,
    beheer: _reducer7.reducer,
    beheerBatch: _resource.beheerBatch.reducer,
    beheerEditor: _resource.beheerEditor.reducer,
    beheerResource: _resource.beheerResource.reducer,
    auth: _reducer2.default,
    emailarchiveBatch: _resource6.emailArchiveBatch.reducer,
    emailarchiveEditor: _resource6.emailArchiveEditor.reducer,
    emailarchiveResource: _resource6.emailArchiveResource.reducer,
    bookmarksBatch: _resource2.bookmarksBatch.reducer,
    bookmarksEditor: _resource2.bookmarksEditor.reducer,
    bookmarksResource: _resource2.bookmarksResource.reducer,
    browser: _reducer4.default,
    categoriesBatch: _resource3.categoriesBatch.reducer,
    categoriesEditor: _resource3.categoriesEditor.reducer,
    categoriesResource: _resource3.categoriesResource.reducer,
    categorySelectPopup: _reducer11.default,
    filter: _reducer14.reducer,
    flyover: _reducer15.reducer,
    meta: _reducer6.reducer,
    noteLocator: _reducer16.reducer,
    notechatBatch: _resource11.notechatBatch.reducer,
    notechatEditor: _resource11.notechatEditor.reducer,
    notechatResource: _resource11.notechatResource.reducer,
    notechat: _reducer27.reducer,
    notemenu: _reducer17.reducer,
    notesReducer: _reducer9.reducer,
    notesBatch: _resource8.notesBatch.reducer,
    notesEditor: _resource8.notesEditor.reducer,
    notesResource: _resource8.notesResource.reducer,
    notesSharedBatch: _resource5.notesSharedBatch.reducer,
    notesSharedEditor: _resource5.notesSharedEditor.reducer,
    notesSharedResource: _resource5.notesSharedResource.reducer,
    pageFilter: _reducer18.reducer,
    selection: _reducer19.reducer,
    statusDialog: _reducer20.reducer,
    window: _reducer22.default,
    batchdelete: _reducer23.reducer,
    participantBatch: _resource4.participantsBatch.reducer,
    participantEditor: _resource4.participantsEditor.reducer,
    participantResource: _resource4.participantsResource.reducer,
    participantidResource: _resource9.useridResource.reducer,
    participantidEditor: _resource9.useridEditor.reducer,
    participantidBatch: _resource9.useridBatch.reducer,
    participantid: _reducer25.reducer,
    participant: _reducer24.reducer,
    questionaddresseeBatch: _resource12.questionaddresseeBatch.reducer,
    questionaddresseeEditor: _resource12.questionaddresseeEditor.reducer,
    questionaddresseeResource: _resource12.questionaddresseeResource.reducer,
    questionaddressee: _reducer28.reducer,
    questionsBatch: _resource7.questionsBatch.reducer,
    questionsEditor: _resource7.questionsEditor.reducer,
    questionsResource: _resource7.questionsResource.reducer,
    questionReducer: _reducer29.reducer,
    noteParticipantSelectPopup: _reducer13.default,
    usergroupBatch: _resource10.usergroupBatch.reducer,
    userGroupEditor: _resource10.usergroupEditor.reducer,
    userGroupResource: _resource10.usergroupResource.reducer,
    usergroup: _reducer26.reducer });

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _CONFIG = __webpack_require__(572);var _CONFIG2 = _interopRequireDefault(_CONFIG);
var _READY = __webpack_require__(512);var _READY2 = _interopRequireDefault(_READY);
var _SESSION_RESTORED = __webpack_require__(538);var _SESSION_RESTORED2 = _interopRequireDefault(_SESSION_RESTORED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
function () {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { ready: false, restoringSession: true, config: {} };var action = arguments[1];
    if ((0, _fsa.isType)(action, _SESSION_RESTORED2.default)) {
        return (0, _extends3.default)({}, state, { restoringSession: false });
    }
    if ((0, _fsa.isType)(action, _READY2.default)) {
        return (0, _extends3.default)({}, state, { ready: true });
    }
    if ((0, _fsa.isType)(action, _CONFIG2.default)) {
        var config = action.payload;
        return (0, _extends3.default)({}, state, { config: config });
    }
    return state;
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _TOUCHEND = __webpack_require__(535);var _TOUCHEND2 = _interopRequireDefault(_TOUCHEND);
var _TOUCHMOVE = __webpack_require__(536);var _TOUCHMOVE2 = _interopRequireDefault(_TOUCHMOVE);
var _TOUCHSTART = __webpack_require__(537);var _TOUCHSTART2 = _interopRequireDefault(_TOUCHSTART);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    state: '-',
    x: 0,
    y: 0 };

var selector = exports.selector = function selector(state) {return state.debug;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _TOUCHEND2.default)) {
        return (0, _extends3.default)({}, state, { state: '-' });
    }
    if ((0, _fsa.isType)(action, _TOUCHMOVE2.default)) {
        var x = action.payload.x;
        var y = action.payload.y;
        return (0, _extends3.default)({}, state, { x: x, y: y });
    }
    if ((0, _fsa.isType)(action, _TOUCHSTART2.default)) {
        return (0, _extends3.default)({}, state, { state: 'Selecting' });
    }
    return state;
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _CHANGE = __webpack_require__(574);var _CHANGE2 = _interopRequireDefault(_CHANGE);
var _RESET = __webpack_require__(871);var _RESET2 = _interopRequireDefault(_RESET);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    docId: null,
    docName: null,
    pageId: null,
    pageName: null,
    pageNumber: null,
    pageUrl: null,
    tenantId: null,
    tenantName: null,
    breadcrumb: null,
    mailToName: null,
    mailToAddress: null };

var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _CHANGE2.default)) {
        return (0, _extends3.default)({},
        state, {
            docId: action.payload.docId,
            docName: action.payload.docName,
            pageCount: action.payload.pageCount,
            pageId: action.payload.pageId,
            pageName: action.payload.pageName,
            pageNumber: action.payload.pageNumber,
            pageUrl: action.payload.pageUrl,
            tenantId: action.payload.tenantId,
            tenantName: action.payload.tenantName,
            breadcrumb: action.payload.breadcrumb,
            mailToName: action.payload.mailToName,
            mailToAddress: action.payload.mailToAddress });

    }
    if ((0, _fsa.isType)(action, _RESET2.default)) {
        return (0, _extends3.default)({},
        state, {
            docId: null,
            docName: null,
            pageCount: null,
            pageId: null,
            pageName: null,
            pageNumber: null,
            pageUrl: null,
            tenantId: null,
            tenantName: null,
            breadcrumb: null,
            mailToAddress: null,
            mailToName: null });

    }
    return state;
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('METADATA_RESET');

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _NOTES_MINIMIZE = __webpack_require__(713);var _NOTES_MINIMIZE2 = _interopRequireDefault(_NOTES_MINIMIZE);
var _NOTES_ITEM_LAST_TOUCHED = __webpack_require__(555);var _NOTES_ITEM_LAST_TOUCHED2 = _interopRequireDefault(_NOTES_ITEM_LAST_TOUCHED);
var _NOTES_TOGGLE_NOTEMENU = __webpack_require__(654);var _NOTES_TOGGLE_NOTEMENU2 = _interopRequireDefault(_NOTES_TOGGLE_NOTEMENU);
var _NOTES_INITIALIZE = __webpack_require__(546);var _NOTES_INITIALIZE2 = _interopRequireDefault(_NOTES_INITIALIZE);
var _NOTES_INSPECT = __webpack_require__(544);var _NOTES_INSPECT2 = _interopRequireDefault(_NOTES_INSPECT);
var _START_CHAT = __webpack_require__(547);var _START_CHAT2 = _interopRequireDefault(_START_CHAT);
var _STOP_CHAT = __webpack_require__(610);var _STOP_CHAT2 = _interopRequireDefault(_STOP_CHAT);
var _SHOW = __webpack_require__(498);var _SHOW2 = _interopRequireDefault(_SHOW);
var _NOTES_DELETE_BATCH_COMPLETE = __webpack_require__(611);var _NOTES_DELETE_BATCH_COMPLETE2 = _interopRequireDefault(_NOTES_DELETE_BATCH_COMPLETE);
var _NOTES_DELETE_BATCH = __webpack_require__(556);var _NOTES_DELETE_BATCH2 = _interopRequireDefault(_NOTES_DELETE_BATCH);
var _NOTES_DELETE_BATCH_FAILURE = __webpack_require__(612);var _NOTES_DELETE_BATCH_FAILURE2 = _interopRequireDefault(_NOTES_DELETE_BATCH_FAILURE);
var _NOTES_DELETE_BATCH_START = __webpack_require__(714);var _NOTES_DELETE_BATCH_START2 = _interopRequireDefault(_NOTES_DELETE_BATCH_START);
var _NOTES_DELETE_BATCH_CANCEL = __webpack_require__(715);var _NOTES_DELETE_BATCH_CANCEL2 = _interopRequireDefault(_NOTES_DELETE_BATCH_CANCEL);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    showMiniMenu: false,
    noteselected: undefined,
    minimized: false,
    initialize: false,
    inspect: undefined,
    items: undefined,
    batchdelete: false };

var selector = exports.selector = function selector(state) {return state.selection;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _NOTES_TOGGLE_NOTEMENU2.default)) {
        return (0, _extends3.default)({}, state, { showMiniMenu: action.payload.showMiniMenu, itemMiniMenu: action.payload.itemMiniMenu });
    }
    if ((0, _fsa.isType)(action, _NOTES_ITEM_LAST_TOUCHED2.default)) {
        return (0, _extends3.default)({}, state, { noteselected: action.payload.item });
    }
    if ((0, _fsa.isType)(action, _NOTES_MINIMIZE2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, minimized: action.payload.minimized });
    }
    if ((0, _fsa.isType)(action, _NOTES_INITIALIZE2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, initialize: action.payload.initialize });
    }
    if ((0, _fsa.isType)(action, _NOTES_INSPECT2.default)) {
        return (0, _extends3.default)({}, state, { inspect: action.payload.item });
    }
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { inspect: undefined });
    }
    if ((0, _fsa.isType)(action, _START_CHAT2.default)) {
        return (0, _extends3.default)({}, state, { inspect: action.payload.item });
    }
    if ((0, _fsa.isType)(action, _STOP_CHAT2.default)) {
        return (0, _extends3.default)({}, state, { inspect: undefined });
    }
    if ((0, _fsa.isType)(action, _NOTES_DELETE_BATCH2.default)) {
        return (0, _extends3.default)({}, state, { items: action.payload.items, batchdelete: true });
    }
    if ((0, _fsa.isType)(action, _NOTES_DELETE_BATCH_COMPLETE2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchdelete: false });
    }
    if ((0, _fsa.isType)(action, _NOTES_DELETE_BATCH_FAILURE2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchdelete: false });
    }
    if ((0, _fsa.isType)(action, _NOTES_DELETE_BATCH_CANCEL2.default)) {
        return (0, _extends3.default)({}, state, { items: undefined, batchdelete: false });
    }
    if ((0, _fsa.isType)(action, _NOTES_DELETE_BATCH_START2.default)) {
        return (0, _extends3.default)({}, state, { items: action.payload.items, batchdelete: true });
    }
    return state;
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FILTER_HIDE');

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('KINDS');

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('FILTER_SHOW');

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = undefined;var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _fsa = __webpack_require__(1);
var _actions = __webpack_require__(615);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    missingNoteIds: [] };

var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _actions.FOUND)) {
        if (state.missingNoteIds.includes(action.payload.noteId)) {
            state = { missingNoteIds: state.missingNoteIds.filter(function (x) {return x !== action.payload.noteId;}) };
        }
    }
    if ((0, _fsa.isType)(action, _actions.MISSING)) {
        if (!state.missingNoteIds.includes(action.payload.noteId)) {
            state = { missingNoteIds: [].concat((0, _toConsumableArray3.default)(state.missingNoteIds), [action.payload.noteId]) };
        }
    }
    if ((0, _fsa.isType)(action, _actions.CLEAR)) {
        state = { missingNoteIds: [] };
    }
    return state;
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);
var _SHOW = __webpack_require__(498);var _SHOW2 = _interopRequireDefault(_SHOW);
var _SHOW3 = __webpack_require__(499);var _SHOW4 = _interopRequireDefault(_SHOW3);
var _HIDE = __webpack_require__(616);var _HIDE2 = _interopRequireDefault(_HIDE);
var _SHOW5 = __webpack_require__(617);var _SHOW6 = _interopRequireDefault(_SHOW5);
var _ERASE = __webpack_require__(558);var _ERASE2 = _interopRequireDefault(_ERASE);
var _REFRESH_BOOKMARKUPDATE = __webpack_require__(559);var _REFRESH_BOOKMARKUPDATE2 = _interopRequireDefault(_REFRESH_BOOKMARKUPDATE);
var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);
var _RELEASE_BUTTON_LOCK = __webpack_require__(618);var _RELEASE_BUTTON_LOCK2 = _interopRequireDefault(_RELEASE_BUTTON_LOCK);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = { visible: false };
var selector = exports.selector = function selector(state) {return state.notemenu;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _SHOW6.default)) {
        return (0, _extends3.default)({}, state, { visible: true, erase: false });
    }
    if ((0, _fsa.isType)(action, _HIDE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false, erase: false });
    }
    if ((0, _fsa.isType)(action, _ERASE2.default)) {
        return (0, _extends3.default)({}, state, { visible: false, erase: true });
    }
    if ((0, _fsa.isType)(action, _LOGGEDOUT2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _SHOW2.default)) {
        return (0, _extends3.default)({}, state, { visible: false });
    }
    if ((0, _fsa.isType)(action, _SHOW4.default)) {
        return (0, _extends3.default)({}, state, { visible: false, buttonNo: action.payload.buttonNo, origin: action.payload.origin });
    }
    if ((0, _fsa.isType)(action, _REFRESH_BOOKMARKUPDATE2.default)) {
        return (0, _extends3.default)({}, state, { visible: true, item: action.payload.item, add: action.payload.add });
    }
    if ((0, _fsa.isType)(action, _UPDATE_BUTTON_NO2.default)) {
        return (0, _extends3.default)({}, state, {
            buttonNo: action.payload.buttonNo,
            origin: action.payload.origin,
            buttonAction: action.payload.buttonAction,
            lasttoucheditem: action.payload.lasttoucheditem });

    }
    if ((0, _fsa.isType)(action, _RELEASE_BUTTON_LOCK2.default)) {
        return (0, _extends3.default)({}, state, {
            buttonNo: 0,
            origin: action.payload.origin,
            buttonAction: action.payload.buttonAction });

    }
    return state;
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var emptyState = {
    visible: false,
    items: [] };

var selector = exports.selector = function selector(state) {return state.batchdelete;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    return state;
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _PARTICIPANTS_LOADED = __webpack_require__(627);var _PARTICIPANTS_LOADED2 = _interopRequireDefault(_PARTICIPANTS_LOADED);
var _PARTICIPANTS_NOT_LOADED = __webpack_require__(880);var _PARTICIPANTS_NOT_LOADED2 = _interopRequireDefault(_PARTICIPANTS_NOT_LOADED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    participant: undefined };

var selector = exports.selector = function selector(state) {return state.participant;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _PARTICIPANTS_NOT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _PARTICIPANTS_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    return state;
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('PARTICIPANTS_NOT_LOADED');

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _NOTECHAT_LOADED = __webpack_require__(632);var _NOTECHAT_LOADED2 = _interopRequireDefault(_NOTECHAT_LOADED);
var _NOTECHAT_NOT_LOADED = __webpack_require__(882);var _NOTECHAT_NOT_LOADED2 = _interopRequireDefault(_NOTECHAT_NOT_LOADED);
var _NOTECHAT_TOGGLE_MENU = __webpack_require__(699);var _NOTECHAT_TOGGLE_MENU2 = _interopRequireDefault(_NOTECHAT_TOGGLE_MENU);
var _NOTECHATATTACHED_TOGGLE_MENU = __webpack_require__(700);var _NOTECHATATTACHED_TOGGLE_MENU2 = _interopRequireDefault(_NOTECHATATTACHED_TOGGLE_MENU);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    notechat: { userId: '', noteId: 0, created: new Date(Date.now()).valueOf(), text: '', id: 0 },
    showMiniMenuChat: false,
    showMiniMenuChatAttached: false,
    itemMiniMenuChat: undefined };

var selector = exports.selector = function selector(state) {return state.notechat;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _NOTECHAT_NOT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _NOTECHAT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _NOTECHAT_TOGGLE_MENU2.default)) {
        return (0, _extends3.default)({}, state, { showMiniMenuChat: action.payload.showMiniMenuChat, itemMiniMenuChat: action.payload.itemMiniMenuChat });
    }
    if ((0, _fsa.isType)(action, _NOTECHATATTACHED_TOGGLE_MENU2.default)) {
        return (0, _extends3.default)({}, state, { showMiniMenuChatAttached: action.payload.showMiniMenuChatAttached, itemMiniMenuChatAttached: action.payload.itemMiniMenuChatAttached });
    }
    return state;
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('NOTECHAT_NOT_LOADED');

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.reducer = exports.selector = undefined;var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _fsa = __webpack_require__(1);
var _ADDRESSEE_LOADED = __webpack_require__(633);var _ADDRESSEE_LOADED2 = _interopRequireDefault(_ADDRESSEE_LOADED);
var _ADDRESSEE_NOT_LOADED = __webpack_require__(634);var _ADDRESSEE_NOT_LOADED2 = _interopRequireDefault(_ADDRESSEE_NOT_LOADED);
var _ADDRESSEE_CREATED = __webpack_require__(635);var _ADDRESSEE_CREATED2 = _interopRequireDefault(_ADDRESSEE_CREATED);
var _ADDRESSEE_UPDATED = __webpack_require__(636);var _ADDRESSEE_UPDATED2 = _interopRequireDefault(_ADDRESSEE_UPDATED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var emptyState = {
    questionaddressee: { name: '', email: '', id: 0 } };

var selector = exports.selector = function selector(state) {return state.questionaddressee;};
var reducer = exports.reducer = function reducer() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;var action = arguments[1];
    if ((0, _fsa.isType)(action, _ADDRESSEE_NOT_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _ADDRESSEE_LOADED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _ADDRESSEE_CREATED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    if ((0, _fsa.isType)(action, _ADDRESSEE_UPDATED2.default)) {
        return (0, _extends3.default)({}, state);
    }
    return state;
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('QUESTION_ITEM_LAST_TOUCHED');

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.




















storeRootSaga = storeRootSaga;var _reduxSaga = __webpack_require__(47);var _saga = __webpack_require__(886);var _saga2 = _interopRequireDefault(_saga);var _sagas = __webpack_require__(887);var _sagas2 = __webpack_require__(888);var _sagas3 = __webpack_require__(889);var _sagas4 = __webpack_require__(890);var _sagas5 = _interopRequireDefault(_sagas4);var _sagas6 = __webpack_require__(891);var _sagas7 = _interopRequireDefault(_sagas6);var _sagas8 = __webpack_require__(892);var _sagas9 = __webpack_require__(893);var _sagas10 = __webpack_require__(895);var _sagas11 = __webpack_require__(905);var _sagas12 = __webpack_require__(906);var _sagas13 = __webpack_require__(909);var _sagas14 = __webpack_require__(910);var _sagas15 = __webpack_require__(911);var _sagas16 = __webpack_require__(912);var _sagas17 = __webpack_require__(914);var _sagas18 = __webpack_require__(915);var _sagas19 = __webpack_require__(916);var _sagas20 = __webpack_require__(917);var _sagas21 = __webpack_require__(918);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(storeRootSaga);function storeRootSaga() {return _regenerator2.default.wrap(function storeRootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                        (0, _reduxSaga.fork)(_saga2.default));case 2:_context.next = 4;return (
                        (0, _reduxSaga.fork)(_sagas2.rootSaga));case 4:_context.next = 6;return (
                        (0, _reduxSaga.fork)(_sagas14.rootSaga));case 6:_context.next = 8;return (
                        (0, _reduxSaga.fork)(_sagas12.rootSaga));case 8:_context.next = 10;return (
                        (0, _reduxSaga.fork)(_sagas9.rootSaga));case 10:_context.next = 12;return (
                        (0, _reduxSaga.fork)(_sagas10.rootSaga));case 12:_context.next = 14;return (
                        (0, _reduxSaga.fork)(_sagas.rootSaga));case 14:_context.next = 16;return (
                        (0, _reduxSaga.fork)(_sagas3.rootSaga));case 16:_context.next = 18;return (
                        (0, _reduxSaga.fork)(_sagas8.rootSaga));case 18:_context.next = 20;return (
                        (0, _reduxSaga.fork)(_sagas13.rootSaga));case 20:_context.next = 22;return (
                        (0, _reduxSaga.fork)(_sagas5.default));case 22:_context.next = 24;return (
                        (0, _reduxSaga.fork)(_sagas15.rootSaga));case 24:_context.next = 26;return (
                        (0, _reduxSaga.fork)(_sagas7.default));case 26:_context.next = 28;return (
                        (0, _reduxSaga.fork)(_sagas11.rootSaga));case 28:_context.next = 30;return (
                        (0, _reduxSaga.fork)(_sagas16.rootSaga));case 30:_context.next = 32;return (
                        (0, _reduxSaga.fork)(_sagas17.rootSaga));case 32:_context.next = 34;return (
                        (0, _reduxSaga.fork)(_sagas18.rootSaga));case 34:_context.next = 36;return (
                        (0, _reduxSaga.fork)(_sagas19.rootSaga));case 36:_context.next = 38;return (
                        (0, _reduxSaga.fork)(_sagas20.rootSaga));case 38:_context.next = 40;return (
                        (0, _reduxSaga.fork)(_sagas21.rootSaga));case 40:case 'end':return _context.stop();}}}, _marked, this);}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.default =




rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _userManager = __webpack_require__(241);var _userManager2 = _interopRequireDefault(_userManager);var _LOGIN = __webpack_require__(523);var _LOGIN2 = _interopRequireDefault(_LOGIN);var _LOGOUT = __webpack_require__(551);var _LOGOUT2 = _interopRequireDefault(_LOGOUT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(




monitorLoggedOut),_marked3 = /*#__PURE__*/_regenerator2.default.mark(












monitorLogin),_marked4 = /*#__PURE__*/_regenerator2.default.mark(






monitorLogout);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(monitorLoggedOut);case 2:_context.next = 4;return (0, _reduxSaga.fork)(monitorLogin);case 4:_context.next = 6;return (0, _reduxSaga.fork)(monitorLogout);case 6:case 'end':return _context.stop();}}}, _marked, this);}function monitorLoggedOut() {var _this = this;return _regenerator2.default.wrap(function monitorLoggedOut$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _userManager2.default)(function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(um) {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return um.signoutRedirectCallback().then(function (response) {if (response && response.state) {window.location.href = response.state.url;} else if (window.sessionStorage.getItem('__appredirecturl')) {var url = window.sessionStorage.getItem('__appredirecturl');window.sessionStorage.removeItem('__appredirecturl');window.location.href = url;}}, function (err) {});case 2:return _context2.abrupt('return', _context2.sent);case 3:case 'end':return _context2.stop();}}}, _callee, _this);}));return function (_x) {return _ref.apply(this, arguments);};}());case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function monitorLogin() {return _regenerator2.default.wrap(function monitorLogin$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _fsaSaga.takeEvery)(_LOGIN2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {var _this2 = this;return _regenerator2.default.wrap(function _callee3$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _userManager2.default)(function () {var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(um) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return um.signinRedirect({ state: { url: window.location.href } });case 2:case 'end':return _context4.stop();}}}, _callee2, _this2);}));return function (_x2) {return _ref2.apply(this, arguments);};}());case 2:case 'end':return _context5.stop();}}}, _callee3, this);}));case 2:case 'end':return _context6.stop();}}}, _marked3, this);}function monitorLogout() {return _regenerator2.default.wrap(function monitorLogout$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee5() {var _this3 = this;return _regenerator2.default.wrap(function _callee5$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:
                                            window.sessionStorage['__appredirecturl'] = window.location.href;_context8.next = 3;return (
                                                (0, _userManager2.default)(function () {var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(um) {return _regenerator2.default.wrap(function _callee4$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return um.signoutRedirect({ state: { url: window.location.href } });case 2:return _context7.abrupt('return', _context7.sent);case 3:case 'end':return _context7.stop();}}}, _callee4, _this3);}));return function (_x3) {return _ref3.apply(this, arguments);};}()));case 3:case 'end':return _context8.stop();}}}, _callee5, this);})));case 2:case 'end':return _context9.stop();}}}, _marked4, this);}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.





rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(163);var _selectors = __webpack_require__(78);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(







monitorSelectedBookmark),_marked3 = /*#__PURE__*/_regenerator2.default.mark(








signalBookmarksList),_marked4 = /*#__PURE__*/_regenerator2.default.mark(






signalBookmarksReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.bookmarksResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.bookmarksEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.bookmarksBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(monitorSelectedBookmark);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalBookmarksList);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalBookmarksReset);case 12:case 'end':return _context.stop();}}}, _marked, this);}function monitorSelectedBookmark() {return _regenerator2.default.wrap(function monitorSelectedBookmark$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_resource.bookmarksEditor.actions.READ, /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var pageIdEff, pageId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 2:pageIdEff = _context2.sent;pageId = pageIdEff;if (action.payload.item.pageId !== pageId) {window.location.href = action.payload.item.url;}case 5:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalBookmarksList() {return _regenerator2.default.wrap(function signalBookmarksList$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee2() {var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context4.sent;selectionDocumentId = selectionDocument;_context4.next = 6;return (0, _fsaSaga.put)(_resource.bookmarksResource.actions.LIST({ params: { selectionDocumentId: selectionDocumentId } }));case 6:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalBookmarksReset() {return _regenerator2.default.wrap(function signalBookmarksReset$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (
                                                (0, _fsaSaga.put)(_resource.bookmarksEditor.actions.RESET({})));case 2:_context6.next = 4;return (
                                                (0, _fsaSaga.put)(_resource.bookmarksResource.actions.RESET({})));case 4:case 'end':return _context6.stop();}}}, _callee3, this);})));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.










rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _selectors = __webpack_require__(78);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(234);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _effects = __webpack_require__(170);var _ADMIN_CREATE = __webpack_require__(553);var _ADMIN_CREATE2 = _interopRequireDefault(_ADMIN_CREATE);var _ADMIN_UPDATE = __webpack_require__(554);var _ADMIN_UPDATE2 = _interopRequireDefault(_ADMIN_UPDATE);var _ADMIN_INIT = __webpack_require__(609);var _ADMIN_INIT2 = _interopRequireDefault(_ADMIN_INIT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(









signalcreatebeheer),_marked3 = /*#__PURE__*/_regenerator2.default.mark(















signalupdatebeheer),_marked4 = /*#__PURE__*/_regenerator2.default.mark(



























signallistbeheer),_marked5 = /*#__PURE__*/_regenerator2.default.mark(




















signalBeheerReadWhenAuthenticated),_marked6 = /*#__PURE__*/_regenerator2.default.mark(






signalBeheerReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.beheerResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.beheerEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.beheerBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalcreatebeheer);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalupdatebeheer);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signallistbeheer);case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalBeheerReadWhenAuthenticated);case 14:_context.next = 16;return (0, _reduxSaga.fork)(signalBeheerReset);case 16:case 'end':return _context.stop();}}}, _marked, this);}function signalcreatebeheer() {return _regenerator2.default.wrap(function signalcreatebeheer$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)([_ADMIN_CREATE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!action.payload.item) {_context2.next = 13;break;}_context2.prev = 1;_context2.next = 4;return (0, _reduxSaga.put)(_resource.beheerResource.actions.CREATE({ item: _resource.beheerResource.create(action.payload.item) }));case 4:_context2.next = 13;break;case 6:_context2.prev = 6;_context2.t0 = _context2['catch'](1);console.log('Admin couldn\'t be backed up');_context2.next = 11;return (0, _reduxSaga.put)(_resource.beheerEditor.actions.CREATE_CANCEL({ item: action.payload.item }));case 11:_context2.next = 13;return (0, _reduxSaga.put)((0, _ADMIN_INIT2.default)({ item: action.payload.item, busy: false }));case 13:case 'end':return _context2.stop();}}}, _callee, this, [[1, 6]]);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalupdatebeheer() {return _regenerator2.default.wrap(function signalupdatebeheer$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_ADMIN_UPDATE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {var raceWaitTime, waiting, waitresult;return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:raceWaitTime = 5000;if (!action.payload.item) {_context4.next = 24;break;}_context4.prev = 2;_context4.next = 5;return (0, _reduxSaga.put)(_resource.beheerEditor.actions.UPDATE({ item: action.payload.item }));case 5:_context4.next = 7;return (0, _effects.race)({ timeout: (0, _effects.call)(_reduxSaga.delay, raceWaitTime), updateend: (0, _effects.take)([_resource.beheerResource.actions.UPDATE]) });case 7:waiting = _context4.sent;waitresult = waiting;if (!waitresult.updateend) {_context4.next = 14;break;}_context4.next = 12;return (0, _reduxSaga.put)(_resource.beheerEditor.actions.UPDATE_CONTINUE({ item: action.payload.item }));case 12:_context4.next = 15;break;case 14:console.log('Admin couldn\'t be backed up');case 15:_context4.next = 24;break;case 17:_context4.prev = 17;_context4.t0 = _context4['catch'](2);console.log('Admin couldn\'t be backed up');_context4.next = 22;return (0, _reduxSaga.put)(_resource.beheerEditor.actions.UPDATE_CANCEL({ item: action.payload.item }));case 22:_context4.next = 24;return (0, _reduxSaga.put)((0, _ADMIN_INIT2.default)({ item: action.payload.item, busy: false }));case 24:case 'end':return _context4.stop();}}}, _callee2, this, [[2, 17]]);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signallistbeheer() {return _regenerator2.default.wrap(function signallistbeheer$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([_resource.beheerResource.actions.LIST_SUCCESS, _resource.beheerResource.actions.LIST_FAILURE, _resource.beheerResource.actions.CREATE_SUCCESS, _resource.beheerResource.actions.UPDATE_SUCCESS, _resource.beheerResource.actions.DELETE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee3() {var beheer, documentIdEff, documentId, current;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _reduxSaga.select)(_resource.beheerResource.selectors.items);case 2:beheer = _context6.sent;_context6.next = 5;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 5:documentIdEff = _context6.sent;documentId = documentIdEff;current = beheer.qWhere(function (x) {return x.documentId === documentId;}).qFirst();if (!current) {_context6.next = 15;break;}_context6.next = 11;return (0, _reduxSaga.put)(_resource.beheerResource.actions.READ({ item: current }));case 11:_context6.next = 13;return (0, _reduxSaga.put)((0, _ADMIN_INIT2.default)({ item: current, busy: false }));case 13:_context6.next = 17;break;case 15:_context6.next = 17;return (0, _reduxSaga.put)((0, _ADMIN_INIT2.default)({ item: undefined, busy: false }));case 17:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalBeheerReadWhenAuthenticated() {return _regenerator2.default.wrap(function signalBeheerReadWhenAuthenticated$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee4() {var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context8.sent;selectionDocumentId = selectionDocument;_context8.next = 6;return (0, _reduxSaga.put)(_resource.beheerResource.actions.LIST({ params: { selectionDocumentId: selectionDocumentId } }));case 6:case 'end':return _context8.stop();}}}, _callee4, this);}));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}function signalBeheerReset() {return _regenerator2.default.wrap(function signalBeheerReset$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (
                                                (0, _reduxSaga.put)(_resource.beheerResource.actions.RESET({})));case 2:_context10.next = 4;return (
                                                (0, _reduxSaga.put)((0, _ADMIN_INIT2.default)({ item: undefined, busy: false })));case 4:_context10.next = 6;return (
                                                (0, _reduxSaga.put)(_resource.beheerEditor.actions.RESET({})));case 6:case 'end':return _context10.stop();}}}, _callee5, this);})));case 2:case 'end':return _context11.stop();}}}, _marked6, this);}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.





rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(162);var _selectors = __webpack_require__(78);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(






signalCategoriesList),_marked3 = /*#__PURE__*/_regenerator2.default.mark(






signalCategoriesReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.categoriesResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.categoriesEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.categoriesBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalCategoriesList);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalCategoriesReset);case 10:case 'end':return _context.stop();}}}, _marked, this);}function signalCategoriesList() {return _regenerator2.default.wrap(function signalCategoriesList$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee() {var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context2.sent;selectionDocumentId = selectionDocument;_context2.next = 6;return (0, _reduxSaga.put)(_resource.categoriesResource.actions.LIST({ params: { selectionDocumentId: selectionDocumentId } }));case 6:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalCategoriesReset() {return _regenerator2.default.wrap(function signalCategoriesReset$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee2() {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
                                                (0, _reduxSaga.put)(_resource.categoriesEditor.actions.RESET({})));case 2:_context4.next = 4;return (
                                                (0, _reduxSaga.put)(_resource.categoriesResource.actions.RESET({})));case 4:case 'end':return _context4.stop();}}}, _callee2, this);})));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.default =







rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(163);var _resource2 = __webpack_require__(162);var _resource3 = __webpack_require__(106);var _SELECT = __webpack_require__(548);var _SELECT2 = _interopRequireDefault(_SELECT);var _HIDE = __webpack_require__(487);var _HIDE2 = _interopRequireDefault(_HIDE);var _HIDE3 = __webpack_require__(539);var _HIDE4 = _interopRequireDefault(_HIDE3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(



updateEditors),_marked3 = /*#__PURE__*/_regenerator2.default.mark(









updateEditorsAfterCloseFlyover);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(updateEditors);case 2:_context.next = 4;return (0, _reduxSaga.fork)(updateEditorsAfterCloseFlyover);case 4:case 'end':return _context.stop();}}}, _marked, this);}function updateEditors() {return _regenerator2.default.wrap(function updateEditors$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_resource2.categoriesResource.actions.CREATE_SUCCESS, /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var categoryId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:categoryId = action.payload.item.id;_context2.next = 3;return (0, _reduxSaga.put)(_resource3.notesEditor.actions.APPLY({ item: { categoryId: categoryId } }));case 3:_context2.next = 5;return (0, _reduxSaga.put)(_resource3.notesBatch.actions.APPLY({ item: { categoryId: categoryId } }));case 5:_context2.next = 7;return (0, _reduxSaga.put)(_resource.bookmarksEditor.actions.APPLY({ item: { categoryId: categoryId } }));case 7:_context2.next = 9;return (0, _reduxSaga.put)(_resource.bookmarksBatch.actions.APPLY({ item: { categoryId: categoryId } }));case 9:_context2.next = 11;return (0, _reduxSaga.put)((0, _SELECT2.default)({ categoryId: categoryId }));case 11:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function updateEditorsAfterCloseFlyover() {return _regenerator2.default.wrap(function updateEditorsAfterCloseFlyover$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_HIDE2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
                                                (0, _reduxSaga.put)((0, _HIDE4.default)({})));case 2:case 'end':return _context4.stop();}}}, _callee2, this);})));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.default =




rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _HIDE = __webpack_require__(613);var _HIDE2 = _interopRequireDefault(_HIDE);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _HIDE3 = __webpack_require__(487);var _HIDE4 = _interopRequireDefault(_HIDE3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(


updateEditors);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(updateEditors);case 2:case 'end':return _context.stop();}}}, _marked, this);}function updateEditors() {return _regenerator2.default.wrap(function updateEditors$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                        (0, _fsaSaga.takeEvery)([_AUTHENTICATED2.default, _HIDE4.default], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                                                (0, _reduxSaga.put)((0, _HIDE2.default)({})));case 2:case 'end':return _context2.stop();}}}, _callee, this);})));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.







rootSaga = rootSaga;var _fsa = __webpack_require__(1);var _fsaSaga = __webpack_require__(59);var _effects = __webpack_require__(170);var _abstractselection = __webpack_require__(486);var _index = __webpack_require__(244);var _resource = __webpack_require__(106);var _actions = __webpack_require__(615);var _resource2 = __webpack_require__(223);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(










update);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _fsaSaga.takeLatest)([_actions.CLEAR, _resource.notesResource.actions.CREATE_SUCCESS, _resource.notesResource.actions.DELETE_SUCCESS, _resource.notesResource.actions.LIST_SUCCESS, _resource.notesResource.actions.READ_SUCCESS, _resource.notesResource.actions.UPDATE_SUCCESS, _resource.notesResource.actions.RESET], update);case 2:case 'end':return _context.stop();}}}, _marked, this);}function update(action) {var notes, nodes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note;return _regenerator2.default.wrap(function update$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (
                    (0, _fsa.isType)(action, _actions.CLEAR)) {_context2.next = 8;break;}if (!
                    (0, _fsa.isType)(action, _resource.notesResource.actions.DELETE_SUCCESS)) {_context2.next = 6;break;}_context2.next = 4;return (
                        (0, _fsaSaga.put)(_resource.notesEditor.actions.RESET({})));case 4:_context2.next = 6;return (
                        (0, _fsaSaga.put)(_resource2.questionsEditor.actions.RESET({})));case 6:_context2.next = 8;return (

                        (0, _fsaSaga.put)((0, _actions.CLEAR)({})));case 8:_context2.next = 10;return (

                        (0, _effects.select)(_resource.notesResource.selectors.items));case 10:notes = _context2.sent;
                    nodes = (0, _index.getAnchorFromDocument)();_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context2.prev = 15;_iterator = (0, _getIterator3.default)(
                    notes);case 17:if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {_context2.next = 29;break;}note = _step.value;if (!
                    (0, _abstractselection.resolvePathWithOffset)(nodes, note.startElementXPath)) {_context2.next = 24;break;}_context2.next = 22;return (
                        (0, _fsaSaga.put)((0, _actions.FOUND)({ noteId: note.id })));case 22:_context2.next = 26;break;case 24:_context2.next = 26;return (


                        (0, _fsaSaga.put)((0, _actions.MISSING)({ noteId: note.id })));case 26:_iteratorNormalCompletion = true;_context2.next = 17;break;case 29:_context2.next = 35;break;case 31:_context2.prev = 31;_context2.t0 = _context2['catch'](15);_didIteratorError = true;_iteratorError = _context2.t0;case 35:_context2.prev = 35;_context2.prev = 36;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 38:_context2.prev = 38;if (!_didIteratorError) {_context2.next = 41;break;}throw _iteratorError;case 41:return _context2.finish(38);case 42:return _context2.finish(35);case 43:case 'end':return _context2.stop();}}}, _marked2, this, [[15, 31, 35, 43], [36,, 38, 42]]);}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.































































































































































































































rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(596);var _fsa = __webpack_require__(1);var _reduxSaga2 = __webpack_require__(47);var _types = __webpack_require__(245);var _launch = __webpack_require__(235);var _HIDE = __webpack_require__(543);var _HIDE2 = _interopRequireDefault(_HIDE);var _REQUEST = __webpack_require__(500);var _REQUEST2 = _interopRequireDefault(_REQUEST);var _RESET = __webpack_require__(249);var _RESET2 = _interopRequireDefault(_RESET);var _HIDE3 = __webpack_require__(616);var _HIDE4 = _interopRequireDefault(_HIDE3);var _SHOW = __webpack_require__(617);var _SHOW2 = _interopRequireDefault(_SHOW);var _SHOW3 = __webpack_require__(499);var _SHOW4 = _interopRequireDefault(_SHOW3);var _REFRESH_BOOKMARKUPDATE = __webpack_require__(559);var _REFRESH_BOOKMARKUPDATE2 = _interopRequireDefault(_REFRESH_BOOKMARKUPDATE);var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);var _RELEASE_BUTTON_LOCK = __webpack_require__(618);var _RELEASE_BUTTON_LOCK2 = _interopRequireDefault(_RELEASE_BUTTON_LOCK);var _UPDATED_BUTTON_LOCK = __webpack_require__(665);var _UPDATED_BUTTON_LOCK2 = _interopRequireDefault(_UPDATED_BUTTON_LOCK);var _resource = __webpack_require__(163);var _resource2 = __webpack_require__(106);var _reselectors = __webpack_require__(542);var _reselectors2 = _interopRequireDefault(_reselectors);var _PAGEFILTER_TOGGLE_CATEGORY = __webpack_require__(622);var _PAGEFILTER_TOGGLE_CATEGORY2 = _interopRequireDefault(_PAGEFILTER_TOGGLE_CATEGORY);var _SHOW5 = __webpack_require__(560);var _SHOW6 = _interopRequireDefault(_SHOW5);var _PAGEFILTER_TOGGLE_SORTING = __webpack_require__(623);var _PAGEFILTER_TOGGLE_SORTING2 = _interopRequireDefault(_PAGEFILTER_TOGGLE_SORTING);var _resource3 = __webpack_require__(162);var _USERGROUP_UPDATED = __webpack_require__(489);var _USERGROUP_UPDATED2 = _interopRequireDefault(_USERGROUP_UPDATED);var _USERGROUP_CREATED = __webpack_require__(488);var _USERGROUP_CREATED2 = _interopRequireDefault(_USERGROUP_CREATED);var _NOTES_INITIALIZE = __webpack_require__(546);var _NOTES_INITIALIZE2 = _interopRequireDefault(_NOTES_INITIALIZE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(watchButtonActions),_marked2 = /*#__PURE__*/_regenerator2.default.mark(signalEndNotesEdit),_marked3 = /*#__PURE__*/_regenerator2.default.mark(signalBeginNotesEdit),_marked4 = /*#__PURE__*/_regenerator2.default.mark(signalReturnFromSelection),_marked5 = /*#__PURE__*/_regenerator2.default.mark(signalReturnFromDeletion),_marked6 = /*#__PURE__*/_regenerator2.default.mark(signalReturnFromMyItems),_marked7 = /*#__PURE__*/_regenerator2.default.mark(watchBookmarkButtonActions),_marked8 = /*#__PURE__*/_regenerator2.default.mark(signalUpdatebutton),_marked9 = /*#__PURE__*/_regenerator2.default.mark(signalUpdatebuttonFlyover),_marked10 = /*#__PURE__*/_regenerator2.default.mark(signalReleaselock),_marked11 = /*#__PURE__*/_regenerator2.default.mark(signalChangeFilterCategory),_marked12 = /*#__PURE__*/_regenerator2.default.mark(signalChangeFilterSorting),_marked13 = /*#__PURE__*/_regenerator2.default.mark(rootSaga);function watchButtonActions() {return _regenerator2.default.wrap(function watchButtonActions$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _fsaSaga.takeEvery)([_REQUEST2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var origin;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:origin = _launch.hack.store.getState().notemenu.origin;if (!(origin === _UPDATE_BUTTON_NO.originNoteMenu)) {_context.next = 4;break;}_context.next = 4;return (0, _reduxSaga2.put)((0, _HIDE4.default)({}));case 4:case 'end':return _context.stop();}}}, _callee, this);}));case 2:case 'end':return _context2.stop();}}}, _marked, this);}function signalEndNotesEdit() {return _regenerator2.default.wrap(function signalEndNotesEdit$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesEditor.actions.CREATE_CONTINUE, _resource2.notesEditor.actions.UPDATE_CONTINUE, _resource2.notesEditor.actions.CREATE_CANCEL, _resource2.notesEditor.actions.UPDATE_CANCEL], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _reduxSaga2.put)((0, _NOTES_INITIALIZE2.default)({ initialize: false }));case 2:case 'end':return _context3.stop();}}}, _callee2, this);}));case 2:case 'end':return _context4.stop();}}}, _marked2, this);}function signalBeginNotesEdit() {return _regenerator2.default.wrap(function signalBeginNotesEdit$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesEditor.actions.CREATE, _resource2.notesEditor.actions.UPDATE], /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {var delayDispatch;return _regenerator2.default.wrap(function _callee3$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:delayDispatch = 200;_context5.next = 3;return (0, _reduxSaga2.call)(_reduxSaga.delay, delayDispatch);case 3:_context5.next = 5;return (0, _reduxSaga2.put)((0, _NOTES_INITIALIZE2.default)({ initialize: true }));case 5:case 'end':return _context5.stop();}}}, _callee3, this);}));case 2:case 'end':return _context6.stop();}}}, _marked3, this);}function signalReturnFromSelection() {return _regenerator2.default.wrap(function signalReturnFromSelection$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (0, _fsaSaga.takeEvery)([_RESET2.default, _resource2.notesEditor.actions.CREATE_CONTINUE, _resource2.notesEditor.actions.UPDATE_CONTINUE, _resource2.notesEditor.actions.CREATE_CANCEL, _resource2.notesEditor.actions.UPDATE_CANCEL, _resource3.categoriesEditor.actions.CREATE_CONTINUE, _resource3.categoriesEditor.actions.UPDATE_CONTINUE, _resource3.categoriesEditor.actions.CREATE_CANCEL, _resource3.categoriesEditor.actions.UPDATE_CANCEL, _resource.bookmarksEditor.actions.CREATE_CONTINUE, _resource.bookmarksEditor.actions.UPDATE_CONTINUE, _resource.bookmarksEditor.actions.CREATE_CANCEL, _resource.bookmarksEditor.actions.UPDATE_CANCEL, _USERGROUP_UPDATED2.default, _USERGROUP_CREATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var origin, lasttoucheditem, usergroup, itm;return _regenerator2.default.wrap(function _callee4$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:origin = _launch.hack.store.getState().notemenu.origin;lasttoucheditem = _launch.hack.store.getState().notemenu.lasttoucheditem;if (!(0, _fsa.isType)(action, _USERGROUP_CREATED2.default)) {_context7.next = 9;break;}_context7.next = 5;return (0, _reduxSaga.delay)(500);case 5:_context7.next = 7;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonUsergroupCreeerDeelnemers, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenUsergroup }));case 7:_context7.next = 51;break;case 9:if (!(0, _fsa.isType)(action, _USERGROUP_UPDATED2.default)) {_context7.next = 18;break;}usergroup = action.payload.usergroup;if (!(0, _types.isUsergroup)(usergroup)) {_context7.next = 16;break;}_context7.next = 14;return (0, _reduxSaga.delay)(500);case 14:_context7.next = 16;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: usergroup.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenUsergroup }));case 16:_context7.next = 51;break;case 18:if (!(origin === _UPDATE_BUTTON_NO.originNoteMenu)) {_context7.next = 21;break;}_context7.next = 51;break;case 21:if (!(origin === _UPDATE_BUTTON_NO.originAdmin)) {_context7.next = 51;break;}itm = action.payload;if (!(0, _types.isNote)(itm.item)) {_context7.next = 28;break;}_context7.next = 26;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: itm.item.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenItem }));case 26:_context7.next = 51;break;case 28:if (!(0, _types.isNote)(lasttoucheditem)) {_context7.next = 35;break;}_context7.next = 31;return (0, _reduxSaga.delay)(300);case 31:_context7.next = 33;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: lasttoucheditem.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenItem }));case 33:_context7.next = 51;break;case 35:if (!(0, _types.isCategory)(lasttoucheditem)) {_context7.next = 42;break;}_context7.next = 38;return (0, _reduxSaga.delay)(300);case 38:_context7.next = 40;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: lasttoucheditem.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenCategory }));case 40:_context7.next = 51;break;case 42:if (!lasttoucheditem) {_context7.next = 49;break;}_context7.next = 45;return (0, _reduxSaga.delay)(300);case 45:_context7.next = 47;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: lasttoucheditem.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionBewerkenBookmark }));case 47:_context7.next = 51;break;case 49:_context7.next = 51;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonAdminNotitiesButton, origin: _UPDATE_BUTTON_NO.originAdmin }));case 51:case 'end':return _context7.stop();}}}, _callee4, this);}));case 2:case 'end':return _context8.stop();}}}, _marked4, this);}function determineClosest(prev, curr, value) {if (value === curr) return prev;return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;}function signalReturnFromDeletion() {return _regenerator2.default.wrap(function signalReturnFromDeletion$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesEditor.actions.DELETE_CANCEL, _resource2.notesEditor.actions.DELETE_CONTINUE, _resource3.categoriesEditor.actions.DELETE_CANCEL, _resource3.categoriesEditor.actions.DELETE_CONTINUE], /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {var origin, lasttoucheditem, itm, items, closest, _items;return _regenerator2.default.wrap(function _callee5$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:origin = _launch.hack.store.getState().notemenu.origin;lasttoucheditem = _launch.hack.store.getState().notemenu.lasttoucheditem;if (!(origin === _UPDATE_BUTTON_NO.originAdmin)) {_context9.next = 34;break;}itm = action.payload;if (!(0, _types.isNote)(itm.item)) {_context9.next = 14;break;}if (!(0, _fsa.isType)(action, _resource2.notesEditor.actions.DELETE_CONTINUE)) {_context9.next = 12;break;}items = _reselectors2.default.notesItemsSelector(_launch.hack.store.getState());closest = items.map(function (x) {return x.id;}).reduce(function (prev, curr) {return determineClosest(prev, curr, itm.item.id);});_context9.next = 10;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: closest, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteItem }));case 10:_context9.next = 14;break;case 12:_context9.next = 14;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: itm.item.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteItem }));case 14:if (!(0, _types.isCategory)(itm.item)) {_context9.next = 26;break;}if (!(0, _fsa.isType)(action, _resource2.notesEditor.actions.DELETE_CONTINUE)) {_context9.next = 22;break;}_items = _reselectors2.default.categoriesItemsSelector(_launch.hack.store.getState());closest = _items.map(function (x) {return x.id;}).reduce(function (prev, curr) {return determineClosest(prev, curr, itm.item.id);});_context9.next = 20;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: closest, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteCategory }));case 20:_context9.next = 24;break;case 22:_context9.next = 24;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: itm.item.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteCategory }));case 24:_context9.next = 34;break;case 26:if (!(0, _types.isNote)(lasttoucheditem)) {_context9.next = 31;break;}_context9.next = 29;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: lasttoucheditem.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteItem }));case 29:_context9.next = 34;break;case 31:if (!(0, _types.isCategory)(lasttoucheditem)) {_context9.next = 34;break;}_context9.next = 34;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: lasttoucheditem.id, origin: _UPDATE_BUTTON_NO.originAdmin, buttonAction: _UPDATE_BUTTON_NO.itemButtonTypeActionDeleteCategory }));case 34:case 'end':return _context9.stop();}}}, _callee5, this);}));case 2:case 'end':return _context10.stop();}}}, _marked5, this);}function signalReturnFromMyItems() {return _regenerator2.default.wrap(function signalReturnFromMyItems$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (0, _fsaSaga.takeEvery)([_HIDE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {return _regenerator2.default.wrap(function _callee6$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _reduxSaga2.put)((0, _SHOW2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonMijnItems, origin: _UPDATE_BUTTON_NO.originNoteMenu }));case 2:case 'end':return _context11.stop();}}}, _callee6, this);}));case 2:case 'end':return _context12.stop();}}}, _marked6, this);}function watchBookmarkButtonActions() {return _regenerator2.default.wrap(function watchBookmarkButtonActions$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:_context14.next = 2;return (0, _fsaSaga.takeEvery)([_REFRESH_BOOKMARKUPDATE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {return _regenerator2.default.wrap(function _callee7$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:if (!action.payload.add) {_context13.next = 5;break;}_context13.next = 3;return (0, _reduxSaga2.put)(_resource.bookmarksResource.actions.CREATE({ item: _resource.bookmarksResource.create(action.payload.item) }));case 3:_context13.next = 7;break;case 5:_context13.next = 7;return (0, _reduxSaga2.put)(_resource.bookmarksResource.actions.DELETE({ item: action.payload.item }));case 7:case 'end':return _context13.stop();}}}, _callee7, this);}));case 2:case 'end':return _context14.stop();}}}, _marked7, this);}function signalUpdatebutton() {return _regenerator2.default.wrap(function signalUpdatebutton$(_context16) {while (1) {switch (_context16.prev = _context16.next) {case 0:_context16.next = 2;return (0, _fsaSaga.takeEvery)([_SHOW2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee8(action) {return _regenerator2.default.wrap(function _callee8$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:_context15.next = 2;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: action.payload.buttonNo, origin: _UPDATE_BUTTON_NO.originNoteMenu }));case 2:case 'end':return _context15.stop();}}}, _callee8, this);}));case 2:case 'end':return _context16.stop();}}}, _marked8, this);}function signalUpdatebuttonFlyover() {return _regenerator2.default.wrap(function signalUpdatebuttonFlyover$(_context18) {while (1) {switch (_context18.prev = _context18.next) {case 0:_context18.next = 2;return (0, _fsaSaga.takeEvery)([_SHOW4.default], /*#__PURE__*/_regenerator2.default.mark(function _callee9(action) {return _regenerator2.default.wrap(function _callee9$(_context17) {while (1) {switch (_context17.prev = _context17.next) {case 0:if (!(action.payload.buttonNo === _UPDATE_BUTTON_NO.buttonNotitiesToevoegenFlyover)) {_context17.next = 3;break;}_context17.next = 3;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: action.payload.buttonNo, origin: _UPDATE_BUTTON_NO.originFlyover }));case 3:case 'end':return _context17.stop();}}}, _callee9, this);}));case 2:case 'end':return _context18.stop();}}}, _marked9, this);}function signalReleaselock() {return _regenerator2.default.wrap(function signalReleaselock$(_context20) {while (1) {switch (_context20.prev = _context20.next) {case 0:_context20.next = 2;return (0, _fsaSaga.takeEvery)([_UPDATED_BUTTON_LOCK2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee10(action) {return _regenerator2.default.wrap(function _callee10$(_context19) {while (1) {switch (_context19.prev = _context19.next) {case 0:_context19.next = 2;return (0, _reduxSaga.delay)((0, _UPDATE_BUTTON_NO.GetDelay)(action.payload.buttonNo));case 2:_context19.next = 4;return (0, _reduxSaga2.put)((0, _RELEASE_BUTTON_LOCK2.default)({ buttonNo: action.payload.buttonNo, origin: action.payload.origin, buttonAction: action.payload.buttonAction }));case 4:case 'end':return _context19.stop();}}}, _callee10, this);}));case 2:case 'end':return _context20.stop();}}}, _marked10, this);}function signalChangeFilterCategory() {return _regenerator2.default.wrap(function signalChangeFilterCategory$(_context22) {while (1) {switch (_context22.prev = _context22.next) {case 0:_context22.next = 2;return (0, _fsaSaga.takeEvery)([_PAGEFILTER_TOGGLE_CATEGORY2.default, _SHOW6.default], /*#__PURE__*/_regenerator2.default.mark(function _callee11(action) {return _regenerator2.default.wrap(function _callee11$(_context21) {while (1) {switch (_context21.prev = _context21.next) {case 0:_context21.next = 2;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonDropDownCategory, origin: _UPDATE_BUTTON_NO.originFlyover }));case 2:case 'end':return _context21.stop();}}}, _callee11, this);}));case 2:case 'end':return _context22.stop();}}}, _marked11, this);}function signalChangeFilterSorting() {return _regenerator2.default.wrap(function signalChangeFilterSorting$(_context24) {while (1) {switch (_context24.prev = _context24.next) {case 0:_context24.next = 2;return (0, _fsaSaga.takeEvery)([_PAGEFILTER_TOGGLE_SORTING2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee12(action) {return _regenerator2.default.wrap(function _callee12$(_context23) {while (1) {switch (_context23.prev = _context23.next) {case 0:_context23.next = 2;return (0, _reduxSaga2.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonDropDownSorting, origin: _UPDATE_BUTTON_NO.originFlyover }));case 2:case 'end':return _context23.stop();}}}, _callee12, this);}));case 2:case 'end':return _context24.stop();}}}, _marked12, this);}function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context25) {while (1) {switch (_context25.prev = _context25.next) {case 0:_context25.next = 2;return (
                        (0, _reduxSaga2.fork)(watchButtonActions));case 2:_context25.next = 4;return (
                        (0, _reduxSaga2.fork)(signalReturnFromSelection));case 4:_context25.next = 6;return (
                        (0, _reduxSaga2.fork)(signalReturnFromDeletion));case 6:_context25.next = 8;return (
                        (0, _reduxSaga2.fork)(signalReturnFromMyItems));case 8:_context25.next = 10;return (
                        (0, _reduxSaga2.fork)(signalUpdatebutton));case 10:_context25.next = 12;return (
                        (0, _reduxSaga2.fork)(signalUpdatebuttonFlyover));case 12:_context25.next = 14;return (
                        (0, _reduxSaga2.fork)(signalReleaselock));case 14:_context25.next = 16;return (
                        (0, _reduxSaga2.fork)(watchBookmarkButtonActions));case 16:_context25.next = 18;return (
                        (0, _reduxSaga2.fork)(signalChangeFilterCategory));case 18:_context25.next = 20;return (
                        (0, _reduxSaga2.fork)(signalChangeFilterSorting));case 20:_context25.next = 22;return (
                        (0, _reduxSaga2.fork)(signalEndNotesEdit));case 22:_context25.next = 24;return (
                        (0, _reduxSaga2.fork)(signalBeginNotesEdit));case 24:case 'end':return _context25.stop();}}}, _marked13, this);}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.participantIdSelector = undefined;var _reselect = __webpack_require__(221);
var _reducer = __webpack_require__(628);
var participantIdSelector = exports.participantIdSelector = (0, _reselect.createSelector)(_reducer.selector, function (state) {return state.id;});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _toConsumableArray2 = __webpack_require__(172);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var contentNavActivate = function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(









































































































































































































































    function _callee11(el) {return _regenerator2.default.wrap(function _callee11$(_context19) {while (1) {switch (_context19.prev = _context19.next) {case 0:return _context19.abrupt('return',
                        new _promise2.default(function (resolve, reject) {
                            try {
                                var cn = window.ContentNav;
                                if (cn) {
                                    var timer = setTimeout(function () {
                                        console.error('[Notes] ContentNav timed out');
                                        resolve();
                                    }, timeoutContentNav);
                                    cn.activate(el, function () {
                                        resolve();
                                        clearTimeout(timer);
                                    });
                                } else
                                {
                                    resolve();
                                }
                            }
                            catch (ex) {
                                reject(ex);
                            }
                        }));case 1:case 'end':return _context19.stop();}}}, _callee11, this);}));return function contentNavActivate(_x) {return _ref.apply(this, arguments);};}();exports.rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _reselect = __webpack_require__(221);var _index = __webpack_require__(244);var _launch = __webpack_require__(235);var _highlight = __webpack_require__(531);var _selectors = __webpack_require__(78);var _reduxSaga = __webpack_require__(47);var _types = __webpack_require__(245);var _resource = __webpack_require__(162);var _selectors2 = __webpack_require__(703);var _selectors3 = __webpack_require__(522);var _selectors4 = _interopRequireDefault(_selectors3);var _selectors5 = __webpack_require__(651);var _selectors6 = _interopRequireDefault(_selectors5);var _resource2 = __webpack_require__(106);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _READY = __webpack_require__(512);var _READY2 = _interopRequireDefault(_READY);var _HIDE = __webpack_require__(487);var _HIDE2 = _interopRequireDefault(_HIDE);var _CHANGE_CATEGORY = __webpack_require__(620);var _CHANGE_CATEGORY2 = _interopRequireDefault(_CHANGE_CATEGORY);var _CHANGE_SORTING = __webpack_require__(621);var _CHANGE_SORTING2 = _interopRequireDefault(_CHANGE_SORTING);var _SUCCESS = __webpack_require__(501);var _SUCCESS2 = _interopRequireDefault(_SUCCESS);var _RESET = __webpack_require__(249);var _RESET2 = _interopRequireDefault(_RESET);var _REQUEST = __webpack_require__(500);var _REQUEST2 = _interopRequireDefault(_REQUEST);var _NOTES_REDRAW = __webpack_require__(573);var _NOTES_REDRAW2 = _interopRequireDefault(_NOTES_REDRAW);var _HIDE3 = __webpack_require__(539);var _HIDE4 = _interopRequireDefault(_HIDE3);var _style = __webpack_require__(650);var _style2 = _interopRequireDefault(_style);



var _mathlib = __webpack_require__(667);
var _index2 = __webpack_require__(486);
var _fsa = __webpack_require__(1);
var _SESSION_RESTORED = __webpack_require__(538);var _SESSION_RESTORED2 = _interopRequireDefault(_SESSION_RESTORED);
var _NOTES_ITEM_LAST_TOUCHED = __webpack_require__(555);var _NOTES_ITEM_LAST_TOUCHED2 = _interopRequireDefault(_NOTES_ITEM_LAST_TOUCHED);
var _resource3 = __webpack_require__(494);
var _resource4 = __webpack_require__(246);
var _effects = __webpack_require__(170);
var _publisherspecific = __webpack_require__(903);
var _NOTE_DELETE_WITH_CHAT = __webpack_require__(668);var _NOTE_DELETE_WITH_CHAT2 = _interopRequireDefault(_NOTE_DELETE_WITH_CHAT);
var _resource5 = __webpack_require__(517);
var _NOTES_DELETE_BATCH = __webpack_require__(556);var _NOTES_DELETE_BATCH2 = _interopRequireDefault(_NOTES_DELETE_BATCH);
var _NOTES_DELETE_BATCH_COMPLETE = __webpack_require__(611);var _NOTES_DELETE_BATCH_COMPLETE2 = _interopRequireDefault(_NOTES_DELETE_BATCH_COMPLETE);
var _NOTES_DELETE_BATCH_FAILURE = __webpack_require__(612);var _NOTES_DELETE_BATCH_FAILURE2 = _interopRequireDefault(_NOTES_DELETE_BATCH_FAILURE);
var _resource6 = __webpack_require__(223);
var _TAB_ACTIVATE = __webpack_require__(557);var _TAB_ACTIVATE2 = _interopRequireDefault(_TAB_ACTIVATE);
var _USERGROUP_UPDATED = __webpack_require__(489);var _USERGROUP_UPDATED2 = _interopRequireDefault(_USERGROUP_UPDATED);
var _USERGROUP_CREATED = __webpack_require__(488);var _USERGROUP_CREATED2 = _interopRequireDefault(_USERGROUP_CREATED);
var _resource7 = __webpack_require__(234);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(signalDeleteBatchNotes),_marked3 = /*#__PURE__*/_regenerator2.default.mark(signalDeleteNoteWithChats),_marked4 = /*#__PURE__*/_regenerator2.default.mark(signalNotesList),_marked5 = /*#__PURE__*/_regenerator2.default.mark(monitorSelectedNote),_marked6 = /*#__PURE__*/_regenerator2.default.mark(monitorSelectedCategory),_marked7 = /*#__PURE__*/_regenerator2.default.mark(monitorHighlightNoteOnCreate),_marked8 = /*#__PURE__*/_regenerator2.default.mark(monitorBrowserReady),_marked9 = /*#__PURE__*/_regenerator2.default.mark(

monitorScrollToNote),_marked10 = /*#__PURE__*/_regenerator2.default.mark(

































































signalNotesReset),_marked11 = /*#__PURE__*/_regenerator2.default.mark(






































monitorNoteHighlights),_marked12 = /*#__PURE__*/_regenerator2.default.mark(













































































































































monitorBrowserRestoreActiveNote);var timeoutContentNav = 1500;var delayafterreload = 1500;var maxDelayTime = 10000;var minDelayTime = 1000;function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource2.notesResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource2.notesEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource2.notesBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalNotesList);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalNotesReset);case 10:_context.next = 12;return (0, _reduxSaga.fork)(monitorSelectedNote);case 12:_context.next = 14;return (0, _reduxSaga.fork)(monitorSelectedCategory);case 14:_context.next = 16;return (0, _reduxSaga.fork)(monitorHighlightNoteOnCreate);case 16:_context.next = 18;return (0, _reduxSaga.fork)(monitorBrowserReady);case 18:_context.next = 20;return (0, _reduxSaga.fork)(monitorNoteHighlights);case 20:_context.next = 22;return (0, _reduxSaga.fork)(monitorBrowserRestoreActiveNote);case 22:_context.next = 24;return (0, _reduxSaga.fork)(signalDeleteNoteWithChats);case 24:_context.next = 26;return (0, _reduxSaga.fork)(signalDeleteBatchNotes);case 26:case 'end':return _context.stop();}}}, _marked, this);}function signalDeleteBatchNotes() {return _regenerator2.default.wrap(function signalDeleteBatchNotes$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_NOTES_DELETE_BATCH2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var notes, countNotesToUpdate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note, waiting, waitresult;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!(0, _fsa.isType)(action, _NOTES_DELETE_BATCH2.default)) {_context2.next = 51;break;}notes = action.payload.items.qWhere(function (itm) {return !(0, _types.isSharedNote)(itm);});if (!notes) {_context2.next = 51;break;}countNotesToUpdate = notes.length;if (!(countNotesToUpdate > 0)) {_context2.next = 51;break;}_context2.prev = 5;_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context2.prev = 9;_iterator = (0, _getIterator3.default)(notes);case 11:if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {_context2.next = 30;break;}note = _step.value;_context2.next = 15;return (0, _reduxSaga.put)((0, _NOTE_DELETE_WITH_CHAT2.default)({ item: note }));case 15:_context2.next = 17;return (0, _effects.race)({ timeout: (0, _reduxSaga.call)(_reduxSaga.delay, maxDelayTime), updateend: (0, _fsaSaga.take)([_resource2.notesResource.actions.DELETE_FAILURE, _resource2.notesResource.actions.DELETE_SUCCESS]) });case 17:waiting = _context2.sent;waitresult = waiting;if (!waitresult.updateend) {_context2.next = 27;break;}if (!(countNotesToUpdate > 0)) {_context2.next = 27;break;}countNotesToUpdate--;if (!(countNotesToUpdate === 0)) {_context2.next = 27;break;}_context2.next = 25;return (0, _reduxSaga.call)(_reduxSaga.delay, minDelayTime);case 25:_context2.next = 27;return (0, _reduxSaga.put)((0, _NOTES_DELETE_BATCH_COMPLETE2.default)({ items: undefined, batchdelete: false }));case 27:_iteratorNormalCompletion = true;_context2.next = 11;break;case 30:_context2.next = 36;break;case 32:_context2.prev = 32;_context2.t0 = _context2['catch'](9);_didIteratorError = true;_iteratorError = _context2.t0;case 36:_context2.prev = 36;_context2.prev = 37;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 39:_context2.prev = 39;if (!_didIteratorError) {_context2.next = 42;break;}throw _iteratorError;case 42:return _context2.finish(39);case 43:return _context2.finish(36);case 44:_context2.next = 51;break;case 46:_context2.prev = 46;_context2.t1 = _context2['catch'](5);console.log(_context2.t1);_context2.next = 51;return (0, _reduxSaga.put)((0, _NOTES_DELETE_BATCH_FAILURE2.default)({ items: undefined, batchdelete: false }));case 51:case 'end':return _context2.stop();}}}, _callee, this, [[5, 46], [9, 32, 36, 44], [37,, 39, 43]]);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalDeleteNoteWithChats() {return _regenerator2.default.wrap(function signalDeleteNoteWithChats$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)(_NOTE_DELETE_WITH_CHAT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {var note, notechats, questions, notechatsNotes, countNotesToUpdate, questionNote, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, notechat, waiting, waitresult;return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (!(0, _fsa.isType)(action, _NOTE_DELETE_WITH_CHAT2.default)) {_context4.next = 69;break;}note = action.payload.item;if ((0, _types.isSharedNote)(note)) {_context4.next = 69;break;}_context4.next = 5;return (0, _reduxSaga.select)(_resource5.notechatResource.selectors.items);case 5:notechats = _context4.sent;_context4.next = 8;return (0, _reduxSaga.select)(_resource6.questionsResource.selectors.items);case 8:questions = _context4.sent;notechatsNotes = notechats.qWhere(function (itm) {return itm.noteId === note.id;});countNotesToUpdate = notechatsNotes.length;questionNote = questions.qFirst(function (itm) {return itm.noteId === note.id;});if (!(countNotesToUpdate > 0)) {_context4.next = 62;break;}_context4.prev = 13;_iteratorNormalCompletion2 = true;_didIteratorError2 = false;_iteratorError2 = undefined;_context4.prev = 17;_iterator2 = (0, _getIterator3.default)(notechatsNotes);case 19:if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {_context4.next = 41;break;}notechat = _step2.value;_context4.next = 23;return (0, _reduxSaga.put)(_resource5.notechatEditor.actions.DELETE_CONTINUE({ item: notechat }));case 23:_context4.next = 25;return (0, _effects.race)({ timeout: (0, _reduxSaga.call)(_reduxSaga.delay, maxDelayTime), updateend: (0, _fsaSaga.take)([_resource5.notechatResource.actions.DELETE_FAILURE, _resource5.notechatResource.actions.DELETE_SUCCESS]) });case 25:waiting = _context4.sent;waitresult = waiting;if (!waitresult.updateend) {_context4.next = 38;break;}if (!(countNotesToUpdate > 0)) {_context4.next = 38;break;}countNotesToUpdate--;if (!(countNotesToUpdate === 0)) {_context4.next = 38;break;}if (!questionNote) {_context4.next = 34;break;}_context4.next = 34;return (0, _reduxSaga.put)(_resource6.questionsEditor.actions.DELETE_CONTINUE({ item: questionNote }));case 34:_context4.next = 36;return (0, _reduxSaga.call)(_reduxSaga.delay, minDelayTime);case 36:_context4.next = 38;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.DELETE_CONTINUE({ item: note }));case 38:_iteratorNormalCompletion2 = true;_context4.next = 19;break;case 41:_context4.next = 47;break;case 43:_context4.prev = 43;_context4.t0 = _context4['catch'](17);_didIteratorError2 = true;_iteratorError2 = _context4.t0;case 47:_context4.prev = 47;_context4.prev = 48;if (!_iteratorNormalCompletion2 && _iterator2.return) {_iterator2.return();}case 50:_context4.prev = 50;if (!_didIteratorError2) {_context4.next = 53;break;}throw _iteratorError2;case 53:return _context4.finish(50);case 54:return _context4.finish(47);case 55:_context4.next = 60;break;case 57:_context4.prev = 57;_context4.t1 = _context4['catch'](13);console.log(_context4.t1);case 60:_context4.next = 69;break;case 62:if (!questionNote) {_context4.next = 65;break;}_context4.next = 65;return (0, _reduxSaga.put)(_resource6.questionsEditor.actions.DELETE_CONTINUE({ item: questionNote }));case 65:_context4.next = 67;return (0, _reduxSaga.call)(_reduxSaga.delay, minDelayTime);case 67:_context4.next = 69;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.DELETE_CONTINUE({ item: note }));case 69:case 'end':return _context4.stop();}}}, _callee2, this, [[13, 57], [17, 43, 47, 55], [48,, 50, 54]]);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalNotesList() {return _regenerator2.default.wrap(function signalNotesList$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.takeEvery)([_AUTHENTICATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee3() {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context6.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context6.next = 7;return (0, _reduxSaga.put)(_resource2.notesResource.actions.LIST({ params: { documentId: documentId } }));case 7:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:_context9.next = 4;return (0, _fsaSaga.takeEvery)([_USERGROUP_CREATED2.default, _USERGROUP_UPDATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee4() {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee4$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context7.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context7.next = 7;return (0, _reduxSaga.put)(_resource2.notesResource.actions.LIST({ params: { documentId: documentId } }));case 7:case 'end':return _context7.stop();}}}, _callee4, this);}));case 4:_context9.next = 6;return (0, _fsaSaga.takeEvery)([_resource7.beheerResource.actions.CREATE_SUCCESS, _resource7.beheerResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee5() {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee5$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context8.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context8.next = 7;return (0, _reduxSaga.put)(_resource2.notesResource.actions.LIST({ params: { documentId: documentId } }));case 7:case 'end':return _context8.stop();}}}, _callee5, this);}));case 6:case 'end':return _context9.stop();}}}, _marked4, this);}function monitorSelectedNote() {return _regenerator2.default.wrap(function monitorSelectedNote$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (0, _fsaSaga.takeEvery)(_resource2.notesEditor.actions.READ, /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {var selectionPage, selectionPageId, pageId;return _regenerator2.default.wrap(function _callee6$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 2:selectionPage = _context10.sent;selectionPageId = selectionPage;pageId = selectionPageId;if (!(action.payload.item.pageId !== pageId)) {_context10.next = 9;break;}window.location.href = action.payload.item.url;_context10.next = 11;break;case 9:_context10.next = 11;return (0, _reduxSaga.call)(monitorScrollToNote, action.payload.item);case 11:case 'end':return _context10.stop();}}}, _callee6, this);}));case 2:_context12.next = 4;return (0, _fsaSaga.takeEvery)(_resource3.notesSharedEditor.actions.READ, /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {var selectionPage, selectionPageId, pageId;return _regenerator2.default.wrap(function _callee7$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 2:selectionPage = _context11.sent;selectionPageId = selectionPage;pageId = selectionPageId;if (!(action.payload.item.pageId !== pageId)) {_context11.next = 9;break;}window.location.href = action.payload.item.url;_context11.next = 11;break;case 9:_context11.next = 11;return (0, _reduxSaga.call)(monitorScrollToNote, action.payload.item);case 11:case 'end':return _context11.stop();}}}, _callee7, this);}));case 4:case 'end':return _context12.stop();}}}, _marked5, this);}function monitorSelectedCategory() {return _regenerator2.default.wrap(function monitorSelectedCategory$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:_context14.next = 2;return (0, _fsaSaga.takeEvery)(_resource2.notesEditor.actions.APPLY, /*#__PURE__*/_regenerator2.default.mark(function _callee8(action) {return _regenerator2.default.wrap(function _callee8$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:_context13.next = 2;return (0, _reduxSaga.put)((0, _HIDE4.default)({}));case 2:case 'end':return _context13.stop();}}}, _callee8, this);}));case 2:case 'end':return _context14.stop();}}}, _marked6, this);}function monitorHighlightNoteOnCreate() {return _regenerator2.default.wrap(function monitorHighlightNoteOnCreate$(_context16) {while (1) {switch (_context16.prev = _context16.next) {case 0:_context16.next = 2;return (0, _fsaSaga.takeLatest)(_resource2.notesEditor.actions.CREATE, /*#__PURE__*/_regenerator2.default.mark(function _callee9(action) {var note;return _regenerator2.default.wrap(function _callee9$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:(0, _highlight.removeHighlights)(document.documentElement, '.js-highlight');_context15.prev = 1;_context15.next = 4;return (0, _reduxSaga.select)(_resource2.notesEditor.selectors.item);case 4:note = _context15.sent;_context15.next = 7;return (0, _highlight.applyHighlights)((0, _index.getAnchorFromDocument)(), note.startElementXPath, note.endElementXPath, function (node) {node.className = (0, _style2.default)('highlight', 'highlight-active') + ' js-highlight';});case 7:_context15.next = 9;return (0, _reduxSaga.call)(monitorScrollToNote, note);case 9:_context15.next = 14;break;case 11:_context15.prev = 11;_context15.t0 = _context15['catch'](1);console.error('[Notes] Update creating highlights failed.', _context15.t0);case 14:_context15.next = 16;return (0, _fsaSaga.take)([_resource2.notesEditor.actions.CREATE, _resource2.notesEditor.actions.CREATE_CANCEL, _resource2.notesEditor.actions.CREATE_CONTINUE, _resource2.notesEditor.actions.RESET]);case 16:(0, _highlight.removeHighlights)(document.documentElement, '.js-highlight');case 17:case 'end':return _context15.stop();}}}, _callee9, this, [[1, 11]]);}));case 2:case 'end':return _context16.stop();}}}, _marked7, this);}function monitorBrowserReady() {return _regenerator2.default.wrap(function monitorBrowserReady$(_context18) {while (1) {switch (_context18.prev = _context18.next) {case 0:_context18.next = 2;return (0, _fsaSaga.takeEvery)(_READY2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee10(action) {var itemEff, item, readingEff, reading, questionsEff, questions, pageIdEff, pageId, _pageIdEff, _pageId, current;return _regenerator2.default.wrap(function _callee10$(_context17) {while (1) {switch (_context17.prev = _context17.next) {case 0:_context17.next = 2;return (0, _reduxSaga.select)(_resource2.notesEditor.selectors.item);case 2:itemEff = _context17.sent;item = itemEff;_context17.next = 6;return (0, _reduxSaga.select)(_resource2.notesEditor.selectors.reading);case 6:readingEff = _context17.sent;reading = readingEff;_context17.next = 10;return (0, _reduxSaga.select)(_resource6.questionsResource.selectors.items);case 10:questionsEff = _context17.sent;questions = questionsEff;if (!(item && reading)) {_context17.next = 28;break;}_context17.next = 15;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 15:pageIdEff = _context17.sent;pageId = pageIdEff;if (!(item.pageId === pageId)) {_context17.next = 22;break;}_context17.next = 20;return (0, _reduxSaga.call)(monitorScrollToNote, item);case 20:_context17.next = 26;break;case 22:_context17.next = 24;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.RESET({}));case 24:_context17.next = 26;return (0, _reduxSaga.put)(_resource6.questionsEditor.actions.RESET({}));case 26:_context17.next = 47;break;case 28:if (!item) {_context17.next = 47;break;}_context17.next = 31;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 31:_pageIdEff = _context17.sent;_pageId = _pageIdEff;if (!(item.pageId === _pageId)) {_context17.next = 43;break;}_context17.next = 36;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.READ({ item: item }));case 36:if (!(0, _types.isQuestion)(item)) {_context17.next = 41;break;}current = questions.qWhere(function (x) {return x.noteId === item.id;}).qFirst();if (!current) {_context17.next = 41;break;}_context17.next = 41;return (0, _reduxSaga.put)(_resource6.questionsEditor.actions.READ({ item: current }));case 41:_context17.next = 47;break;case 43:_context17.next = 45;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.RESET({}));case 45:_context17.next = 47;return (0, _reduxSaga.put)(_resource6.questionsEditor.actions.RESET({}));case 47:case 'end':return _context17.stop();}}}, _callee10, this);}));case 2:case 'end':return _context18.stop();}}}, _marked8, this);}var bezier = __webpack_require__(904);var cubic = bezier.prepare(4);var scrollTask = void 0;function monitorScrollToNote(note) {var pageIdEff, pageId, scrollTaskEff;return _regenerator2.default.wrap(function monitorScrollToNote$(_context21) {while (1) {switch (_context21.prev = _context21.next) {case 0:if (!scrollTask) {_context21.next = 3;break;}_context21.next = 3;return (0, _reduxSaga.cancel)(scrollTask);case 3:if (note) {_context21.next = 5;break;}return _context21.abrupt('return');case 5:_context21.next = 7;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 7:pageIdEff = _context21.sent;pageId = pageIdEff;if (!(note.pageId !== pageId)) {_context21.next = 11;break;}return _context21.abrupt('return');case 11:_context21.next = 13;return (0, _reduxSaga.fork)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {var detailsNav, details, fps, duration, maxDuration, ps, detailselement, detailsTop, scrollingElement, scrollTopStart, scrollHeight, viewportHeight, targetY, time, diffY, bezierInput, scrollTop, t;return _regenerator2.default.wrap(function _callee12$(_context20) {while (1) {switch (_context20.prev = _context20.next) {case 0:_context20.prev = 0;detailsNav = (0, _index2.getSelectionDetail)((0, _index.getAnchorFromDocument)(), note.startElementXPath);if (detailsNav) {_context20.next = 4;break;}return _context20.abrupt('return');case 4:_context20.prev = 4;_context20.next = 7;return contentNavActivate(detailsNav.textStart);case 7:_context20.next = 12;break;case 9:_context20.prev = 9;_context20.t0 = _context20['catch'](4);console.error('[Notes] ContentNav failed', _context20.t0);case 12:details = (0, _index2.getSelectionDetail)((0, _index.getAnchorFromDocument)(), note.startElementXPath);if (details) {_context20.next = 16;break;}console.error('[Notes] selection details not found after ContentNav for [' + note.startElementXPath + ']');return _context20.abrupt('return');case 16:fps = 60;duration = 300;maxDuration = 600;ps = new _publisherspecific.PublisherSpecific();detailselement = details.textStart.parentNode;if (detailselement && !ps.isVisible(detailselement)) {while (detailselement && !ps.isVisible(detailselement)) {detailselement = detailselement.parentNode;}if (!detailselement) detailselement = details.textStart.parentNode;};detailsTop = detailselement.getBoundingClientRect().top;scrollingElement = document.scrollingElement || document.documentElement;scrollTopStart = scrollingElement.scrollTop;scrollHeight = scrollingElement.scrollHeight;viewportHeight = window.innerHeight;targetY = (0, _mathlib.constrain)(Math.floor(scrollTopStart + detailsTop - viewportHeight * .33), 0, scrollHeight - viewportHeight);time = Date.now();diffY = targetY - scrollTopStart;bezierInput = [0, diffY * .1, diffY * .9, diffY];scrollTop = scrollTopStart;case 33:if (!(scrollTop !== targetY && Date.now() - time < maxDuration)) {_context20.next = 42;break;}t = (0, _mathlib.map_constrain)(Date.now() - time, 0, duration, 0, 1);scrollTop = scrollTopStart + cubic(bezierInput, t);document.documentElement.scrollTop = scrollTop;document.body.scrollTop = scrollTop;_context20.next = 40;return (0, _reduxSaga.delay)(1000 / fps);case 40:_context20.next = 33;break;case 42:_context20.next = 47;break;case 44:_context20.prev = 44;_context20.t1 = _context20['catch'](0);console.debug('[Notes] Unable to get selection details for [' + note.startElementXPath + ']', _context20.t1);case 47:case 'end':return _context20.stop();}}}, _callee12, this, [[0, 44], [4, 9]]);}));case 13:scrollTaskEff = _context21.sent;scrollTask = scrollTaskEff;case 15:case 'end':return _context21.stop();}}}, _marked9, this);}function signalNotesReset() {return _regenerator2.default.wrap(function signalNotesReset$(_context23) {while (1) {switch (_context23.prev = _context23.next) {case 0:_context23.next = 2;return (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee13() {return _regenerator2.default.wrap(function _callee13$(_context22) {while (1) {switch (_context22.prev = _context22.next) {case 0:_context22.next = 2;return (0, _reduxSaga.put)(_resource2.notesEditor.actions.RESET({}));case 2:_context22.next = 4;return (0, _reduxSaga.put)(_resource2.notesResource.actions.RESET({}));case 4:case 'end':return _context22.stop();}}}, _callee13, this);}));case 2:case 'end':return _context23.stop();}}}, _marked10, this);}function getCategoryCss(activeNote, note) {if ((0, _types.isSharedNote)(activeNote) && (0, _types.isSharedNote)(note)) {return _resource3.notesSharedResource.hasSameId(activeNote, note) ? (0, _style2.default)('highlight-shared', 'highlight-active-shared') : (0, _style2.default)('highlight-shared', 'highlight-normal-shared');} else if (!(0, _types.isSharedNote)(activeNote) && !(0, _types.isSharedNote)(note)) {return _resource2.notesResource.hasSameId(activeNote, note) ? (0, _style2.default)('highlight', 'highlight-active') : (0, _style2.default)('highlight', 'highlight-normal');} else if ((0, _types.isSharedNote)(note)) {return (0, _style2.default)('highlight-shared', 'highlight-normal-shared');} else {return (0, _style2.default)('highlight', 'highlight-normal');}}function getNoteTitle(note, participants) {if ((0, _types.isSharedNote)(note)) {if (participants.qWhere(function (itm) {return itm.id === note.userId;}).qAny()) {var participantname = participants.qWhere(function (itm) {return itm.id === note.userId;}).qFirst().name;return 'Notitie van ' + participantname + ': ' + note.text;} else {return note.text;}} else {return note.text;}}var editorItemSelector = (0, _reselect.createSelector)(_resource2.notesEditor.selectors.creating, _resource2.notesEditor.selectors.reading, _resource2.notesEditor.selectors.updating, _resource2.notesEditor.selectors.deleting, _resource2.notesEditor.selectors.item, _resource3.notesSharedEditor.selectors.reading, _resource3.notesSharedEditor.selectors.item, function (creating, reading, updating, deleting, item, readingshared, itemshared) {return (creating || reading || updating || deleting) && item || readingshared && itemshared;});function monitorNoteHighlights() {var debounceDelay, slowWarningInterval, _task, prev, clickListeners, renderTimesIdx, renderTimesHistoryCount, renderSlowThreshold, giveSlowWarning, slowWarningTimer, renderTimes, avgRenderTime, pushRenderTime;return _regenerator2.default.wrap(function monitorNoteHighlights$(_context28) {while (1) {switch (_context28.prev = _context28.next) {case 0:debounceDelay = 50;slowWarningInterval = 10000;_task = void 0;prev = void 0;clickListeners = [];renderTimesIdx = 0;renderTimesHistoryCount = 5;renderSlowThreshold = 200;giveSlowWarning = true;slowWarningTimer = null;renderTimes = new Int32Array(renderTimesHistoryCount);avgRenderTime = function avgRenderTime() {return renderTimes.reduce(function (state, next) {return state + next;}, 0) / renderTimesHistoryCount;};pushRenderTime = function pushRenderTime(time) {renderTimes[renderTimesIdx++ % renderTimesHistoryCount] = time;};_context28.next = 15;return (0, _fsaSaga.takeEvery)([].concat((0, _toConsumableArray3.default)(_resource2.notesEditor.actions.all), (0, _toConsumableArray3.default)(_resource2.notesResource.actions.all), (0, _toConsumableArray3.default)(_resource3.notesSharedEditor.actions.all), (0, _toConsumableArray3.default)(_resource3.notesSharedResource.actions.all), [_CHANGE_SORTING2.default, _CHANGE_CATEGORY2.default, _REQUEST2.default, _SUCCESS2.default, _RESET2.default, _LOGGEDOUT2.default, _NOTES_REDRAW2.default]), /*#__PURE__*/_regenerator2.default.mark(function _callee16(action) {var _taskEff;return _regenerator2.default.wrap(function _callee16$(_context27) {while (1) {switch (_context27.prev = _context27.next) {case 0:if (!_task) {_context27.next = 3;break;}_context27.next = 3;return (0, _reduxSaga.cancel)(_task);case 3:_context27.next = 5;return (0, _reduxSaga.fork)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {var _this = this;var state;return _regenerator2.default.wrap(function _callee15$(_context26) {while (1) {switch (_context26.prev = _context26.next) {case 0:_context26.next = 2;return (0, _reduxSaga.delay)(debounceDelay);case 2:_context26.next = 4;return (0, _reduxSaga.select)(_resource.categoriesResource.selectors.items);case 4:_context26.t0 = _context26.sent;_context26.next = 7;return (0, _reduxSaga.select)(_selectors4.default.creating);case 7:_context26.t1 = _context26.sent;_context26.next = 10;return (0, _reduxSaga.select)(editorItemSelector);case 10:_context26.t2 = _context26.sent;_context26.next = 13;return (0, _reduxSaga.select)(_selectors2.notesAndQuestionsPageSelector);case 13:_context26.t3 = _context26.sent;_context26.next = 16;return (0, _reduxSaga.select)(_resource4.participantsResource.selectors.items);case 16:_context26.t4 = _context26.sent;_context26.next = 19;return (0, _reduxSaga.select)(_resource6.questionsResource.selectors.items);case 19:_context26.t5 = _context26.sent;state = { categories: _context26.t0, creatingSelection: _context26.t1, currentItem: _context26.t2, items: _context26.t3, participants: _context26.t4, allQuestions: _context26.t5 };if (shallowEquals(prev, state)) {_context26.next = 23;break;}return _context26.delegateYield( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, unsub, creatingSelection, currentItem, items, participants, allQuestions, sortedNotes, onClick, sortedNotesCount, anchors, _loop, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, note, _ret2;return _regenerator2.default.wrap(function _callee14$(_context25) {while (1) {switch (_context25.prev = _context25.next) {case 0:prev = state;_iteratorNormalCompletion3 = true;_didIteratorError3 = false;_iteratorError3 = undefined;_context25.prev = 4;for (_iterator3 = (0, _getIterator3.default)(clickListeners); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {unsub = _step3.value;unsub();}_context25.next = 12;break;case 8:_context25.prev = 8;_context25.t0 = _context25['catch'](4);_didIteratorError3 = true;_iteratorError3 = _context25.t0;case 12:_context25.prev = 12;_context25.prev = 13;if (!_iteratorNormalCompletion3 && _iterator3.return) {_iterator3.return();}case 15:_context25.prev = 15;if (!_didIteratorError3) {_context25.next = 18;break;}throw _iteratorError3;case 18:return _context25.finish(15);case 19:return _context25.finish(12);case 20:clickListeners = [];creatingSelection = state.creatingSelection, currentItem = state.currentItem, items = state.items, participants = state.participants, allQuestions = state.allQuestions;(0, _highlight.removeHighlights)(document.documentElement, '.js-note');sortedNotes = items.slice(0).sort(function (a, b) {if (_resource2.notesResource.hasSameId(a, currentItem)) {return 1;}if (_resource2.notesResource.hasSameId(b, currentItem)) {return -1;}return a.startElementXPath.localeCompare(b.startElementXPath);});onClick = function onClick(note) {if (_resource2.notesResource.hasSameId(note, currentItem)) {_launch.hack.store.dispatch(_resource2.notesEditor.actions.READ_CANCEL({}));_launch.hack.store.dispatch(_resource3.notesSharedEditor.actions.READ_CANCEL({}));_launch.hack.store.dispatch(_resource6.questionsEditor.actions.READ_CANCEL({}));_launch.hack.store.dispatch((0, _HIDE2.default)({}));} else {if (!!(0, _types.isSharedNote)(note)) {_launch.hack.store.dispatch(_resource2.notesEditor.actions.READ_CANCEL({}));_launch.hack.store.dispatch(_resource3.notesSharedEditor.actions.READ({ item: note }));} else {_launch.hack.store.dispatch(_resource3.notesSharedEditor.actions.READ_CANCEL({}));_launch.hack.store.dispatch(_resource2.notesEditor.actions.READ({ item: note }));}var readquestion = false;if ((0, _types.isQuestion)(note)) {var current = allQuestions.qWhere(function (x) {return x.noteId === note.id;}).qFirst();if (current) {_launch.hack.store.dispatch(_resource6.questionsEditor.actions.READ({ item: current }));_launch.hack.store.dispatch((0, _TAB_ACTIVATE2.default)({ index: 1 })), readquestion = true;}} else {_launch.hack.store.dispatch((0, _TAB_ACTIVATE2.default)({ index: 0 }));}if ((0, _types.isQuestion)(note) && !readquestion) {_launch.hack.store.dispatch(_resource6.questionsEditor.actions.READ_CANCEL({}));}}};sortedNotesCount = sortedNotes.length;anchors = (0, _index.getAnchorFromDocument)();_loop = /*#__PURE__*/_regenerator2.default.mark(function _loop(note) {var time, tooSlowMultiplier;return _regenerator2.default.wrap(function _loop$(_context24) {while (1) {switch (_context24.prev = _context24.next) {case 0:_context24.prev = 0;time = Date.now();_context24.next = 4;return (0, _highlight.applyHighlights)(anchors, note.startElementXPath, note.endElementXPath, function (node) {node.className = getCategoryCss(currentItem, note) + ' js-note';node.id = 'id-note-' + note.id.toString();node.title = getNoteTitle(note, participants);if (!creatingSelection) {clickListeners.push(onClickElement(node, onClick.bind(null, note)));}if (currentItem.id === note.id) {var ps = new _publisherspecific.PublisherSpecific();ps.waitFor('#' + node.id).then(function (elm) {ps.unHideHidden(node).then(function (topHiddenElement) {}).catch(function (res) {console.log(res);});}).catch(function (res) {console.log(res);});}});case 4:pushRenderTime(Date.now() - time);if (!(avgRenderTime() * sortedNotesCount >= renderSlowThreshold)) {_context24.next = 12;break;}if (giveSlowWarning) {tooSlowMultiplier = avgRenderTime() * sortedNotesCount / renderSlowThreshold;console.warn('[NoteService] Rendering notes progressive, due to slow performance: ' + sortedNotes.length + ' notes, ' + (1000 / avgRenderTime()).toFixed(1) + 'notes/sec (' + tooSlowMultiplier.toFixed(1) + 'x too slow). May cause flickering.');giveSlowWarning = false;}if (!slowWarningTimer) {slowWarningTimer = setTimeout(function () {slowWarningTimer = null;giveSlowWarning = true;}, slowWarningInterval);}_context24.next = 10;return;case 10:_context24.next = 13;break;case 12:if (!giveSlowWarning) {console.warn('[NoteService] Rendering notes instantly: ' + sortedNotes.length + ' notes, ' + (1000 / avgRenderTime()).toFixed(1) + 'notes/sec.');giveSlowWarning = true;}case 13:_context24.next = 20;break;case 15:_context24.prev = 15;_context24.t0 = _context24['catch'](0);if (!(_context24.t0.message === 'No matching node')) {_context24.next = 19;break;}return _context24.abrupt('return', 'continue');case 19:console.error('[NoteService] Failed to render note [' + note.startElementXPath + ':' + note.endElementXPath + ']: ' + _context24.t0.message);case 20:case 'end':return _context24.stop();}}}, _loop, _this, [[0, 15]]);});_iteratorNormalCompletion4 = true;_didIteratorError4 = false;_iteratorError4 = undefined;_context25.prev = 31;_iterator4 = (0, _getIterator3.default)(sortedNotes);case 33:if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {_context25.next = 42;break;}note = _step4.value;return _context25.delegateYield(_loop(note), 't1', 36);case 36:_ret2 = _context25.t1;if (!(_ret2 === 'continue')) {_context25.next = 39;break;}return _context25.abrupt('continue', 39);case 39:_iteratorNormalCompletion4 = true;_context25.next = 33;break;case 42:_context25.next = 48;break;case 44:_context25.prev = 44;_context25.t2 = _context25['catch'](31);_didIteratorError4 = true;_iteratorError4 = _context25.t2;case 48:_context25.prev = 48;_context25.prev = 49;if (!_iteratorNormalCompletion4 && _iterator4.return) {_iterator4.return();}case 51:_context25.prev = 51;if (!_didIteratorError4) {_context25.next = 54;break;}throw _iteratorError4;case 54:return _context25.finish(51);case 55:return _context25.finish(48);case 56:case 'end':return _context25.stop();}}}, _callee14, _this, [[4, 8, 12, 20], [13,, 15, 19], [31, 44, 48, 56], [49,, 51, 55]]);})(), 't6', 23);case 23:case 'end':return _context26.stop();}}}, _callee15, this);}));case 5:_taskEff = _context27.sent;_task = _taskEff;case 7:case 'end':return _context27.stop();}}}, _callee16, this);}));case 15:case 'end':return _context28.stop();}}}, _marked11, this);}function monitorBrowserRestoreActiveNote() {return _regenerator2.default.wrap(function monitorBrowserRestoreActiveNote$(_context30) {while (1) {switch (_context30.prev = _context30.next) {case 0:_context30.next = 2;return (
                        (0, _fsaSaga.takeEvery)([_SESSION_RESTORED2.default, _NOTES_ITEM_LAST_TOUCHED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee17(action) {var curitem, item, _item, readquestion, questions, _currentitem;return _regenerator2.default.wrap(function _callee17$(_context29) {while (1) {switch (_context29.prev = _context29.next) {case 0:if (!(
                                            _selectors6.default !== undefined)) {_context29.next = 37;break;}if (!
                                            _launch.hack.store.getState()) {_context29.next = 37;break;}
                                            curitem = _selectors6.default.currentitem(_launch.hack.store.getState());if (
                                            !(0, _types.isSharedNote)(curitem)) {_context29.next = 13;break;}
                                            item = curitem;_context29.next = 7;return (
                                                (0, _reduxSaga.call)(_reduxSaga.delay, delayafterreload));case 7:_context29.next = 9;return (
                                                (0, _reduxSaga.put)(_resource3.notesSharedEditor.actions.READ({ item: item })));case 9:_context29.next = 11;return (
                                                (0, _reduxSaga.put)(_resource2.notesEditor.actions.READ_CANCEL({})));case 11:_context29.next = 21;break;case 13:if (

                                            !(0, _types.isNote)(curitem)) {_context29.next = 21;break;}
                                            _item = curitem;_context29.next = 17;return (
                                                (0, _reduxSaga.call)(_reduxSaga.delay, delayafterreload));case 17:_context29.next = 19;return (
                                                (0, _reduxSaga.put)(_resource2.notesEditor.actions.READ({ item: _item })));case 19:_context29.next = 21;return (
                                                (0, _reduxSaga.put)(_resource3.notesSharedEditor.actions.READ_CANCEL({})));case 21:

                                            readquestion = false;if (!
                                            (0, _types.isQuestion)(curitem)) {_context29.next = 31;break;}_context29.next = 25;return (
                                                (0, _reduxSaga.select)(_resource6.questionsResource.selectors.items));case 25:questions = _context29.sent;
                                            _currentitem = questions.qWhere(function (x) {return x.noteId === curitem.id;}).qFirst();if (!
                                            _currentitem) {_context29.next = 31;break;}_context29.next = 30;return (
                                                (0, _reduxSaga.put)(_resource6.questionsEditor.actions.READ({ item: _currentitem })));case 30:
                                            readquestion = true;case 31:if (!(


                                            (0, _types.isQuestion)(curitem) && !readquestion)) {_context29.next = 34;break;}_context29.next = 34;return (
                                                (0, _reduxSaga.put)(_resource6.questionsEditor.actions.READ_CANCEL({})));case 34:if (!

                                            (0, _fsa.isType)(action, _SESSION_RESTORED2.default)) {_context29.next = 37;break;}_context29.next = 37;return (
                                                (0, _reduxSaga.put)((0, _NOTES_ITEM_LAST_TOUCHED2.default)({ item: undefined })));case 37:case 'end':return _context29.stop();}}}, _callee17, this);})));case 2:case 'end':return _context30.stop();}}}, _marked12, this);}





function onClickElement(el, onClick) {
    el.addEventListener('click', onClick);
    return function () {
        el.removeEventListener('click', onClick);
    };
}
function shallowEquals(a, b) {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    var keys = [].concat((0, _toConsumableArray3.default)((0, _keys2.default)(a)), (0, _toConsumableArray3.default)((0, _keys2.default)(b))).qDistinct();
    return keys.every(function (x) {return a[x] === b[x];});
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(529);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(115);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(898);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, ".sCds9pUT{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.sCds9pUT,.sCds9pUT span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.sCds9pUT span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.sCds9pUT:hover span{background:#30379d}.sCds9pUT:focus{border-color:#30379d;outline:none}.sCds9pUT:focus span{background:#30379d}.sCds9pUT._28kdjyDt{cursor:not-allowed}.sCds9pUT._28kdjyDt span{background:#f4f4f8;color:#6e6e77}.sCds9pUT.MIo4Xiop{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.sCds9pUT._1Yi0dnCz span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.sCds9pUT._1Yi0dnCz:hover span{background:#f4f4f8}.sCds9pUT._1Yi0dnCz:focus{border-color:#30379d}.sCds9pUT._1Yi0dnCz._28kdjyDt{cursor:not-allowed}.sCds9pUT._1Yi0dnCz._28kdjyDt span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.sCds9pUT._2nGRBQAx span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.sCds9pUT._2nGRBQAx span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.sCds9pUT._2nGRBQAx:hover span{background:#f4f4f8}.sCds9pUT._2nGRBQAx:focus{border-color:#30379d}.sCds9pUT._2nGRBQAx._28kdjyDt{cursor:not-allowed}.sCds9pUT._2nGRBQAx._28kdjyDt span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.sCds9pUT.nhUodTvW span{background:transparent;color:#414141;letter-spacing:.36px}.sCds9pUT.nhUodTvW:hover span{background:#f4f4f8}.sCds9pUT.nhUodTvW:focus{border-color:#30379d}.sCds9pUT.nhUodTvW:focus span{background:#f4f4f8}.sCds9pUT.nhUodTvW._28kdjyDt{cursor:not-allowed}.sCds9pUT.nhUodTvW._28kdjyDt span{background:#f4f4f8;color:#6e6e77}._3NGgGKhR{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}._3NGgGKhR._3J4e2AKe:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._3BudJw5Z{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._3BudJw5Z,._3BudJw5Z span{display:inline-block}._3BudJw5Z span._2qlZKt4v{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._3BudJw5Z span.Gmf_fo0W{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._3BudJw5Z span.Gmf_fo0W:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._3BudJw5Z span.Gmf_fo0W._1wLvC8hh:after{content:\"\\E5CF\"}._3BudJw5Z span.Gmf_fo0W._2ywqOlL5:after{content:\"\\E5CE\"}._3BudJw5Z:focus{outline-color:#4b55f6}.sCds9pUT._2R7fFCkK{border-radius:50%;width:40px;height:40px;position:relative}.sCds9pUT._2R7fFCkK span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.sCds9pUT._2R7fFCkK span,.sCds9pUT._2R7fFCkK span:after{color:#4b55f6;display:inline-block;position:relative}.sCds9pUT._2R7fFCkK span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.sCds9pUT._2R7fFCkK:hover span{background:#f4f4f8}.sCds9pUT._2R7fFCkK:focus{border-color:#4b55f6}.sCds9pUT._2R7fFCkK:focus span{background:#f4f4f8}.sCds9pUT._2R7fFCkK._28kdjyDt span{background:#f4f4f8;color:#6e6e77}.sCds9pUT._2R7fFCkK._2kqlwl3w span:after{content:\"\\E7FD\"}.sCds9pUT._2R7fFCkK._30gh26sR span:after{content:\"\\F233\"}.sCds9pUT._2R7fFCkK._2Cbbt-9E span:after{content:\"\\F1CF\"}.sCds9pUT._2R7fFCkK._3AGRT_V0 span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK.r2jsfb2v span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK._3a-17FJq span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK._3glzNcxG span:after{content:\"\\E876\"}.sCds9pUT._2R7fFCkK._140B3lRN span:after{content:\"\\E835\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK.tT6ygeBi span:after{content:\"\\E834\"}.sCds9pUT._2R7fFCkK._2FUEbPYP span:after{content:\"\\E5CF\"}.sCds9pUT._2R7fFCkK._1R-kYgzh span:after{content:\"\\E5CE\"}.sCds9pUT._2R7fFCkK._3kL5Z4pF span:after{content:\"\\E5CD\"}.sCds9pUT._2R7fFCkK._3c8-z7UJ span:after{content:\"\\E0C6\"}.sCds9pUT._2R7fFCkK._3wduiukY span:after{content:\"\\E5D4\"}.sCds9pUT._2R7fFCkK._2S0PyKpy span:after{content:\"\\E880\"}.sCds9pUT._2R7fFCkK._3D_17lj_ span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK._2aXINEPo span:after{content:\"\\E87D\"}.sCds9pUT._2R7fFCkK._1p6hILuD span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK.gmekxW_l span:after{content:\"\\E41A\"}.sCds9pUT._2R7fFCkK._3QL-LQch span:after{content:\"\\E8B6\"}.sCds9pUT._2R7fFCkK.Kkt81M-b span:after{content:\"\\E0B7\"}.sCds9pUT._2R7fFCkK._22Wvh6Kg span:after{content:\"\\E150\"}.sCds9pUT._2R7fFCkK._36GCVz1L span:after{content:\"\\E150\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK._1ci2jCTS span:after{content:\"\\E145\"}.sCds9pUT._2R7fFCkK._3xNrOYrQ span:after{content:\"\\E836\"}.sCds9pUT._2R7fFCkK._7vheC1d9 span:after{content:\"\\E837\"}.sCds9pUT._2R7fFCkK.hm0hIV8j span:after{content:\"\\E163\"}.sCds9pUT._2R7fFCkK._2TurE2AG span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK.dC1f-geW span:after{content:\"\\E872\";font-family:Material Icons Outlined}.sCds9pUT._2R7fFCkK._3RFec2kX span:after{content:\"\\E5C4\"}.sCds9pUT._2R7fFCkK._2ARKLcoM span:after{content:\"\\E5C8\"}.sCds9pUT._2R7fFCkK._2d9_OEy2,.sCds9pUT._2R7fFCkK._3Yh7nDfg{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}.sCds9pUT._2R7fFCkK._2d9_OEy2 span,.sCds9pUT._2R7fFCkK._3Yh7nDfg span{padding:0;height:24px;width:24px}.sCds9pUT._2R7fFCkK._2d9_OEy2 span:after,.sCds9pUT._2R7fFCkK._3Yh7nDfg span:after{color:#414141}.sCds9pUT._2R7fFCkK._2d9_OEy2._1xZh_wCl,.sCds9pUT._2R7fFCkK._2d9_OEy2._1xZh_wCl span:after,.sCds9pUT._2R7fFCkK._3Yh7nDfg._1xZh_wCl,.sCds9pUT._2R7fFCkK._3Yh7nDfg._1xZh_wCl span:after{color:#4b55f6}.sCds9pUT._2R7fFCkK._2d9_OEy2 span:after{content:\"\\E8EF\"}.sCds9pUT._2R7fFCkK._3Yh7nDfg span:after{content:\"\\E9B0\"}.sCds9pUT._2JqAwZyh{position:relative;padding:0;border:none;border-radius:0}.sCds9pUT._2JqAwZyh span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.sCds9pUT._2JqAwZyh span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.sCds9pUT._2JqAwZyh:hover span{background:#f4f4f8}.sCds9pUT._2JqAwZyh._3wduiukY span:after{content:\"\\E5D4\"}._3JV30Cec .-MI_XTRN{display:none}._3JV30Cec .-MI_XTRN+._14pmCpoh{display:inline-block}._3JV30Cec .-MI_XTRN+._14pmCpoh:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3JV30Cec .-MI_XTRN:checked+._14pmCpoh:before{content:\"\\E834\"}._3JV30Cec span{padding-left:14px}._3WTaGltv{display:block}._3WTaGltv input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._3WTaGltv input[type=radio]+.lSkkdqfa:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._3WTaGltv input[type=radio]+.lSkkdqfa span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._3WTaGltv input[type=radio]:checked+.lSkkdqfa:before{content:\"\\E837\"}._3WTaGltv input[type=radio]+.lSkkdqfa:empty:before{margin-right:0}._2vBy_95y{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}._8mS9GS7i ._3bg0-ot3{background-color:#30379d}._12VCkurg._2_fnnu7m,._12VCkurg._2_fnnu7m div:first-child{background-color:transparent}._12VCkurg._2_fnnu7m div:first-child span:first-child{background-color:aqua}._12VCkurg._2_fnnu7m div:first-child span:nth-child(2){color:transparent}._3whQf5iP{width:100%;float:left}._1Iav0ypm{background-color:#f0f0f0}._3Q70_pcZ{cursor:pointer}._2YKBTYRh{background-color:#d1d8e0;color:#000}._176kDcW-{background-color:#768ca4;color:#fff}._1WwND5ub{cursor:pointer}._1z1gwXpx{background-color:#b4ffda;color:#000}.xcBQLJUe{background-color:#455f33;color:#fff}._2aHS0GKj{font-weight:300;color:#404040;color:rgba(0,0,0,.75)}._1NMSnPEE{position:absolute;top:-3px;right:16px}.fwrZj8L_,.rGoCz8lJ{margin:0}.DB59deDr{font-weight:300;padding:.5em 0;white-space:pre-wrap;word-wrap:break-word}._3sMuBRxo{font-weight:600;display:inline-block}.VFZHlxsY{color:#966;white-space:normal}._2KTUTZFf{vertical-align:text-bottom}._3oA2PGaW{display:block;overflow-y:none;padding:0 16px}._3oA2PGaW ._2EDUwxng{color:#fff;background-color:#607d8b;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-size:14px;line-height:20px;padding:20px;text-align:center;text-transform:uppercase;font-weight:500}._3oA2PGaW ._3DjFFACH{margin-bottom:15px}._3oA2PGaW ._3DjFFACH textarea{width:100%;display:block;padding:16px;border:2px solid #e8e8e8;border-radius:4px;outline:none;font-family:Roboto,sans-serif;line-height:16.8px;overflow:hidden}._3oA2PGaW ._3DjFFACH textarea:focus-visible{border-color:#4b55f6}._3oA2PGaW ._3DjFFACH>div>span:last-child{text-align:right;display:block;color:#414141;font-weight:400}._3oA2PGaW ._3DjFFACH._1SPjtxMr{max-height:340px;overflow-y:auto}._3oA2PGaW ._3DjFFACH._2eIpovfH,._3oA2PGaW ._3DjFFACH._2eIpovfH>div>span:last-child{color:red}._3oA2PGaW button{margin-bottom:16px}._2ugXyGmZ{position:relative;font-weight:400;color:#414141;font-size:12px}._2ugXyGmZ ._3k9Y3uXT{padding:0 16px;display:inline-block;width:100%}._2ugXyGmZ ._3k9Y3uXT ._1cruIs8H{margin-bottom:8px}.kerT1r-a{width:100%;position:relative;display:inline-block}.kerT1r-a ._2bG6Mhy-{display:block}.kerT1r-a ._2bG6Mhy- ._D_PR_10{position:relative;display:block;font-size:14px;line-height:18px;letter-spacing:.42px;font-weight:700;margin-bottom:8px}._2Y9i62od{padding:0 16px;overflow:hidden;overflow-y:auto;padding-bottom:16px}._2Y9i62od,._2Y9i62od.suGvu4nW{max-height:340px}._2Y9i62od._1SPjtxMr{max-height:373px}._2Y9i62od ._38dgqFVD{margin:8px 0;display:grid;display:-ms-grid;grid-template-columns:50% 50%;-ms-grid-columns:50% 50%}._2Y9i62od ._38dgqFVD .JDbUjjR1{grid-column:1;-ms-grid-column:1;display:block}._2Y9i62od ._38dgqFVD .JDbUjjR1 ._1bnjnHG3{display:block;font-weight:700;line-height:16px;margin-bottom:4px}._2Y9i62od ._38dgqFVD .JDbUjjR1 ._2TEVmUDk{display:block;line-height:16px}._2Y9i62od ._38dgqFVD .g4biroMW{grid-column:2;-ms-grid-column:2;display:block}._2Y9i62od ._38dgqFVD .g4biroMW ._1jLCRnDw{display:block;font-weight:700;line-height:16px;margin-bottom:4px}._2Y9i62od ._38dgqFVD .g4biroMW ._1Hdti8rA{display:block;line-height:16px}._2Y9i62od ._38dgqFVD .g4biroMW ._1Hdti8rA>span>span:first-child{width:11px;height:11px}._2Y9i62od ._1nhJtpmA,._2Y9i62od ._3a_6YSLU{display:block;margin-bottom:16px}._2Y9i62od ._3hbDLiY6{padding:0}._2Y9i62od .XF0ujWku .kxbHyiIW{line-height:16px;font-weight:700}._2Y9i62od .XF0ujWku ._2JzK4PKq .cfyrcmtD,._2Y9i62od .XF0ujWku ._2JzK4PKq .iG-7zPL_{display:block;margin-right:0}._2Y9i62od .XF0ujWku ._2JzK4PKq .cfyrcmtD span,._2Y9i62od .XF0ujWku ._2JzK4PKq .iG-7zPL_ span{background:#e8e8e8;display:inline-block;width:21px;height:21px;border-radius:50%;padding:2px;margin:0 8px 0 0}._2Y9i62od .XF0ujWku ._2JzK4PKq .cfyrcmtD span:after,._2Y9i62od .XF0ujWku ._2JzK4PKq .iG-7zPL_ span:after{font-size:16px;left:1px}._2Y9i62od ._2K1vsEx3{margin:8px 0 0;padding-bottom:8px;white-space:normal;border-bottom:1px solid rgba(65,65,65,.22);display:inline-block;width:100%}._2Y9i62od ._2K1vsEx3 ._3CXXw1D1{font-weight:700;line-height:16px;margin-bottom:4px}._2Y9i62od ._2K1vsEx3 ._2PDBvIHu{display:block;line-height:16.8px}._3o9TYrdD{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._3o9TYrdD._2U9n2akF{position:relative}._2AgSBgKA{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}._2JzK4PKq{display:block;white-space:normal}._2JzK4PKq .cfyrcmtD,._2JzK4PKq .iG-7zPL_{display:inline-block;margin-right:16px;line-height:22px;letter-spacing:.42px;font-size:14px}._2JzK4PKq .cfyrcmtD ._3IpCIHgD,._2JzK4PKq .cfyrcmtD ._3n3sBIgS,._2JzK4PKq .iG-7zPL_ ._3IpCIHgD,._2JzK4PKq .iG-7zPL_ ._3n3sBIgS{display:inline-block;margin-right:6px;background:transparent;height:24px;vertical-align:middle}._2JzK4PKq .cfyrcmtD ._3IpCIHgD:after,._2JzK4PKq .cfyrcmtD ._3n3sBIgS:after,._2JzK4PKq .iG-7zPL_ ._3IpCIHgD:after,._2JzK4PKq .iG-7zPL_ ._3n3sBIgS:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";color:#414141}._2JzK4PKq .cfyrcmtD ._3n3sBIgS:after,._2JzK4PKq .iG-7zPL_ ._3n3sBIgS:after{content:\"\\E7FD\"}._2JzK4PKq .cfyrcmtD ._3IpCIHgD:after,._2JzK4PKq .iG-7zPL_ ._3IpCIHgD:after{content:\"\\F233\"}._3qMYieyy{background:transparent;float:left;height:47px;position:relative}._3qMYieyy ._2wSwcjsL{font-size:16px;background-color:#eef9f0;display:inline-block;border-radius:12px;color:#124612;width:47px;height:47px;text-align:center;position:relative}._3qMYieyy ._2wSwcjsL:after{color:#5eb670;font-size:20px;font-family:Material Icons;content:\"\\E0C6\";padding:11px;position:absolute;left:0;right:0}._3qMYieyy .Kkt81M-b{font-size:16px;background-color:#eaf5ff;display:inline-block;border-radius:12px;color:#eaf5ff;width:47px;height:47px;text-align:center;position:relative}._3qMYieyy .Kkt81M-b:after{color:#5e87b6;font-family:Material Icons;content:\"\\E0B7\";font-size:20px;padding:11px;position:absolute;left:0;right:0}.OXIapNIr{float:left;padding-left:16px;width:calc(100% - 47px);vertical-align:middle;top:9px;position:relative}.OXIapNIr ._1bnjnHG3,.OXIapNIr ._2TEVmUDk{display:block;font-size:12px;color:#414141;line-height:16px}.OXIapNIr ._1bnjnHG3{font-weight:700}.OXIapNIr ._2TEVmUDk{font-style:italic;font-weight:300}._25FnFsiG title{display:grid;display:-ms-grid;grid-template-columns:47px 1fr;-ms-grid-columns:47px 1fr;-webkit-column-gap:16px;column-gap:16px;width:100%;font-size:12px;font-weight:700;line-height:16px;color:#414141;position:relative;margin-bottom:12px;padding:0 16px}._25FnFsiG title ._2n0u-yEp{width:47px;height:47px;background:transparent;border-radius:12px;grid-column:1;text-align:center}._25FnFsiG title ._2n0u-yEp:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;-webkit-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;font-size:20px}._25FnFsiG title ._2n0u-yEp[data-icon=icon_message-text]{background:#eaf5ff}._25FnFsiG title ._2n0u-yEp[data-icon=icon_message-text]:before{content:\"\\E0B7\";color:#5e87b6}._25FnFsiG title ._2n0u-yEp[data-icon=icon_comment-question]{background:#eef9f0}._25FnFsiG title ._2n0u-yEp[data-icon=icon_comment-question]:before{content:\"\\E0C6\";color:#5eb670}._25FnFsiG title ._1DPS3qw8{padding:15px 0}._25FnFsiG .TxuDOjA_{font-size:12px;line-height:16px;color:#414141;display:block;margin-bottom:4px;font-weight:700}._25FnFsiG .TxuDOjA_ .-vSGXl4k{display:inline-block;color:#f36;font-weight:700;font-size:17px;position:relative;top:0}._25FnFsiG ._3oA2PGaW{max-height:365px;overflow-y:auto}._2MpjqCtv{position:absolute;bottom:0;width:100%;left:0;right:0;-webkit-box-shadow:0 -7px 8px rgba(0,0,0,.1);box-shadow:0 -7px 8px rgba(0,0,0,.1);padding-top:15px;background:#fff;height:67px}._1x_yClr4{margin:0 16px}._1x_yClr4 button:first-child span{border-color:transparent}._1x_yClr4 button:first-child:hover span{border-color:#4b55f6}._1x_yClr4 button:last-child{float:right}._2fk0ozXF,.XtXPf2TJ{white-space:normal}._2fk0ozXF{display:block;position:relative;padding:16px;color:#414141;font-weight:400;border-radius:20px}._2fk0ozXF ._20eTogK8{display:block;font-size:18px;letter-spacing:.54px;line-height:18px;font-weight:700;margin-bottom:8px}._2fk0ozXF ._2alt3nsl p{font-size:14px;line-height:19.6px;letter-spacing:0;margin-bottom:10px;color:#414141}._2fk0ozXF ._2alt3nsl p._1yNIibO-{font-weight:500}._3ZVlw_7w{z-index:1001;position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1;bottom:calc(50% - 100px);left:calc(50% - 100px);background-color:#e0e0e0;padding:10px;border:1px solid #000}", ""]);

// exports
exports.locals = {
	"btn": "sCds9pUT",
	"disabled": "_28kdjyDt",
	"user-btn": "MIo4Xiop",
	"secondary-btn": "_1Yi0dnCz",
	"secondary-button_icon": "_2nGRBQAx",
	"ghost-btn": "nhUodTvW",
	"btn-icon-text_back": "_3NGgGKhR",
	"icon_arrow-back": "_3J4e2AKe",
	"btn-type-dropdown": "_3BudJw5Z",
	"default-header": "_2qlZKt4v",
	"icon": "Gmf_fo0W",
	"icon_chevron-down": "_1wLvC8hh",
	"icon_chevron-up": "_2ywqOlL5",
	"icon-btn": "_2R7fFCkK",
	"account": "_2kqlwl3w",
	"account_group": "_30gh26sR",
	"collapse": "_2Cbbt-9E",
	"expand": "_3AGRT_V0",
	"arrow_right": "r2jsfb2v",
	"check_circle": "_3a-17FJq",
	"check": "_3glzNcxG",
	"checkbox_blank": "_140B3lRN",
	"checkbox_marked": "tT6ygeBi",
	"chevron_down": "_2FUEbPYP",
	"chevron_up": "_1R-kYgzh",
	"close": "_3kL5Z4pF",
	"comment_question": "_3c8-z7UJ",
	"dots_vertical": "_3wduiukY",
	"file_document_box": "_2S0PyKpy",
	"filter": "_3D_17lj_",
	"heart": "_2aXINEPo",
	"heart_outline": "_1p6hILuD",
	"loading": "gmekxW_l",
	"magnify": "_3QL-LQch",
	"message": "Kkt81M-b",
	"pencil": "_22Wvh6Kg",
	"pencil_outline": "_36GCVz1L",
	"plus": "_1ci2jCTS",
	"radiobox_blank": "_3xNrOYrQ",
	"radiobox_marked": "_7vheC1d9",
	"icon-send": "hm0hIV8j",
	"tooltip_text_outline": "_2TurE2AG",
	"trash_can_outline": "dC1f-geW",
	"icon_arrow-left": "_3RFec2kX",
	"icon_arrow-right": "_2ARKLcoM",
	"list": "_2d9_OEy2",
	"tile": "_3Yh7nDfg",
	"active": "_1xZh_wCl",
	"list-item-icon-btn": "_2JqAwZyh",
	"default-checkbox-div": "_3JV30Cec",
	"default-checkbox": "-MI_XTRN",
	"checkmark": "_14pmCpoh",
	"radio": "_3WTaGltv",
	"radio-label": "lSkkdqfa",
	"material-icons": "_2vBy_95y",
	"question-status-container": "_8mS9GS7i",
	"dropdown": "_3bg0-ot3",
	"app": "_12VCkurg",
	"minimized": "_2_fnnu7m",
	"note-details": "_3whQf5iP",
	"submit-btn": "_1Iav0ypm",
	"highlight": "_3Q70_pcZ",
	"highlight-normal": "_2YKBTYRh",
	"highlight-active": "_176kDcW-",
	"highlight-shared": "_1WwND5ub",
	"highlight-normal-shared": "_1z1gwXpx",
	"highlight-active-shared": "xcBQLJUe",
	"header": "_2aHS0GKj",
	"menu": "_1NMSnPEE",
	"category": "fwrZj8L_",
	"lastmodified": "rGoCz8lJ",
	"content": "DB59deDr",
	"name-label": "_3sMuBRxo",
	"warning": "VFZHlxsY",
	"warning-icon": "_2KTUTZFf",
	"note-container": "_3oA2PGaW",
	"title": "_2EDUwxng",
	"input-text-notitie": "_3DjFFACH",
	"flyover": "_1SPjtxMr",
	"alert-max-chars": "_2eIpovfH",
	"details": "_2ugXyGmZ",
	"content-container": "_3k9Y3uXT",
	"button-container": "_1cruIs8H",
	"details-top-container": "kerT1r-a",
	"details-title-container": "_2bG6Mhy-",
	"title-text-action": "_D_PR_10",
	"details-content-container": "_2Y9i62od",
	"modal": "suGvu4nW",
	"middle-container": "_38dgqFVD",
	"made-by-container": "JDbUjjR1",
	"text-created-container-top": "_1bnjnHG3",
	"text-created-container-bottom": "_2TEVmUDk",
	"category-container": "g4biroMW",
	"category-container-top": "_1jLCRnDw",
	"category-container-bottom": "_1Hdti8rA",
	"edit-category-container": "_1nhJtpmA",
	"edit-shared-container": "_3a_6YSLU",
	"edit-note-container": "_3hbDLiY6",
	"middle-shared-container": "XF0ujWku",
	"shared-with-label": "kxbHyiIW",
	"list-of-shared": "_2JzK4PKq",
	"shared-div": "cfyrcmtD",
	"shared_multiple-div": "iG-7zPL_",
	"bottom-container": "_2K1vsEx3",
	"note-label": "_3CXXw1D1",
	"note-text": "_2PDBvIHu",
	"bottom-buttons-container": "_3o9TYrdD",
	"not-absolute": "_2U9n2akF",
	"wcag-invisible": "_2AgSBgKA",
	"icon-shared": "_3n3sBIgS",
	"icon-shared_multiple": "_3IpCIHgD",
	"icon-left-container": "_3qMYieyy",
	"question": "_2wSwcjsL",
	"text-created-container": "OXIapNIr",
	"create_note": "_25FnFsiG",
	"title-icon": "_2n0u-yEp",
	"title-text": "_1DPS3qw8",
	"sub-title": "TxuDOjA_",
	"important-icon": "-vSGXl4k",
	"bottom-panel": "_2MpjqCtv",
	"buttons-container": "_1x_yClr4",
	"text-content": "XtXPf2TJ",
	"warning-container": "_2fk0ozXF",
	"warning-title": "_20eTogK8",
	"warning-content": "_2alt3nsl",
	"medium": "_1yNIibO-",
	"notes-batch-delete-dialog": "_3ZVlw_7w"
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function (value, min, max) {
  return value <= min ? min : value >= max ? max : value;
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function (value, inLow, inHigh, outLow, outHigh) {
  return (value - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function (value, inLow, inHigh, outMin, outMax) {
  var map = (value - inLow) * (outMax - outMin) / (inHigh - inLow) + outMin;
  return outMin < outMax ?
  map <= outMin ? outMin : map >= outMax ? outMax : map :
  map <= outMax ? outMax : map >= outMin ? outMin : map;
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports = function (value, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.PublisherSpecific = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var PublisherSpecific = exports.PublisherSpecific = function () {
    function PublisherSpecific() {(0, _classCallCheck3.default)(this, PublisherSpecific);}(0, _createClass3.default)(PublisherSpecific, [{ key: 'isVisible', value: function isVisible(
        elem) {
            var minOpacy = 0.1;
            try {
                if (!(elem instanceof Element))
                throw Error('DomUtil: elem is not an element.');
                if (elem.className.indexOf('dx-accordion-item-closed') >= 0)
                return false;
                var style = getComputedStyle(elem);
                if (style.display === 'none')
                return false;
                if (style.visibility !== 'visible')
                return false;
                if (style['aria-hidden'] === 'true')
                return false;
                if (parseFloat(style.opacity) < minOpacy)
                return false;
                if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height +
                elem.getBoundingClientRect().width === 0) {
                    return false;
                }
                return true;
            }
            catch (ex) {
                console.log(ex);
                return false;
            }
        } }, { key: 'isTab', value: function isTab(
        node) {
            return node["role"] == "tabpanel";
        } }, { key: 'tabHasReference', value: function tabHasReference(
        node) {
            return node.getAttribute('aria-labelledby');
        } }, { key: 'isAccordion', value: function isAccordion(
        node) {
            return node && node.className && node.className.indexOf('dx-accordion-item-body') >= 0;
        } }, { key: 'unHideHidden', value: function () {var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(
            startNode) {var _this = this;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:return _context.abrupt('return',
                                new _promise2.default(function (res, rej) {
                                    var tophiddenElement;
                                    try {
                                        var nodetrail = document.getElementById(startNode.id);
                                        if (nodetrail === undefined) {
                                            return false;
                                        }
                                        while (nodetrail != null) {
                                            if (nodetrail.parentNode != null && !_this.isVisible(nodetrail)) {
                                                if (_this.isTab(nodetrail) && _this.tabHasReference(nodetrail)) {
                                                    document.getElementById(nodetrail.getAttribute('aria-labelledby')).click();
                                                    tophiddenElement = nodetrail;
                                                }
                                                if (_this.isAccordion(nodetrail)) {
                                                    if (nodetrail.parentElement != null) {
                                                        nodetrail.parentElement.click();
                                                    }
                                                    tophiddenElement = nodetrail;
                                                }
                                            }
                                            nodetrail = nodetrail.parentNode;
                                        }
                                    }
                                    catch (ex) {
                                        console.log(ex);
                                    }
                                    res(tophiddenElement);
                                }));case 1:case 'end':return _context.stop();}}}, _callee, this);}));function unHideHidden(_x) {return _ref.apply(this, arguments);}return unHideHidden;}() }, { key: 'waitFor', value: function () {var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(

            selector) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:return _context2.abrupt('return',
                                new _promise2.default(function (res, rej) {
                                    var maxRetry = 4;
                                    var delay = 200;
                                    var retry = 1;
                                    waitForElementToDisplay(selector, delay);
                                    function waitForElementToDisplay(selector, time) {
                                        if (document.querySelector(selector) != null) {
                                            res(document.querySelector(selector));
                                        } else
                                        {
                                            retry++;
                                            if (retry > maxRetry)
                                            rej('Not found in DOM');
                                            setTimeout(function () {
                                                waitForElementToDisplay(selector, time);
                                            }, time);
                                        }
                                    }
                                }));case 1:case 'end':return _context2.stop();}}}, _callee2, this);}));function waitFor(_x2) {return _ref2.apply(this, arguments);}return waitFor;}() }]);return PublisherSpecific;}();

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var cache = {
  '1': bezier1,
  '2': bezier2,
  '3': bezier3,
  '4': bezier4 };


module.exports = neat;
module.exports.prepare = prepare;

function neat(arr, t) {
  return prepare(arr.length)(arr, t);
}

function prepare(pieces) {
  pieces = +pieces | 0;
  if (!pieces) throw new Error('Cannot create a interpolator with no elements');
  if (cache[pieces]) return cache[pieces];

  var fn = ['var ut = 1 - t', ''];

  var n = pieces;
  while (n--) {
    for (var j = 0; j < n; j += 1) {
      if (n + 1 === pieces) {
        fn.push('var p' + j + ' = arr[' + j + '] * ut + arr[' + (j + 1) + '] * t');
      } else
      if (n > 1) {
        fn.push('p' + j + ' = p' + j + ' * ut + p' + (j + 1) + ' * t');
      } else {
        fn.push('return p' + j + ' * ut + p' + (j + 1) + ' * t');
      }
    }
    if (n > 1) fn.push('');
  }

  fn = [
  'return function bezier' + pieces + '(arr, t) {',
  fn.map(function (s) {return '  ' + s;}).join('\n'),
  '}'].
  join('\n');

  return Function(fn)();
}

//
// Including the first four degrees
// manually - there's a slight performance penalty
// to generated code. It's outweighed by
// the gains of the optimisations, but always
// helps to cover the most common cases :)
//

function bezier1(arr) {
  return arr[0];
}

function bezier2(arr, t) {
  return arr[0] + (arr[1] - arr[0]) * t;
}

function bezier3(arr, t) {
  var ut = 1 - t;
  return (arr[0] * ut + arr[1] * t) * ut + (arr[1] * ut + arr[2] * t) * t;
}

function bezier4(arr, t) {
  var ut = 1 - t;
  var a1 = arr[1] * ut + arr[2] * t;
  return ((arr[0] * ut + arr[1] * t) * ut + a1 * t) * ut + (a1 * ut + (arr[2] * ut + arr[3] * t) * t) * t;
}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.








rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _selectors = __webpack_require__(78);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(494);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _USERGROUP_CREATED = __webpack_require__(488);var _USERGROUP_CREATED2 = _interopRequireDefault(_USERGROUP_CREATED);var _USERGROUP_UPDATED = __webpack_require__(489);var _USERGROUP_UPDATED2 = _interopRequireDefault(_USERGROUP_UPDATED);var _resource2 = __webpack_require__(234);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(






signalNotesSharedList),_marked3 = /*#__PURE__*/_regenerator2.default.mark(




















signalNotesSharedListRead);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.notesSharedResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.notesSharedEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.notesSharedBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalNotesSharedListRead);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalNotesSharedList);case 10:case 'end':return _context.stop();}}}, _marked, this);}function signalNotesSharedList() {return _regenerator2.default.wrap(function signalNotesSharedList$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee() {var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context2.sent;selectionDocumentId = selectionDocument;_context2.next = 6;return (0, _reduxSaga.put)(_resource.notesSharedResource.actions.LIST({ params: { selectionDocumentId: selectionDocumentId } }));case 6:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:_context5.next = 4;return (0, _fsaSaga.takeEvery)([_USERGROUP_CREATED2.default, _USERGROUP_UPDATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee2() {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee2$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context3.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context3.next = 7;return (0, _reduxSaga.put)(_resource.notesSharedResource.actions.LIST({ params: { documentId: documentId } }));case 7:case 'end':return _context3.stop();}}}, _callee2, this);}));case 4:_context5.next = 6;return (0, _fsaSaga.takeEvery)([_resource2.beheerResource.actions.CREATE_SUCCESS, _resource2.beheerResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee3() {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee3$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context4.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context4.next = 7;return (0, _reduxSaga.put)(_resource.notesSharedResource.actions.LIST({ params: { documentId: documentId } }));case 7:case 'end':return _context4.stop();}}}, _callee3, this);}));case 6:case 'end':return _context5.stop();}}}, _marked2, this);}function signalNotesSharedListRead() {return _regenerator2.default.wrap(function signalNotesSharedListRead$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_resource.notesSharedResource.actions.LIST_SUCCESS, /*#__PURE__*/_regenerator2.default.mark(function _callee4() {return _regenerator2.default.wrap(function _callee4$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (
                                                (0, _reduxSaga.select)(_resource.notesSharedResource.selectors.items));case 2:case 'end':return _context6.stop();}}}, _callee4, this);})));case 2:case 'end':return _context7.stop();}}}, _marked3, this);}

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.















rootSaga = rootSaga;__webpack_require__(76);var _fsa = __webpack_require__(1);var _fsaSaga = __webpack_require__(59);var _abstractselection = __webpack_require__(486);var _anchor = __webpack_require__(244);var _highlight = __webpack_require__(531);var _index = __webpack_require__(47);var _TOUCHEND = __webpack_require__(535);var _TOUCHEND2 = _interopRequireDefault(_TOUCHEND);var _TOUCHMOVE = __webpack_require__(536);var _TOUCHMOVE2 = _interopRequireDefault(_TOUCHMOVE);var _TOUCHSTART = __webpack_require__(537);var _TOUCHSTART2 = _interopRequireDefault(_TOUCHSTART);var _CHANGE = __webpack_require__(625);var _CHANGE2 = _interopRequireDefault(_CHANGE);var _REQUEST = __webpack_require__(500);var _REQUEST2 = _interopRequireDefault(_REQUEST);var _RESET = __webpack_require__(249);var _RESET2 = _interopRequireDefault(_RESET);var _SUCCESS = __webpack_require__(501);var _SUCCESS2 = _interopRequireDefault(_SUCCESS);var _selectors = __webpack_require__(522);var _selectors2 = _interopRequireDefault(_selectors);var _style = __webpack_require__(704);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(

















































loadBrowserSelection),_marked3 = /*#__PURE__*/_regenerator2.default.mark(











watchSelectionRequest),_marked4 = /*#__PURE__*/_regenerator2.default.mark(

















updateHighlights),_marked5 = /*#__PURE__*/_regenerator2.default.mark(
















watchUserCreatingSelection),_marked6 = /*#__PURE__*/_regenerator2.default.mark(
























































processSelection);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _index.fork)(watchSelectionRequest);case 2:_context.next = 4;return (0, _index.fork)(updateHighlights);case 4:case 'end':return _context.stop();}}}, _marked, this);}var isContainerFirst = function isContainerFirst(startContainer, startOffset, endContainer, endOffset) {if (startContainer === endContainer) {return startOffset <= endOffset;} else {var DOCUMENT_POSITION_PRECEDING = 2;var compared = startContainer.compareDocumentPosition(endContainer);return compared !== DOCUMENT_POSITION_PRECEDING;}};var normalizeSelection = function normalizeSelection(sel) {var isStartToEnd = isContainerFirst(sel.startContainer, sel.startOffset, sel.endContainer, sel.endOffset);var startContainer = isStartToEnd ? sel.startContainer : sel.endContainer;var startOffset = isStartToEnd ? sel.startOffset : sel.endOffset;var endContainer = isStartToEnd ? sel.endContainer : sel.startContainer;var endOffset = isStartToEnd ? sel.endOffset : sel.startOffset;return { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset };};var getSelectionFromSelection = function getSelectionFromSelection(sel) {if (!sel) {return;}if (!sel.anchorNode) {return;}if (!sel.focusNode) {return;}if (!sel.anchorNode.compareDocumentPosition) {return;}var startContainer = sel.anchorNode;var startOffset = sel.anchorOffset;var endContainer = sel.focusNode;var endOffset = sel.focusOffset;var result = normalizeSelection({ startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset });sel.removeAllRanges();return result;};var getSelectionFromWindow = function getSelectionFromWindow() {if (!window.getSelection) {return;}var sel = window.getSelection();return getSelectionFromSelection(sel);};function loadBrowserSelection() {var browserSelection, anchors, start, end, selection;return _regenerator2.default.wrap(function loadBrowserSelection$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:browserSelection = getSelectionFromWindow();if (!browserSelection) {_context2.next = 9;break;}anchors = (0, _anchor.getAnchorFromDocument)();start = (0, _abstractselection.getNodePathFromNodeOffset)(anchors, browserSelection.startContainer, browserSelection.startOffset);end = (0, _abstractselection.getNodePathFromNodeOffset)(anchors, browserSelection.endContainer, browserSelection.endOffset);if (!(start && end)) {_context2.next = 9;break;}selection = start + ' | ' + end;_context2.next = 9;return (0, _index.put)((0, _CHANGE2.default)({ selection: selection }));case 9:case 'end':return _context2.stop();}}}, _marked2, this);}function watchSelectionRequest() {var updater, update;return _regenerator2.default.wrap(function watchSelectionRequest$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (false) {_context3.next = 21;break;}_context3.next = 3;return (0, _fsaSaga.take)(_REQUEST2.default);case 3:_context3.next = 5;return (0, _index.call)(loadBrowserSelection);case 5:_context3.prev = 5;_context3.next = 8;return (0, _index.fork)(watchUserCreatingSelection);case 8:updater = _context3.sent;update = updater;_context3.next = 12;return (0, _index.race)({ c: (0, _fsaSaga.take)([_RESET2.default, _SUCCESS2.default]), u: (0, _index.join)(update) });case 12:_context3.next = 14;return (0, _index.cancel)(update);case 14:_context3.next = 19;break;case 16:_context3.prev = 16;_context3.t0 = _context3['catch'](5);console.log(_context3.t0);case 19:_context3.next = 0;break;case 21:case 'end':return _context3.stop();}}}, _marked3, this, [[5, 16]]);}function updateHighlights() {return _regenerator2.default.wrap(function updateHighlights$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeLatest)([_RESET2.default, _SUCCESS2.default, _CHANGE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee() {var selection;return _regenerator2.default.wrap(function _callee$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.prev = 0;_context4.next = 3;return (0, _index.select)(_selectors2.default.selection);case 3:selection = _context4.sent;(0, _highlight.removeHighlights)(document.documentElement, '.js-highlight');if (selection) {_context4.next = 7;break;}return _context4.abrupt('return');case 7:_context4.next = 9;return (0, _highlight.applyHighlights)((0, _anchor.getAnchorFromDocument)(), selection.start, selection.end, function (node) {node.className = (0, _style2.default)('highlight') + ' js-highlight';});case 9:_context4.next = 14;break;case 11:_context4.prev = 11;_context4.t0 = _context4['catch'](0);console.error('[Selection] Update highlights failed.', _context4.t0);case 14:case 'end':return _context4.stop();}}}, _callee, this, [[0, 11]]);}));case 2:case 'end':return _context5.stop();}}}, _marked4, this);}function watchUserCreatingSelection() {var timeSingleClick, timeDoubleClick, clicksSelectWord, clicksSelectParagraph, exitSelectionScope, clickTracking, startEvent, startPositionEvent, anchor, cursorStart, wrapStart, _wrapStart;return _regenerator2.default.wrap(function watchUserCreatingSelection$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:timeSingleClick = 300;timeDoubleClick = 600;clicksSelectWord = 2;clicksSelectParagraph = 3;exitSelectionScope = (0, _highlight.enterSelectionScope)();_context6.prev = 5;clickTracking = [];case 7:if (false) {_context6.next = 57;break;}_context6.next = 10;return (0, _fsaSaga.take)(_TOUCHSTART2.default);case 10:startEvent = _context6.sent;if ((0, _fsa.isType)(startEvent, _TOUCHSTART2.default)) {_context6.next = 13;break;}return _context6.abrupt('continue', 7);case 13:_context6.next = 15;return (0, _fsaSaga.take)([_TOUCHMOVE2.default, _TOUCHEND2.default]);case 15:startPositionEvent = _context6.sent;if ((0, _fsa.isType)(startPositionEvent, _TOUCHMOVE2.default)) {_context6.next = 18;break;}return _context6.abrupt('continue', 7);case 18:clickTracking = clickTracking.qWhere(function (x) {return x > Date.now() - timeDoubleClick;});clickTracking.push(Date.now());anchor = (0, _anchor.getAnchorFromDocument)();cursorStart = (0, _extends3.default)({ type: undefined, touchID: undefined }, startPositionEvent.payload);if (!cursorStart) {_context6.next = 55;break;}_context6.next = 25;return (0, _index.put)((0, _CHANGE2.default)({ selection: null }));case 25:if (!(clickTracking.qCount(function (x) {return x > Date.now() - timeDoubleClick;}) >= clicksSelectParagraph)) {_context6.next = 39;break;}_context6.prev = 26;wrapStart = (0, _abstractselection.extendToDocumentContent)(anchor, (0, _highlight.getSelectionPathFromPositions)(anchor, cursorStart, cursorStart).pathStart);if (!wrapStart) {_context6.next = 31;break;}_context6.next = 31;return (0, _index.put)((0, _CHANGE2.default)({ selection: wrapStart.pathStart + ' | ' + wrapStart.pathEnd }));case 31:_context6.next = 36;break;case 33:_context6.prev = 33;_context6.t0 = _context6['catch'](26);console.error('[Selection] Tripple click failed', _context6.t0);case 36:return _context6.abrupt('continue', 7);case 39:if (!(clickTracking.qCount(function (x) {return x > Date.now() - timeSingleClick;}) >= clicksSelectWord)) {_context6.next = 53;break;}_context6.prev = 40;_wrapStart = (0, _abstractselection.extendToTextNode)(anchor, (0, _highlight.getSelectionPathFromPositions)(anchor, cursorStart, cursorStart).pathStart);if (!_wrapStart) {_context6.next = 45;break;}_context6.next = 45;return (0, _index.put)((0, _CHANGE2.default)({ selection: _wrapStart.pathStart + ' | ' + _wrapStart.pathEnd }));case 45:_context6.next = 50;break;case 47:_context6.prev = 47;_context6.t1 = _context6['catch'](40);console.error('[Selection] Tripple click failed', _context6.t1);case 50:return _context6.abrupt('continue', 7);case 53:_context6.next = 55;return (0, _index.call)(processSelection, anchor, cursorStart);case 55:_context6.next = 7;break;case 57:_context6.prev = 57;exitSelectionScope();return _context6.finish(57);case 60:case 'end':return _context6.stop();}}}, _marked5, this, [[5,, 57, 60], [26, 33], [40, 47]]);}function processSelection(anchor, cursorStart) {var eventPreviousEnd, raceUpdate, takeResult, eventEnd, paths, lenText;return _regenerator2.default.wrap(function processSelection$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:
                    eventPreviousEnd = null;case 1:_context7.next = 3;return (

                        (0, _fsaSaga.take)([_TOUCHMOVE2.default, _TOUCHEND2.default]));case 3:raceUpdate = _context7.sent;
                    takeResult = raceUpdate;if (!
                    (0, _fsa.isType)(takeResult, _TOUCHEND2.default)) {_context7.next = 7;break;}return _context7.abrupt('break', 29);case 7:if (


                    (0, _fsa.isType)(takeResult, _TOUCHMOVE2.default)) {_context7.next = 9;break;}return _context7.abrupt('continue', 27);case 9:


                    eventEnd = takeResult.payload.x ? (0, _extends3.default)({ type: undefined, touchID: undefined }, takeResult.payload) : eventPreviousEnd;
                    eventPreviousEnd = eventEnd;
                    paths = (0, _highlight.getSelectionPathFromPositions)(anchor, cursorStart, eventEnd);if (
                    paths) {_context7.next = 14;break;}return _context7.abrupt('continue', 27);case 14:


                    lenText = (0, _abstractselection.getTextLengthByPath)(anchor, paths.pathStart, paths.pathEnd);if (!(
                    lenText > 0)) {_context7.next = 20;break;}_context7.next = 18;return (
                        (0, _index.put)((0, _CHANGE2.default)({ selection: paths.pathStart + ' | ' + paths.pathEnd })));case 18:_context7.next = 27;break;case 20:if (!(

                    lenText < 0)) {_context7.next = 25;break;}_context7.next = 23;return (
                        (0, _index.put)((0, _CHANGE2.default)({ selection: paths.pathEnd + ' | ' + paths.pathStart })));case 23:_context7.next = 27;break;case 25:_context7.next = 27;return (


                        (0, _index.put)((0, _CHANGE2.default)({ selection: null })));case 27:_context7.next = 1;break;case 29:case 'end':return _context7.stop();}}}, _marked6, this);}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(908);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,500,600,700&display=swap);", ""]);

// module
exports.push([module.i, "._1oreJ7Gq{font-weight:500;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transform:translateZ(0);transform:translateZ(0);text-transform:uppercase;color:#414141;-webkit-backface-visibility:hidden;backface-visibility:hidden;background-color:transparent;border:0;border-left:1px solid rgba(0,0,0,.16)}._1oreJ7Gq:not(._1MZ8O71Q){font-size:12px;padding:0 18px;border-radius:18px}._1oreJ7Gq ._1MZ8O71Q{font-size:16px;width:40px;height:40px;color:#26c6da!important}._1oreJ7Gq .a_Wy3Toi{-webkit-box-shadow:none;box-shadow:none}._1DSZRz04{height:24px;width:24px;display:inline-block;padding:5px;padding-left:1px}._1DSZRz04 ._3TZ0sQHK{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0;width:0;height:0;overflow:hidden;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._1DSZRz04 ._3TZ0sQHK:checked~._2dkP3jIP{background-color:#607d8b;border:2px solid #d2d2d2}._1DSZRz04 ._3TZ0sQHK:checked~._2dkP3jIP:after{display:inline-block}._1DSZRz04 ._2dkP3jIP{position:relative;display:inline-block;width:24px;height:24px;-webkit-box-sizing:content-box;box-sizing:content-box;border:2px solid gray;border-radius:2px}._1DSZRz04 ._2dkP3jIP:after{position:absolute;display:none;top:4px;left:9px;width:7px;height:12px;content:\"\";border-color:#fff;border-style:solid;border-top:0;border-right-width:2px;border-bottom-width:2px;border-left:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}._2a8_QxW4{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.cBy6LZvw{padding:1px;background:#fff;border:2px solid transparent;border-radius:100px}.cBy6LZvw,.cBy6LZvw span{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.cBy6LZvw span{padding:9px 16px 8px;background:#4b55f6;font-size:12px;line-height:18px;letter-spacing:1.2px;text-align:center;color:#fff;display:inline-block;border-radius:100px;font-weight:700;text-transform:uppercase}.cBy6LZvw:hover span{background:#30379d}.cBy6LZvw:focus{border-color:#30379d;outline:none}.cBy6LZvw:focus span{background:#30379d}.cBy6LZvw._1-nXF1k4{cursor:not-allowed}.cBy6LZvw._1-nXF1k4 span{background:#f4f4f8;color:#6e6e77}.cBy6LZvw.-hx-2FG-{display:inline-block;width:40px;height:40px;border-radius:100%;background:#4b55f6;color:#fff;margin-right:8px}.cBy6LZvw._1y0Lc95c span{background:#fff;color:#4b55f6;border:1px solid #4b55f6;letter-spacing:.36px}.cBy6LZvw._1y0Lc95c:hover span{background:#f4f4f8}.cBy6LZvw._1y0Lc95c:focus{border-color:#30379d}.cBy6LZvw._1y0Lc95c._1-nXF1k4{cursor:not-allowed}.cBy6LZvw._1y0Lc95c._1-nXF1k4 span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.cBy6LZvw._1m5gNIaW span{background:#fff;color:#4b55f6;border:1px solid #4b55f6}.cBy6LZvw._1m5gNIaW span:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";margin-right:3px;vertical-align:middle;display:inline-block}.cBy6LZvw._1m5gNIaW:hover span{background:#f4f4f8}.cBy6LZvw._1m5gNIaW:focus{border-color:#30379d}.cBy6LZvw._1m5gNIaW._1-nXF1k4{cursor:not-allowed}.cBy6LZvw._1m5gNIaW._1-nXF1k4 span{color:#6e6e77;border-color:#6e6e77;background:#f4f4f8}.cBy6LZvw.Qb21NKIT span{background:transparent;color:#414141;letter-spacing:.36px}.cBy6LZvw.Qb21NKIT:hover span{background:#f4f4f8}.cBy6LZvw.Qb21NKIT:focus{border-color:#30379d}.cBy6LZvw.Qb21NKIT:focus span{background:#f4f4f8}.cBy6LZvw.Qb21NKIT._1-nXF1k4{cursor:not-allowed}.cBy6LZvw.Qb21NKIT._1-nXF1k4 span{background:#f4f4f8;color:#6e6e77}._16M4nhQc{color:#4b55f6;letter-spacing:.42px;line-height:19px;font-size:14px;text-transform:uppercase;padding:6px 8px;position:relative;border:none;background:transparent;font-weight:700}._16M4nhQc._2KaQsguf:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";content:\"\\E5C4\";color:#4b55f6;font-size:28px;margin-right:6px;width:24px;vertical-align:middle}._1IbWN6b1{width:100%;border-radius:4px;background:#fff;border:2px solid #fff;padding:6px 40px 6px 16px;text-align:left;position:relative;outline-color:#4b55f6}._1IbWN6b1,._1IbWN6b1 span{display:inline-block}._1IbWN6b1 span.AbSL6HmH{font-size:12px;line-height:16px;font-weight:300;color:#414141;padding:10px 34px 10px 8px;font-style:italic;white-space:normal}._1IbWN6b1 span._3ZLZMA9d{position:absolute;top:50%;right:16px;float:right;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:24px;height:24px}._1IbWN6b1 span._3ZLZMA9d:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;color:#4b55f6}._1IbWN6b1 span._3ZLZMA9d.qMjJORJ9:after{content:\"\\E5CF\"}._1IbWN6b1 span._3ZLZMA9d._1Lb3gF7D:after{content:\"\\E5CE\"}._1IbWN6b1:focus{outline-color:#4b55f6}.cBy6LZvw._1ljcFa_2{border-radius:50%;width:40px;height:40px;position:relative}.cBy6LZvw._1ljcFa_2 span{border-radius:50%;font-size:16px;background:transparent;width:34px;height:34px;padding:5px;margin:0;-webkit-box-shadow:none;box-shadow:none}.cBy6LZvw._1ljcFa_2 span,.cBy6LZvw._1ljcFa_2 span:after{color:#4b55f6;display:inline-block;position:relative}.cBy6LZvw._1ljcFa_2 span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.cBy6LZvw._1ljcFa_2:hover span{background:#f4f4f8}.cBy6LZvw._1ljcFa_2:focus{border-color:#4b55f6}.cBy6LZvw._1ljcFa_2:focus span{background:#f4f4f8}.cBy6LZvw._1ljcFa_2._1-nXF1k4 span{background:#f4f4f8;color:#6e6e77}.cBy6LZvw._1ljcFa_2._3bKWEhuC span:after{content:\"\\E7FD\"}.cBy6LZvw._1ljcFa_2._3Q5wEIAp span:after{content:\"\\F233\"}.cBy6LZvw._1ljcFa_2._1D_oXLOz span:after{content:\"\\F1CF\"}.cBy6LZvw._1ljcFa_2._3-QK5R3c span:after{content:\"\\F1CE\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._3VEeYTFL span:after{content:\"\\EAAA\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._7kzb2Hcg span:after{content:\"\\E86C\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._1az53D6C span:after{content:\"\\E876\"}.cBy6LZvw._1ljcFa_2.xpU__A0W span:after{content:\"\\E835\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._1dzwiAHe span:after{content:\"\\E834\"}.cBy6LZvw._1ljcFa_2._3FxNgY7Z span:after{content:\"\\E5CF\"}.cBy6LZvw._1ljcFa_2._1l_3ha2M span:after{content:\"\\E5CE\"}.cBy6LZvw._1ljcFa_2._2DNy4zhP span:after{content:\"\\E5CD\"}.cBy6LZvw._1ljcFa_2._25hdSoRb span:after{content:\"\\E0C6\"}.cBy6LZvw._1ljcFa_2._3N1EzeV4 span:after{content:\"\\E5D4\"}.cBy6LZvw._1ljcFa_2._2KNMuimI span:after{content:\"\\E880\"}.cBy6LZvw._1ljcFa_2._3a28-ZPF span:after{content:\"\\EF4F\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._1CeS1HGu span:after{content:\"\\E87D\"}.cBy6LZvw._1ljcFa_2._2kV8x0Z4 span:after{content:\"\\E87E\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._1QE2jt7q span:after{content:\"\\E41A\"}.cBy6LZvw._1ljcFa_2._3GDeKzGW span:after{content:\"\\E8B6\"}.cBy6LZvw._1ljcFa_2._1lcKEntf span:after{content:\"\\E0B7\"}.cBy6LZvw._1ljcFa_2._2e_fbaxT span:after{content:\"\\E150\"}.cBy6LZvw._1ljcFa_2.xcnAgG12 span:after{content:\"\\E150\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._16G5RBqe span:after{content:\"\\E145\"}.cBy6LZvw._1ljcFa_2._2s7--eTx span:after{content:\"\\E836\"}.cBy6LZvw._1ljcFa_2.fwdTsXxx span:after{content:\"\\E837\"}.cBy6LZvw._1ljcFa_2._3FIwtQZ7 span:after{content:\"\\E163\"}.cBy6LZvw._1ljcFa_2._2ix_s0Pa span:after{content:\"\\E0B7\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2.QZ8_B_Wp span:after{content:\"\\E872\";font-family:Material Icons Outlined}.cBy6LZvw._1ljcFa_2._3ef_lJp0 span:after{content:\"\\E5C4\"}.cBy6LZvw._1ljcFa_2.gqZ8dV6L span:after{content:\"\\E5C8\"}.cBy6LZvw._1ljcFa_2._1tbQOAtK,.cBy6LZvw._1ljcFa_2._16AEHP67{background:transparent;border-radius:0;color:#414141;padding:0;height:28px;width:28px}.cBy6LZvw._1ljcFa_2._1tbQOAtK span,.cBy6LZvw._1ljcFa_2._16AEHP67 span{padding:0;height:24px;width:24px}.cBy6LZvw._1ljcFa_2._1tbQOAtK span:after,.cBy6LZvw._1ljcFa_2._16AEHP67 span:after{color:#414141}.cBy6LZvw._1ljcFa_2._1tbQOAtK.iE6Ify5G,.cBy6LZvw._1ljcFa_2._1tbQOAtK.iE6Ify5G span:after,.cBy6LZvw._1ljcFa_2._16AEHP67.iE6Ify5G,.cBy6LZvw._1ljcFa_2._16AEHP67.iE6Ify5G span:after{color:#4b55f6}.cBy6LZvw._1ljcFa_2._16AEHP67 span:after{content:\"\\E8EF\"}.cBy6LZvw._1ljcFa_2._1tbQOAtK span:after{content:\"\\E9B0\"}.cBy6LZvw._29hkXoKy{position:relative;padding:0;border:none;border-radius:0}.cBy6LZvw._29hkXoKy span{color:#4b55f6;font-size:16px;background:transparent;display:inline-block;width:24px;height:24px;position:relative;margin:0;-webkit-box-shadow:none;box-shadow:none;padding:0;padding:5px}.cBy6LZvw._29hkXoKy span:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:14px;font-weight:700}.cBy6LZvw._29hkXoKy:hover span{background:#f4f4f8}.cBy6LZvw._29hkXoKy._3N1EzeV4 span:after{content:\"\\E5D4\"}._1DSZRz04 ._3TZ0sQHK{display:none}._1DSZRz04 ._3TZ0sQHK+._2dkP3jIP{display:inline-block}._1DSZRz04 ._3TZ0sQHK+._2dkP3jIP:before{content:\"\\E835\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1DSZRz04 ._3TZ0sQHK:checked+._2dkP3jIP:before{content:\"\\E834\"}._1DSZRz04 span{padding-left:14px}._1haTXINJ{display:block}._1haTXINJ input[type=radio]{position:absolute;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}._1haTXINJ input[type=radio]+._1ufkX30P:before{content:\"\\E836\";font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;position:relative;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle}._1haTXINJ input[type=radio]+._1ufkX30P span{padding-left:14px;font-size:12px;line-height:16px;color:#414141;font-weight:400}._1haTXINJ input[type=radio]:checked+._1ufkX30P:before{content:\"\\E837\"}._1haTXINJ input[type=radio]+._1ufkX30P:empty:before{margin-right:0}._1WFDj8IT{padding:0 16px}._1WXoWZVQ{background-color:#768ca4}.bjrljFt-{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:60px;width:100%;margin:8px 0 16px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;border-radius:5px;text-transform:uppercase}.bjrljFt-,.bjrljFt- ._1sKkz-Gq{background:#fff;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bjrljFt- ._1sKkz-Gq{min-width:150px;max-width:165px;display:grid;display:-ms-grid;grid-template-columns:47px 1fr;-ms-grid-columns:47px 1fr;-webkit-column-gap:16px;column-gap:16px;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;border-radius:16px;cursor:pointer;padding:4px;-webkit-transition:all .3s ease;transition:all .3s ease;margin:0}.bjrljFt- ._1sKkz-Gq.iE6Ify5G{border:2px solid #4b55f6;background:#f8f8ff;background:rgba(75,85,246,.04)}.bjrljFt- ._1sKkz-Gq:not(.iE6Ify5G){border:2px solid #fff;-webkit-box-shadow:0 0 10px rgba(0,0,0,.1);box-shadow:0 0 10px rgba(0,0,0,.1)}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2{grid-column:1;-ms-grid-column:1;width:47px;height:47px;background:transparent;border-radius:12px;position:relative;text-align:center}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2:after{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;color:#4b55f6;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";vertical-align:middle;-webkit-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;font-size:20px}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2[data-icon=icon_message-text]{background:#eaf5ff}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2[data-icon=icon_message-text]:after{content:\"\\E0B7\";color:#5e87b6}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2[data-icon=icon_comment-question]{background:#eef9f0}.bjrljFt- ._1sKkz-Gq ._2teJ7yZ2[data-icon=icon_comment-question]:after{content:\"\\E0C6\";color:#5eb670}.bjrljFt- ._1sKkz-Gq span{grid-column:2;-ms-grid-column:2;font-size:12px;color:#414141;line-height:16px;font-weight:700;white-space:normal}input[type=radio]{display:none}._1P5crHJP{visibility:hidden;position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}._1Bu58Juj,._3LMU1g4W{font-weight:700;font-size:12px;line-height:16px;color:#414141;margin-right:16px}._3LMU1g4W{margin-bottom:30px}._2M0ctipg .KlC6enot{font-size:12px;display:block;overflow:hidden;white-space:normal}._2M0ctipg ._2etAL3pw{font-weight:700;color:#414141;font-size:12px;display:block;margin-bottom:5px;border-bottom:1px solid #e8e8e8;text-align:center}.flwYFJD0{padding:15px 16px}.flwYFJD0 ._1y0Lc95c span{border-color:transparent}.flwYFJD0 button:last-child{float:right}", ""]);

// exports
exports.locals = {
	"button-big": "_1oreJ7Gq",
	"floating": "_1MZ8O71Q",
	"raised": "a_Wy3Toi",
	"default-checkbox-div": "_1DSZRz04",
	"default-checkbox": "_3TZ0sQHK",
	"checkmark": "_2dkP3jIP",
	"material-icons": "_2a8_QxW4",
	"btn": "cBy6LZvw",
	"disabled": "_1-nXF1k4",
	"user-btn": "-hx-2FG-",
	"secondary-btn": "_1y0Lc95c",
	"secondary-button_icon": "_1m5gNIaW",
	"ghost-btn": "Qb21NKIT",
	"btn-icon-text_back": "_16M4nhQc",
	"icon_arrow-back": "_2KaQsguf",
	"btn-type-dropdown": "_1IbWN6b1",
	"default-header": "AbSL6HmH",
	"icon": "_3ZLZMA9d",
	"icon_chevron-down": "qMjJORJ9",
	"icon_chevron-up": "_1Lb3gF7D",
	"icon-btn": "_1ljcFa_2",
	"account": "_3bKWEhuC",
	"account_group": "_3Q5wEIAp",
	"collapse": "_1D_oXLOz",
	"expand": "_3-QK5R3c",
	"arrow_right": "_3VEeYTFL",
	"check_circle": "_7kzb2Hcg",
	"check": "_1az53D6C",
	"checkbox_blank": "xpU__A0W",
	"checkbox_marked": "_1dzwiAHe",
	"chevron_down": "_3FxNgY7Z",
	"chevron_up": "_1l_3ha2M",
	"close": "_2DNy4zhP",
	"comment_question": "_25hdSoRb",
	"dots_vertical": "_3N1EzeV4",
	"file_document_box": "_2KNMuimI",
	"filter": "_3a28-ZPF",
	"heart": "_1CeS1HGu",
	"heart_outline": "_2kV8x0Z4",
	"loading": "_1QE2jt7q",
	"magnify": "_3GDeKzGW",
	"message": "_1lcKEntf",
	"pencil": "_2e_fbaxT",
	"pencil_outline": "xcnAgG12",
	"plus": "_16G5RBqe",
	"radiobox_blank": "_2s7--eTx",
	"radiobox_marked": "fwdTsXxx",
	"icon-send": "_3FIwtQZ7",
	"tooltip_text_outline": "_2ix_s0Pa",
	"trash_can_outline": "QZ8_B_Wp",
	"icon_arrow-left": "_3ef_lJp0",
	"icon_arrow-right": "gqZ8dV6L",
	"list": "_16AEHP67",
	"tile": "_1tbQOAtK",
	"active": "iE6Ify5G",
	"list-item-icon-btn": "_29hkXoKy",
	"radio": "_1haTXINJ",
	"radio-label": "_1ufkX30P",
	"select-kind-note-container": "_1WFDj8IT",
	"highlight": "_1WXoWZVQ",
	"wrapper": "bjrljFt-",
	"option": "_1sKkz-Gq",
	"option_icon": "_2teJ7yZ2",
	"wcag-invisible": "_1P5crHJP",
	"select-kind-of-note": "_1Bu58Juj",
	"select-tekst": "_3LMU1g4W",
	"selected-container": "_2M0ctipg",
	"selected-text": "KlC6enot",
	"selected-text_title": "_2etAL3pw",
	"buttons-container": "flwYFJD0"
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.













rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(163);var _resource2 = __webpack_require__(162);var _resource3 = __webpack_require__(106);var _resource4 = __webpack_require__(513);var _resource5 = __webpack_require__(233);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _HIDE = __webpack_require__(561);var _HIDE2 = _interopRequireDefault(_HIDE);var _SHOW = __webpack_require__(626);var _SHOW2 = _interopRequireDefault(_SHOW);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(





















showMessage),_marked3 = /*#__PURE__*/_regenerator2.default.mark(










signalLogout),_marked4 = /*#__PURE__*/_regenerator2.default.mark(






signalResourceBusy),_marked5 = /*#__PURE__*/_regenerator2.default.mark(






signalResourceSaveSuccess),_marked6 = /*#__PURE__*/_regenerator2.default.mark(





signalResourceSaveFailed),_marked7 = /*#__PURE__*/_regenerator2.default.mark(





signalResourceRemoveSuccess),_marked8 = /*#__PURE__*/_regenerator2.default.mark(





signalResourceRemoveFailed);var hideErrorDelay = 2000;var hideBusyDelay = 5000;var hideSuccessDelay = 2000;function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(signalLogout);case 2:_context.next = 4;return (0, _reduxSaga.fork)(signalResourceBusy, _resource3.notesResource);case 4:_context.next = 6;return (0, _reduxSaga.fork)(signalResourceSaveSuccess, _resource3.notesResource, 'Sucessvol opgeslagen!');case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalResourceSaveFailed, _resource3.notesResource, 'Niet opgeslagen!');case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalResourceRemoveSuccess, _resource3.notesResource, 'Sucessvol verwijderd!');case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalResourceRemoveFailed, _resource3.notesResource, 'Niet verwijderd!');case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalResourceSaveSuccess, _resource.bookmarksResource, 'Favoriet sucessvol opgeslagen!');case 14:_context.next = 16;return (0, _reduxSaga.fork)(signalResourceSaveFailed, _resource.bookmarksResource, 'Favoriet is niet opgeslagen!');case 16:_context.next = 18;return (0, _reduxSaga.fork)(signalResourceRemoveSuccess, _resource.bookmarksResource, 'Favoriet sucessvol verwijderd!');case 18:_context.next = 20;return (0, _reduxSaga.fork)(signalResourceRemoveFailed, _resource.bookmarksResource, 'Favoriet is niet verwijderd!');case 20:_context.next = 22;return (0, _reduxSaga.fork)(signalResourceSaveSuccess, _resource2.categoriesResource, 'Categorie sucessvol opgeslagen!');case 22:_context.next = 24;return (0, _reduxSaga.fork)(signalResourceSaveFailed, _resource2.categoriesResource, 'Categorie is niet opgeslagen!');case 24:_context.next = 26;return (0, _reduxSaga.fork)(signalResourceRemoveSuccess, _resource2.categoriesResource, 'Categorie sucessvol verwijderd!');case 26:_context.next = 28;return (0, _reduxSaga.fork)(signalResourceRemoveFailed, _resource2.categoriesResource, 'Categorie is niet verwijderd!');case 28:_context.next = 30;return (0, _reduxSaga.fork)(signalResourceRemoveSuccess, _resource4.emailArchiveResource, 'Email sucessvol verwijderd!');case 30:_context.next = 32;return (0, _reduxSaga.fork)(signalResourceRemoveFailed, _resource4.emailArchiveResource, 'Email is niet verwijderd!');case 32:_context.next = 34;return (0, _reduxSaga.fork)(signalResourceSaveSuccess, _resource5.usergroupResource, 'Gebruikersgroup succesvol opgeslagen!');case 34:_context.next = 36;return (0, _reduxSaga.fork)(signalResourceSaveFailed, _resource5.usergroupResource, 'Gebruikersgroup is niet opgeslagen!');case 36:_context.next = 38;return (0, _reduxSaga.fork)(signalResourceRemoveSuccess, _resource5.usergroupResource, 'Gebruikersgroep succesvol verwijderd!');case 38:_context.next = 40;return (0, _reduxSaga.fork)(signalResourceRemoveFailed, _resource5.usergroupResource, 'Gebruikersgroep is niet verwijderd!');case 40:case 'end':return _context.stop();}}}, _marked, this);}function showMessage(message, status, timeout) {var waiting, waitresult;return _regenerator2.default.wrap(function showMessage$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _fsaSaga.put)((0, _SHOW2.default)({ message: message, status: status }));case 2:_context2.next = 4;return (0, _reduxSaga.race)({ autohide: (0, _reduxSaga.call)(_reduxSaga.delay, timeout), cancel: (0, _fsaSaga.take)([_HIDE2.default, _SHOW2.default]) });case 4:waiting = _context2.sent;waitresult = waiting;if (!waitresult.autohide) {_context2.next = 9;break;}_context2.next = 9;return (0, _fsaSaga.put)((0, _HIDE2.default)({}));case 9:case 'end':return _context2.stop();}}}, _marked2, this);}function signalLogout() {return _regenerator2.default.wrap(function signalLogout$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (false) {_context3.next = 9;break;}_context3.next = 3;return (0, _fsaSaga.take)(_AUTHENTICATED2.default);case 3:_context3.next = 5;return (0, _fsaSaga.take)(_LOGGEDOUT2.default);case 5:_context3.next = 7;return (0, _reduxSaga.call)(showMessage, 'Successvol uitgelogd', 'success', hideSuccessDelay);case 7:_context3.next = 0;break;case 9:case 'end':return _context3.stop();}}}, _marked3, this);}function signalResourceBusy(resource) {return _regenerator2.default.wrap(function signalResourceBusy$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([resource.actions.CREATE, resource.actions.UPDATE], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.call)(showMessage, 'Bezig met opslaan', 'busy', hideBusyDelay);case 2:case 'end':return _context4.stop();}}}, _callee, this);}));case 2:case 'end':return _context5.stop();}}}, _marked4, this);}function signalResourceSaveSuccess(resource, message) {return _regenerator2.default.wrap(function signalResourceSaveSuccess$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([resource.actions.CREATE_SUCCESS, resource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee2() {return _regenerator2.default.wrap(function _callee2$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _fsaSaga.put)((0, _HIDE2.default)({}));case 2:_context6.next = 4;return (0, _reduxSaga.call)(showMessage, message, 'success', hideSuccessDelay);case 4:case 'end':return _context6.stop();}}}, _callee2, this);}));case 2:case 'end':return _context7.stop();}}}, _marked5, this);}function signalResourceSaveFailed(resource, message) {return _regenerator2.default.wrap(function signalResourceSaveFailed$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.takeEvery)([resource.actions.CREATE_FAILURE, resource.actions.UPDATE_FAILURE], /*#__PURE__*/_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (0, _fsaSaga.put)((0, _HIDE2.default)({}));case 2:_context8.next = 4;return (0, _reduxSaga.call)(showMessage, message, 'error', hideErrorDelay);case 4:case 'end':return _context8.stop();}}}, _callee3, this);}));case 2:case 'end':return _context9.stop();}}}, _marked6, this);}function signalResourceRemoveSuccess(resource, message) {return _regenerator2.default.wrap(function signalResourceRemoveSuccess$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _fsaSaga.takeEvery)(resource.actions.DELETE_SUCCESS, /*#__PURE__*/_regenerator2.default.mark(function _callee4() {return _regenerator2.default.wrap(function _callee4$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (0, _fsaSaga.put)((0, _HIDE2.default)({}));case 2:_context10.next = 4;return (0, _reduxSaga.call)(showMessage, message, 'success', hideSuccessDelay);case 4:case 'end':return _context10.stop();}}}, _callee4, this);}));case 2:case 'end':return _context11.stop();}}}, _marked7, this);}function signalResourceRemoveFailed(resource, message) {return _regenerator2.default.wrap(function signalResourceRemoveFailed$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:_context13.next = 2;return (
                        (0, _fsaSaga.takeEvery)(resource.actions.DELETE_FAILURE, /*#__PURE__*/_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (
                                                (0, _fsaSaga.put)((0, _HIDE2.default)({})));case 2:_context12.next = 4;return (
                                                (0, _reduxSaga.call)(showMessage, message, 'error', hideErrorDelay));case 4:case 'end':return _context12.stop();}}}, _callee5, this);})));case 2:case 'end':return _context13.stop();}}}, _marked8, this);}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.

















rootSaga = rootSaga;__webpack_require__(76);var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _selectors = __webpack_require__(78);var _resource = __webpack_require__(163);var _resource2 = __webpack_require__(106);var _selectors2 = __webpack_require__(522);var _selectors3 = _interopRequireDefault(_selectors2);var _HIDE = __webpack_require__(487);var _HIDE2 = _interopRequireDefault(_HIDE);var _BUTTON_HIDE_FLYOVER = __webpack_require__(705);var _BUTTON_HIDE_FLYOVER2 = _interopRequireDefault(_BUTTON_HIDE_FLYOVER);var _SHOW = __webpack_require__(499);var _SHOW2 = _interopRequireDefault(_SHOW);var _ERASE = __webpack_require__(558);var _ERASE2 = _interopRequireDefault(_ERASE);var _RESET = __webpack_require__(249);var _RESET2 = _interopRequireDefault(_RESET);var _SUCCESS = __webpack_require__(501);var _SUCCESS2 = _interopRequireDefault(_SUCCESS);var _UPDATE_BUTTON_NO = __webpack_require__(519);var _UPDATE_BUTTON_NO2 = _interopRequireDefault(_UPDATE_BUTTON_NO);var _settings = __webpack_require__(83);var _resource3 = __webpack_require__(162);var _resource4 = __webpack_require__(223);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(









signalButtonHideFlyover),_marked3 = /*#__PURE__*/_regenerator2.default.mark(





signalHideNoteMenu),_marked4 = /*#__PURE__*/_regenerator2.default.mark(




signalSelectionReset),_marked5 = /*#__PURE__*/_regenerator2.default.mark(








signalReadNote),_marked6 = /*#__PURE__*/_regenerator2.default.mark(



















signalQuestion),_marked7 = /*#__PURE__*/_regenerator2.default.mark(
























signalReadBookmark),_marked8 = /*#__PURE__*/_regenerator2.default.mark(
















signalReadCategory),_marked9 = /*#__PURE__*/_regenerator2.default.mark(






signalNotesRequest);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(signalButtonHideFlyover);case 2:_context.next = 4;return (0, _reduxSaga.fork)(signalHideNoteMenu);case 4:_context.next = 6;return (0, _reduxSaga.fork)(signalNotesRequest);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalSelectionReset);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalReadNote);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalReadBookmark);case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalReadCategory);case 14:_context.next = 16;return (0, _reduxSaga.fork)(signalQuestion);case 16:case 'end':return _context.stop();}}}, _marked, this);}function signalButtonHideFlyover() {return _regenerator2.default.wrap(function signalButtonHideFlyover$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)([_BUTTON_HIDE_FLYOVER2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _fsaSaga.put)((0, _HIDE2.default)({}));case 2:_context2.next = 4;return (0, _fsaSaga.put)((0, _UPDATE_BUTTON_NO2.default)({ buttonNo: _UPDATE_BUTTON_NO.buttonBekijkItems, origin: _UPDATE_BUTTON_NO.originFlyover }));case 4:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalHideNoteMenu() {return _regenerator2.default.wrap(function signalHideNoteMenu$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)(_SHOW2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _fsaSaga.put)((0, _ERASE2.default)({}));case 2:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalSelectionReset() {return _regenerator2.default.wrap(function signalSelectionReset$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)(_SHOW2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {var creatingSelectionEff, creatingSelection;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _reduxSaga.select)(_selectors3.default.creating);case 2:creatingSelectionEff = _context6.sent;creatingSelection = creatingSelectionEff;if (!creatingSelection) {_context6.next = 7;break;}_context6.next = 7;return (0, _fsaSaga.put)((0, _RESET2.default)({}));case 7:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalReadNote() {var updateEff, update, resolveEff, resolve, pageIdEff, pageId;return _regenerator2.default.wrap(function signalReadNote$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:if (false) {_context8.next = 19;break;}_context8.next = 3;return (0, _fsaSaga.take)(_resource2.notesEditor.actions.UPDATE);case 3:updateEff = _context8.sent;update = updateEff;_context8.next = 7;return (0, _fsaSaga.take)([_resource2.notesEditor.actions.UPDATE_CANCEL, _resource2.notesResource.actions.UPDATE_SUCCESS, _resource2.notesResource.actions.UPDATE_FAILURE, _resource2.notesEditor.actions.RESET]);case 7:resolveEff = _context8.sent;resolve = resolveEff;if (!resolve) {_context8.next = 17;break;}_context8.next = 12;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 12:pageIdEff = _context8.sent;pageId = pageIdEff;if (!(update.payload.item.pageId === pageId)) {_context8.next = 17;break;}_context8.next = 17;return (0, _fsaSaga.put)(_resource2.notesEditor.actions.READ({ item: update.payload.item }));case 17:_context8.next = 0;break;case 19:case 'end':return _context8.stop();}}}, _marked5, this);}function signalQuestion() {var _this = this;var _loop, readquestion, current;return _regenerator2.default.wrap(function signalQuestion$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {var updateEff, update, resolveEff, resolve, questions;return _regenerator2.default.wrap(function _loop$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.take)(_resource4.questionsEditor.actions.UPDATE);case 2:updateEff = _context9.sent;update = updateEff;_context9.next = 6;return (0, _fsaSaga.take)([_resource4.questionsEditor.actions.UPDATE_CANCEL, _resource4.questionsResource.actions.UPDATE_SUCCESS, _resource4.questionsResource.actions.UPDATE_FAILURE, _resource4.questionsEditor.actions.RESET]);case 6:resolveEff = _context9.sent;resolve = resolveEff;if (!resolve) {_context9.next = 18;break;}readquestion = false;_context9.next = 12;return (0, _reduxSaga.select)(_resource4.questionsResource.selectors.items);case 12:questions = _context9.sent;current = questions.qWhere(function (x) {return x.id === update.payload.item.id;}).qFirst();if (!current) {_context9.next = 18;break;}_context9.next = 17;return (0, _fsaSaga.put)(_resource4.questionsEditor.actions.READ({ item: current }));case 17:readquestion = true;case 18:if (readquestion) {_context9.next = 21;break;}_context9.next = 21;return (0, _fsaSaga.put)(_resource4.questionsEditor.actions.READ_CANCEL({}));case 21:case 'end':return _context9.stop();}}}, _loop, _this);});case 1:if (false) {_context10.next = 5;break;}return _context10.delegateYield(_loop(), 't0', 3);case 3:_context10.next = 1;break;case 5:case 'end':return _context10.stop();}}}, _marked6, this);}function signalReadBookmark() {return _regenerator2.default.wrap(function signalReadBookmark$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (0, _fsaSaga.takeEvery)([_resource.bookmarksResource.actions.LIST_SUCCESS, _resource.bookmarksResource.actions.CREATE_SUCCESS, _resource.bookmarksResource.actions.READ_SUCCESS, _resource.bookmarksResource.actions.UPDATE_SUCCESS, _resource.bookmarksResource.actions.DELETE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee4() {var bookmarks, pageIdEff, pageId, current;return _regenerator2.default.wrap(function _callee4$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _reduxSaga.select)(_resource.bookmarksResource.selectors.items);case 2:bookmarks = _context11.sent;_context11.next = 5;return (0, _reduxSaga.select)(_selectors.selectors.pageId);case 5:pageIdEff = _context11.sent;pageId = pageIdEff;current = bookmarks.qWhere(function (x) {return x.pageId === pageId;}).qFirst();if (!current) {_context11.next = 11;break;}_context11.next = 11;return (0, _fsaSaga.put)(_resource.bookmarksEditor.actions.READ({ item: current }));case 11:case 'end':return _context11.stop();}}}, _callee4, this);}));case 2:case 'end':return _context12.stop();}}}, _marked7, this);}function signalReadCategory() {return _regenerator2.default.wrap(function signalReadCategory$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:_context14.next = 2;return (0, _fsaSaga.takeEvery)([_resource3.categoriesResource.actions.CREATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {return _regenerator2.default.wrap(function _callee5$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:_context13.next = 2;return (0, _fsaSaga.put)(_resource3.categoriesResource.actions.READ({ item: action.payload.item }));case 2:case 'end':return _context13.stop();}}}, _callee5, this);}));case 2:case 'end':return _context14.stop();}}}, _marked8, this);}function signalNotesRequest() {return _regenerator2.default.wrap(function signalNotesRequest$(_context16) {while (1) {switch (_context16.prev = _context16.next) {case 0:_context16.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_SUCCESS2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {var selectionDocument, selectionDocumentId, docId, pageId;return _regenerator2.default.wrap(function _callee6$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:_context15.next = 2;return (
                                                (0, _reduxSaga.select)(_selectors.selectors.docId));case 2:selectionDocument = _context15.sent;
                                            selectionDocumentId = selectionDocument;
                                            docId = selectionDocumentId;
                                            pageId = (0, _settings.getPageId)();_context15.next = 8;return (
                                                (0, _fsaSaga.put)(_resource2.notesEditor.actions.CREATE({
                                                    item: {
                                                        categoryId: null,
                                                        documentId: docId,
                                                        endCharacter: 0,
                                                        endElementXPath: action.payload.end,
                                                        pageId: pageId,
                                                        pageState: 'null',
                                                        startCharacter: 0,
                                                        startElementXPath: action.payload.start,
                                                        text: '',
                                                        isquestion: !action.payload.isnote } })));case 8:if (


                                            action.payload.isnote) {_context15.next = 11;break;}_context15.next = 11;return (
                                                (0, _fsaSaga.put)(_resource4.questionsEditor.actions.CREATE({
                                                    item: {
                                                        documentId: docId,
                                                        status: 1,
                                                        antwoordConcern: '',
                                                        practicionerId: undefined } })));case 11:case 'end':return _context15.stop();}}}, _callee6, this);})));case 2:case 'end':return _context16.stop();}}}, _marked9, this);}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.






rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(246);var _resource2 = __webpack_require__(495);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _PARTICIPANTS_LOADED = __webpack_require__(627);var _PARTICIPANTS_LOADED2 = _interopRequireDefault(_PARTICIPANTS_LOADED);var _USER_ID_LOADED = __webpack_require__(540);var _USER_ID_LOADED2 = _interopRequireDefault(_USER_ID_LOADED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(







signalLoadAllParticipants),_marked3 = /*#__PURE__*/_regenerator2.default.mark(





signalLoadAllParticipantsSuccess),_marked4 = /*#__PURE__*/_regenerator2.default.mark(





signalParticipantReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.participantsResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.participantsEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.participantsBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalLoadAllParticipants);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalLoadAllParticipantsSuccess);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalParticipantReset);case 12:case 'end':return _context.stop();}}}, _marked, this);}function signalLoadAllParticipants() {return _regenerator2.default.wrap(function signalLoadAllParticipants$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_USER_ID_LOADED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee() {var users;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.select)(_resource2.useridResource.selectors.items);case 2:users = _context2.sent;_context2.next = 5;return (0, _reduxSaga.put)(_resource.participantsResource.actions.LIST({ params: { id: users ? users[0].id : '' } }));case 5:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalLoadAllParticipantsSuccess() {return _regenerator2.default.wrap(function signalLoadAllParticipantsSuccess$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_resource.participantsResource.actions.LIST_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.put)((0, _PARTICIPANTS_LOADED2.default)({}));case 2:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalParticipantReset() {return _regenerator2.default.wrap(function signalParticipantReset$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (
                                                (0, _reduxSaga.put)(_resource.participantsResource.actions.RESET({})));case 2:_context6.next = 4;return (
                                                (0, _reduxSaga.put)(_resource.participantsEditor.actions.RESET({})));case 4:_context6.next = 6;return (
                                                (0, _reduxSaga.put)(_resource.participantsBatch.actions.RESET({})));case 6:case 'end':return _context6.stop();}}}, _callee3, this);})));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _from = __webpack_require__(117);var _from2 = _interopRequireDefault(_from);var _extends2 = __webpack_require__(24);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.










































































































rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(513);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _CANCEL = __webpack_require__(549);var _CANCEL2 = _interopRequireDefault(_CANCEL);var _resource2 = __webpack_require__(106);var _launch = __webpack_require__(235);var _resource3 = __webpack_require__(246);var _resource4 = __webpack_require__(233);var _settings = __webpack_require__(83);var _fsa = __webpack_require__(1);var _EMAIL_START_SEND_NOTIFICATION_NOTE = __webpack_require__(913);var _EMAIL_START_SEND_NOTIFICATION_NOTE2 = _interopRequireDefault(_EMAIL_START_SEND_NOTIFICATION_NOTE);var _resource5 = __webpack_require__(521);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(








signalEmailList),_marked3 = /*#__PURE__*/_regenerator2.default.mark(




signalEmailListWhenAuthenticated),_marked4 = /*#__PURE__*/_regenerator2.default.mark(




sendNoteEmailNotificationsaga),_marked5 = /*#__PURE__*/_regenerator2.default.mark(








signalEmailNote);function sendmailaddresses(note, allparticipants, allUsergroups, defaultQuestionAddressee) {var userids = note.noteParticipantsIDs;var selectedUsergroups = note.noteParticipantGroupIDs ? allUsergroups.qWhere(function (usergroup) {return note.noteParticipantGroupIDs ? note.noteParticipantGroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : false;}) : undefined;if (selectedUsergroups) {selectedUsergroups.map(function (usrgr) {if (userids && userids.length) {userids = userids.concat(usrgr.userIDs);} else {userids = usrgr.userIDs;}});}var uniqueUseridsArray = [];if (userids) {uniqueUseridsArray = userids.filter(function (item, pos) {return userids.indexOf(item) === pos;});}if (defaultQuestionAddressee && uniqueUseridsArray && uniqueUseridsArray.length > 0) {return defaultQuestionAddressee.email + ';' + allparticipants.qWhere(function (participant) {return uniqueUseridsArray.qIncludes(participant.id);}).qSelect(function (i) {return i.email;}).join(';');} else if (defaultQuestionAddressee) {return defaultQuestionAddressee.email;} else {return allparticipants.qWhere(function (participant) {return uniqueUseridsArray.qIncludes(participant.id);}).qSelect(function (i) {return i.email;}).join(';');}}function sendmailnames(note, allparticipants, allUsergroups, defaultQuestionAddressee) {var userids = note.noteParticipantsIDs;var selectedUsergroups = note.noteParticipantGroupIDs ? allUsergroups.qWhere(function (usergroup) {return note.noteParticipantGroupIDs ? note.noteParticipantGroupIDs.qSelect(function (x) {return parseInt(x);}).qIncludes(usergroup.id) : false;}) : undefined;if (selectedUsergroups) {selectedUsergroups.map(function (usrgr) {if (userids && userids.length) {userids = userids.concat(usrgr.userIDs);} else {userids = usrgr.userIDs;}});}var uniqueUseridsArray = [];if (userids) {uniqueUseridsArray = userids.filter(function (item, pos) {return userids.indexOf(item) === pos;});}if (defaultQuestionAddressee && uniqueUseridsArray && uniqueUseridsArray.length > 0) {return defaultQuestionAddressee.name + ';' + allparticipants.qWhere(function (participant) {return uniqueUseridsArray.qIncludes(participant.id);}).qSelect(function (i) {return i.name;}).join(';');} else if (defaultQuestionAddressee) {return defaultQuestionAddressee.name;} else {return allparticipants.qWhere(function (participant) {return uniqueUseridsArray.qIncludes(participant.id);}).qSelect(function (i) {return i.name;}).join(';');}}function sendmail(note, create, user, allparticipants, allparticipantsgroups, defaultQuestionAddressee) {if (!(note.noteParticipantsIDs && note.noteParticipantsIDs.qAny() || note.noteParticipantGroupIDs && note.noteParticipantGroupIDs.qAny())) {if (!(note.isquestion && defaultQuestionAddressee !== undefined)) {return undefined;}}var email = { id: null, documentId: note.documentId ? note.documentId : '', htmlMail: '<p>' + note.text + '</p>', dateEmail: Date.now(), dateEmailString: new Date(Date.now()).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }), mailToAddresses: sendmailaddresses(note, allparticipants, allparticipantsgroups, defaultQuestionAddressee), mailToName: sendmailnames(note, allparticipants, allparticipantsgroups, defaultQuestionAddressee), mailFromId: '', mailFromName: user ? user.name : '', mailFromAddress: user ? user.email : '', relatiebreadcrumb: '', relatiepageUrl: '', pageUrl: note.url ? note.url : '', pageId: note.pageId ? note.pageId : 0, pageBreadcrumb: note.breadcrumb ? note.breadcrumb : '', subject: 'Gedeelde ' + (note.isquestion ? 'vraag' : 'notitie'), emailtext: (create ? 'Er is een ' + (note.isquestion ? 'vraag' : 'notitie') + ' met u gedeeld<br/>' : 'Een met u gedeelde ' + (note.isquestion ? 'vraag' : 'notitie') + ' is gewijzigd<br/>') + '<strong>Inhoud: </strong>' + note.text, isQuestion: note.isquestion, emailParticipantsIDs: [], defaultParticipantSet: false, noteIDs: [], emailParticipantGroupIDs: [], publicatie: (0, _settings.getDocumentName)() };return email;}function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.emailArchiveResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.emailArchiveEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.emailArchiveBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalEmailList);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalEmailListWhenAuthenticated);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalEmailNote);case 12:_context.next = 14;return (0, _reduxSaga.fork)(sendNoteEmailNotificationsaga);case 14:case 'end':return _context.stop();}}}, _marked, this);}function signalEmailList() {return _regenerator2.default.wrap(function signalEmailList$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)([_CANCEL2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.put)(_resource.emailArchiveResource.actions.LIST({}));case 2:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalEmailListWhenAuthenticated() {return _regenerator2.default.wrap(function signalEmailListWhenAuthenticated$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_AUTHENTICATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee2() {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.put)(_resource.emailArchiveResource.actions.LIST({}));case 2:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function sendNoteEmailNotificationsaga() {return _regenerator2.default.wrap(function sendNoteEmailNotificationsaga$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([_EMAIL_START_SEND_NOTIFICATION_NOTE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (!(0, _fsa.isType)(action, _EMAIL_START_SEND_NOTIFICATION_NOTE2.default)) {_context6.next = 3;break;}_context6.next = 3;return (0, _reduxSaga.put)(_resource.emailArchiveResource.actions.CREATE({ item: _resource.emailArchiveResource.create((0, _extends3.default)({}, action.payload.email)) }));case 3:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalEmailNote() {return _regenerator2.default.wrap(function signalEmailNote$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (
                        (0, _fsaSaga.takeEvery)([
                        _resource2.notesResource.actions.CREATE_SUCCESS, _resource2.notesResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(
                        function _callee4(action) {var state, item, defaultQuestionAddressees, defaultQuestionAddressee, domain, breadcrumb, hasPublisher, baseUrl, userparticipant, allparticipants, allparticipantsgroups, email, _email;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:
                                            state = _launch.hack.store.getState();
                                            item = action.payload.item;
                                            defaultQuestionAddressees = _resource5.questionaddresseeResource.selectors.items(state).qSelect(function (item) {return item;});
                                            defaultQuestionAddressee = !!item.isquestion && defaultQuestionAddressees && defaultQuestionAddressees.length > 0 ? defaultQuestionAddressees[0] : undefined;if (!(
                                            item.noteParticipantsIDs && item.noteParticipantsIDs.qAny() ||
                                            item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.qAny() ||
                                            item.isquestion && defaultQuestionAddressees && defaultQuestionAddressees.length > 0)) {_context8.next = 22;break;}
                                            domain = window.location.origin || window.location.protocol + '//' + window.location.host;
                                            breadcrumb = item.breadcrumb;
                                            hasPublisher = (0, _from2.default)(document.querySelectorAll('meta')).filter(function (x) {return x.name.indexOf('lias-document-baseurl') >= 0;}).length > 0;
                                            if (hasPublisher) {
                                                baseUrl = (0, _from2.default)(document.querySelectorAll('meta')).filter(function (x) {return x.name.indexOf('lias-document-baseurl') >= 0;}).qFirst().content;
                                                item.url = baseUrl.endsWith("/") ? '' + baseUrl + item.url : baseUrl + '/' + item.url;
                                            } else
                                            {
                                                item.url = breadcrumb === 'Home' ? domain : domain + '/p' + item.pageId.toString() + '.html';
                                            }
                                            userparticipant = _resource3.participantsResource.selectors.items(state).qFirst(function (itm) {return itm.isUser;});
                                            allparticipants = _resource3.participantsResource.selectors.items(state).qSelect(function (item) {return item;});
                                            allparticipantsgroups = _resource4.usergroupResource.selectors.items(state).qSelect(function (item) {return item;});if (!
                                            (0, _fsa.isType)(action, _resource2.notesEditor.actions.CREATE_CONTINUE)) {_context8.next = 18;break;}
                                            email = sendmail(item, true, userparticipant, allparticipants, allparticipantsgroups, defaultQuestionAddressee);_context8.next = 16;return (
                                                (0, _reduxSaga.put)((0, _EMAIL_START_SEND_NOTIFICATION_NOTE2.default)({ email: email })));case 16:_context8.next = 22;break;case 18:


                                            _email = sendmail(item, false, userparticipant, allparticipants, allparticipantsgroups, defaultQuestionAddressee);
                                            _email.id = 1;_context8.next = 22;return (
                                                (0, _reduxSaga.put)((0, _EMAIL_START_SEND_NOTIFICATION_NOTE2.default)({ email: _email })));case 22:case 'end':return _context8.stop();}}}, _callee4, this);})));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _fsa = __webpack_require__(1);exports.default =
(0, _fsa.Action)('EMAIL_START_SEND_NOTIFICATION_NOTE');

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.






rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(495);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _USER_ID_LOADED = __webpack_require__(540);var _USER_ID_LOADED2 = _interopRequireDefault(_USER_ID_LOADED);var _USER_ID_NOT_LOADED = __webpack_require__(629);var _USER_ID_NOT_LOADED2 = _interopRequireDefault(_USER_ID_NOT_LOADED);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(






signalUserLoad),_marked3 = /*#__PURE__*/_regenerator2.default.mark(




signalUserLoaded),_marked4 = /*#__PURE__*/_regenerator2.default.mark(







signalUserNotLoaded),_marked5 = /*#__PURE__*/_regenerator2.default.mark(




signalParticipantReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.useridResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(signalUserLoad);case 4:_context.next = 6;return (0, _reduxSaga.fork)(signalUserLoaded);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalUserNotLoaded);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalParticipantReset);case 10:case 'end':return _context.stop();}}}, _marked, this);}function signalUserLoad() {return _regenerator2.default.wrap(function signalUserLoad$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.put)(_resource.useridResource.actions.LIST({}));case 2:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalUserLoaded() {return _regenerator2.default.wrap(function signalUserLoaded$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)(_resource.useridResource.actions.LIST_SUCCESS, /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {var participantid;return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:participantid = action.payload.list && action.payload.list.length > 0 ? action.payload.list[0].id : '';_context4.next = 3;return (0, _reduxSaga.put)((0, _USER_ID_LOADED2.default)({ id: participantid }));case 3:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalUserNotLoaded() {return _regenerator2.default.wrap(function signalUserNotLoaded$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)(_resource.useridResource.actions.LIST_FAILURE, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (0, _reduxSaga.put)((0, _USER_ID_NOT_LOADED2.default)({}));case 2:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalParticipantReset() {return _regenerator2.default.wrap(function signalParticipantReset$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee4() {return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (
                                                (0, _reduxSaga.put)(_resource.useridResource.actions.RESET({})));case 2:case 'end':return _context8.stop();}}}, _callee4, this);})));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.













rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(233);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _USERGROUP_LOADED = __webpack_require__(630);var _USERGROUP_LOADED2 = _interopRequireDefault(_USERGROUP_LOADED);var _USERGROUP_NOT_LOADED = __webpack_require__(631);var _USERGROUP_NOT_LOADED2 = _interopRequireDefault(_USERGROUP_NOT_LOADED);var _USERGROUP_UPDATED = __webpack_require__(489);var _USERGROUP_UPDATED2 = _interopRequireDefault(_USERGROUP_UPDATED);var _USERGROUP_CREATED = __webpack_require__(488);var _USERGROUP_CREATED2 = _interopRequireDefault(_USERGROUP_CREATED);var _USERGROUP_REMOVE = __webpack_require__(562);var _USERGROUP_REMOVE2 = _interopRequireDefault(_USERGROUP_REMOVE);var _fsa = __webpack_require__(1);var _resource2 = __webpack_require__(106);var _effects = __webpack_require__(170);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(











signalLoadAllUserGroupSuccess),_marked3 = /*#__PURE__*/_regenerator2.default.mark(





signalLoadAllUserGroupNotSuccess),_marked4 = /*#__PURE__*/_regenerator2.default.mark(





signalUserGroupCreateSuccess),_marked5 = /*#__PURE__*/_regenerator2.default.mark(







signalUserGroupUpdateSuccess),_marked6 = /*#__PURE__*/_regenerator2.default.mark(







signalUserGroupWhenAuthenticated),_marked7 = /*#__PURE__*/_regenerator2.default.mark(




signalUserGroupReset),_marked8 = /*#__PURE__*/_regenerator2.default.mark(




signalUserGroupRemove);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.usergroupResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.usergroupEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.usergroupBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalUserGroupWhenAuthenticated);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalUserGroupReset);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalLoadAllUserGroupSuccess);case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalLoadAllUserGroupNotSuccess);case 14:_context.next = 16;return (0, _reduxSaga.fork)(signalUserGroupUpdateSuccess);case 16:_context.next = 18;return (0, _reduxSaga.fork)(signalUserGroupCreateSuccess);case 18:_context.next = 20;return (0, _reduxSaga.fork)(signalUserGroupRemove);case 20:case 'end':return _context.stop();}}}, _marked, this);}function signalLoadAllUserGroupSuccess() {return _regenerator2.default.wrap(function signalLoadAllUserGroupSuccess$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)([_resource.usergroupResource.actions.LIST_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.put)((0, _USERGROUP_LOADED2.default)({}));case 2:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalLoadAllUserGroupNotSuccess() {return _regenerator2.default.wrap(function signalLoadAllUserGroupNotSuccess$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_resource.usergroupResource.actions.LIST_FAILURE], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (0, _reduxSaga.put)((0, _USERGROUP_NOT_LOADED2.default)({}));case 2:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalUserGroupCreateSuccess() {return _regenerator2.default.wrap(function signalUserGroupCreateSuccess$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([_resource.usergroupResource.actions.CREATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {var usergr;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:usergr = action.payload.item;_context6.next = 3;return (0, _reduxSaga.put)((0, _USERGROUP_CREATED2.default)({ usergroup: usergr }));case 3:_context6.next = 5;return (0, _reduxSaga.put)(_resource.usergroupResource.actions.LIST({}));case 5:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalUserGroupUpdateSuccess() {return _regenerator2.default.wrap(function signalUserGroupUpdateSuccess$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.takeEvery)([_resource.usergroupResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var usergr;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:usergr = action.payload.item;_context8.next = 3;return (0, _reduxSaga.put)((0, _USERGROUP_UPDATED2.default)({ usergroup: usergr }));case 3:_context8.next = 5;return (0, _reduxSaga.put)(_resource.usergroupResource.actions.LIST({}));case 5:case 'end':return _context8.stop();}}}, _callee4, this);}));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}function signalUserGroupWhenAuthenticated() {return _regenerator2.default.wrap(function signalUserGroupWhenAuthenticated$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _fsaSaga.takeEvery)([_AUTHENTICATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (0, _reduxSaga.put)(_resource.usergroupResource.actions.LIST({}));case 2:case 'end':return _context10.stop();}}}, _callee5, this);}));case 2:case 'end':return _context11.stop();}}}, _marked6, this);}function signalUserGroupReset() {return _regenerator2.default.wrap(function signalUserGroupReset$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:_context13.next = 2;return (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee6() {return _regenerator2.default.wrap(function _callee6$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (0, _reduxSaga.put)(_resource.usergroupResource.actions.RESET({}));case 2:case 'end':return _context12.stop();}}}, _callee6, this);}));case 2:case 'end':return _context13.stop();}}}, _marked7, this);}function signalUserGroupRemove() {var maxDelayTime, minDelayTime;return _regenerator2.default.wrap(function signalUserGroupRemove$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:
                    maxDelayTime = 10000;
                    minDelayTime = 1000;_context15.next = 4;return (
                        (0, _fsaSaga.takeEvery)(_USERGROUP_REMOVE2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {var usergroup, notes, usergroupNotes, countNotesToUpdate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note, waiting, waitresult;return _regenerator2.default.wrap(function _callee7$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:if (!
                                            (0, _fsa.isType)(action, _USERGROUP_REMOVE2.default)) {_context14.next = 57;break;}
                                            usergroup = action.payload.usergroup;_context14.next = 4;return (
                                                (0, _reduxSaga.select)(_resource2.notesResource.selectors.items));case 4:notes = _context14.sent;
                                            usergroupNotes = notes.qWhere(function (itm) {return itm.noteParticipantGroupIDs ? itm.noteParticipantGroupIDs.map(function (x) {return typeof x === 'number' ? x : parseInt(x);}).qIncludes(usergroup.id) : false;});
                                            countNotesToUpdate = usergroupNotes.length;if (!(
                                            countNotesToUpdate > 0)) {_context14.next = 55;break;}_context14.prev = 8;_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context14.prev = 12;_iterator = (0, _getIterator3.default)(

                                            usergroupNotes);case 14:if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {_context14.next = 34;break;}note = _step.value;
                                            note.noteParticipantGroupIDs = note.noteParticipantGroupIDs.filter(function (id) {return id === usergroup.id.toString();});_context14.next = 19;return (
                                                (0, _reduxSaga.put)(_resource2.notesEditor.actions.UPDATE_CONTINUE({ item: note })));case 19:_context14.next = 21;return (
                                                (0, _effects.race)({
                                                    timeout: (0, _effects.call)(_reduxSaga.delay, maxDelayTime),
                                                    updateend: (0, _effects.take)([_resource2.notesResource.actions.UPDATE_FAILURE, _resource2.notesResource.actions.UPDATE_SUCCESS]) }));case 21:waiting = _context14.sent;

                                            waitresult = waiting;if (!
                                            waitresult.updateend) {_context14.next = 31;break;}if (!(
                                            countNotesToUpdate > 0)) {_context14.next = 31;break;}
                                            countNotesToUpdate--;if (!(
                                            countNotesToUpdate === 0)) {_context14.next = 31;break;}_context14.next = 29;return (
                                                (0, _effects.call)(_reduxSaga.delay, minDelayTime));case 29:_context14.next = 31;return (
                                                (0, _reduxSaga.put)(_resource.usergroupEditor.actions.DELETE_CONTINUE({ item: usergroup })));case 31:_iteratorNormalCompletion = true;_context14.next = 14;break;case 34:_context14.next = 40;break;case 36:_context14.prev = 36;_context14.t0 = _context14['catch'](12);_didIteratorError = true;_iteratorError = _context14.t0;case 40:_context14.prev = 40;_context14.prev = 41;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 43:_context14.prev = 43;if (!_didIteratorError) {_context14.next = 46;break;}throw _iteratorError;case 46:return _context14.finish(43);case 47:return _context14.finish(40);case 48:_context14.next = 53;break;case 50:_context14.prev = 50;_context14.t1 = _context14['catch'](8);






                                            console.log(_context14.t1);case 53:_context14.next = 57;break;case 55:_context14.next = 57;return (



                                                (0, _reduxSaga.put)(_resource.usergroupEditor.actions.DELETE_CONTINUE({ item: usergroup })));case 57:case 'end':return _context14.stop();}}}, _callee7, this, [[8, 50], [12, 36, 40, 48], [41,, 43, 47]]);})));case 4:case 'end':return _context15.stop();}}}, _marked8, this);}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.











rootSaga = rootSaga;var _fsa = __webpack_require__(1);var _effects = __webpack_require__(170);var _types = __webpack_require__(245);var _START_CHAT = __webpack_require__(547);var _START_CHAT2 = _interopRequireDefault(_START_CHAT);var _resource = __webpack_require__(517);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _NOTECHAT_LOADED = __webpack_require__(632);var _NOTECHAT_LOADED2 = _interopRequireDefault(_NOTECHAT_LOADED);var _selectors = __webpack_require__(78);var _resource2 = __webpack_require__(106);var _launch = __webpack_require__(235);var _STOP_CHAT = __webpack_require__(610);var _STOP_CHAT2 = _interopRequireDefault(_STOP_CHAT);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(









signalNoteChatLoadWhenAuthenticated),_marked3 = /*#__PURE__*/_regenerator2.default.mark(









signalNoteChatListSuccess),_marked4 = /*#__PURE__*/_regenerator2.default.mark(







signalNoteChatReset),_marked5 = /*#__PURE__*/_regenerator2.default.mark(







signalStartNoteChat),_marked6 = /*#__PURE__*/_regenerator2.default.mark(



























signalNoteChatChange);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _effects.fork)(_resource.notechatResource.saga);case 2:_context.next = 4;return (0, _effects.fork)(_resource.notechatEditor.saga);case 4:_context.next = 6;return (0, _effects.fork)(_resource.notechatBatch.saga);case 6:_context.next = 8;return (0, _effects.fork)(signalNoteChatLoadWhenAuthenticated);case 8:_context.next = 10;return (0, _effects.fork)(signalNoteChatReset);case 10:_context.next = 12;return (0, _effects.fork)(signalStartNoteChat);case 12:_context.next = 14;return (0, _effects.fork)(signalNoteChatChange);case 14:_context.next = 16;return (0, _effects.fork)(signalNoteChatListSuccess);case 16:case 'end':return _context.stop();}}}, _marked, this);}function signalNoteChatLoadWhenAuthenticated() {return _regenerator2.default.wrap(function signalNoteChatLoadWhenAuthenticated$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _effects.takeEvery)([_AUTHENTICATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var selectionDocument, selectionDocumentId, documentId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!(0, _fsa.isType)(action, _AUTHENTICATED2.default)) {_context2.next = 8;break;}_context2.next = 3;return (0, _effects.select)(_selectors.selectors.docId);case 3:selectionDocument = _context2.sent;selectionDocumentId = selectionDocument;documentId = selectionDocumentId;_context2.next = 8;return (0, _effects.put)(_resource.notechatResource.actions.LIST({ params: { documentId: documentId } }));case 8:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalNoteChatListSuccess() {return _regenerator2.default.wrap(function signalNoteChatListSuccess$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _effects.takeEvery)([_resource.notechatResource.actions.LIST_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (!(0, _fsa.isType)(action, _resource.notechatResource.actions.LIST_SUCCESS)) {_context4.next = 3;break;}_context4.next = 3;return (0, _effects.put)((0, _NOTECHAT_LOADED2.default)({}));case 3:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalNoteChatReset() {return _regenerator2.default.wrap(function signalNoteChatReset$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _effects.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (!(0, _fsa.isType)(action, _LOGGEDOUT2.default)) {_context6.next = 5;break;}_context6.next = 3;return (0, _effects.put)(_resource.notechatResource.actions.RESET({}));case 3:_context6.next = 5;return (0, _effects.put)(_resource.notechatEditor.actions.RESET({}));case 5:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalStartNoteChat() {return _regenerator2.default.wrap(function signalStartNoteChat$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _effects.takeEvery)(_START_CHAT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var note, creatingChat;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:if (!(0, _fsa.isType)(action, _START_CHAT2.default)) {_context8.next = 14;break;}note = action.payload.item;_context8.next = 4;return (0, _effects.select)(_resource.notechatEditor.selectors.creating);case 4:creatingChat = _context8.sent;if (!(note && !creatingChat)) {_context8.next = 14;break;}if (!(0, _types.isSharedNote)(note)) {_context8.next = 11;break;}_context8.next = 9;return (0, _effects.put)(_resource.notechatEditor.actions.CREATE({ item: { userId: note.userId, noteId: note.id, text: '' } }));case 9:_context8.next = 14;break;case 11:if (!(0, _types.isNote)(note)) {_context8.next = 14;break;}_context8.next = 14;return (0, _effects.put)(_resource.notechatEditor.actions.CREATE({ item: { userId: note.userId, noteId: note.id, text: '' } }));case 14:case 'end':return _context8.stop();}}}, _callee4, this);}));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}function signalNoteChatChange() {return _regenerator2.default.wrap(function signalNoteChatChange$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (
                        (0, _effects.takeEvery)([
                        _resource2.notesEditor.actions.READ,
                        _resource.notechatResource.actions.CREATE_SUCCESS,
                        _resource.notechatResource.actions.CREATE_CANCEL,
                        _resource.notechatResource.actions.CREATE_FAILURE,
                        _resource.notechatResource.actions.UPDATE_SUCCESS,
                        _resource.notechatResource.actions.UPDATE_CANCEL,
                        _resource.notechatResource.actions.UPDATE_FAILURE,
                        _resource.notechatResource.actions.DELETE_SUCCESS,
                        _resource.notechatResource.actions.DELETE_CANCEL], /*#__PURE__*/_regenerator2.default.mark(
                        function _callee5(action) {var selectionDocument, selectionDocumentId, documentId, flyoverVisible, _selectionDocument, _selectionDocumentId, _documentId;return _regenerator2.default.wrap(function _callee5$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:if (!
                                            (0, _fsa.isType)(action, _resource2.notesEditor.actions.READ)) {_context10.next = 16;break;}_context10.next = 3;return (
                                                (0, _effects.put)(_resource.notechatResource.actions.RESET({})));case 3:_context10.next = 5;return (
                                                (0, _effects.put)(_resource.notechatEditor.actions.RESET({})));case 5:_context10.next = 7;return (
                                                (0, _effects.put)(_resource.notechatBatch.actions.RESET({})));case 7:_context10.next = 9;return (
                                                (0, _effects.select)(_selectors.selectors.docId));case 9:selectionDocument = _context10.sent;
                                            selectionDocumentId = selectionDocument;
                                            documentId = selectionDocumentId;_context10.next = 14;return (
                                                (0, _effects.put)(_resource.notechatResource.actions.LIST({ params: { documentId: documentId } })));case 14:_context10.next = 30;break;case 16:if (!(

                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.CREATE_SUCCESS) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.UPDATE_SUCCESS) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.UPDATE_FAILURE) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.DELETE_SUCCESS) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.CREATE_CANCEL) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.CREATE_FAILURE) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.UPDATE_CANCEL) ||
                                            (0, _fsa.isType)(action, _resource.notechatResource.actions.DELETE_CANCEL))) {_context10.next = 30;break;}
                                            flyoverVisible = _launch.hack.store.getState().flyover.visible;if (!
                                            flyoverVisible) {_context10.next = 21;break;}_context10.next = 21;return (
                                                (0, _effects.put)((0, _STOP_CHAT2.default)({})));case 21:_context10.next = 23;return (

                                                (0, _effects.put)(_resource.notechatEditor.actions.RESET({})));case 23:_context10.next = 25;return (
                                                (0, _effects.select)(_selectors.selectors.docId));case 25:_selectionDocument = _context10.sent;
                                            _selectionDocumentId = _selectionDocument;
                                            _documentId = _selectionDocumentId;_context10.next = 30;return (
                                                (0, _effects.put)(_resource.notechatResource.actions.LIST({ params: { documentId: _documentId } })));case 30:case 'end':return _context10.stop();}}}, _callee5, this);})));case 2:case 'end':return _context11.stop();}}}, _marked6, this);}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.










rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);__webpack_require__(76);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(521);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _ADDRESSEE_LOADED = __webpack_require__(633);var _ADDRESSEE_LOADED2 = _interopRequireDefault(_ADDRESSEE_LOADED);var _ADDRESSEE_NOT_LOADED = __webpack_require__(634);var _ADDRESSEE_NOT_LOADED2 = _interopRequireDefault(_ADDRESSEE_NOT_LOADED);var _ADDRESSEE_UPDATED = __webpack_require__(636);var _ADDRESSEE_UPDATED2 = _interopRequireDefault(_ADDRESSEE_UPDATED);var _ADDRESSEE_CREATED = __webpack_require__(635);var _ADDRESSEE_CREATED2 = _interopRequireDefault(_ADDRESSEE_CREATED);var _fsa = __webpack_require__(1);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(












signalLoadAllQuestionaddresseeSuccess),_marked3 = /*#__PURE__*/_regenerator2.default.mark(











signalLoadAllQuestionaddresseeNotSuccess),_marked4 = /*#__PURE__*/_regenerator2.default.mark(







signalQuestionaddresseeCreateSuccess),_marked5 = /*#__PURE__*/_regenerator2.default.mark(








signalQuestionaddresseeUpdateSuccess),_marked6 = /*#__PURE__*/_regenerator2.default.mark(








signalQuestionaddresseeCreateCancel),_marked7 = /*#__PURE__*/_regenerator2.default.mark(







signalQuestionaddresseeUpdateCancel),_marked8 = /*#__PURE__*/_regenerator2.default.mark(







signalQuestionaddresseeWhenAuthenticated),_marked9 = /*#__PURE__*/_regenerator2.default.mark(




signalQuestionaddresseeReset);function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.questionaddresseeResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.questionaddresseeEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.questionaddresseeBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalQuestionaddresseeWhenAuthenticated);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalQuestionaddresseeReset);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalLoadAllQuestionaddresseeSuccess);case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalLoadAllQuestionaddresseeNotSuccess);case 14:_context.next = 16;return (0, _reduxSaga.fork)(signalQuestionaddresseeUpdateSuccess);case 16:_context.next = 18;return (0, _reduxSaga.fork)(signalQuestionaddresseeCreateSuccess);case 18:_context.next = 20;return (0, _reduxSaga.fork)(signalQuestionaddresseeCreateCancel);case 20:_context.next = 22;return (0, _reduxSaga.fork)(signalQuestionaddresseeUpdateCancel);case 22:case 'end':return _context.stop();}}}, _marked, this);}function signalLoadAllQuestionaddresseeSuccess() {return _regenerator2.default.wrap(function signalLoadAllQuestionaddresseeSuccess$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeResource.actions.LIST_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {var addressees;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeResource.actions.LIST_SUCCESS)) {_context2.next = 7;break;}_context2.next = 3;return (0, _reduxSaga.put)((0, _ADDRESSEE_LOADED2.default)({}));case 3:addressees = action.payload.list;if (!(addressees && addressees.qCount() > 0)) {_context2.next = 7;break;}_context2.next = 7;return (0, _reduxSaga.put)(_resource.questionaddresseeEditor.actions.READ_CONTINUE({ item: addressees[0] }));case 7:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalLoadAllQuestionaddresseeNotSuccess() {return _regenerator2.default.wrap(function signalLoadAllQuestionaddresseeNotSuccess$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeResource.actions.LIST_FAILURE], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeResource.actions.LIST_FAILURE)) {_context4.next = 3;break;}_context4.next = 3;return (0, _reduxSaga.put)((0, _ADDRESSEE_NOT_LOADED2.default)({}));case 3:case 'end':return _context4.stop();}}}, _callee2, this);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalQuestionaddresseeCreateSuccess() {return _regenerator2.default.wrap(function signalQuestionaddresseeCreateSuccess$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeResource.actions.CREATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {var addressee;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeResource.actions.CREATE_SUCCESS)) {_context6.next = 4;break;}addressee = action.payload.item;_context6.next = 4;return (0, _reduxSaga.put)((0, _ADDRESSEE_CREATED2.default)({ questionaddressee: addressee }));case 4:case 'end':return _context6.stop();}}}, _callee3, this);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalQuestionaddresseeUpdateSuccess() {return _regenerator2.default.wrap(function signalQuestionaddresseeUpdateSuccess$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var addressee;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeResource.actions.UPDATE_SUCCESS)) {_context8.next = 4;break;}addressee = action.payload.item;_context8.next = 4;return (0, _reduxSaga.put)((0, _ADDRESSEE_UPDATED2.default)({ questionaddressee: addressee }));case 4:case 'end':return _context8.stop();}}}, _callee4, this);}));case 2:case 'end':return _context9.stop();}}}, _marked5, this);}function signalQuestionaddresseeCreateCancel() {return _regenerator2.default.wrap(function signalQuestionaddresseeCreateCancel$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeEditor.actions.CREATE_CANCEL], /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {return _regenerator2.default.wrap(function _callee5$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeEditor.actions.CREATE_CANCEL)) {_context10.next = 3;break;}_context10.next = 3;return (0, _reduxSaga.put)(_resource.questionaddresseeResource.actions.LIST({}));case 3:case 'end':return _context10.stop();}}}, _callee5, this);}));case 2:case 'end':return _context11.stop();}}}, _marked6, this);}function signalQuestionaddresseeUpdateCancel() {return _regenerator2.default.wrap(function signalQuestionaddresseeUpdateCancel$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:_context13.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionaddresseeEditor.actions.UPDATE_CANCEL], /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {return _regenerator2.default.wrap(function _callee6$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:if (!(0, _fsa.isType)(action, _resource.questionaddresseeEditor.actions.UPDATE_CANCEL)) {_context12.next = 3;break;}_context12.next = 3;return (0, _reduxSaga.put)(_resource.questionaddresseeResource.actions.LIST({}));case 3:case 'end':return _context12.stop();}}}, _callee6, this);}));case 2:case 'end':return _context13.stop();}}}, _marked7, this);}function signalQuestionaddresseeWhenAuthenticated() {return _regenerator2.default.wrap(function signalQuestionaddresseeWhenAuthenticated$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:_context15.next = 2;return (0, _fsaSaga.takeEvery)([_AUTHENTICATED2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee7() {return _regenerator2.default.wrap(function _callee7$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:_context14.next = 2;return (0, _reduxSaga.put)(_resource.questionaddresseeResource.actions.LIST({}));case 2:case 'end':return _context14.stop();}}}, _callee7, this);}));case 2:case 'end':return _context15.stop();}}}, _marked8, this);}function signalQuestionaddresseeReset() {return _regenerator2.default.wrap(function signalQuestionaddresseeReset$(_context17) {while (1) {switch (_context17.prev = _context17.next) {case 0:_context17.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee8() {return _regenerator2.default.wrap(function _callee8$(_context16) {while (1) {switch (_context16.prev = _context16.next) {case 0:_context16.next = 2;return (
                                                (0, _reduxSaga.put)(_resource.questionaddresseeResource.actions.RESET({})));case 2:case 'end':return _context16.stop();}}}, _callee8, this);})));case 2:case 'end':return _context17.stop();}}}, _marked9, this);}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getIterator2 = __webpack_require__(115);var _getIterator3 = _interopRequireDefault(_getIterator2);var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);exports.




















rootSaga = rootSaga;var _fsaSaga = __webpack_require__(59);var _reduxSaga = __webpack_require__(47);var _resource = __webpack_require__(223);var _selectors = __webpack_require__(78);var _AUTHENTICATED = __webpack_require__(84);var _AUTHENTICATED2 = _interopRequireDefault(_AUTHENTICATED);var _LOGGEDOUT = __webpack_require__(65);var _LOGGEDOUT2 = _interopRequireDefault(_LOGGEDOUT);var _effects = __webpack_require__(170);var _resource2 = __webpack_require__(106);var _launch = __webpack_require__(235);var _NOTES_INSPECT = __webpack_require__(544);var _NOTES_INSPECT2 = _interopRequireDefault(_NOTES_INSPECT);var _QUESTION_INSPECT = __webpack_require__(637);var _QUESTION_INSPECT2 = _interopRequireDefault(_QUESTION_INSPECT);var _QUESTION_CHANGE_STATUS_BATCH = __webpack_require__(563);var _QUESTION_CHANGE_STATUS_BATCH2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH);var _fsa = __webpack_require__(1);var _QUESTION_CHANGE_STATUS_BATCH_COMPLETE = __webpack_require__(638);var _QUESTION_CHANGE_STATUS_BATCH_COMPLETE2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_COMPLETE);var _QUESTION_CHANGE_STATUS_BATCH_FAILURE = __webpack_require__(639);var _QUESTION_CHANGE_STATUS_BATCH_FAILURE2 = _interopRequireDefault(_QUESTION_CHANGE_STATUS_BATCH_FAILURE);var _authcheck = __webpack_require__(518);var _resource3 = __webpack_require__(495);var _resource4 = __webpack_require__(233);var _QUESTION_SAVE = __webpack_require__(550);var _QUESTION_SAVE2 = _interopRequireDefault(_QUESTION_SAVE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _marked = /*#__PURE__*/_regenerator2.default.mark(rootSaga),_marked2 = /*#__PURE__*/_regenerator2.default.mark(













signalquestionsList),_marked3 = /*#__PURE__*/_regenerator2.default.mark(






signalcreate),_marked4 = /*#__PURE__*/_regenerator2.default.mark(





















signalupdate),_marked5 = /*#__PURE__*/_regenerator2.default.mark(


































signalupdatecontinue),_marked6 = /*#__PURE__*/_regenerator2.default.mark(




























































signalChangeBatchStatus),_marked7 = /*#__PURE__*/_regenerator2.default.mark(













































signallistbeheer),_marked8 = /*#__PURE__*/_regenerator2.default.mark(












monitorSelectedNote),_marked9 = /*#__PURE__*/_regenerator2.default.mark(














monitorNotesInspectQuestion),_marked10 = /*#__PURE__*/_regenerator2.default.mark(


































signalquestionsReset);var maxDelayTime = 10000;var minDelayTime = 1000;function rootSaga() {return _regenerator2.default.wrap(function rootSaga$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (0, _reduxSaga.fork)(_resource.questionsResource.saga);case 2:_context.next = 4;return (0, _reduxSaga.fork)(_resource.questionsEditor.saga);case 4:_context.next = 6;return (0, _reduxSaga.fork)(_resource.questionsBatch.saga);case 6:_context.next = 8;return (0, _reduxSaga.fork)(signalquestionsList);case 8:_context.next = 10;return (0, _reduxSaga.fork)(signalcreate);case 10:_context.next = 12;return (0, _reduxSaga.fork)(signalupdate);case 12:_context.next = 14;return (0, _reduxSaga.fork)(signalupdatecontinue);case 14:_context.next = 16;return (0, _reduxSaga.fork)(signallistbeheer);case 16:_context.next = 18;return (0, _reduxSaga.fork)(monitorSelectedNote);case 18:_context.next = 20;return (0, _reduxSaga.fork)(signalquestionsReset);case 20:_context.next = 22;return (0, _reduxSaga.fork)(monitorNotesInspectQuestion);case 22:_context.next = 24;return (0, _reduxSaga.fork)(signalChangeBatchStatus);case 24:case 'end':return _context.stop();}}}, _marked, this);}function signalquestionsList() {return _regenerator2.default.wrap(function signalquestionsList$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (0, _fsaSaga.takeEvery)(_AUTHENTICATED2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee() {var selectionDocument, selectionDocumentId;return _regenerator2.default.wrap(function _callee$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (0, _reduxSaga.select)(_selectors.selectors.docId);case 2:selectionDocument = _context2.sent;selectionDocumentId = selectionDocument;_context2.next = 6;return (0, _fsaSaga.put)(_resource.questionsResource.actions.LIST({ params: { selectionDocumentId: selectionDocumentId } }));case 6:case 'end':return _context2.stop();}}}, _callee, this);}));case 2:case 'end':return _context3.stop();}}}, _marked2, this);}function signalcreate() {return _regenerator2.default.wrap(function signalcreate$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesResource.actions.CREATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {var note, question;return _regenerator2.default.wrap(function _callee2$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:note = action.payload.item;if (!note) {_context4.next = 18;break;}if (!note.isquestion) {_context4.next = 18;break;}_context4.next = 5;return (0, _reduxSaga.select)(_resource.questionsEditor.selectors.item);case 5:question = _context4.sent;if (!question) {_context4.next = 18;break;}question.noteId = note.id;_context4.prev = 8;_context4.next = 11;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.CREATE_CONTINUE({ item: _resource.questionsResource.create(question) }));case 11:_context4.next = 18;break;case 13:_context4.prev = 13;_context4.t0 = _context4['catch'](8);console.log('Question couldn\'t be backed up');_context4.next = 18;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.CREATE_CANCEL({}));case 18:case 'end':return _context4.stop();}}}, _callee2, this, [[8, 13]]);}));case 2:case 'end':return _context5.stop();}}}, _marked3, this);}function signalupdate() {return _regenerator2.default.wrap(function signalupdate$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesEditor.actions.UPDATE], /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {var questions, current;return _regenerator2.default.wrap(function _callee3$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (!action.payload.item) {_context6.next = 25;break;}if (!action.payload.item.isquestion) {_context6.next = 25;break;}_context6.next = 4;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 4:questions = _context6.sent;current = questions.qWhere(function (x) {return x.noteId === action.payload.item.id;}).qFirst();if (!current) {_context6.next = 17;break;}_context6.prev = 7;_context6.next = 10;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.UPDATE({ item: current }));case 10:_context6.next = 15;break;case 12:_context6.prev = 12;_context6.t0 = _context6['catch'](7);console.log('Question couldn\'t be backed up');case 15:_context6.next = 25;break;case 17:_context6.prev = 17;_context6.next = 20;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.CREATE({ item: fixNoteDevelopmentJsonServerQuestion({ status: 1, noteId: action.payload.item.id, antwoordConcern: '', practicionerId: undefined }) }));case 20:_context6.next = 25;break;case 22:_context6.prev = 22;_context6.t1 = _context6['catch'](17);console.log('Question couldn\'t be backed up');case 25:case 'end':return _context6.stop();}}}, _callee3, this, [[7, 12], [17, 22]]);}));case 2:case 'end':return _context7.stop();}}}, _marked4, this);}function signalupdatecontinue() {return _regenerator2.default.wrap(function signalupdatecontinue$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (0, _fsaSaga.takeEvery)([_resource2.notesResource.actions.UPDATE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {var note, current, allQuestions, parent, _allQuestions, items, batchstatus;return _regenerator2.default.wrap(function _callee4$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:note = action.payload.item;if (!action.payload.item) {_context8.next = 32;break;}if (!action.payload.item.isquestion) {_context8.next = 32;break;}_context8.next = 5;return (0, _reduxSaga.select)(_resource.questionsEditor.selectors.item);case 5:current = _context8.sent;if (!current) {_context8.next = 32;break;}_context8.prev = 7;if (!current.parentId) {_context8.next = 15;break;}_context8.next = 11;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 11:allQuestions = _context8.sent;parent = allQuestions.qFirst(function (o) {return o.noteId === current.parentId;});current.status = parent.status;current.antwoordConcern = parent.antwoordConcern;case 15:_context8.next = 17;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.UPDATE_CONTINUE({ item: current }));case 17:_context8.next = 22;break;case 19:_context8.prev = 19;_context8.t0 = _context8['catch'](7);console.log('Question couldn\'t be backed up');case 22:_context8.prev = 22;_context8.next = 25;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 25:_allQuestions = _context8.sent;items = _allQuestions.qWhere(function (o) {return o.parentId === note.id;});items.forEach(function (itm) {return itm.antwoordConcern = current.antwoordConcern;});batchstatus = _authcheck.statusses.qFirst(function (itm) {return itm.id === current.status;});_context8.next = 31;return (0, _fsaSaga.put)((0, _QUESTION_CHANGE_STATUS_BATCH2.default)({ items: items, batchstatus: batchstatus, batchchange: false }));case 31:return _context8.finish(22);case 32:case 'end':return _context8.stop();}}}, _callee4, this, [[7, 19, 22, 32]]);}));case 2:_context10.next = 4;return (0, _fsaSaga.takeEvery)([_QUESTION_SAVE2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {var current, allQuestions, parent, _allQuestions2, items, batchstatus;return _regenerator2.default.wrap(function _callee5$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:if (!action.payload.saveitem) {_context9.next = 28;break;}current = action.payload.saveitem;if (!current) {_context9.next = 28;break;}_context9.prev = 3;if (!current.parentId) {_context9.next = 11;break;}_context9.next = 7;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 7:allQuestions = _context9.sent;parent = allQuestions.qFirst(function (o) {return o.noteId === current.parentId;});current.status = parent.status;current.antwoordConcern = parent.antwoordConcern;case 11:_context9.next = 13;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.UPDATE_CONTINUE({ item: current }));case 13:_context9.next = 18;break;case 15:_context9.prev = 15;_context9.t0 = _context9['catch'](3);console.log('Question couldn\'t be backed up');case 18:_context9.prev = 18;_context9.next = 21;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 21:_allQuestions2 = _context9.sent;items = _allQuestions2.qWhere(function (o) {return o.parentId === current.noteId;});items.forEach(function (itm) {return itm.antwoordConcern = current.antwoordConcern;});batchstatus = _authcheck.statusses.qFirst(function (itm) {return itm.id === current.status;});_context9.next = 27;return (0, _fsaSaga.put)((0, _QUESTION_CHANGE_STATUS_BATCH2.default)({ items: items, batchstatus: batchstatus, batchchange: false }));case 27:return _context9.finish(18);case 28:case 'end':return _context9.stop();}}}, _callee5, this, [[3, 15, 18, 28]]);}));case 4:case 'end':return _context10.stop();}}}, _marked5, this);}function signalChangeBatchStatus() {return _regenerator2.default.wrap(function signalChangeBatchStatus$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (0, _fsaSaga.takeEvery)(_QUESTION_CHANGE_STATUS_BATCH2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {var questions, statusnew, currentUser, currentUserid, usergroups, countQuestionsToUpdate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, question, waiting, waitresult;return _regenerator2.default.wrap(function _callee6$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:if (!(0, _fsa.isType)(action, _QUESTION_CHANGE_STATUS_BATCH2.default)) {_context11.next = 62;break;}questions = action.payload.items;statusnew = action.payload.batchstatus;_context11.next = 5;return (0, _reduxSaga.select)(_resource3.useridResource.selectors.items);case 5:currentUser = _context11.sent;currentUserid = currentUser.length > 0 ? currentUser[0].id : '';_context11.next = 9;return (0, _reduxSaga.select)(_resource4.usergroupResource.selectors.items);case 9:usergroups = _context11.sent;if (!questions) {_context11.next = 62;break;}countQuestionsToUpdate = questions.length;if (!(countQuestionsToUpdate > 0)) {_context11.next = 62;break;}_context11.prev = 13;_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context11.prev = 17;_iterator = (0, _getIterator3.default)(questions);case 19:if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {_context11.next = 41;break;}question = _step.value;if ((0, _authcheck.statussesallowed)(_authcheck.statusses, question.status, currentUserid, usergroups).includes(statusnew)) {question.status = statusnew.id;}_context11.next = 24;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.UPDATE({ item: question }));case 24:_context11.next = 26;return (0, _effects.race)({ timeout: (0, _effects.call)(_reduxSaga.delay, maxDelayTime), updateend: (0, _effects.take)([_resource2.notesResource.actions.UPDATE_FAILURE, _resource2.notesResource.actions.UPDATE_SUCCESS]) });case 26:waiting = _context11.sent;waitresult = waiting;if (!waitresult.updateend) {_context11.next = 38;break;}if (!(countQuestionsToUpdate > 0)) {_context11.next = 38;break;}_context11.next = 32;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.UPDATE_CONTINUE({ item: question }));case 32:countQuestionsToUpdate--;if (!(countQuestionsToUpdate === 0)) {_context11.next = 38;break;}_context11.next = 36;return (0, _effects.call)(_reduxSaga.delay, minDelayTime);case 36:_context11.next = 38;return (0, _fsaSaga.put)((0, _QUESTION_CHANGE_STATUS_BATCH_COMPLETE2.default)({ items: undefined, batchstatus: undefined, batchchange: false }));case 38:_iteratorNormalCompletion = true;_context11.next = 19;break;case 41:_context11.next = 47;break;case 43:_context11.prev = 43;_context11.t0 = _context11['catch'](17);_didIteratorError = true;_iteratorError = _context11.t0;case 47:_context11.prev = 47;_context11.prev = 48;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 50:_context11.prev = 50;if (!_didIteratorError) {_context11.next = 53;break;}throw _iteratorError;case 53:return _context11.finish(50);case 54:return _context11.finish(47);case 55:_context11.next = 62;break;case 57:_context11.prev = 57;_context11.t1 = _context11['catch'](13);console.log(_context11.t1);_context11.next = 62;return (0, _fsaSaga.put)((0, _QUESTION_CHANGE_STATUS_BATCH_FAILURE2.default)({ items: undefined, batchstatus: undefined, batchchange: true }));case 62:case 'end':return _context11.stop();}}}, _callee6, this, [[13, 57], [17, 43, 47, 55], [48,, 50, 54]]);}));case 2:case 'end':return _context12.stop();}}}, _marked6, this);}function fixNoteDevelopmentJsonServerQuestion(itemQuestion) {return itemQuestion;}function signallistbeheer() {return _regenerator2.default.wrap(function signallistbeheer$(_context14) {while (1) {switch (_context14.prev = _context14.next) {case 0:_context14.next = 2;return (0, _fsaSaga.takeEvery)([_resource.questionsResource.actions.LIST_SUCCESS, _resource.questionsResource.actions.LIST_FAILURE, _resource.questionsResource.actions.CREATE_SUCCESS, _resource.questionsResource.actions.UPDATE_SUCCESS, _resource.questionsResource.actions.DELETE_SUCCESS], /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {return _regenerator2.default.wrap(function _callee7$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:if (!action.payload.item) {_context13.next = 3;break;}_context13.next = 3;return (0, _fsaSaga.put)(_resource.questionsResource.actions.READ({ item: action.payload.item }));case 3:case 'end':return _context13.stop();}}}, _callee7, this);}));case 2:case 'end':return _context14.stop();}}}, _marked7, this);}function monitorSelectedNote() {return _regenerator2.default.wrap(function monitorSelectedNote$(_context16) {while (1) {switch (_context16.prev = _context16.next) {case 0:_context16.next = 2;return (0, _fsaSaga.takeEvery)(_resource2.notesEditor.actions.READ, /*#__PURE__*/_regenerator2.default.mark(function _callee8(action) {var state, questions, current;return _regenerator2.default.wrap(function _callee8$(_context15) {while (1) {switch (_context15.prev = _context15.next) {case 0:state = _launch.hack.store.getState();if (!(!_resource.questionsEditor.selectors.creating(state) && !_resource.questionsEditor.selectors.creating(state))) {_context15.next = 10;break;}if (!action.payload.item.isquestion) {_context15.next = 10;break;}_context15.next = 5;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 5:questions = _context15.sent;current = questions.qWhere(function (x) {return x.noteId === action.payload.item.id;}).qFirst();if (!current) {_context15.next = 10;break;}_context15.next = 10;return (0, _fsaSaga.put)(_resource.questionsEditor.actions.READ({ item: current }));case 10:case 'end':return _context15.stop();}}}, _callee8, this);}));case 2:case 'end':return _context16.stop();}}}, _marked8, this);}function monitorNotesInspectQuestion() {var maxDelayTime;return _regenerator2.default.wrap(function monitorNotesInspectQuestion$(_context18) {while (1) {switch (_context18.prev = _context18.next) {case 0:maxDelayTime = 3000;_context18.next = 3;return (0, _fsaSaga.takeEvery)([_NOTES_INSPECT2.default], /*#__PURE__*/_regenerator2.default.mark(function _callee9(action) {var note, questions, current, question, waiting, waitresult, _questions;return _regenerator2.default.wrap(function _callee9$(_context17) {while (1) {switch (_context17.prev = _context17.next) {case 0:note = action.payload.item;if (!(note && note.isquestion)) {_context17.next = 26;break;}_context17.next = 4;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 4:questions = _context17.sent;current = questions.qWhere(function (x) {return x.noteId === action.payload.item.id;}).qFirst();if (!current) {_context17.next = 11;break;}_context17.next = 9;return (0, _fsaSaga.put)((0, _QUESTION_INSPECT2.default)({ item: current }));case 9:_context17.next = 26;break;case 11:question = { status: 1, noteId: action.payload.item.id, antwoordConcern: '', parentId: undefined, practicionerId: undefined };_context17.next = 14;return (0, _fsaSaga.put)(_resource.questionsResource.actions.CREATE({ item: _resource.questionsResource.create(question) }));case 14:_context17.next = 16;return (0, _effects.race)({ timeout: (0, _effects.call)(_reduxSaga.delay, maxDelayTime), createend: (0, _effects.take)([_resource.questionsResource.actions.CREATE_SUCCESS, _resource2.notesResource.actions.CREATE_FAILURE]) });case 16:waiting = _context17.sent;waitresult = waiting;if (!waitresult.createend) {_context17.next = 26;break;}_context17.next = 21;return (0, _reduxSaga.select)(_resource.questionsResource.selectors.items);case 21:_questions = _context17.sent;current = _questions.qWhere(function (x) {return x.noteId === action.payload.item.id;}).qFirst();if (!current) {_context17.next = 26;break;}_context17.next = 26;return (0, _fsaSaga.put)((0, _QUESTION_INSPECT2.default)({ item: current }));case 26:case 'end':return _context17.stop();}}}, _callee9, this);}));case 3:case 'end':return _context18.stop();}}}, _marked9, this);}function signalquestionsReset() {return _regenerator2.default.wrap(function signalquestionsReset$(_context20) {while (1) {switch (_context20.prev = _context20.next) {case 0:_context20.next = 2;return (
                        (0, _fsaSaga.takeEvery)(_LOGGEDOUT2.default, /*#__PURE__*/_regenerator2.default.mark(function _callee10() {return _regenerator2.default.wrap(function _callee10$(_context19) {while (1) {switch (_context19.prev = _context19.next) {case 0:_context19.next = 2;return (
                                                (0, _fsaSaga.put)(_resource.questionsEditor.actions.RESET({})));case 2:_context19.next = 4;return (
                                                (0, _fsaSaga.put)(_resource.questionsResource.actions.RESET({})));case 4:case 'end':return _context19.stop();}}}, _callee10, this);})));case 2:case 'end':return _context20.stop();}}}, _marked10, this);}

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.RenderApp = undefined;var _regenerator = __webpack_require__(11);var _regenerator2 = _interopRequireDefault(_regenerator);var _promise = __webpack_require__(68);var _promise2 = _interopRequireDefault(_promise);var _asyncToGenerator2 = __webpack_require__(104);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var RenderApp = exports.RenderApp = function () {var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(































    function _callee4(store) {var _this = this;var conditionalCss = function () {var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(










































            function _callee2(target, additional) {var el;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                                el = document.querySelector(target);
                                if (el) {
                                    el.className += ' ' + (0, _style2.default)(target.replace('#', '')) + ' ' + (additional || '');
                                }case 2:case 'end':return _context2.stop();}}}, _callee2, this);}));return function conditionalCss(_x2, _x3) {return _ref4.apply(this, arguments);};}();var conditional = function () {var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(

            function _callee3(name, target, content) {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                                    new _promise2.default(function (resolve, reject) {
                                        var el = document.querySelector(target);
                                        if (el) {
                                            el.className += ' ' + (0, _style2.default)(target.replace('#', ''), 'minireset');
                                            (0, _react.render)(React.createElement(_reactRedux.Provider, { store: store }, content()), el, function () {return resolve();});
                                        } else
                                        {
                                            console.warn('[NoteService] Unable to place ' + name);
                                            resolve();
                                        }
                                    }));case 2:return _context3.abrupt('return', _context3.sent);case 3:case 'end':return _context3.stop();}}}, _callee3, this);}));return function conditional(_x4, _x5, _x6) {return _ref5.apply(this, arguments);};}();var PropTypes, React, NoteApp, NoteBar, NoteUI, isVisible;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 967));case 2:PropTypes = _context4.sent;_context4.next = 5;return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 171));case 5:React = _context4.sent;React.PropTypes = PropTypes;NoteApp = (0, _reactAsyncLoading.asyncComponent)(function () {return __webpack_require__.e/* require.ensure */(1).then((function () {return __webpack_require__(968);}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);});NoteBar = (0, _reactAsyncLoading.asyncComponent)(function () {return __webpack_require__.e/* require.ensure */(3).then((function () {return __webpack_require__(969);}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);});NoteUI = (0, _reactAsyncLoading.asyncComponent)(function () {return __webpack_require__.e/* require.ensure */(2).then((function () {return __webpack_require__(970);}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);});_context4.next = 12;return _promise2.default.all([conditionalCss('#ls-userdata', (0, _style2.default)('loading')), conditionalCss('#ls-userdata-bar'), conditional('Note App', '#ls-userdata-app', function () {return React.createElement(AppVisible, null, React.createElement(NoteApp, null));}), conditional('Note Bar', '#ls-userdata-note', function () {return React.createElement(AppVisible, null, React.createElement(NoteBar, null));}), conditional('Note UI', '#ls-userdata-ui', function () {return React.createElement(AppVisible, null, React.createElement(NoteUI, null));})]).then(function () {store.dispatch((0, _READY2.default)({}));setTimeout((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return conditionalCss('#ls-userdata', (0, _style2.default)('loaded'));case 2:case 'end':return _context.stop();}}}, _callee, _this);})));setTimeout(function () {store.dispatch((0, _SESSION_RESTORED2.default)({}));}, triggerSessionRestoredDelay);}, function (err) {console.error('[NoteService] Failed to load', err);});case 12:isVisible = true;store.subscribe(function () {var state = store.getState();var v = _selectors2.default.visible(state);if (isVisible !== v) {var bar = document.querySelector('#ls-userdata-bar');bar.style.display = v ? null : 'none';isVisible = v;}var note = document.querySelector('#ls-userdata-bar');if (note.style.visibility !== (!state.admin.visible ? null : 'hidden')) note.style.visibility = !state.admin.visible ? null : 'hidden';var note2 = document.querySelector('#ls-userdata-note');if (note2.style.visibility !== (!state.admin.visible ? null : 'hidden')) note2.style.visibility = !state.admin.visible ? null : 'hidden';});case 14:case 'end':return _context4.stop();}}}, _callee4, this);}));return function RenderApp(_x) {return _ref2.apply(this, arguments);};}();exports.RenderOutOfDate = RenderOutOfDate;exports.DefaultPlaceHolder = DefaultPlaceHolder;var _reactAsyncLoading = __webpack_require__(920);var _reactRedux = __webpack_require__(514);var _react = __webpack_require__(648);var _READY = __webpack_require__(512);var _READY2 = _interopRequireDefault(_READY);var _SESSION_RESTORED = __webpack_require__(538);var _SESSION_RESTORED2 = _interopRequireDefault(_SESSION_RESTORED);var _selectors = __webpack_require__(545);var _selectors2 = _interopRequireDefault(_selectors);var _style = __webpack_require__(960);var _style2 = _interopRequireDefault(_style);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var triggerSessionRestoredDelay = 300;function RenderOutOfDate(target) {var OutOfDate = (0, _reactAsyncLoading.asyncComponent)(function () {return __webpack_require__.e/* require.ensure */(4).then((function () {return __webpack_require__(971);}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);});var div = document.createElement('div');div.id = 'ls-userdata--browser-out-of-date';document.body.appendChild(div);(0, _react.render)(_react.React.createElement(OutOfDate, null), div);}var AppVisible = (0, _react.PureConnect)('AppVisible')(function (state) {return { visible: _selectors2.default.visible(state) };}, null, function (_ref) {var visible = _ref.visible,children = _ref.children;return visible ? children : null;});function DefaultPlaceHolder() {if (!document.querySelector('#ls-userdata,#ls-userdata-bar,#ls-userdata-app,#ls-userdata-note,#ls-userdata-askquestion')) {var div = document.createElement('div');div.id = 'ls-userdata';div.setAttribute('role', 'complementary');div.innerHTML = '\n<div id="ls-userdata-app" ></div>\n<ul id="ls-userdata-bar" role="menubar" aria-label="functions">\n  <li id="ls-userdata-note" role="menuitem" aria-label="Notitie gedeelte"></li>\n  <li id="ls-userdata-quicknav" role="menuitem" aria-label="Snelle navigatie"></li>\n</ul>\n<div id="ls-userdata-ui"></div>\n';document.body.appendChild(div);}}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.asyncComponent = undefined;

var _asyncComponent = __webpack_require__(921);

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.asyncComponent = _asyncComponent2.default;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault2(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault2(_create);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault2(_iterator);var _typeof3 = __webpack_require__(25);var _typeof4 = _interopRequireDefault2(_typeof3);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault2(_symbol);function _interopRequireDefault2(obj) {return obj && obj.__esModule ? obj : { default: obj };}

exports.__esModule = true;

var _typeof = typeof _symbol2.default === "function" && (0, _typeof4.default)(_iterator2.default) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);} : function (obj) {return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeof4.default)(obj);};

var _react = __webpack_require__(171);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof4.default)(call)) === "object" || typeof call === "function") ? call : self;}

function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof4.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}

var errorLoading = function errorLoading(err) {
  return console.error('asyncComponent: Loading failed', err);
};
var isFunction = function isFunction(func) {
  return Object.prototype.toString.call(func) === '[object Function]';
};
var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

exports.default = function (loader) {
  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var placeholder = _ref.placeholder;

  var asyncComponent = function (_Component) {
    _inherits(asyncComponent, _Component);

    function asyncComponent() {
      _classCallCheck(this, asyncComponent);

      var _this = _possibleConstructorReturn(this, _Component.call(this));

      _this.state = {
        component: null };

      _this.mounting = true;
      return _this;
    }

    asyncComponent.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (!isFunction(loader)) {
        return console.error('asyncComponent: Loader is not function');
      }

      var component = loader();

      if (!isPromise(component)) {
        return console.error('asyncComponent: Loader doesn\'t return a promise');
      }

      component.then(function (module) {
        return _this2.mounting && _this2.setState({ component: module.default || module });
      }).catch(errorLoading);
    };

    asyncComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.mounting = false;
    };

    asyncComponent.prototype.render = function render() {
      if (this.state.component) {
        return _react2.default.createElement(this.state.component, this.props);
      }

      return placeholder || null;
    };

    return asyncComponent;
  }(_react.Component);

  return asyncComponent;
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var k = __webpack_require__(640),n = "function" === typeof _symbol2.default && _for2.default,p = n ? (0, _for2.default)("react.element") : 60103,q = n ? (0, _for2.default)("react.portal") : 60106,r = n ? (0, _for2.default)("react.fragment") : 60107,t = n ? (0, _for2.default)("react.strict_mode") : 60108,u = n ? (0, _for2.default)("react.profiler") : 60114,v = n ? (0, _for2.default)("react.provider") : 60109,w = n ? (0, _for2.default)("react.context") : 60110,x = n ? (0, _for2.default)("react.concurrent_mode") : 60111,y = n ? (0, _for2.default)("react.forward_ref") : 60112,z = n ? (0, _for2.default)("react.suspense") : 60113,aa = n ? (0, _for2.default)("react.memo") :
60115,ba = n ? (0, _for2.default)("react.lazy") : 60116,A = "function" === typeof _symbol2.default && _iterator2.default;function ca(a, b, d, c, e, g, h, f) {if (!a) {a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var l = [d, c, e, g, h, f],m = 0;a = Error(b.replace(/%s/g, function () {return l[m++];}));a.name = "Invariant Violation";}a.framesToPop = 1;throw a;}}
function B(a) {for (var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {d += "&args[]=" + encodeURIComponent(arguments[c + 1]);}ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);}var C = { isMounted: function isMounted() {return !1;}, enqueueForceUpdate: function enqueueForceUpdate() {}, enqueueReplaceState: function enqueueReplaceState() {}, enqueueSetState: function enqueueSetState() {} },D = {};
function E(a, b, d) {this.props = a;this.context = b;this.refs = D;this.updater = d || C;}E.prototype.isReactComponent = {};E.prototype.setState = function (a, b) {"object" !== (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) && "function" !== typeof a && null != a ? B("85") : void 0;this.updater.enqueueSetState(this, a, b, "setState");};E.prototype.forceUpdate = function (a) {this.updater.enqueueForceUpdate(this, a, "forceUpdate");};function F() {}F.prototype = E.prototype;function G(a, b, d) {this.props = a;this.context = b;this.refs = D;this.updater = d || C;}var H = G.prototype = new F();
H.constructor = G;k(H, E.prototype);H.isPureReactComponent = !0;var I = { current: null },J = { current: null },K = Object.prototype.hasOwnProperty,L = { key: !0, ref: !0, __self: !0, __source: !0 };
function M(a, b, d) {var c = void 0,e = {},g = null,h = null;if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) {K.call(b, c) && !L.hasOwnProperty(c) && (e[c] = b[c]);}var f = arguments.length - 2;if (1 === f) e.children = d;else if (1 < f) {for (var l = Array(f), m = 0; m < f; m++) {l[m] = arguments[m + 2];}e.children = l;}if (a && a.defaultProps) for (c in f = a.defaultProps, f) {void 0 === e[c] && (e[c] = f[c]);}return { $$typeof: p, type: a, key: g, ref: h, props: e, _owner: J.current };}
function da(a, b) {return { $$typeof: p, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };}function N(a) {return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) && null !== a && a.$$typeof === p;}function escape(a) {var b = { "=": "=0", ":": "=2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {return b[a];});}var O = /\/+/g,P = [];function Q(a, b, d, c) {if (P.length) {var e = P.pop();e.result = a;e.keyPrefix = b;e.func = d;e.context = c;e.count = 0;return e;}return { result: a, keyPrefix: b, func: d, context: c, count: 0 };}
function R(a) {a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > P.length && P.push(a);}
function S(a, b, d, c) {var e = typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a);if ("undefined" === e || "boolean" === e) a = null;var g = !1;if (null === a) g = !0;else switch (e) {case "string":case "number":g = !0;break;case "object":switch (a.$$typeof) {case p:case q:g = !0;}}if (g) return d(c, a, "" === b ? "." + T(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {e = a[h];var f = b + T(e, h);g += S(e, f, d, c);} else if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) ? f = null : (f = A && a[A] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h =
  0; !(e = a.next()).done;) {e = e.value, f = b + T(e, h++), g += S(e, f, d, c);} else "object" === e && (d = "" + a, B("31", "[object Object]" === d ? "object with keys {" + (0, _keys2.default)(a).join(", ") + "}" : d, ""));return g;}function U(a, b, d) {return null == a ? 0 : S(a, "", b, d);}function T(a, b) {return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) && null !== a && null != a.key ? escape(a.key) : b.toString(36);}function ea(a, b) {a.func.call(a.context, b, a.count++);}
function fa(a, b, d) {var c = a.result,e = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? V(a, c, d, function (a) {return a;}) : null != a && (N(a) && (a = da(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(O, "$&/") + "/") + d)), c.push(a));}function V(a, b, d, c, e) {var g = "";null != d && (g = ("" + d).replace(O, "$&/") + "/");b = Q(b, g, c, e);U(a, fa, b);R(b);}function W() {var a = I.current;null === a ? B("307") : void 0;return a;}
var X = { Children: { map: function map(a, b, d) {if (null == a) return a;var c = [];V(a, c, null, b, d);return c;}, forEach: function forEach(a, b, d) {if (null == a) return a;b = Q(null, null, b, d);U(a, ea, b);R(b);}, count: function count(a) {return U(a, function () {return null;}, null);}, toArray: function toArray(a) {var b = [];V(a, b, null, function (a) {return a;});return b;}, only: function only(a) {N(a) ? void 0 : B("143");return a;} }, createRef: function createRef() {return { current: null };}, Component: E, PureComponent: G, createContext: function createContext(a, b) {void 0 === b && (b = null);a = { $$typeof: w, _calculateChangedBits: b,
      _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null };a.Provider = { $$typeof: v, _context: a };return a.Consumer = a;}, forwardRef: function forwardRef(a) {return { $$typeof: y, render: a };}, lazy: function lazy(a) {return { $$typeof: ba, _ctor: a, _status: -1, _result: null };}, memo: function memo(a, b) {return { $$typeof: aa, type: a, compare: void 0 === b ? null : b };}, useCallback: function useCallback(a, b) {return W().useCallback(a, b);}, useContext: function useContext(a, b) {return W().useContext(a, b);}, useEffect: function useEffect(a, b) {return W().useEffect(a, b);}, useImperativeHandle: function useImperativeHandle(a,
  b, d) {return W().useImperativeHandle(a, b, d);}, useDebugValue: function useDebugValue() {}, useLayoutEffect: function useLayoutEffect(a, b) {return W().useLayoutEffect(a, b);}, useMemo: function useMemo(a, b) {return W().useMemo(a, b);}, useReducer: function useReducer(a, b, d) {return W().useReducer(a, b, d);}, useRef: function useRef(a) {return W().useRef(a);}, useState: function useState(a) {return W().useState(a);}, Fragment: r, StrictMode: t, Suspense: z, createElement: M, cloneElement: function cloneElement(a, b, d) {null === a || void 0 === a ? B("267", a) : void 0;var c = void 0,e = k({}, a.props),g = a.key,h = a.ref,f = a._owner;if (null !=
    b) {void 0 !== b.ref && (h = b.ref, f = J.current);void 0 !== b.key && (g = "" + b.key);var l = void 0;a.type && a.type.defaultProps && (l = a.type.defaultProps);for (c in b) {K.call(b, c) && !L.hasOwnProperty(c) && (e[c] = void 0 === b[c] && void 0 !== l ? l[c] : b[c]);}}c = arguments.length - 2;if (1 === c) e.children = d;else if (1 < c) {l = Array(c);for (var m = 0; m < c; m++) {l[m] = arguments[m + 2];}e.children = l;}return { $$typeof: p, type: a.type, key: g, ref: h, props: e, _owner: f };}, createFactory: function createFactory(a) {var b = M.bind(null, a);b.type = a;return b;}, isValidElement: N, version: "16.8.1",
  unstable_ConcurrentMode: x, unstable_Profiler: u, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentDispatcher: I, ReactCurrentOwner: J, assign: k } },Y = { default: X },Z = Y && X || Y;module.exports = Z.default || Z;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(227);
module.exports = __webpack_require__(13).Symbol['for'];


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _setPrototypeOf = __webpack_require__(493);var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);var _create = __webpack_require__(222);var _create2 = _interopRequireDefault(_create);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);exports.




















createProvider = createProvider;var _react = __webpack_require__(171);var _propTypes = __webpack_require__(641);var _propTypes2 = _interopRequireDefault(_propTypes);var _PropTypes = __webpack_require__(642);var _warning = __webpack_require__(541);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));}subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;}var didWarnAboutReceivingStore = false;function warnAboutReceivingStore() {if (didWarnAboutReceivingStore) {return;}didWarnAboutReceivingStore = true;(0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');}function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return _react.Children.only(this.props.children);
    };

    return Provider;
  }(_react.Component);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: _PropTypes.storeShape.isRequired,
    children: _propTypes2.default.element.isRequired };

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}exports.default =

createProvider();

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(926);
var invariant = __webpack_require__(927);
var ReactPropTypesSecret = __webpack_require__(928);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
    false,
    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
    'Use PropTypes.checkPropTypes() to call them. ' +
    'Read more at http://fb.me/use-check-prop-types');

  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim };


  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               * 
               */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var _getOwnPropertyNames = __webpack_require__(497);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true };


var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true };


var isGetOwnPropertySymbolsAvailable = typeof _getOwnPropertySymbols2.default === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') {// don't hoist over string (html) components
        var keys = (0, _getOwnPropertyNames2.default)(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat((0, _getOwnPropertySymbols2.default)(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
      'Minified exception occurred; use the non-minified dev environment ' +
      'for the full error message and additional helpful warnings.');

    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
      format.replace(/%s/g, function () {return args[argIndex++];}));

      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {} };


function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    } };

}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();exports.

default = Subscription;module.exports = exports["default"];

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.












































createConnect = createConnect;var _connectAdvanced = __webpack_require__(643);var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);var _shallowEqual = __webpack_require__(933);var _shallowEqual2 = _interopRequireDefault(_shallowEqual);var _mapDispatchToProps = __webpack_require__(934);var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);var _mapStateToProps = __webpack_require__(944);var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);var _mergeProps = __webpack_require__(945);var _mergeProps2 = _interopRequireDefault(_mergeProps);var _selectorFactory = __webpack_require__(946);var _selectorFactory2 = _interopRequireDefault(_selectorFactory);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;} /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         connect is a facade over connectAdvanced. It turns its args into a compatible
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         selectorFactory, which has the signature:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         connect passes its args to connectAdvanced as options, which will in turn pass them to
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         selectorFactory each time a Connect component instance is instantiated or hot reloaded.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         selectorFactory returns a final props selector from its mapStateToProps,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         mergePropsFactories, and pure args.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         The resulting final props selector is called by the Connect component instance whenever
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         it receives new props or store state.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */function match(arg, factories, name) {for (var i = factories.length - 1; i >= 0; i--) {var result = factories[i](arg);if (result) return result;}return function (dispatch, options) {throw new Error('Invalid value of type ' + (typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg)) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');};}function strictEqual(a, b) {return a === b;} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref$connectHOC = _ref.connectHOC,connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,_ref$mapStateToPropsF = _ref.mapStateToPropsFactories,mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,_ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,_ref$mergePropsFactor = _ref.mergePropsFactories,mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,_ref$selectorFactory = _ref.selectorFactory,selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},_ref2$pure = _ref2.pure,pure = _ref2$pure === undefined ? true : _ref2$pure,_ref2$areStatesEqual = _ref2.areStatesEqual,
    areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
    _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
    areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
    _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
    areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
    _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
    areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
    extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual },

    extraOptions));
  };
}exports.default =

createConnect();

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);exports.default =









shallowEqual;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var hasOwn = Object.prototype.hasOwnProperty;function is(x, y) {if (x === y) {return x !== 0 || y !== 0 || 1 / x === 1 / y;} else {return x !== x && y !== y;}}function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : (0, _typeof3.default)(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : (0, _typeof3.default)(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = (0, _keys2.default)(objA);
  var keysB = (0, _keys2.default)(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}module.exports = exports['default'];

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);exports.


whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;exports.



whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;exports.





whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;var _redux = __webpack_require__(575);var _wrapMapToProps = __webpack_require__(644);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;}function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {return { dispatch: dispatch };}) : undefined;}function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && (typeof mapDispatchToProps === 'undefined' ? 'undefined' : (0, _typeof3.default)(mapDispatchToProps)) === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
  }) : undefined;
}exports.default =

[whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _baseGetTag = __webpack_require__(936);var _baseGetTag2 = _interopRequireDefault(_baseGetTag);
var _getPrototype = __webpack_require__(941);var _getPrototype2 = _interopRequireDefault(_getPrototype);
var _isObjectLike = __webpack_require__(943);var _isObjectLike2 = _interopRequireDefault(_isObjectLike);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
                                                   * Checks if `value` is a plain object, that is, an object created by the
                                                   * `Object` constructor or one with a `[[Prototype]]` of `null`.
                                                   *
                                                   * @static
                                                   * @memberOf _
                                                   * @since 0.8.0
                                                   * @category Lang
                                                   * @param {*} value The value to check.
                                                   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                                                   * @example
                                                   *
                                                   * function Foo() {
                                                   *   this.a = 1;
                                                   * }
                                                   *
                                                   * _.isPlainObject(new Foo);
                                                   * // => false
                                                   *
                                                   * _.isPlainObject([1, 2, 3]);
                                                   * // => false
                                                   *
                                                   * _.isPlainObject({ 'x': 0, 'y': 0 });
                                                   * // => true
                                                   *
                                                   * _.isPlainObject(Object.create(null));
                                                   * // => true
                                                   */
function isPlainObject(value) {
  if (!(0, _isObjectLike2.default)(value) || (0, _baseGetTag2.default)(value) != objectTag) {
    return false;
  }
  var proto = (0, _getPrototype2.default)(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
  funcToString.call(Ctor) == objectCtorString;
}exports.default =

isPlainObject;module.exports = exports['default'];

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _Symbol2 = __webpack_require__(646);var _Symbol3 = _interopRequireDefault(_Symbol2);
var _getRawTag = __webpack_require__(939);var _getRawTag2 = _interopRequireDefault(_getRawTag);
var _objectToString = __webpack_require__(940);var _objectToString2 = _interopRequireDefault(_objectToString);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
                                                                                   * The base implementation of `getTag` without fallbacks for buggy environments.
                                                                                   *
                                                                                   * @private
                                                                                   * @param {*} value The value to query.
                                                                                   * @returns {string} Returns the `toStringTag`.
                                                                                   */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ?
  (0, _getRawTag2.default)(value) :
  (0, _objectToString2.default)(value);
}exports.default =

baseGetTag;module.exports = exports['default'];

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);var _freeGlobal = __webpack_require__(938);var _freeGlobal2 = _interopRequireDefault(_freeGlobal);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : (0, _typeof3.default)(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal2.default || freeSelf || Function('return this')();exports.default =

root;module.exports = exports['default'];

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) == 'object' && global && global.Object === Object && global;exports.default =

freeGlobal;module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _Symbol2 = __webpack_require__(646);var _Symbol3 = _interopRequireDefault(_Symbol2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
                                                  * Used to resolve the
                                                  * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                                                  * of values.
                                                  */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
                                                                                   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                                                                                   *
                                                                                   * @private
                                                                                   * @param {*} value The value to query.
                                                                                   * @returns {string} Returns the raw `toStringTag`.
                                                                                   */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
  tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}exports.default =

getRawTag;module.exports = exports['default'];

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true }); /** Used for built-in method references. */
var objectProto = Object.prototype;

/**
                                     * Used to resolve the
                                     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                                     * of values.
                                     */
var nativeObjectToString = objectProto.toString;

/**
                                                  * Converts `value` to a string using `Object.prototype.toString`.
                                                  *
                                                  * @private
                                                  * @param {*} value The value to convert.
                                                  * @returns {string} Returns the converted string.
                                                  */
function objectToString(value) {
  return nativeObjectToString.call(value);
}exports.default =

objectToString;module.exports = exports["default"];

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _overArg = __webpack_require__(942);var _overArg2 = _interopRequireDefault(_overArg);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/** Built-in value references. */
var getPrototype = (0, _overArg2.default)(_getPrototypeOf2.default, Object);exports.default =

getPrototype;module.exports = exports['default'];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                             * Creates a unary function that invokes `func` with its argument transformed.
                                                                             *
                                                                             * @private
                                                                             * @param {Function} func The function to wrap.
                                                                             * @param {Function} transform The argument transform.
                                                                             * @returns {Function} Returns the new function.
                                                                             */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}exports.default =

overArg;module.exports = exports["default"];

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                                                                 * Checks if `value` is object-like. A value is object-like if it's not `null`
                                                                                                                                                                                                                                                                                 * and has a `typeof` result of "object".
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * @static
                                                                                                                                                                                                                                                                                 * @memberOf _
                                                                                                                                                                                                                                                                                 * @since 4.0.0
                                                                                                                                                                                                                                                                                 * @category Lang
                                                                                                                                                                                                                                                                                 * @param {*} value The value to check.
                                                                                                                                                                                                                                                                                 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                                                                                                                                                                                                                                                                                 * @example
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike({});
                                                                                                                                                                                                                                                                                 * // => true
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike([1, 2, 3]);
                                                                                                                                                                                                                                                                                 * // => true
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike(_.noop);
                                                                                                                                                                                                                                                                                 * // => false
                                                                                                                                                                                                                                                                                 *
                                                                                                                                                                                                                                                                                 * _.isObjectLike(null);
                                                                                                                                                                                                                                                                                 * // => false
                                                                                                                                                                                                                                                                                 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object';
}exports.default =

isObjectLike;module.exports = exports['default'];

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.

whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;exports.



whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;var _wrapMapToProps = __webpack_require__(644);function whenMapStateToPropsIsFunction(mapStateToProps) {return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;}function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
    return {};
  }) : undefined;
}exports.default =

[whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);exports.



defaultMergeProps = defaultMergeProps;exports.



wrapMergePropsFunc = wrapMergePropsFunc;exports.

























whenMergePropsIsFunction = whenMergePropsIsFunction;exports.



whenMergePropsIsOmitted = whenMergePropsIsOmitted;var _verifyPlainObject = __webpack_require__(645);var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _extends = _assign2.default || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};function defaultMergeProps(stateProps, dispatchProps, ownProps) {return _extends({}, ownProps, stateProps, dispatchProps);}function wrapMergePropsFunc(mergeProps) {return function initMergePropsProxy(dispatch, _ref) {var displayName = _ref.displayName,pure = _ref.pure,areMergedPropsEqual = _ref.areMergedPropsEqual;var hasRunOnce = false;var mergedProps = void 0;return function mergePropsProxy(stateProps, dispatchProps, ownProps) {var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);if (hasRunOnce) {if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;} else {hasRunOnce = true;mergedProps = nextMergedProps;if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');}return mergedProps;};};}function whenMergePropsIsFunction(mergeProps) {return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;}function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}exports.default =

[whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.



impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;exports.





pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;exports.default =









































































finalPropsSelectorFactory;var _verifySubselectors = __webpack_require__(947);var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {return function impureFinalPropsSelector(state, ownProps) {return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);};}function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {var areStatesEqual = _ref.areStatesEqual,areOwnPropsEqual = _ref.areOwnPropsEqual,areStatePropsEqual = _ref.areStatePropsEqual;var hasRunAtLeastOnce = false;var state = void 0;var ownProps = void 0;var stateProps = void 0;var dispatchProps = void 0;var mergedProps = void 0;function handleFirstCall(firstState, firstOwnProps) {state = firstState;ownProps = firstOwnProps;stateProps = mapStateToProps(state, ownProps);dispatchProps = mapDispatchToProps(dispatch, ownProps);mergedProps = mergeProps(stateProps, dispatchProps, ownProps);hasRunAtLeastOnce = true;return mergedProps;}function handleNewPropsAndNewState() {stateProps = mapStateToProps(state, ownProps);if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);mergedProps = mergeProps(stateProps, dispatchProps, ownProps);return mergedProps;}function handleNewProps() {if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);mergedProps = mergeProps(stateProps, dispatchProps, ownProps);return mergedProps;}function handleNewState() {var nextStateProps = mapStateToProps(state, ownProps);var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);stateProps = nextStateProps;if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);return mergedProps;}function handleSubsequentCalls(nextState, nextOwnProps) {var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);var stateChanged = !areStatesEqual(nextState, state);state = nextState;ownProps = nextOwnProps;if (propsChanged && stateChanged) return handleNewPropsAndNewState();if (propsChanged) return handleNewProps();if (stateChanged) return handleNewState();return mergedProps;}return function pureFinalPropsSelector(nextState, nextOwnProps) {return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);};} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.
function finalPropsSelectorFactory(dispatch, _ref2) {var initMapStateToProps = _ref2.initMapStateToProps,initMapDispatchToProps = _ref2.initMapDispatchToProps,initMergeProps = _ref2.initMergeProps,options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =











verifySubselectors;var _warning = __webpack_require__(541);var _warning2 = _interopRequireDefault(_warning);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function verify(selector, methodName, displayName) {if (!selector) {throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');} else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {if (!selector.hasOwnProperty('dependsOnOwnProps')) {(0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');}}}function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
     Modernizr 3.0.0pre (Custom Build) | MIT
    */
var _stringify = __webpack_require__(247);var _stringify2 = _interopRequireDefault(_stringify);var _map = __webpack_require__(659);var _map2 = _interopRequireDefault(_map);var _set = __webpack_require__(565);var _set2 = _interopRequireDefault(_set);var _keys = __webpack_require__(85);var _keys2 = _interopRequireDefault(_keys);var _iterator = __webpack_require__(79);var _iterator2 = _interopRequireDefault(_iterator);var _for = __webpack_require__(520);var _for2 = _interopRequireDefault(_for);var _symbol = __webpack_require__(69);var _symbol2 = _interopRequireDefault(_symbol);var _defineProperty = __webpack_require__(161);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _getOwnPropertyDescriptor = __webpack_require__(652);var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var aa = __webpack_require__(171),n = __webpack_require__(640),ba = __webpack_require__(954);function ca(a, b, c, d, e, f, g, h) {if (!a) {a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var k = [c, d, e, f, g, h],l = 0;a = Error(b.replace(/%s/g, function () {return k[l++];}));a.name = "Invariant Violation";}a.framesToPop = 1;throw a;}}
function t(a) {for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {c += "&args[]=" + encodeURIComponent(arguments[d + 1]);}ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);}aa ? void 0 : t("227");function da(a, b, c, d, e, f, g, h, k) {var l = Array.prototype.slice.call(arguments, 3);try {b.apply(c, l);} catch (m) {this.onError(m);}}
var ea = !1,fa = null,ha = !1,ia = null,ja = { onError: function onError(a) {ea = !0;fa = a;} };function ka(a, b, c, d, e, f, g, h, k) {ea = !1;fa = null;da.apply(ja, arguments);}function la(a, b, c, d, e, f, g, h, k) {ka.apply(this, arguments);if (ea) {if (ea) {var l = fa;ea = !1;fa = null;} else t("198"), l = void 0;ha || (ha = !0, ia = l);}}var ma = null,na = {};
function oa() {if (ma) for (var a in na) {var b = na[a],c = ma.indexOf(a);-1 < c ? void 0 : t("96", a);if (!pa[c]) {b.extractEvents ? void 0 : t("97", a);pa[c] = b;c = b.eventTypes;for (var d in c) {var e = void 0;var f = c[d],g = b,h = d;qa.hasOwnProperty(h) ? t("99", h) : void 0;qa[h] = f;var k = f.phasedRegistrationNames;if (k) {for (e in k) {k.hasOwnProperty(e) && ra(k[e], g, h);}e = !0;} else f.registrationName ? (ra(f.registrationName, g, h), e = !0) : e = !1;e ? void 0 : t("98", d, a);}}}}
function ra(a, b, c) {sa[a] ? t("100", a) : void 0;sa[a] = b;ta[a] = b.eventTypes[c].dependencies;}var pa = [],qa = {},sa = {},ta = {},ua = null,va = null,wa = null;function xa(a, b, c) {var d = a.type || "unknown-event";a.currentTarget = wa(c);la(d, b, void 0, a);a.currentTarget = null;}function ya(a, b) {null == b ? t("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;}return Array.isArray(b) ? [a].concat(b) : [a, b];}
function za(a, b, c) {Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);}var Aa = null;function Ba(a) {if (a) {var b = a._dispatchListeners,c = a._dispatchInstances;if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) {xa(a, b[d], c[d]);} else b && xa(a, b, c);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);}}
var Ca = { injectEventPluginOrder: function injectEventPluginOrder(a) {ma ? t("101") : void 0;ma = Array.prototype.slice.call(a);oa();}, injectEventPluginsByName: function injectEventPluginsByName(a) {var b = !1,c;for (c in a) {if (a.hasOwnProperty(c)) {var d = a[c];na.hasOwnProperty(c) && na[c] === d || (na[c] ? t("102", c) : void 0, na[c] = d, b = !0);}}b && oa();} };
function Da(a, b) {var c = a.stateNode;if (!c) return null;var d = ua(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:a = !1;}if (a) return null;c && "function" !== typeof c ? t("231", b, typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c)) : void 0;
  return c;}function Ea(a) {null !== a && (Aa = ya(Aa, a));a = Aa;Aa = null;if (a && (za(a, Ba), Aa ? t("95") : void 0, ha)) throw a = ia, ha = !1, ia = null, a;}var Fa = Math.random().toString(36).slice(2),Ga = "__reactInternalInstance$" + Fa,Ha = "__reactEventHandlers$" + Fa;function Ia(a) {if (a[Ga]) return a[Ga];for (; !a[Ga];) {if (a.parentNode) a = a.parentNode;else return null;}a = a[Ga];return 5 === a.tag || 6 === a.tag ? a : null;}function Ja(a) {a = a[Ga];return !a || 5 !== a.tag && 6 !== a.tag ? null : a;}
function Ka(a) {if (5 === a.tag || 6 === a.tag) return a.stateNode;t("33");}function La(a) {return a[Ha] || null;}function Ma(a) {do {a = a.return;} while (a && 5 !== a.tag);return a ? a : null;}function Na(a, b, c) {if (b = Da(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a);}
function Oa(a) {if (a && a.dispatchConfig.phasedRegistrationNames) {for (var b = a._targetInst, c = []; b;) {c.push(b), b = Ma(b);}for (b = c.length; 0 < b--;) {Na(c[b], "captured", a);}for (b = 0; b < c.length; b++) {Na(c[b], "bubbled", a);}}}function Pa(a, b, c) {a && c && c.dispatchConfig.registrationName && (b = Da(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a));}function Qa(a) {a && a.dispatchConfig.registrationName && Pa(a._targetInst, null, a);}
function Ra(a) {za(a, Oa);}var Sa = !("undefined" === typeof window || !window.document || !window.document.createElement);function Ta(a, b) {var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;return c;}var Ua = { animationend: Ta("Animation", "AnimationEnd"), animationiteration: Ta("Animation", "AnimationIteration"), animationstart: Ta("Animation", "AnimationStart"), transitionend: Ta("Transition", "TransitionEnd") },Va = {},Wa = {};
Sa && (Wa = document.createElement("div").style, "AnimationEvent" in window || (delete Ua.animationend.animation, delete Ua.animationiteration.animation, delete Ua.animationstart.animation), "TransitionEvent" in window || delete Ua.transitionend.transition);function Xa(a) {if (Va[a]) return Va[a];if (!Ua[a]) return a;var b = Ua[a],c;for (c in b) {if (b.hasOwnProperty(c) && c in Wa) return Va[a] = b[c];}return a;}
var Ya = Xa("animationend"),Za = Xa("animationiteration"),$a = Xa("animationstart"),ab = Xa("transitionend"),bb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb = null,eb = null,fb = null;
function gb() {if (fb) return fb;var a,b = eb,c = b.length,d,e = "value" in cb ? cb.value : cb.textContent,f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var g = c - a;for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {}return fb = e.slice(a, 1 < d ? 1 - d : void 0);}function hb() {return !0;}function ib() {return !1;}
function A(a, b, c, d) {this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);}this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? hb : ib;this.isPropagationStopped = ib;return this;}
n(A.prototype, { preventDefault: function preventDefault() {this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = hb);}, stopPropagation: function stopPropagation() {var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = hb);}, persist: function persist() {this.isPersistent = hb;}, isPersistent: ib, destructor: function destructor() {var a = this.constructor.Interface,
    b;for (b in a) {this[b] = null;}this.nativeEvent = this._targetInst = this.dispatchConfig = null;this.isPropagationStopped = this.isDefaultPrevented = ib;this._dispatchInstances = this._dispatchListeners = null;} });A.Interface = { type: null, target: null, currentTarget: function currentTarget() {return null;}, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {return a.timeStamp || Date.now();}, defaultPrevented: null, isTrusted: null };
A.extend = function (a) {function b() {}function c() {return d.apply(this, arguments);}var d = this;b.prototype = d.prototype;var e = new b();n(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = n({}, d.Interface, a);c.extend = d.extend;jb(c);return c;};jb(A);function kb(a, b, c, d) {if (this.eventPool.length) {var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;}return new this(a, b, c, d);}function lb(a) {a instanceof this ? void 0 : t("279");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);}
function jb(a) {a.eventPool = [];a.getPooled = kb;a.release = lb;}var mb = A.extend({ data: null }),nb = A.extend({ data: null }),ob = [9, 13, 27, 32],pb = Sa && "CompositionEvent" in window,qb = null;Sa && "documentMode" in document && (qb = document.documentMode);
var rb = Sa && "TextEvent" in window && !qb,sb = Sa && (!pb || qb && 8 < qb && 11 >= qb),tb = String.fromCharCode(32),ub = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } },vb = !1;
function wb(a, b) {switch (a) {case "keyup":return -1 !== ob.indexOf(b.keyCode);case "keydown":return 229 !== b.keyCode;case "keypress":case "mousedown":case "blur":return !0;default:return !1;}}function xb(a) {a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) && "data" in a ? a.data : null;}var yb = !1;function zb(a, b) {switch (a) {case "compositionend":return xb(b);case "keypress":if (32 !== b.which) return null;vb = !0;return tb;case "textInput":return a = b.data, a === tb && vb ? null : a;default:return null;}}
function Ab(a, b) {if (yb) return "compositionend" === a || !pb && wb(a, b) ? (a = gb(), fb = eb = cb = null, yb = !1, a) : null;switch (a) {case "paste":return null;case "keypress":if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);}return null;case "compositionend":return sb && "ko" !== b.locale ? null : b.data;default:return null;}}
var Bb = { eventTypes: ub, extractEvents: function extractEvents(a, b, c, d) {var e = void 0;var f = void 0;if (pb) b: {switch (a) {case "compositionstart":e = ub.compositionStart;break b;case "compositionend":e = ub.compositionEnd;break b;case "compositionupdate":e = ub.compositionUpdate;break b;}e = void 0;} else yb ? wb(a, c) && (e = ub.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = ub.compositionStart);e ? (sb && "ko" !== c.locale && (yb || e !== ub.compositionStart ? e === ub.compositionEnd && yb && (f = gb()) : (cb = d, eb = "value" in cb ? cb.value : cb.textContent, yb =
    !0)), e = mb.getPooled(e, b, c, d), f ? e.data = f : (f = xb(c), null !== f && (e.data = f)), Ra(e), f = e) : f = null;(a = rb ? zb(a, c) : Ab(a, c)) ? (b = nb.getPooled(ub.beforeInput, b, c, d), b.data = a, Ra(b)) : b = null;return null === f ? b : null === b ? f : [f, b];} },Cb = null,Db = null,Eb = null;function Hb(a) {if (a = va(a)) {"function" !== typeof Cb ? t("280") : void 0;var b = ua(a.stateNode);Cb(a.stateNode, a.type, b);}}function Ib(a) {Db ? Eb ? Eb.push(a) : Eb = [a] : Db = a;}function Jb() {if (Db) {var a = Db,b = Eb;Eb = Db = null;Hb(a);if (b) for (a = 0; a < b.length; a++) {Hb(b[a]);}}}
function Kb(a, b) {return a(b);}function Lb(a, b, c) {return a(b, c);}function Mb() {}var Nb = !1;function Ob(a, b) {if (Nb) return a(b);Nb = !0;try {return Kb(a, b);} finally {if (Nb = !1, null !== Db || null !== Eb) Mb(), Jb();}}var Pb = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function Qb(a) {var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!Pb[a.type] : "textarea" === b ? !0 : !1;}
function Rb(a) {a = a.target || a.srcElement || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;}function Sb(a) {if (!Sa) return !1;a = "on" + a;var b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;}function Tb(a) {var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);}
function Ub(a) {var b = Tb(a) ? "checked" : "value",c = (0, _getOwnPropertyDescriptor2.default)(a.constructor.prototype, b),d = "" + a[b];if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {var e = c.get,f = c.set;(0, _defineProperty2.default)(a, b, { configurable: !0, get: function get() {return e.call(this);}, set: function set(a) {d = "" + a;f.call(this, a);} });(0, _defineProperty2.default)(a, b, { enumerable: c.enumerable });return { getValue: function getValue() {return d;}, setValue: function setValue(a) {d = "" + a;}, stopTracking: function stopTracking() {a._valueTracker =
        null;delete a[b];} };}}function Vb(a) {a._valueTracker || (a._valueTracker = Ub(a));}function Wb(a) {if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = Tb(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;}
var Xb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb = /^(.*)[\\\/]/,D = "function" === typeof _symbol2.default && _for2.default,Zb = D ? (0, _for2.default)("react.element") : 60103,$b = D ? (0, _for2.default)("react.portal") : 60106,ac = D ? (0, _for2.default)("react.fragment") : 60107,bc = D ? (0, _for2.default)("react.strict_mode") : 60108,cc = D ? (0, _for2.default)("react.profiler") : 60114,dc = D ? (0, _for2.default)("react.provider") : 60109,ec = D ? (0, _for2.default)("react.context") : 60110,fc = D ? (0, _for2.default)("react.concurrent_mode") : 60111,gc = D ? (0, _for2.default)("react.forward_ref") : 60112,hc = D ? (0, _for2.default)("react.suspense") :
60113,ic = D ? (0, _for2.default)("react.memo") : 60115,jc = D ? (0, _for2.default)("react.lazy") : 60116,kc = "function" === typeof _symbol2.default && _iterator2.default;function lc(a) {if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) return null;a = kc && a[kc] || a["@@iterator"];return "function" === typeof a ? a : null;}
function mc(a) {if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case fc:return "ConcurrentMode";case ac:return "Fragment";case $b:return "Portal";case cc:return "Profiler";case bc:return "StrictMode";case hc:return "Suspense";}if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) switch (a.$$typeof) {case ec:return "Context.Consumer";case dc:return "Context.Provider";case gc:var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b +
      ")" : "ForwardRef");case ic:return mc(a.type);case jc:if (a = 1 === a._status ? a._result : null) return mc(a);}return null;}function nc(a) {var b = "";do {a: switch (a.tag) {case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c = a._debugOwner,d = a._debugSource,e = mc(a.type);var f = null;c && (f = mc(c.type));c = e;e = "";d ? e = " (at " + d.fileName.replace(Yb, "") + ":" + d.lineNumber + ")" : f && (e = " (created by " + f + ")");f = "\n    in " + (c || "Unknown") + e;break a;default:f = "";}b += f;a = a.return;} while (a);return b;}
var oc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc = Object.prototype.hasOwnProperty,qc = {},rc = {};
function sc(a) {if (pc.call(rc, a)) return !0;if (pc.call(qc, a)) return !1;if (oc.test(a)) return rc[a] = !0;qc[a] = !0;return !1;}function tc(a, b, c, d) {if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) {case "function":case "symbol":return !0;case "boolean":if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:return !1;}}
function uc(a, b, c, d) {if (null === b || "undefined" === typeof b || tc(a, b, c, d)) return !0;if (d) return !1;if (null !== c) switch (c.type) {case 3:return !b;case 4:return !1 === b;case 5:return isNaN(b);case 6:return isNaN(b) || 1 > b;}return !1;}function E(a, b, c, d, e) {this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;}var F = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {F[a] = new E(a, 0, !1, a, null);});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {var b = a[0];F[b] = new E(b, 1, !1, a[1], null);});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {F[a] = new E(a, 2, !1, a.toLowerCase(), null);});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {F[a] = new E(a, 2, !1, a, null);});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {F[a] = new E(a, 3, !1, a.toLowerCase(), null);});["checked", "multiple", "muted", "selected"].forEach(function (a) {F[a] = new E(a, 3, !0, a, null);});
["capture", "download"].forEach(function (a) {F[a] = new E(a, 4, !1, a, null);});["cols", "rows", "size", "span"].forEach(function (a) {F[a] = new E(a, 6, !1, a, null);});["rowSpan", "start"].forEach(function (a) {F[a] = new E(a, 5, !1, a.toLowerCase(), null);});var vc = /[\-:]([a-z])/g;function xc(a) {return a[1].toUpperCase();}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {var b = a.replace(vc,
  xc);F[b] = new E(b, 1, !1, a, null);});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {var b = a.replace(vc, xc);F[b] = new E(b, 1, !1, a, "http://www.w3.org/1999/xlink");});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {var b = a.replace(vc, xc);F[b] = new E(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");});F.tabIndex = new E("tabIndex", 1, !1, "tabindex", null);
function yc(a, b, c, d) {var e = F.hasOwnProperty(b) ? F[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (uc(b, c, e, d) && (c = null), d || null === e ? sc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));}
function zc(a) {switch (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) {case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return "";}}function Ac(a, b) {var c = b.checked;return n({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });}
function Bc(a, b) {var c = null == b.defaultValue ? "" : b.defaultValue,d = null != b.checked ? b.checked : b.defaultChecked;c = zc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };}function Cc(a, b) {b = b.checked;null != b && yc(a, "checked", b, !1);}
function Dc(a, b) {Cc(a, b);var c = zc(b.value),d = b.type;if (null != c) {if ("number" === d) {if (0 === c && "" === a.value || a.value != c) a.value = "" + c;} else a.value !== "" + c && (a.value = "" + c);} else if ("submit" === d || "reset" === d) {a.removeAttribute("value");return;}b.hasOwnProperty("value") ? Ec(a, b.type, c) : b.hasOwnProperty("defaultValue") && Ec(a, b.type, zc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);}
function Fc(a, b, c) {if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {var d = b.type;if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;b = "" + a._wrapperState.initialValue;c || b === a.value || (a.value = b);a.defaultValue = b;}c = a.name;"" !== c && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !!a._wrapperState.initialChecked;"" !== c && (a.name = c);}
function Ec(a, b, c) {if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);}var Gc = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };function Hc(a, b, c) {a = A.getPooled(Gc.change, a, b, c);a.type = "change";Ib(c);Ra(a);return a;}var Jc = null,Kc = null;function Lc(a) {Ea(a);}
function Mc(a) {var b = Ka(a);if (Wb(b)) return a;}function Nc(a, b) {if ("change" === a) return b;}var Oc = !1;Sa && (Oc = Sb("input") && (!document.documentMode || 9 < document.documentMode));function Pc() {Jc && (Jc.detachEvent("onpropertychange", Qc), Kc = Jc = null);}function Qc(a) {"value" === a.propertyName && Mc(Kc) && (a = Hc(Kc, a, Rb(a)), Ob(Lc, a));}function Rc(a, b, c) {"focus" === a ? (Pc(), Jc = b, Kc = c, Jc.attachEvent("onpropertychange", Qc)) : "blur" === a && Pc();}function Sc(a) {if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Mc(Kc);}
function Tc(a, b) {if ("click" === a) return Mc(b);}function Uc(a, b) {if ("input" === a || "change" === a) return Mc(b);}
var Vc = { eventTypes: Gc, _isInputEventSupported: Oc, extractEvents: function extractEvents(a, b, c, d) {var e = b ? Ka(b) : window,f = void 0,g = void 0,h = e.nodeName && e.nodeName.toLowerCase();"select" === h || "input" === h && "file" === e.type ? f = Nc : Qb(e) ? Oc ? f = Uc : (f = Sc, g = Rc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = Tc);if (f && (f = f(a, b))) return Hc(f, c, d);g && g(a, e, b);"blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Ec(e, "number", e.value);} },Wc = A.extend({ view: null, detail: null }),Xc = { Alt: "altKey",
  Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function Yc(a) {var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = Xc[a]) ? !!b[a] : !1;}function Zc() {return Yc;}
var $c = 0,ad = 0,bd = !1,cd = !1,dd = Wc.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Zc, button: null, buttons: null, relatedTarget: function relatedTarget(a) {return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);}, movementX: function movementX(a) {if ("movementX" in a) return a.movementX;var b = $c;$c = a.screenX;return bd ? "mousemove" === a.type ? a.screenX - b : 0 : (bd = !0, 0);}, movementY: function movementY(a) {if ("movementY" in a) return a.movementY;
    var b = ad;ad = a.screenY;return cd ? "mousemove" === a.type ? a.screenY - b : 0 : (cd = !0, 0);} }),ed = dd.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }),fd = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: { registrationName: "onPointerLeave",
    dependencies: ["pointerout", "pointerover"] } },gd = { eventTypes: fd, extractEvents: function extractEvents(a, b, c, d) {var e = "mouseover" === a || "pointerover" === a,f = "mouseout" === a || "pointerout" === a;if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? Ia(b) : null) : f = null;if (f === b) return null;var g = void 0,h = void 0,k = void 0,l = void 0;if ("mouseout" === a || "mouseover" === a) g = dd, h = fd.mouseLeave, k = fd.mouseEnter, l = "mouse";else
    if ("pointerout" === a || "pointerover" === a) g = ed, h = fd.pointerLeave, k = fd.pointerEnter, l = "pointer";var m = null == f ? e : Ka(f);e = null == b ? e : Ka(b);a = g.getPooled(h, f, c, d);a.type = l + "leave";a.target = m;a.relatedTarget = e;c = g.getPooled(k, b, c, d);c.type = l + "enter";c.target = e;c.relatedTarget = m;d = b;if (f && d) a: {b = f;e = d;l = 0;for (g = b; g; g = Ma(g)) {l++;}g = 0;for (k = e; k; k = Ma(k)) {g++;}for (; 0 < l - g;) {b = Ma(b), l--;}for (; 0 < g - l;) {e = Ma(e), g--;}for (; l--;) {if (b === e || b === e.alternate) break a;b = Ma(b);e = Ma(e);}b = null;} else b = null;e = b;for (b = []; f && f !== e;) {l =
      f.alternate;if (null !== l && l === e) break;b.push(f);f = Ma(f);}for (f = []; d && d !== e;) {l = d.alternate;if (null !== l && l === e) break;f.push(d);d = Ma(d);}for (d = 0; d < b.length; d++) {Pa(b[d], "bubbled", a);}for (d = f.length; 0 < d--;) {Pa(f[d], "captured", c);}return [a, c];} },hd = Object.prototype.hasOwnProperty;function id(a, b) {return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;}
function jd(a, b) {if (id(a, b)) return !0;if ("object" !== (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) || null === b) return !1;var c = (0, _keys2.default)(a),d = (0, _keys2.default)(b);if (c.length !== d.length) return !1;for (d = 0; d < c.length; d++) {if (!hd.call(b, c[d]) || !id(a[c[d]], b[c[d]])) return !1;}return !0;}function kd(a) {var b = a;if (a.alternate) for (; b.return;) {b = b.return;} else {if (0 !== (b.effectTag & 2)) return 1;for (; b.return;) {if (b = b.return, 0 !== (b.effectTag & 2)) return 1;}}return 3 === b.tag ? 2 : 3;}function ld(a) {2 !== kd(a) ? t("188") : void 0;}
function md(a) {var b = a.alternate;if (!b) return b = kd(a), 3 === b ? t("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {var e = c.return,f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {for (var g = e.child; g;) {if (g === c) return ld(e), a;if (g === d) return ld(e), b;g = g.sibling;}t("188");}if (c.return !== d.return) c = e, d = f;else {g = !1;for (var h = e.child; h;) {if (h === c) {g = !0;c = e;d = f;break;}if (h === d) {g = !0;d = e;c = f;break;}h = h.sibling;}if (!g) {for (h = f.child; h;) {if (h === c) {g = !0;c = f;d = e;break;}if (h === d) {g = !0;d = f;c = e;break;}h = h.sibling;}g ?
        void 0 : t("189");}}c.alternate !== d ? t("190") : void 0;}3 !== c.tag ? t("188") : void 0;return c.stateNode.current === c ? a : b;}function nd(a) {a = md(a);if (!a) return null;for (var b = a;;) {if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child.return = b, b = b.child;else {if (b === a) break;for (; !b.sibling;) {if (!b.return || b.return === a) return null;b = b.return;}b.sibling.return = b.return;b = b.sibling;}}return null;}
var od = A.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),pd = A.extend({ clipboardData: function clipboardData(a) {return "clipboardData" in a ? a.clipboardData : window.clipboardData;} }),qd = Wc.extend({ relatedTarget: null });function rd(a) {var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;}
var sd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },td = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },ud = Wc.extend({ key: function key(a) {if (a.key) {var b = sd[a.key] || a.key;if ("Unidentified" !== b) return b;}return "keypress" === a.type ? (a = rd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? td[a.keyCode] || "Unidentified" : "";}, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Zc, charCode: function charCode(a) {return "keypress" ===
    a.type ? rd(a) : 0;}, keyCode: function keyCode(a) {return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;}, which: function which(a) {return "keypress" === a.type ? rd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;} }),vd = dd.extend({ dataTransfer: null }),wd = Wc.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Zc }),xd = A.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),yd = dd.extend({ deltaX: function deltaX(a) {return "deltaX" in a ? a.deltaX : "wheelDeltaX" in
    a ? -a.wheelDeltaX : 0;}, deltaY: function deltaY(a) {return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;}, deltaZ: null, deltaMode: null }),zd = [["abort", "abort"], [Ya, "animationEnd"], [Za, "animationIteration"], [$a, "animationStart"], ["canplay", "canPlay"], ["canplaythrough", "canPlayThrough"], ["drag", "drag"], ["dragenter", "dragEnter"], ["dragexit", "dragExit"], ["dragleave", "dragLeave"], ["dragover", "dragOver"], ["durationchange", "durationChange"], ["emptied", "emptied"], ["encrypted", "encrypted"],
["ended", "ended"], ["error", "error"], ["gotpointercapture", "gotPointerCapture"], ["load", "load"], ["loadeddata", "loadedData"], ["loadedmetadata", "loadedMetadata"], ["loadstart", "loadStart"], ["lostpointercapture", "lostPointerCapture"], ["mousemove", "mouseMove"], ["mouseout", "mouseOut"], ["mouseover", "mouseOver"], ["playing", "playing"], ["pointermove", "pointerMove"], ["pointerout", "pointerOut"], ["pointerover", "pointerOver"], ["progress", "progress"], ["scroll", "scroll"], ["seeking", "seeking"], ["stalled", "stalled"],
["suspend", "suspend"], ["timeupdate", "timeUpdate"], ["toggle", "toggle"], ["touchmove", "touchMove"], [ab, "transitionEnd"], ["waiting", "waiting"], ["wheel", "wheel"]],Ad = {},Bd = {};function Cd(a, b) {var c = a[0];a = a[1];var d = "on" + (a[0].toUpperCase() + a.slice(1));b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };Ad[a] = b;Bd[c] = b;}
[["blur", "blur"], ["cancel", "cancel"], ["click", "click"], ["close", "close"], ["contextmenu", "contextMenu"], ["copy", "copy"], ["cut", "cut"], ["auxclick", "auxClick"], ["dblclick", "doubleClick"], ["dragend", "dragEnd"], ["dragstart", "dragStart"], ["drop", "drop"], ["focus", "focus"], ["input", "input"], ["invalid", "invalid"], ["keydown", "keyDown"], ["keypress", "keyPress"], ["keyup", "keyUp"], ["mousedown", "mouseDown"], ["mouseup", "mouseUp"], ["paste", "paste"], ["pause", "pause"], ["play", "play"], ["pointercancel", "pointerCancel"],
["pointerdown", "pointerDown"], ["pointerup", "pointerUp"], ["ratechange", "rateChange"], ["reset", "reset"], ["seeked", "seeked"], ["submit", "submit"], ["touchcancel", "touchCancel"], ["touchend", "touchEnd"], ["touchstart", "touchStart"], ["volumechange", "volumeChange"]].forEach(function (a) {Cd(a, !0);});zd.forEach(function (a) {Cd(a, !1);});
var Dd = { eventTypes: Ad, isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {a = Bd[a];return void 0 !== a && !0 === a.isInteractive;}, extractEvents: function extractEvents(a, b, c, d) {var e = Bd[a];if (!e) return null;switch (a) {case "keypress":if (0 === rd(c)) return null;case "keydown":case "keyup":a = ud;break;case "blur":case "focus":a = qd;break;case "click":if (2 === c.button) return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a = dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a =
        vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a = wd;break;case Ya:case Za:case $a:a = od;break;case ab:a = xd;break;case "scroll":a = Wc;break;case "wheel":a = yd;break;case "copy":case "cut":case "paste":a = pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a = ed;break;default:a = A;}b = a.getPooled(e, b, c, d);Ra(b);return b;} },Ed = Dd.isInteractiveTopLevelEventType,
Fd = [];function Gd(a) {var b = a.targetInst,c = b;do {if (!c) {a.ancestors.push(c);break;}var d;for (d = c; d.return;) {d = d.return;}d = 3 !== d.tag ? null : d.stateNode.containerInfo;if (!d) break;a.ancestors.push(c);c = Ia(d);} while (c);for (c = 0; c < a.ancestors.length; c++) {b = a.ancestors[c];var e = Rb(a.nativeEvent);d = a.topLevelType;for (var f = a.nativeEvent, g = null, h = 0; h < pa.length; h++) {var k = pa[h];k && (k = k.extractEvents(d, b, f, e)) && (g = ya(g, k));}Ea(g);}}var Hd = !0;
function G(a, b) {if (!b) return null;var c = (Ed(a) ? Id : Jd).bind(null, a);b.addEventListener(a, c, !1);}function Kd(a, b) {if (!b) return null;var c = (Ed(a) ? Id : Jd).bind(null, a);b.addEventListener(a, c, !0);}function Id(a, b) {Lb(Jd, a, b);}
function Jd(a, b) {if (Hd) {var c = Rb(b);c = Ia(c);null === c || "number" !== typeof c.tag || 2 === kd(c) || (c = null);if (Fd.length) {var d = Fd.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;} else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {Ob(Gd, a);} finally {a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Fd.length && Fd.push(a);}}}var Ld = {},Md = 0,Nd = "_reactListenersID" + ("" + Math.random()).slice(2);
function Od(a) {Object.prototype.hasOwnProperty.call(a, Nd) || (a[Nd] = Md++, Ld[a[Nd]] = {});return Ld[a[Nd]];}function Pd(a) {a = a || ("undefined" !== typeof document ? document : void 0);if ("undefined" === typeof a) return null;try {return a.activeElement || a.body;} catch (b) {return a.body;}}function Qd(a) {for (; a && a.firstChild;) {a = a.firstChild;}return a;}
function Rd(a, b) {var c = Qd(a);a = 0;for (var d; c;) {if (3 === c.nodeType) {d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;}a: {for (; c;) {if (c.nextSibling) {c = c.nextSibling;break a;}c = c.parentNode;}c = void 0;}c = Qd(c);}}function Sd(a, b) {return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Sd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;}
function Td() {for (var a = window, b = Pd(); b instanceof a.HTMLIFrameElement;) {try {a = b.contentDocument.defaultView;} catch (c) {break;}b = Pd(a.document);}return b;}function Ud(a) {var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);}
var Vd = Sa && "documentMode" in document && 11 >= document.documentMode,Wd = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } },Xd = null,Yd = null,Zd = null,$d = !1;
function ae(a, b) {var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;if ($d || null == Xd || Xd !== Pd(c)) return null;c = Xd;"selectionStart" in c && Ud(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });return Zd && jd(Zd, c) ? null : (Zd = c, a = A.getPooled(Wd.select, Yd, a, b), a.type = "select", a.target = Xd, Ra(a), a);}
var be = { eventTypes: Wd, extractEvents: function extractEvents(a, b, c, d) {var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,f;if (!(f = !e)) {a: {e = Od(e);f = ta.onSelect;for (var g = 0; g < f.length; g++) {var h = f[g];if (!e.hasOwnProperty(h) || !e[h]) {e = !1;break a;}}e = !0;}f = !e;}if (f) return null;e = b ? Ka(b) : window;switch (a) {case "focus":if (Qb(e) || "true" === e.contentEditable) Xd = e, Yd = b, Zd = null;break;case "blur":Zd = Yd = Xd = null;break;case "mousedown":$d = !0;break;case "contextmenu":case "mouseup":case "dragend":return $d = !1, ae(c, d);case "selectionchange":if (Vd) break;
      case "keydown":case "keyup":return ae(c, d);}return null;} };Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua = La;va = Ja;wa = Ka;Ca.injectEventPluginsByName({ SimpleEventPlugin: Dd, EnterLeaveEventPlugin: gd, ChangeEventPlugin: Vc, SelectEventPlugin: be, BeforeInputEventPlugin: Bb });function de(a) {var b = "";aa.Children.forEach(a, function (a) {null != a && (b += a);});return b;}
function ee(a, b) {a = n({ children: void 0 }, b);if (b = de(b.children)) a.children = b;return a;}function fe(a, b, c, d) {a = a.options;if (b) {b = {};for (var e = 0; e < c.length; e++) {b["$" + c[e]] = !0;}for (c = 0; c < a.length; c++) {e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);}} else {c = "" + zc(c);b = null;for (e = 0; e < a.length; e++) {if (a[e].value === c) {a[e].selected = !0;d && (a[e].defaultSelected = !0);return;}null !== b || a[e].disabled || (b = a[e]);}null !== b && (b.selected = !0);}}
function ge(a, b) {null != b.dangerouslySetInnerHTML ? t("91") : void 0;return n({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });}function he(a, b) {var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? t("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : t("93"), b = b[0]), c = b), null == c && (c = ""));a._wrapperState = { initialValue: zc(c) };}
function ie(a, b) {var c = zc(b.value),d = zc(b.defaultValue);null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));null != d && (a.defaultValue = "" + d);}function je(a) {var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);}var ke = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function le(a) {switch (a) {case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml";}}function me(a, b) {return null == a || "http://www.w3.org/1999/xhtml" === a ? le(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;}
var ne = void 0,oe = function (a) {return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {MSApp.execUnsafeLocalFunction(function () {return a(b, c, d, e);});} : a;}(function (a, b) {if (a.namespaceURI !== ke.svg || "innerHTML" in a) a.innerHTML = b;else {ne = ne || document.createElement("div");ne.innerHTML = "<svg>" + b + "</svg>";for (b = ne.firstChild; a.firstChild;) {a.removeChild(a.firstChild);}for (; b.firstChild;) {a.appendChild(b.firstChild);}}});
function pe(a, b) {if (b) {var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {c.nodeValue = b;return;}}a.textContent = b;}
var qe = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridArea: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0,
  floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },re = ["Webkit", "ms", "Moz", "O"];(0, _keys2.default)(qe).forEach(function (a) {re.forEach(function (b) {b = b + a.charAt(0).toUpperCase() + a.substring(1);qe[b] = qe[a];});});function se(a, b, c) {return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qe.hasOwnProperty(a) && qe[a] ? ("" + b).trim() : b + "px";}
function te(a, b) {a = a.style;for (var c in b) {if (b.hasOwnProperty(c)) {var d = 0 === c.indexOf("--"),e = se(c, b[c], d);"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;}}}var ue = n({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function ve(a, b) {b && (ue[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? t("137", a, "") : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? t("60") : void 0, "object" === (0, _typeof3.default)(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : t("61")), null != b.style && "object" !== (0, _typeof3.default)(b.style) ? t("62", "") : void 0);}
function we(a, b) {if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return !1;default:return !0;}}
function xe(a, b) {a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = Od(a);b = ta[b];for (var d = 0; d < b.length; d++) {var e = b[d];if (!c.hasOwnProperty(e) || !c[e]) {switch (e) {case "scroll":Kd("scroll", a);break;case "focus":case "blur":Kd("focus", a);Kd("blur", a);c.blur = !0;c.focus = !0;break;case "cancel":case "close":Sb(e) && Kd(e, a);break;case "invalid":case "submit":case "reset":break;default:-1 === bb.indexOf(e) && G(e, a);}c[e] = !0;}}}function ye() {}var ze = null,Ae = null;
function Be(a, b) {switch (a) {case "button":case "input":case "select":case "textarea":return !!b.autoFocus;}return !1;}function Ce(a, b) {return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, _typeof3.default)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;}var De = "function" === typeof setTimeout ? setTimeout : void 0,Ee = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Fe(a) {for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {a = a.nextSibling;}return a;}function Ge(a) {for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {a = a.nextSibling;}return a;}new _set2.default();var He = [],Ie = -1;function H(a) {0 > Ie || (a.current = He[Ie], He[Ie] = null, Ie--);}function I(a, b) {Ie++;He[Ie] = a.current;a.current = b;}var Je = {},J = { current: Je },K = { current: !1 },Ke = Je;
function Le(a, b) {var c = a.type.contextTypes;if (!c) return Je;var d = a.stateNode;if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;var e = {},f;for (f in c) {e[f] = b[f];}d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);return e;}function L(a) {a = a.childContextTypes;return null !== a && void 0 !== a;}function Me(a) {H(K, a);H(J, a);}function Ne(a) {H(K, a);H(J, a);}
function Oe(a, b, c) {J.current !== Je ? t("168") : void 0;I(J, b, a);I(K, c, a);}function Pe(a, b, c) {var d = a.stateNode;a = b.childContextTypes;if ("function" !== typeof d.getChildContext) return c;d = d.getChildContext();for (var e in d) {e in a ? void 0 : t("108", mc(b) || "Unknown", e);}return n({}, c, d);}function Qe(a) {var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || Je;Ke = J.current;I(J, b, a);I(K, K.current, a);return !0;}
function Re(a, b, c) {var d = a.stateNode;d ? void 0 : t("169");c ? (b = Pe(a, b, Ke), d.__reactInternalMemoizedMergedChildContext = b, H(K, a), H(J, a), I(J, b, a)) : H(K, a);I(K, c, a);}var Se = null,Te = null;function Ue(a) {return function (b) {try {return a(b);} catch (c) {}};}
function Ve(a) {if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {var c = b.inject(a);Se = Ue(function (a) {return b.onCommitFiberRoot(c, a);});Te = Ue(function (a) {return b.onCommitFiberUnmount(c, a);});} catch (d) {}return !0;}
function We(a, b, c, d) {this.tag = a;this.key = c;this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;this.index = 0;this.ref = null;this.pendingProps = b;this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.childExpirationTime = this.expirationTime = 0;this.alternate = null;}function M(a, b, c, d) {return new We(a, b, c, d);}
function Xe(a) {a = a.prototype;return !(!a || !a.isReactComponent);}function Ye(a) {if ("function" === typeof a) return Xe(a) ? 1 : 0;if (void 0 !== a && null !== a) {a = a.$$typeof;if (a === gc) return 11;if (a === ic) return 14;}return 2;}
function Ze(a, b) {var c = a.alternate;null === c ? (c = M(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);c.childExpirationTime = a.childExpirationTime;c.expirationTime = a.expirationTime;c.child = a.child;c.memoizedProps = a.memoizedProps;c.memoizedState = a.memoizedState;c.updateQueue = a.updateQueue;c.firstContextDependency = a.firstContextDependency;c.sibling = a.sibling;
  c.index = a.index;c.ref = a.ref;return c;}
function $e(a, b, c, d, e, f) {var g = 2;d = a;if ("function" === typeof a) Xe(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {case ac:return af(c.children, e, f, b);case fc:return bf(c, e | 3, f, b);case bc:return bf(c, e | 2, f, b);case cc:return a = M(12, c, b, e | 4), a.elementType = cc, a.type = cc, a.expirationTime = f, a;case hc:return a = M(13, c, b, e), a.elementType = hc, a.type = hc, a.expirationTime = f, a;default:if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) && null !== a) switch (a.$$typeof) {case dc:g = 10;break a;case ec:g = 9;break a;case gc:g = 11;break a;case ic:g =
          14;break a;case jc:g = 16;d = null;break a;}t("130", null == a ? a : typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a), "");}b = M(g, c, b, e);b.elementType = a;b.type = d;b.expirationTime = f;return b;}function af(a, b, c, d) {a = M(7, a, d, b);a.expirationTime = c;return a;}function bf(a, b, c, d) {a = M(8, a, d, b);b = 0 === (b & 1) ? bc : fc;a.elementType = b;a.type = b;a.expirationTime = c;return a;}function cf(a, b, c) {a = M(6, a, null, b);a.expirationTime = c;return a;}
function df(a, b, c) {b = M(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;}function ef(a, b) {a.didError = !1;var c = a.earliestPendingTime;0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);ff(b, a);}
function gf(a, b) {a.didError = !1;var c = a.latestPingedTime;0 !== c && c >= b && (a.latestPingedTime = 0);c = a.earliestPendingTime;var d = a.latestPendingTime;c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);c = a.earliestSuspendedTime;d = a.latestSuspendedTime;0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);ff(b, a);}
function hf(a, b) {var c = a.earliestPendingTime;a = a.earliestSuspendedTime;c > b && (b = c);a > b && (b = a);return b;}function ff(a, b) {var c = b.earliestSuspendedTime,d = b.latestSuspendedTime,e = b.earliestPendingTime,f = b.latestPingedTime;e = 0 !== e ? e : f;0 === e && (0 === a || d < a) && (e = d);a = e;0 !== a && c > a && (a = c);b.nextExpirationTimeToWorkOn = e;b.expirationTime = a;}var jf = !1;
function kf(a) {return { baseState: a, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };}function lf(a) {return { baseState: a.baseState, firstUpdate: a.firstUpdate, lastUpdate: a.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };}
function mf(a) {return { expirationTime: a, tag: 0, payload: null, callback: null, next: null, nextEffect: null };}function nf(a, b) {null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);}
function of(a, b) {var c = a.alternate;if (null === c) {var d = a.updateQueue;var e = null;null === d && (d = a.updateQueue = kf(a.memoizedState));} else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = kf(a.memoizedState), e = c.updateQueue = kf(c.memoizedState)) : d = a.updateQueue = lf(e) : null === e && (e = c.updateQueue = lf(d));null === e || d === e ? nf(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (nf(d, b), nf(e, b)) : (nf(d, b), e.lastUpdate = b);}
function pf(a, b) {var c = a.updateQueue;c = null === c ? a.updateQueue = kf(a.memoizedState) : qf(a, c);null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);}function qf(a, b) {var c = a.alternate;null !== c && b === c.updateQueue && (b = a.updateQueue = lf(b));return b;}
function rf(a, b, c, d, e, f) {switch (c.tag) {case 1:return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;case 3:a.effectTag = a.effectTag & -2049 | 64;case 0:a = c.payload;e = "function" === typeof a ? a.call(f, d, e) : a;if (null === e || void 0 === e) break;return n({}, d, e);case 2:jf = !0;}return d;}
function sf(a, b, c, d, e) {jf = !1;b = qf(a, b);for (var f = b.baseState, g = null, h = 0, k = b.firstUpdate, l = f; null !== k;) {var m = k.expirationTime;m < e ? (null === g && (g = k, f = l), h < m && (h = m)) : (l = rf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k)));k = k.next;}m = null;for (k = b.firstCapturedUpdate; null !== k;) {var q = k.expirationTime;q < e ? (null === m && (m = k, null === g && (f = l)), h < q && (h = q)) : (l = rf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |=
    32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k)));k = k.next;}null === g && (b.lastUpdate = null);null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;null === g && null === m && (f = l);b.baseState = f;b.firstUpdate = g;b.firstCapturedUpdate = m;a.expirationTime = h;a.memoizedState = l;}
function tf(a, b, c) {null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);uf(b.firstEffect, c);b.firstEffect = b.lastEffect = null;uf(b.firstCapturedEffect, c);b.firstCapturedEffect = b.lastCapturedEffect = null;}function uf(a, b) {for (; null !== a;) {var c = a.callback;if (null !== c) {a.callback = null;var d = b;"function" !== typeof c ? t("191", c) : void 0;c.call(d);}a = a.nextEffect;}}
function vf(a, b) {return { value: a, source: b, stack: nc(b) };}var wf = { current: null },xf = null,yf = null,zf = null;function Af(a, b) {var c = a.type._context;I(wf, c._currentValue, a);c._currentValue = b;}function Bf(a) {var b = wf.current;H(wf, a);a.type._context._currentValue = b;}function Cf(a) {xf = a;zf = yf = null;a.firstContextDependency = null;}
function Df(a, b) {if (zf !== a && !1 !== b && 0 !== b) {if ("number" !== typeof b || 1073741823 === b) zf = a, b = 1073741823;b = { context: a, observedBits: b, next: null };null === yf ? (null === xf ? t("293") : void 0, xf.firstContextDependency = yf = b) : yf = yf.next = b;}return a._currentValue;}var Ef = {},N = { current: Ef },Ff = { current: Ef },Gf = { current: Ef };function Hf(a) {a === Ef ? t("174") : void 0;return a;}
function If(a, b) {I(Gf, b, a);I(Ff, a, a);I(N, Ef, a);var c = b.nodeType;switch (c) {case 9:case 11:b = (b = b.documentElement) ? b.namespaceURI : me(null, "");break;default:c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = me(b, c);}H(N, a);I(N, b, a);}function Jf(a) {H(N, a);H(Ff, a);H(Gf, a);}function Kf(a) {Hf(Gf.current);var b = Hf(N.current);var c = me(b, a.type);b !== c && (I(Ff, a, a), I(N, c, a));}function Lf(a) {Ff.current === a && (H(N, a), H(Ff, a));}
function O(a, b) {if (a && a.defaultProps) {b = n({}, b);a = a.defaultProps;for (var c in a) {void 0 === b[c] && (b[c] = a[c]);}}return b;}function Mf(a) {var b = a._result;switch (a._status) {case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status = 0, b = a._ctor, b = b(), b.then(function (b) {0 === a._status && (b = b.default, a._status = 1, a._result = b);}, function (b) {0 === a._status && (a._status = 2, a._result = b);}), a._result = b, b;}}var Nf = Xb.ReactCurrentOwner,Of = new aa.Component().refs;
function Pf(a, b, c, d) {b = a.memoizedState;c = c(d, b);c = null === c || void 0 === c ? b : n({}, b, c);a.memoizedState = c;d = a.updateQueue;null !== d && 0 === a.expirationTime && (d.baseState = c);}
var Uf = { isMounted: function isMounted(a) {return (a = a._reactInternalFiber) ? 2 === kd(a) : !1;}, enqueueSetState: function enqueueSetState(a, b, c) {a = a._reactInternalFiber;var d = Qf();d = Rf(d, a);var e = mf(d);e.payload = b;void 0 !== c && null !== c && (e.callback = c);Sf();of(a, e);Tf(a, d);}, enqueueReplaceState: function enqueueReplaceState(a, b, c) {a = a._reactInternalFiber;var d = Qf();d = Rf(d, a);var e = mf(d);e.tag = 1;e.payload = b;void 0 !== c && null !== c && (e.callback = c);Sf();of(a, e);Tf(a, d);}, enqueueForceUpdate: function enqueueForceUpdate(a, b) {a = a._reactInternalFiber;var c = Qf();c = Rf(c, a);var d = mf(c);d.tag =
    2;void 0 !== b && null !== b && (d.callback = b);Sf();of(a, d);Tf(a, c);} };function Vf(a, b, c, d, e, f, g) {a = a.stateNode;return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !jd(c, d) || !jd(e, f) : !0;}
function Wf(a, b, c) {var d = !1,e = Je;var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f)) && null !== f ? f = Nf.currentDispatcher.readContext(f) : (e = L(b) ? Ke : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Le(a, e) : Je);b = new b(c, f);a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;b.updater = Uf;a.stateNode = b;b._reactInternalFiber = a;d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);return b;}
function Xf(a, b, c, d) {a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && Uf.enqueueReplaceState(b, b.state, null);}
function Yf(a, b, c, d) {var e = a.stateNode;e.props = c;e.state = a.memoizedState;e.refs = Of;var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f)) && null !== f ? e.context = Nf.currentDispatcher.readContext(f) : (f = L(b) ? Ke : J.current, e.context = Le(a, f));f = a.updateQueue;null !== f && (sf(a, f, c, e, d), e.state = a.memoizedState);f = b.getDerivedStateFromProps;"function" === typeof f && (Pf(a, b, f, c), e.state = a.memoizedState);"function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount &&
  "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Uf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (sf(a, f, c, e, d), e.state = a.memoizedState));"function" === typeof e.componentDidMount && (a.effectTag |= 4);}var Zf = Array.isArray;
function $f(a, b, c) {a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))) {if (c._owner) {c = c._owner;var d = void 0;c && (1 !== c.tag ? t("289") : void 0, d = c.stateNode);d ? void 0 : t("147", a);var e = "" + a;if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {var b = d.refs;b === Of && (b = d.refs = {});null === a ? delete b[e] : b[e] = a;};b._stringRef = e;return b;}"string" !== typeof a ? t("284") : void 0;c._owner ? void 0 : t("290", a);}return a;}
function ag(a, b) {"textarea" !== a.type && t("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + (0, _keys2.default)(b).join(", ") + "}" : b, "");}
function bg(a) {function b(b, c) {if (a) {var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;}}function c(c, d) {if (!a) return null;for (; null !== d;) {b(c, d), d = d.sibling;}return null;}function d(a, b) {for (a = new _map2.default(); null !== b;) {null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;}return a;}function e(a, b, c) {a = Ze(a, b, c);a.index = 0;a.sibling = null;return a;}function f(b, c, d) {b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag =
    2, c) : d;b.effectTag = 2;return c;}function g(b) {a && null === b.alternate && (b.effectTag = 2);return b;}function h(a, b, c, d) {if (null === b || 6 !== b.tag) return b = cf(c, a.mode, d), b.return = a, b;b = e(b, c, d);b.return = a;return b;}function k(a, b, c, d) {if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $f(a, b, c), d.return = a, d;d = $e(c.type, c.key, c.props, null, a.mode, d);d.ref = $f(a, b, c);d.return = a;return d;}function l(a, b, c, d) {if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !==
    c.implementation) return b = df(c, a.mode, d), b.return = a, b;b = e(b, c.children || [], d);b.return = a;return b;}function m(a, b, c, d, g) {if (null === b || 7 !== b.tag) return b = af(c, a.mode, d, g), b.return = a, b;b = e(b, c, d);b.return = a;return b;}function q(a, b, c) {if ("string" === typeof b || "number" === typeof b) return b = cf("" + b, a.mode, c), b.return = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) && null !== b) {switch (b.$$typeof) {case Zb:return c = $e(b.type, b.key, b.props, null, a.mode, c), c.ref = $f(a, null, b), c.return = a, c;case $b:return b = df(b, a.mode, c), b.return = a, b;}if (Zf(b) ||
      lc(b)) return b = af(b, a.mode, c, null), b.return = a, b;ag(a, b);}return null;}function x(a, b, c, d) {var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c)) && null !== c) {switch (c.$$typeof) {case Zb:return c.key === e ? c.type === ac ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case $b:return c.key === e ? l(a, b, c, d) : null;}if (Zf(c) || lc(c)) return null !== e ? null : m(a, b, c, d, null);ag(a, c);}return null;}function z(a, b, c, d, e) {if ("string" === typeof d || "number" === typeof d) return a =
    a.get(c) || null, h(b, a, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : (0, _typeof3.default)(d)) && null !== d) {switch (d.$$typeof) {case Zb:return a = a.get(null === d.key ? c : d.key) || null, d.type === ac ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);case $b:return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);}if (Zf(d) || lc(d)) return a = a.get(c) || null, m(b, a, d, e, null);ag(b, d);}return null;}function B(e, g, h, k) {for (var l = null, r = null, m = g, u = g = 0, p = null; null !== m && u < h.length; u++) {m.index > u ? (p = m, m = null) : p = m.sibling;var v = x(e, m, h[u], k);if (null === v) {null === m && (m = p);break;}a &&
      m && null === v.alternate && b(e, m);g = f(v, g, u);null === r ? l = v : r.sibling = v;r = v;m = p;}if (u === h.length) return c(e, m), l;if (null === m) {for (; u < h.length; u++) {if (m = q(e, h[u], k)) g = f(m, g, u), null === r ? l = m : r.sibling = m, r = m;}return l;}for (m = d(e, m); u < h.length; u++) {if (p = z(m, e, u, h[u], k)) a && null !== p.alternate && m.delete(null === p.key ? u : p.key), g = f(p, g, u), null === r ? l = p : r.sibling = p, r = p;}a && m.forEach(function (a) {return b(e, a);});return l;}function Q(e, g, h, k) {var l = lc(h);"function" !== typeof l ? t("150") : void 0;h = l.call(h);null == h ? t("151") : void 0;
    for (var m = l = null, r = g, u = g = 0, p = null, v = h.next(); null !== r && !v.done; u++, v = h.next()) {r.index > u ? (p = r, r = null) : p = r.sibling;var y = x(e, r, v.value, k);if (null === y) {r || (r = p);break;}a && r && null === y.alternate && b(e, r);g = f(y, g, u);null === m ? l = y : m.sibling = y;m = y;r = p;}if (v.done) return c(e, r), l;if (null === r) {for (; !v.done; u++, v = h.next()) {v = q(e, v.value, k), null !== v && (g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);}return l;}for (r = d(e, r); !v.done; u++, v = h.next()) {v = z(r, e, u, v.value, k), null !== v && (a && null !== v.alternate && r.delete(null === v.key ? u :
      v.key), g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);}a && r.forEach(function (a) {return b(e, a);});return l;}return function (a, d, f, h) {var k = "object" === (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f)) && null !== f && f.type === ac && null === f.key;k && (f = f.props.children);var l = "object" === (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f)) && null !== f;if (l) switch (f.$$typeof) {case Zb:a: {l = f.key;for (k = d; null !== k;) {if (k.key === l) {if (7 === k.tag ? f.type === ac : k.elementType === f.type) {c(a, k.sibling);d = e(k, f.type === ac ? f.props.children : f.props, h);d.ref = $f(a, k, f);d.return = a;a = d;break a;} else {c(a, k);break;}} else b(a, k);k =
            k.sibling;}f.type === ac ? (d = af(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e(f.type, f.key, f.props, null, a.mode, h), h.ref = $f(a, d, f), h.return = a, a = h);}return g(a);case $b:a: {for (k = f.key; null !== d;) {if (d.key === k) {if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {c(a, d.sibling);d = e(d, f.children || [], h);d.return = a;a = d;break a;} else {c(a, d);break;}} else b(a, d);d = d.sibling;}d = df(f, a.mode, h);d.return = a;a = d;}return g(a);}if ("string" === typeof f || "number" === typeof f) return f =
    "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = cf(f, a.mode, h), d.return = a, a = d), g(a);if (Zf(f)) return B(a, d, f, h);if (lc(f)) return Q(a, d, f, h);l && ag(a, f);if ("undefined" === typeof f && !k) switch (a.tag) {case 1:case 0:h = a.type, t("152", h.displayName || h.name || "Component");}return c(a, d);};}var cg = bg(!0),dg = bg(!1),eg = null,fg = null,gg = !1;
function hg(a, b) {var c = M(5, null, null, 0);c.elementType = "DELETED";c.type = "DELETED";c.stateNode = b;c.return = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;}function ig(a, b) {switch (a.tag) {case 5:var c = a.type;b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;return null !== b ? (a.stateNode = b, !0) : !1;case 6:return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;default:return !1;}}
function jg(a) {if (gg) {var b = fg;if (b) {var c = b;if (!ig(a, b)) {b = Fe(c);if (!b || !ig(a, b)) {a.effectTag |= 2;gg = !1;eg = a;return;}hg(eg, c);}eg = a;fg = Ge(b);} else a.effectTag |= 2, gg = !1, eg = a;}}function kg(a) {for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;) {a = a.return;}eg = a;}function lg(a) {if (a !== eg) return !1;if (!gg) return kg(a), gg = !0, !1;var b = a.type;if (5 !== a.tag || "head" !== b && "body" !== b && !Ce(b, a.memoizedProps)) for (b = fg; b;) {hg(a, b), b = Fe(b);}kg(a);fg = eg ? Fe(a.stateNode) : null;return !0;}function mg() {fg = eg = null;gg = !1;}var ng = Xb.ReactCurrentOwner;
function P(a, b, c, d) {b.child = null === a ? dg(b, null, c, d) : cg(b, a.child, c, d);}function og(a, b, c, d, e) {c = c.render;var f = b.ref;Cf(b, e);d = c(d, f);b.effectTag |= 1;P(a, b, d, e);return b.child;}
function pg(a, b, c, d, e, f) {if (null === a) {var g = c.type;if ("function" === typeof g && !Xe(g) && void 0 === g.defaultProps && null === c.compare) return b.tag = 15, b.type = g, qg(a, b, g, d, e, f);a = $e(c.type, null, d, null, b.mode, f);a.ref = b.ref;a.return = b;return b.child = a;}g = a.child;if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : jd, c(e, d) && a.ref === b.ref)) return rg(a, b, f);b.effectTag |= 1;a = Ze(g, d, f);a.ref = b.ref;a.return = b;return b.child = a;}
function qg(a, b, c, d, e, f) {return null !== a && e < f && jd(a.memoizedProps, d) && a.ref === b.ref ? rg(a, b, f) : sg(a, b, c, d, f);}function tg(a, b) {var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;}function sg(a, b, c, d, e) {var f = L(c) ? Ke : J.current;f = Le(b, f);Cf(b, e);c = c(d, f);b.effectTag |= 1;P(a, b, c, e);return b.child;}
function ug(a, b, c, d, e) {if (L(c)) {var f = !0;Qe(b);} else f = !1;Cf(b, e);if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Wf(b, c, d, e), Yf(b, c, d, e), d = !0;else if (null === a) {var g = b.stateNode,h = b.memoizedProps;g.props = h;var k = g.context,l = c.contextType;"object" === (typeof l === "undefined" ? "undefined" : (0, _typeof3.default)(l)) && null !== l ? l = Nf.currentDispatcher.readContext(l) : (l = L(c) ? Ke : J.current, l = Le(b, l));var m = c.getDerivedStateFromProps,q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;q || "function" !== typeof g.UNSAFE_componentWillReceiveProps &&
    "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Xf(b, g, d, l);jf = !1;var x = b.memoizedState;k = g.state = x;var z = b.updateQueue;null !== z && (sf(b, z, d, g, e), k = b.memoizedState);h !== d || x !== k || K.current || jf ? ("function" === typeof m && (Pf(b, c, m, d), k = b.memoizedState), (h = jf || Vf(b, c, h, d, x, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount &&
    g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);} else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : O(b.type, h), k = g.context, l = c.contextType, "object" === (typeof l === "undefined" ? "undefined" : (0, _typeof3.default)(l)) && null !== l ? l = Nf.currentDispatcher.readContext(l) : (l = L(c) ? Ke : J.current, l = Le(b, l)), m = c.getDerivedStateFromProps,
  (q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Xf(b, g, d, l), jf = !1, k = b.memoizedState, x = g.state = k, z = b.updateQueue, null !== z && (sf(b, z, d, g, e), x = b.memoizedState), h !== d || k !== x || K.current || jf ? ("function" === typeof m && (Pf(b, c, m, d), x = b.memoizedState), (m = jf || Vf(b, c, h, d, k, x, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || (
  "function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps =
  d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);return vg(a, b, c, d, f, e);}
function vg(a, b, c, d, e, f) {tg(a, b);var g = 0 !== (b.effectTag & 64);if (!d && !g) return e && Re(b, c, !1), rg(a, b, f);d = b.stateNode;ng.current = b;var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();b.effectTag |= 1;null !== a && g ? (b.child = cg(b, a.child, null, f), b.child = cg(b, null, h, f)) : P(a, b, h, f);b.memoizedState = d.state;e && Re(b, c, !0);return b.child;}function wg(a) {var b = a.stateNode;b.pendingContext ? Oe(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Oe(a, b.context, !1);If(a, b.containerInfo);}
function xg(a, b, c) {var d = b.mode,e = b.pendingProps,f = b.memoizedState;if (0 === (b.effectTag & 64)) {f = null;var g = !1;} else f = { timedOutAt: null !== f ? f.timedOutAt : 0 }, g = !0, b.effectTag &= -65;null === a ? g ? (g = e.fallback, e = af(null, d, 0, null), 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = af(g, d, c, null), e.sibling = d, c = e, c.return = d.return = b) : c = d = dg(b, null, e.children, c) : null !== a.memoizedState ? (d = a.child, a = d.sibling, g ? (c = e.fallback, e = Ze(d, d.pendingProps, 0), 0 === (b.mode & 1) && (g = null !== b.memoizedState ?
  b.child.child : b.child, g !== d.child && (e.child = g)), d = e.sibling = Ze(a, c, a.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = cg(b, d.child, e.children, c)) : (a = a.child, g ? (g = e.fallback, e = af(null, d, 0, null), e.child = a, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = af(g, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = cg(b, a, e.children, c));b.memoizedState = f;b.child = c;return d;}
function rg(a, b, c) {null !== a && (b.firstContextDependency = a.firstContextDependency);if (b.childExpirationTime < c) return null;null !== a && b.child !== a.child ? t("153") : void 0;if (null !== b.child) {a = b.child;c = Ze(a, a.pendingProps, a.expirationTime);b.child = c;for (c.return = b; null !== a.sibling;) {a = a.sibling, c = c.sibling = Ze(a, a.pendingProps, a.expirationTime), c.return = b;}c.sibling = null;}return b.child;}
function yg(a, b, c) {var d = b.expirationTime;if (null !== a && a.memoizedProps === b.pendingProps && !K.current && d < c) {switch (b.tag) {case 3:wg(b);mg();break;case 5:Kf(b);break;case 1:L(b.type) && Qe(b);break;case 4:If(b, b.stateNode.containerInfo);break;case 10:Af(b, b.memoizedProps.value);break;case 13:if (null !== b.memoizedState) {d = b.child.childExpirationTime;if (0 !== d && d >= c) return xg(a, b, c);b = rg(a, b, c);return null !== b ? b.sibling : null;}}return rg(a, b, c);}b.expirationTime = 0;switch (b.tag) {case 2:d = b.elementType;null !==
      a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);a = b.pendingProps;var e = Le(b, J.current);Cf(b, c);e = d(a, e);b.effectTag |= 1;if ("object" === (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {b.tag = 1;if (L(d)) {var f = !0;Qe(b);} else f = !1;b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;var g = d.getDerivedStateFromProps;"function" === typeof g && Pf(b, d, g, a);e.updater = Uf;b.stateNode = e;e._reactInternalFiber = b;Yf(b, d, a, c);b = vg(null, b, d, !0, f, c);} else b.tag = 0, P(null, b, e, c), b = b.child;
      return b;case 16:e = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);f = b.pendingProps;a = Mf(e);b.type = a;e = b.tag = Ye(a);f = O(a, f);g = void 0;switch (e) {case 0:g = sg(null, b, a, f, c);break;case 1:g = ug(null, b, a, f, c);break;case 11:g = og(null, b, a, f, c);break;case 14:g = pg(null, b, a, O(a.type, f), d, c);break;default:t("283", a);}return g;case 0:return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), sg(a, b, d, e, c);case 1:return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), ug(a, b, d,
      e, c);case 3:wg(b);d = b.updateQueue;null === d ? t("282") : void 0;e = b.memoizedState;e = null !== e ? e.element : null;sf(b, d, b.pendingProps, null, c);d = b.memoizedState.element;if (d === e) mg(), b = rg(a, b, c);else {e = b.stateNode;if (e = (null === a || null === a.child) && e.hydrate) fg = Ge(b.stateNode.containerInfo), eg = b, e = gg = !0;e ? (b.effectTag |= 2, b.child = dg(b, null, d, c)) : (P(a, b, d, c), mg());b = b.child;}return b;case 5:return Kf(b), null === a && jg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ce(d, e) ? g = null : null !==
      f && Ce(d, f) && (b.effectTag |= 16), tg(a, b), 1 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = 1, b = null) : (P(a, b, g, c), b = b.child), b;case 6:return null === a && jg(b), null;case 13:return xg(a, b, c);case 4:return If(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = cg(b, null, d, c) : P(a, b, d, c), b.child;case 11:return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), og(a, b, d, e, c);case 7:return P(a, b, b.pendingProps, c), b.child;case 8:return P(a, b, b.pendingProps.children, c), b.child;case 12:return P(a, b, b.pendingProps.children,
      c), b.child;case 10:a: {d = b.type._context;e = b.pendingProps;g = b.memoizedProps;f = e.value;Af(b, f);if (null !== g) {var h = g.value;f = h === f && (0 !== h || 1 / h === 1 / f) || h !== h && f !== f ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;if (0 === f) {if (g.children === e.children && !K.current) {b = rg(a, b, c);break a;}} else for (g = b.child, null !== g && (g.return = b); null !== g;) {h = g.firstContextDependency;if (null !== h) {do {if (h.context === d && 0 !== (h.observedBits & f)) {if (1 === g.tag) {var k = mf(c);k.tag = 2;of(g, k);}g.expirationTime <
                  c && (g.expirationTime = c);k = g.alternate;null !== k && k.expirationTime < c && (k.expirationTime = c);for (var l = g.return; null !== l;) {k = l.alternate;if (l.childExpirationTime < c) l.childExpirationTime = c, null !== k && k.childExpirationTime < c && (k.childExpirationTime = c);else if (null !== k && k.childExpirationTime < c) k.childExpirationTime = c;else break;l = l.return;}}k = g.child;h = h.next;} while (null !== h);} else k = 10 === g.tag ? g.type === b.type ? null : g.child : g.child;if (null !== k) k.return = g;else for (k = g; null !== k;) {if (k === b) {k = null;break;}g = k.sibling;
              if (null !== g) {g.return = k.return;k = g;break;}k = k.return;}g = k;}}P(a, b, e.children, c);b = b.child;}return b;case 9:return e = b.type, f = b.pendingProps, d = f.children, Cf(b, c), e = Df(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, P(a, b, d, c), b.child;case 14:return e = b.type, f = O(e.type, b.pendingProps), pg(a, b, e, f, d, c);case 15:return qg(a, b, b.type, b.pendingProps, d, c);case 17:return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Qe(b)) :
      a = !1, Cf(b, c), Wf(b, d, e, c), Yf(b, d, e, c), vg(null, b, d, !0, a, c);default:t("156");}}function zg(a) {a.effectTag |= 4;}var Ag = void 0,Bg = void 0,Fg = void 0,Gg = void 0;Ag = function Ag(a, b) {for (var c = b.child; null !== c;) {if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {c.child.return = c;c = c.child;continue;}if (c === b) break;for (; null === c.sibling;) {if (null === c.return || c.return === b) return;c = c.return;}c.sibling.return = c.return;c = c.sibling;}};Bg = function Bg() {};
Fg = function Fg(a, b, c, d, e) {var f = a.memoizedProps;if (f !== d) {var g = b.stateNode;Hf(N.current);a = null;switch (c) {case "input":f = Ac(g, f);d = Ac(g, d);a = [];break;case "option":f = ee(g, f);d = ee(g, d);a = [];break;case "select":f = n({}, f, { value: void 0 });d = n({}, d, { value: void 0 });a = [];break;case "textarea":f = ge(g, f);d = ge(g, d);a = [];break;default:"function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = ye);}ve(c, d);g = c = void 0;var h = null;for (c in f) {if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) if ("style" ===
      c) {var k = f[c];for (g in k) {k.hasOwnProperty(g) && (h || (h = {}), h[g] = "");}} else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (sa.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));}for (c in d) {var l = d[c];k = null != f ? f[c] : void 0;if (d.hasOwnProperty(c) && l !== k && (null != l || null != k)) if ("style" === c) {if (k) {for (g in k) {!k.hasOwnProperty(g) || l && l.hasOwnProperty(g) || (h || (h = {}), h[g] = "");}for (g in l) {l.hasOwnProperty(g) && k[g] !== l[g] && (h || (
            h = {}), h[g] = l[g]);}} else h || (a || (a = []), a.push(c, h)), h = l;} else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, k = k ? k.__html : void 0, null != l && k !== l && (a = a || []).push(c, "" + l)) : "children" === c ? k === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (sa.hasOwnProperty(c) ? (null != l && xe(e, c), a || k === l || (a = [])) : (a = a || []).push(c, l));}h && (a = a || []).push("style", h);e = a;(b.updateQueue = e) && zg(b);}};Gg = function Gg(a, b, c, d) {c !== d && zg(b);};
function Hg(a, b) {var c = b.source,d = b.stack;null === d && null !== c && (d = nc(c));null !== c && mc(c.type);b = b.value;null !== a && 1 === a.tag && mc(a.type);try {console.error(b);} catch (e) {setTimeout(function () {throw e;});}}function Ig(a) {var b = a.ref;if (null !== b) if ("function" === typeof b) try {b(null);} catch (c) {Jg(a, c);} else b.current = null;}
function Kg(a) {"function" === typeof Te && Te(a);switch (a.tag) {case 0:case 11:case 14:case 15:var b = a.updateQueue;if (null !== b && (b = b.lastEffect, null !== b)) {var c = b = b.next;do {var d = c.destroy;if (null !== d) {var e = a;try {d();} catch (f) {Jg(e, f);}}c = c.next;} while (c !== b);}break;case 1:Ig(a);b = a.stateNode;if ("function" === typeof b.componentWillUnmount) try {b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();} catch (f) {Jg(a, f);}break;case 5:Ig(a);break;case 4:Lg(a);}}
function Mg(a) {return 5 === a.tag || 3 === a.tag || 4 === a.tag;}
function Ng(a) {a: {for (var b = a.return; null !== b;) {if (Mg(b)) {var c = b;break a;}b = b.return;}t("160");c = void 0;}var d = b = void 0;switch (c.tag) {case 5:b = c.stateNode;d = !1;break;case 3:b = c.stateNode.containerInfo;d = !0;break;case 4:b = c.stateNode.containerInfo;d = !0;break;default:t("161");}c.effectTag & 16 && (pe(b, ""), c.effectTag &= -17);a: b: for (c = a;;) {for (; null === c.sibling;) {if (null === c.return || Mg(c.return)) {c = null;break a;}c = c.return;}c.sibling.return = c.return;for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {if (c.effectTag & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;}if (!(c.effectTag & 2)) {c = c.stateNode;break a;}}for (var e = a;;) {if (5 === e.tag || 6 === e.tag) {if (c) {if (d) {var f = b,g = e.stateNode,h = c;8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);} else b.insertBefore(e.stateNode, c);} else d ? (g = b, h = e.stateNode, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = ye)) : b.appendChild(e.stateNode);} else
    if (4 !== e.tag && null !== e.child) {e.child.return = e;e = e.child;continue;}if (e === a) break;for (; null === e.sibling;) {if (null === e.return || e.return === a) return;e = e.return;}e.sibling.return = e.return;e = e.sibling;}}
function Lg(a) {for (var b = a, c = !1, d = void 0, e = void 0;;) {if (!c) {c = b.return;a: for (;;) {null === c ? t("160") : void 0;switch (c.tag) {case 5:d = c.stateNode;e = !1;break a;case 3:d = c.stateNode.containerInfo;e = !0;break a;case 4:d = c.stateNode.containerInfo;e = !0;break a;}c = c.return;}c = !0;}if (5 === b.tag || 6 === b.tag) {a: for (var f = b, g = f;;) {if (Kg(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;else {if (g === f) break;for (; null === g.sibling;) {if (null === g.return || g.return === f) break a;g = g.return;}g.sibling.return = g.return;g = g.sibling;}}e ? (
      f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);} else if (4 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : Kg(b), null !== b.child) {b.child.return = b;b = b.child;continue;}if (b === a) break;for (; null === b.sibling;) {if (null === b.return || b.return === a) return;b = b.return;4 === b.tag && (c = !1);}b.sibling.return = b.return;b = b.sibling;}}
function Og(a, b) {switch (b.tag) {case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c = b.stateNode;if (null != c) {var d = b.memoizedProps,e = null !== a ? a.memoizedProps : d;a = b.type;var f = b.updateQueue;b.updateQueue = null;if (null !== f) {c[Ha] = d;"input" === a && "radio" === d.type && null != d.name && Cc(c, d);we(a, e);b = we(a, d);for (e = 0; e < f.length; e += 2) {var g = f[e],h = f[e + 1];"style" === g ? te(c, h) : "dangerouslySetInnerHTML" === g ? oe(c, h) : "children" === g ? pe(c, h) : yc(c, g, h, b);}switch (a) {case "input":Dc(c, d);break;case "textarea":ie(c,
              d);break;case "select":b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? fe(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? fe(c, !!d.multiple, d.defaultValue, !0) : fe(c, !!d.multiple, d.multiple ? [] : "", !1));}}}break;case 6:null === b.stateNode ? t("162") : void 0;b.stateNode.nodeValue = b.memoizedProps;break;case 3:break;case 12:break;case 13:c = b.memoizedState;a = b;null === c ? d = !1 : (d = !0, a = b.child, 0 === c.timedOutAt && (c.timedOutAt = Qf()));if (null !== a) a: for (b = c = a;;) {if (5 ===
        b.tag) a = b.stateNode, d ? a.style.display = "none" : (a = b.stateNode, f = b.memoizedProps.style, f = void 0 !== f && null !== f && f.hasOwnProperty("display") ? f.display : null, a.style.display = se("display", f));else if (6 === b.tag) b.stateNode.nodeValue = d ? "" : b.memoizedProps;else if (13 === b.tag && null !== b.memoizedState) {a = b.child.sibling;a.return = b;b = a;continue;} else if (null !== b.child) {b.child.return = b;b = b.child;continue;}if (b === c) break a;for (; null === b.sibling;) {if (null === b.return || b.return === c) break a;b = b.return;}b.sibling.return =
        b.return;b = b.sibling;}break;case 17:break;default:t("163");}}function Pg(a, b, c) {c = mf(c);c.tag = 3;c.payload = { element: null };var d = b.value;c.callback = function () {Qg(d);Hg(a, b);};return c;}
function Rg(a, b, c) {c = mf(c);c.tag = 3;var d = a.type.getDerivedStateFromError;if ("function" === typeof d) {var e = b.value;c.payload = function () {return d(e);};}var f = a.stateNode;null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {"function" !== typeof d && (null === Sg ? Sg = new _set2.default([this]) : Sg.add(this));var c = b.value,e = b.stack;Hg(a, b);this.componentDidCatch(c, { componentStack: null !== e ? e : "" });});return c;}
function Tg(a) {switch (a.tag) {case 1:L(a.type) && Me(a);var b = a.effectTag;return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 3:return Jf(a), Ne(a), b = a.effectTag, 0 !== (b & 64) ? t("285") : void 0, a.effectTag = b & -2049 | 64, a;case 5:return Lf(a), null;case 13:return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 4:return Jf(a), null;case 10:return Bf(a), null;default:return null;}}
var Ug = { readContext: Df },Vg = Xb.ReactCurrentOwner,Wg = 1073741822,Xg = 0,Yg = !1,R = null,S = null,T = 0,Zg = -1,$g = !1,U = null,ah = !1,bh = null,ch = null,Sg = null;function dh() {if (null !== R) for (var a = R.return; null !== a;) {var b = a;switch (b.tag) {case 1:var c = b.type.childContextTypes;null !== c && void 0 !== c && Me(b);break;case 3:Jf(b);Ne(b);break;case 5:Lf(b);break;case 4:Jf(b);break;case 10:Bf(b);}a = a.return;}S = null;T = 0;Zg = -1;$g = !1;R = null;}function Sf() {null !== ch && (ba.unstable_cancelCallback(bh), ch());}
function eh(a) {for (;;) {var b = a.alternate,c = a.return,d = a.sibling;if (0 === (a.effectTag & 1024)) {R = a;a: {var e = b;b = a;var f = T;var g = b.pendingProps;switch (b.tag) {case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type) && Me(b);break;case 3:Jf(b);Ne(b);g = b.stateNode;g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null);if (null === e || null === e.child) lg(b), b.effectTag &= -3;Bg(b);break;case 5:Lf(b);var h = Hf(Gf.current);f = b.type;if (null !== e && null != b.stateNode) Fg(e, b, f, g, h), e.ref !== b.ref && (b.effectTag |=
            128);else if (g) {var k = Hf(N.current);if (lg(b)) {g = b;e = g.stateNode;var l = g.type,m = g.memoizedProps,q = h;e[Ga] = g;e[Ha] = m;f = void 0;h = l;switch (h) {case "iframe":case "object":G("load", e);break;case "video":case "audio":for (l = 0; l < bb.length; l++) {G(bb[l], e);}break;case "source":G("error", e);break;case "img":case "image":case "link":G("error", e);G("load", e);break;case "form":G("reset", e);G("submit", e);break;case "details":G("toggle", e);break;case "input":Bc(e, m);G("invalid", e);xe(q, "onChange");break;case "select":e._wrapperState =
                    { wasMultiple: !!m.multiple };G("invalid", e);xe(q, "onChange");break;case "textarea":he(e, m), G("invalid", e), xe(q, "onChange");}ve(h, m);l = null;for (f in m) {m.hasOwnProperty(f) && (k = m[f], "children" === f ? "string" === typeof k ? e.textContent !== k && (l = ["children", k]) : "number" === typeof k && e.textContent !== "" + k && (l = ["children", "" + k]) : sa.hasOwnProperty(f) && null != k && xe(q, f));}switch (h) {case "input":Vb(e);Fc(e, m, !0);break;case "textarea":Vb(e);je(e, m);break;case "select":case "option":break;default:"function" === typeof m.onClick && (
                    e.onclick = ye);}f = l;g.updateQueue = f;g = null !== f ? !0 : !1;g && zg(b);} else {m = b;e = f;q = g;l = 9 === h.nodeType ? h : h.ownerDocument;k === ke.html && (k = le(e));k === ke.html ? "script" === e ? (e = l.createElement("div"), e.innerHTML = "<script>\x3c/script>", l = e.removeChild(e.firstChild)) : "string" === typeof q.is ? l = l.createElement(e, { is: q.is }) : (l = l.createElement(e), "select" === e && q.multiple && (l.multiple = !0)) : l = l.createElementNS(k, e);e = l;e[Ga] = m;e[Ha] = g;Ag(e, b, !1, !1);q = e;l = f;m = g;var x = h,z = we(l, m);switch (l) {case "iframe":case "object":G("load",
                    q);h = m;break;case "video":case "audio":for (h = 0; h < bb.length; h++) {G(bb[h], q);}h = m;break;case "source":G("error", q);h = m;break;case "img":case "image":case "link":G("error", q);G("load", q);h = m;break;case "form":G("reset", q);G("submit", q);h = m;break;case "details":G("toggle", q);h = m;break;case "input":Bc(q, m);h = Ac(q, m);G("invalid", q);xe(x, "onChange");break;case "option":h = ee(q, m);break;case "select":q._wrapperState = { wasMultiple: !!m.multiple };h = n({}, m, { value: void 0 });G("invalid", q);xe(x, "onChange");break;case "textarea":he(q,
                    m);h = ge(q, m);G("invalid", q);xe(x, "onChange");break;default:h = m;}ve(l, h);k = void 0;var B = l,Q = q,v = h;for (k in v) {if (v.hasOwnProperty(k)) {var r = v[k];"style" === k ? te(Q, r) : "dangerouslySetInnerHTML" === k ? (r = r ? r.__html : void 0, null != r && oe(Q, r)) : "children" === k ? "string" === typeof r ? ("textarea" !== B || "" !== r) && pe(Q, r) : "number" === typeof r && pe(Q, "" + r) : "suppressContentEditableWarning" !== k && "suppressHydrationWarning" !== k && "autoFocus" !== k && (sa.hasOwnProperty(k) ? null != r && xe(x, k) : null != r && yc(Q, k, r, z));}}switch (l) {case "input":Vb(q);
                    Fc(q, m, !1);break;case "textarea":Vb(q);je(q, m);break;case "option":null != m.value && q.setAttribute("value", "" + zc(m.value));break;case "select":h = q;h.multiple = !!m.multiple;q = m.value;null != q ? fe(h, !!m.multiple, q, !1) : null != m.defaultValue && fe(h, !!m.multiple, m.defaultValue, !0);break;default:"function" === typeof h.onClick && (q.onclick = ye);}(g = Be(f, g)) && zg(b);b.stateNode = e;}null !== b.ref && (b.effectTag |= 128);} else null === b.stateNode ? t("166") : void 0;break;case 6:e && null != b.stateNode ? Gg(e, b, e.memoizedProps, g) : ("string" !==
            typeof g && (null === b.stateNode ? t("166") : void 0), e = Hf(Gf.current), Hf(N.current), lg(b) ? (g = b, f = g.stateNode, e = g.memoizedProps, f[Ga] = g, (g = f.nodeValue !== e) && zg(b)) : (f = b, g = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(g), g[Ga] = b, f.stateNode = g));break;case 11:break;case 13:g = b.memoizedState;if (0 !== (b.effectTag & 64)) {b.expirationTime = f;R = b;break a;}g = null !== g;f = null !== e && null !== e.memoizedState;null !== e && !g && f && (e = e.child.sibling, null !== e && (h = b.firstEffect, null !== h ? (b.firstEffect = e, e.nextEffect = h) : (b.firstEffect =
            b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));if (g !== f || 0 === (b.effectTag & 1) && g) b.effectTag |= 4;break;case 7:break;case 8:break;case 12:break;case 4:Jf(b);Bg(b);break;case 10:Bf(b);break;case 9:break;case 14:break;case 17:L(b.type) && Me(b);break;default:t("156");}R = null;}b = a;if (1 === T || 1 !== b.childExpirationTime) {g = 0;for (f = b.child; null !== f;) {e = f.expirationTime, h = f.childExpirationTime, e > g && (g = e), h > g && (g = h), f = f.sibling;}b.childExpirationTime = g;}if (null !== R) return R;null !== c && 0 === (c.effectTag & 1024) && (null ===
      c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));} else {a = Tg(a, T);if (null !== a) return a.effectTag &= 1023, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);}if (null !== d) return d;if (null !== c) a = c;else break;}return null;}
function fh(a) {var b = yg(a.alternate, a, T);a.memoizedProps = a.pendingProps;null === b && (b = eh(a));Vg.current = null;return b;}
function gh(a, b) {Yg ? t("243") : void 0;Sf();Yg = !0;Vg.currentDispatcher = Ug;var c = a.nextExpirationTimeToWorkOn;if (c !== T || a !== S || null === R) dh(), S = a, T = c, R = Ze(S.current, null, T), a.pendingCommitExpirationTime = 0;var d = !1;do {try {if (b) for (; null !== R && !hh();) {R = fh(R);} else for (; null !== R;) {R = fh(R);}} catch (B) {if (zf = yf = xf = null, null === R) d = !0, Qg(B);else {null === R ? t("271") : void 0;var e = R,f = e.return;if (null === f) d = !0, Qg(B);else {a: {var g = a,h = f,k = e,l = B;f = T;k.effectTag |= 1024;k.firstEffect = k.lastEffect = null;if (null !== l && "object" === (typeof
            l === "undefined" ? "undefined" : (0, _typeof3.default)(l)) && "function" === typeof l.then) {var m = l;l = h;var q = -1,x = -1;do {if (13 === l.tag) {var z = l.alternate;if (null !== z && (z = z.memoizedState, null !== z)) {x = 10 * (1073741822 - z.timedOutAt);break;}z = l.pendingProps.maxDuration;if ("number" === typeof z) if (0 >= z) q = 0;else if (-1 === q || z < q) q = z;}l = l.return;} while (null !== l);l = h;do {if (z = 13 === l.tag) z = void 0 === l.memoizedProps.fallback ? !1 : null === l.memoizedState;if (z) {h = ih.bind(null, g, l, k, 0 === (l.mode & 1) ? 1073741823 : f);m.then(h, h);if (0 === (l.mode & 1)) {l.effectTag |= 64;k.effectTag &= -1957;
                    1 === k.tag && null === k.alternate && (k.tag = 17);k.expirationTime = f;break a;}-1 === q ? g = 1073741823 : (-1 === x && (x = 10 * (1073741822 - hf(g, f)) - 5E3), g = x + q);0 <= g && Zg < g && (Zg = g);l.effectTag |= 2048;l.expirationTime = f;break a;}l = l.return;} while (null !== l);l = Error((mc(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + nc(k));}$g = !0;l = vf(l, k);g = h;do {switch (g.tag) {case 3:k =
                  l;g.effectTag |= 2048;g.expirationTime = f;f = Pg(g, k, f);pf(g, f);break a;case 1:if (k = l, h = g.type, m = g.stateNode, 0 === (g.effectTag & 64) && ("function" === typeof h.getDerivedStateFromError || null !== m && "function" === typeof m.componentDidCatch && (null === Sg || !Sg.has(m)))) {g.effectTag |= 2048;g.expirationTime = f;f = Rg(g, k, f);pf(g, f);break a;}}g = g.return;} while (null !== g);}R = eh(e);continue;}}}break;} while (1);Yg = !1;zf = yf = xf = Vg.currentDispatcher = null;if (d) S = null, a.finishedWork = null;else if (null !== R) a.finishedWork = null;else {d = a.current.alternate;
    null === d ? t("281") : void 0;S = null;if ($g) {e = a.latestPendingTime;f = a.latestSuspendedTime;g = a.latestPingedTime;if (0 !== e && e < c || 0 !== f && f < c || 0 !== g && g < c) {gf(a, c);jh(a, d, c, a.expirationTime, -1);return;}if (!a.didError && b) {a.didError = !0;c = a.nextExpirationTimeToWorkOn = c;b = a.expirationTime = 1073741823;jh(a, d, c, b, -1);return;}}b && -1 !== Zg ? (gf(a, c), b = 10 * (1073741822 - hf(a, c)), b < Zg && (Zg = b), b = 10 * (1073741822 - Qf()), b = Zg - b, jh(a, d, c, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = c, a.finishedWork = d);}}
function Jg(a, b) {for (var c = a.return; null !== c;) {switch (c.tag) {case 1:var d = c.stateNode;if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Sg || !Sg.has(d))) {a = vf(b, a);a = Rg(c, a, 1073741823);of(c, a);Tf(c, 1073741823);return;}break;case 3:a = vf(b, a);a = Pg(c, a, 1073741823);of(c, a);Tf(c, 1073741823);return;}c = c.return;}3 === a.tag && (c = vf(b, a), c = Pg(a, c, 1073741823), of(a, c), Tf(a, 1073741823));}
function Rf(a, b) {0 !== Xg ? a = Xg : Yg ? a = ah ? 1073741823 : T : b.mode & 1 ? (a = kh ? 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1) : 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1), null !== S && a === T && --a) : a = 1073741823;kh && (0 === lh || a < lh) && (lh = a);return a;}
function ih(a, b, c, d) {var e = a.earliestSuspendedTime;var f = a.latestSuspendedTime;if (0 !== e && d <= e && d >= f) {f = e = d;a.didError = !1;var g = a.latestPingedTime;if (0 === g || g > f) a.latestPingedTime = f;ff(f, a);} else e = Qf(), e = Rf(e, b), ef(a, e);0 !== (b.mode & 1) && a === S && T === d && (S = null);mh(b, e);0 === (b.mode & 1) && (mh(c, e), 1 === c.tag && null !== c.stateNode && (b = mf(e), b.tag = 2, of(c, b)));c = a.expirationTime;0 !== c && nh(a, c);}
function mh(a, b) {a.expirationTime < b && (a.expirationTime = b);var c = a.alternate;null !== c && c.expirationTime < b && (c.expirationTime = b);var d = a.return,e = null;if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {c = d.alternate;d.childExpirationTime < b && (d.childExpirationTime = b);null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);if (null === d.return && 3 === d.tag) {e = d.stateNode;break;}d = d.return;}return e;}
function Tf(a, b) {a = mh(a, b);null !== a && (!Yg && 0 !== T && b > T && dh(), ef(a, b), Yg && !ah && S === a || nh(a, a.expirationTime), oh > ph && (oh = 0, t("185")));}function qh(a, b, c, d, e) {var f = Xg;Xg = 1073741823;try {return a(b, c, d, e);} finally {Xg = f;}}var rh = null,V = null,sh = 0,th = void 0,W = !1,uh = null,X = 0,lh = 0,vh = !1,wh = null,Z = !1,xh = !1,kh = !1,yh = null,zh = ba.unstable_now(),Ah = 1073741822 - (zh / 10 | 0),Bh = Ah,ph = 50,oh = 0,Ch = null;function Dh() {Ah = 1073741822 - ((ba.unstable_now() - zh) / 10 | 0);}
function Eh(a, b) {if (0 !== sh) {if (b < sh) return;null !== th && ba.unstable_cancelCallback(th);}sh = b;a = ba.unstable_now() - zh;th = ba.unstable_scheduleCallback(Fh, { timeout: 10 * (1073741822 - b) - a });}function jh(a, b, c, d, e) {a.expirationTime = d;0 !== e || hh() ? 0 < e && (a.timeoutHandle = De(Gh.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);}function Gh(a, b, c) {a.pendingCommitExpirationTime = c;a.finishedWork = b;Dh();Bh = Ah;Hh(a, c);}function Qf() {if (W) return Bh;Ih();if (0 === X || 1 === X) Dh(), Bh = Ah;return Bh;}
function nh(a, b) {null === a.nextScheduledRoot ? (a.expirationTime = b, null === V ? (rh = V = a, a.nextScheduledRoot = a) : (V = V.nextScheduledRoot = a, V.nextScheduledRoot = rh)) : b > a.expirationTime && (a.expirationTime = b);W || (Z ? xh && (uh = a, X = 1073741823, Jh(a, 1073741823, !1)) : 1073741823 === b ? Kh(1073741823, !1) : Eh(a, b));}
function Ih() {var a = 0,b = null;if (null !== V) for (var c = V, d = rh; null !== d;) {var e = d.expirationTime;if (0 === e) {null === c || null === V ? t("244") : void 0;if (d === d.nextScheduledRoot) {rh = V = d.nextScheduledRoot = null;break;} else if (d === rh) rh = e = d.nextScheduledRoot, V.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === V) {V = c;V.nextScheduledRoot = rh;d.nextScheduledRoot = null;break;} else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;} else {e > a && (a = e, b = d);if (d === V) break;if (1073741823 ===
      a) break;c = d;d = d.nextScheduledRoot;}}uh = b;X = a;}var Lh = !1;function hh() {return Lh ? !0 : ba.unstable_shouldYield() ? Lh = !0 : !1;}function Fh() {try {if (!hh() && null !== rh) {Dh();var a = rh;do {var b = a.expirationTime;0 !== b && Ah <= b && (a.nextExpirationTimeToWorkOn = Ah);a = a.nextScheduledRoot;} while (a !== rh);}Kh(0, !0);} finally {Lh = !1;}}
function Kh(a, b) {Ih();if (b) for (Dh(), Bh = Ah; null !== uh && 0 !== X && a <= X && !(Lh && Ah > X);) {Jh(uh, X, Ah > X), Ih(), Dh(), Bh = Ah;} else for (; null !== uh && 0 !== X && a <= X;) {Jh(uh, X, !1), Ih();}b && (sh = 0, th = null);0 !== X && Eh(uh, X);oh = 0;Ch = null;if (null !== yh) for (a = yh, yh = null, b = 0; b < a.length; b++) {var c = a[b];try {c._onComplete();} catch (d) {vh || (vh = !0, wh = d);}}if (vh) throw a = wh, wh = null, vh = !1, a;}function Hh(a, b) {W ? t("253") : void 0;uh = a;X = b;Jh(a, b, !1);Kh(1073741823, !1);}
function Jh(a, b, c) {W ? t("245") : void 0;W = !0;if (c) {var d = a.finishedWork;null !== d ? Mh(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, Ee(d)), gh(a, c), d = a.finishedWork, null !== d && (hh() ? a.finishedWork = d : Mh(a, d, b)));} else d = a.finishedWork, null !== d ? Mh(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, Ee(d)), gh(a, c), d = a.finishedWork, null !== d && Mh(a, d, b));W = !1;}
function Mh(a, b, c) {var d = a.firstBatch;if (null !== d && d._expirationTime >= c && (null === yh ? yh = [d] : yh.push(d), d._defer)) {a.finishedWork = b;a.expirationTime = 0;return;}a.finishedWork = null;a === Ch ? oh++ : (Ch = a, oh = 0);ah = Yg = !0;a.current === b ? t("177") : void 0;c = a.pendingCommitExpirationTime;0 === c ? t("261") : void 0;a.pendingCommitExpirationTime = 0;d = b.expirationTime;var e = b.childExpirationTime;d = e > d ? e : d;a.didError = !1;0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime =
  0) : (e = a.latestPendingTime, 0 !== e && (e > d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? ef(a, d) : d < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, ef(a, d)) : d > e && ef(a, d));ff(0, a);Vg.current = null;1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;ze = Hd;e = Td();if (Ud(e)) {if ("selectionStart" in e) var f = { start: e.selectionStart,
      end: e.selectionEnd };else a: {f = (f = e.ownerDocument) && f.defaultView || window;var g = f.getSelection && f.getSelection();if (g && 0 !== g.rangeCount) {f = g.anchorNode;var h = g.anchorOffset,k = g.focusNode;g = g.focusOffset;try {f.nodeType, k.nodeType;} catch (db) {f = null;break a;}var l = 0,m = -1,q = -1,x = 0,z = 0,B = e,Q = null;b: for (;;) {for (var v;;) {B !== f || 0 !== h && 3 !== B.nodeType || (m = l + h);B !== k || 0 !== g && 3 !== B.nodeType || (q = l + g);3 === B.nodeType && (l += B.nodeValue.length);if (null === (v = B.firstChild)) break;Q = B;B = v;}for (;;) {if (B === e) break b;Q === f &&
            ++x === h && (m = l);Q === k && ++z === g && (q = l);if (null !== (v = B.nextSibling)) break;B = Q;Q = B.parentNode;}B = v;}f = -1 === m || -1 === q ? null : { start: m, end: q };} else f = null;}f = f || { start: 0, end: 0 };} else f = null;Ae = { focusedElem: e, selectionRange: f };Hd = !1;for (U = d; null !== U;) {e = !1;f = void 0;try {for (; null !== U;) {if (U.effectTag & 256) a: {var r = U.alternate;h = U;switch (h.tag) {case 0:case 11:case 15:break a;case 1:if (h.effectTag & 256 && null !== r) {var u = r.memoizedProps,y = r.memoizedState,Y = h.stateNode,Th = Y.getSnapshotBeforeUpdate(h.elementType === h.type ?
                u : O(h.type, u), y);Y.__reactInternalSnapshotBeforeUpdate = Th;}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163");}}U = U.nextEffect;}} catch (db) {e = !0, f = db;}e && (null === U ? t("178") : void 0, Jg(U, f), null !== U && (U = U.nextEffect));}for (U = d; null !== U;) {r = !1;u = void 0;try {for (; null !== U;) {var w = U.effectTag;w & 16 && pe(U.stateNode, "");if (w & 128) {var C = U.alternate;if (null !== C) {var p = C.ref;null !== p && ("function" === typeof p ? p(null) : p.current = null);}}switch (w & 14) {case 2:Ng(U);U.effectTag &= -3;break;case 6:Ng(U);U.effectTag &=
            -3;Og(U.alternate, U);break;case 4:Og(U.alternate, U);break;case 8:y = U, Lg(y), y.return = null, y.child = null, y.alternate && (y.alternate.child = null, y.alternate.return = null);}U = U.nextEffect;}} catch (db) {r = !0, u = db;}r && (null === U ? t("178") : void 0, Jg(U, u), null !== U && (U = U.nextEffect));}p = Ae;C = Td();w = p.focusedElem;u = p.selectionRange;if (C !== w && w && w.ownerDocument && Sd(w.ownerDocument.documentElement, w)) {null !== u && Ud(w) && (C = u.start, p = u.end, void 0 === p && (p = C), "selectionStart" in w ? (w.selectionStart = C, w.selectionEnd = Math.min(p,
    w.value.length)) : (p = (C = w.ownerDocument || document) && C.defaultView || window, p.getSelection && (p = p.getSelection(), y = w.textContent.length, r = Math.min(u.start, y), u = void 0 === u.end ? r : Math.min(u.end, y), !p.extend && r > u && (y = u, u = r, r = y), y = Rd(w, r), Y = Rd(w, u), y && Y && (1 !== p.rangeCount || p.anchorNode !== y.node || p.anchorOffset !== y.offset || p.focusNode !== Y.node || p.focusOffset !== Y.offset) && (C = C.createRange(), C.setStart(y.node, y.offset), p.removeAllRanges(), r > u ? (p.addRange(C), p.extend(Y.node, Y.offset)) : (C.setEnd(Y.node, Y.offset),
    p.addRange(C))))));C = [];for (p = w; p = p.parentNode;) {1 === p.nodeType && C.push({ element: p, left: p.scrollLeft, top: p.scrollTop });}"function" === typeof w.focus && w.focus();for (w = 0; w < C.length; w++) {p = C[w], p.element.scrollLeft = p.left, p.element.scrollTop = p.top;}}Ae = null;Hd = !!ze;ze = null;a.current = b;for (U = d; null !== U;) {d = !1;w = void 0;try {for (C = c; null !== U;) {var Fb = U.effectTag;if (Fb & 36) {var Gb = U.alternate;p = U;r = C;switch (p.tag) {case 0:case 11:case 15:break;case 1:var wc = p.stateNode;if (p.effectTag & 4) if (null === Gb) wc.componentDidMount();else
              {var ci = p.elementType === p.type ? Gb.memoizedProps : O(p.type, Gb.memoizedProps);wc.componentDidUpdate(ci, Gb.memoizedState, wc.__reactInternalSnapshotBeforeUpdate);}var Cg = p.updateQueue;null !== Cg && tf(p, Cg, wc, r);break;case 3:var Dg = p.updateQueue;if (null !== Dg) {u = null;if (null !== p.child) switch (p.child.tag) {case 5:u = p.child.stateNode;break;case 1:u = p.child.stateNode;}tf(p, Dg, u, r);}break;case 5:var di = p.stateNode;null === Gb && p.effectTag & 4 && Be(p.type, p.memoizedProps) && di.focus();break;case 6:break;case 4:break;
            case 12:break;case 13:break;case 17:break;default:t("163");}}if (Fb & 128) {var Ic = U.ref;if (null !== Ic) {var Eg = U.stateNode;switch (U.tag) {case 5:var ce = Eg;break;default:ce = Eg;}"function" === typeof Ic ? Ic(ce) : Ic.current = ce;}}U = U.nextEffect;}} catch (db) {d = !0, w = db;}d && (null === U ? t("178") : void 0, Jg(U, w), null !== U && (U = U.nextEffect));}Yg = ah = !1;"function" === typeof Se && Se(b.stateNode);Fb = b.expirationTime;b = b.childExpirationTime;b = b > Fb ? b : Fb;0 === b && (Sg = null);a.expirationTime = b;a.finishedWork = null;}
function Qg(a) {null === uh ? t("246") : void 0;uh.expirationTime = 0;vh || (vh = !0, wh = a);}function Nh(a, b) {var c = Z;Z = !0;try {return a(b);} finally {(Z = c) || W || Kh(1073741823, !1);}}function Oh(a, b) {if (Z && !xh) {xh = !0;try {return a(b);} finally {xh = !1;}}return a(b);}function Ph(a, b, c) {if (kh) return a(b, c);Z || W || 0 === lh || (Kh(lh, !1), lh = 0);var d = kh,e = Z;Z = kh = !0;try {return a(b, c);} finally {kh = d, (Z = e) || W || Kh(1073741823, !1);}}
function Qh(a, b, c, d, e) {var f = b.current;a: if (c) {c = c._reactInternalFiber;b: {2 === kd(c) && 1 === c.tag ? void 0 : t("170");var g = c;do {switch (g.tag) {case 3:g = g.stateNode.context;break b;case 1:if (L(g.type)) {g = g.stateNode.__reactInternalMemoizedMergedChildContext;break b;}}g = g.return;} while (null !== g);t("171");g = void 0;}if (1 === c.tag) {var h = c.type;if (L(h)) {c = Pe(c, h, g);break a;}}c = g;} else c = Je;null === b.context ? b.context = c : b.pendingContext = c;b = e;e = mf(d);e.payload = { element: a };b = void 0 === b ? null : b;null !== b && (e.callback = b);
  Sf();of(f, e);Tf(f, d);return d;}function Rh(a, b, c, d) {var e = b.current,f = Qf();e = Rf(f, e);return Qh(a, b, c, e, d);}function Sh(a) {a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:return a.child.stateNode;default:return a.child.stateNode;}}function Uh(a, b, c) {var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: $b, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };}
Cb = function Cb(a, b, c) {switch (b) {case "input":Dc(a, c);b = c.name;if ("radio" === c.type && null != b) {for (c = a; c.parentNode;) {c = c.parentNode;}c = c.querySelectorAll("input[name=" + (0, _stringify2.default)("" + b) + '][type="radio"]');for (b = 0; b < c.length; b++) {var d = c[b];if (d !== a && d.form === a.form) {var e = La(d);e ? void 0 : t("90");Wb(d);Dc(d, e);}}}break;case "textarea":ie(a, c);break;case "select":b = c.value, null != b && fe(a, !!c.multiple, b, !1);}};
function Vh(a) {var b = 1073741822 - 25 * (((1073741822 - Qf() + 500) / 25 | 0) + 1);b >= Wg && (b = Wg - 1);this._expirationTime = Wg = b;this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;}Vh.prototype.render = function (a) {this._defer ? void 0 : t("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,c = this._expirationTime,d = new Wh();Qh(a, b, null, c, d._onCommit);return d;};
Vh.prototype.then = function (a) {if (this._didComplete) a();else {var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);}};
Vh.prototype.commit = function () {var a = this._root._internalRoot,b = a.firstBatch;this._defer && null !== b ? void 0 : t("251");if (this._hasChildren) {var c = this._expirationTime;if (b !== this) {this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) {d = e, e = e._next;}null === d ? t("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;}this._defer = !1;Hh(a, c);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);} else this._next =
  null, this._defer = !1;};Vh.prototype._onComplete = function () {if (!this._didComplete) {this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {(0, a[b])();}}};function Wh() {this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);}Wh.prototype.then = function (a) {if (this._didCommit) a();else {var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);}};
Wh.prototype._onCommit = function () {if (!this._didCommit) {this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {var c = a[b];"function" !== typeof c ? t("191", c) : void 0;c();}}};
function Xh(a, b, c) {b = M(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, earliestPendingTime: 0, latestPendingTime: 0, earliestSuspendedTime: 0, latestSuspendedTime: 0, latestPingedTime: 0, didError: !1, pendingCommitExpirationTime: 0, finishedWork: null, timeoutHandle: -1, context: null, pendingContext: null, hydrate: c, nextExpirationTimeToWorkOn: 0, expirationTime: 0, firstBatch: null, nextScheduledRoot: null };this._internalRoot = b.stateNode = a;}
Xh.prototype.render = function (a, b) {var c = this._internalRoot,d = new Wh();b = void 0 === b ? null : b;null !== b && d.then(b);Rh(a, c, null, d._onCommit);return d;};Xh.prototype.unmount = function (a) {var b = this._internalRoot,c = new Wh();a = void 0 === a ? null : a;null !== a && c.then(a);Rh(null, b, null, c._onCommit);return c;};Xh.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {var d = this._internalRoot,e = new Wh();c = void 0 === c ? null : c;null !== c && e.then(c);Rh(b, d, a, e._onCommit);return e;};
Xh.prototype.createBatch = function () {var a = new Vh(this),b = a._expirationTime,c = this._internalRoot,d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {for (c = null; null !== d && d._expirationTime >= b;) {c = d, d = d._next;}a._next = d;null !== c && (c._next = a);}return a;};function Yh(a) {return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));}Kb = Nh;Lb = Ph;Mb = function Mb() {W || 0 === lh || (Kh(lh, !1), lh = 0);};
function Zh(a, b) {b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {a.removeChild(c);}return new Xh(a, !1, b);}
function $h(a, b, c, d, e) {Yh(c) ? void 0 : t("200");var f = c._reactRootContainer;if (f) {if ("function" === typeof e) {var g = e;e = function e() {var a = Sh(f._internalRoot);g.call(a);};}null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);} else {f = c._reactRootContainer = Zh(c, d);if ("function" === typeof e) {var h = e;e = function e() {var a = Sh(f._internalRoot);h.call(a);};}Oh(function () {null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);});}return Sh(f._internalRoot);}
function ai(a, b) {var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;Yh(b) ? void 0 : t("200");return Uh(a, b, null, c);}
var bi = { createPortal: ai, findDOMNode: function findDOMNode(a) {if (null == a) return null;if (1 === a.nodeType) return a;var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? t("188") : t("268", (0, _keys2.default)(a)));a = nd(b);a = null === a ? null : a.stateNode;return a;}, hydrate: function hydrate(a, b, c) {return $h(null, a, b, !0, c);}, render: function render(a, b, c) {return $h(null, a, b, !1, c);}, unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {null == a || void 0 === a._reactInternalFiber ? t("38") : void 0;return $h(a, b, c, !1, d);}, unmountComponentAtNode: function unmountComponentAtNode(a) {Yh(a) ?
    void 0 : t("40");return a._reactRootContainer ? (Oh(function () {$h(null, null, a, !1, function () {a._reactRootContainer = null;});}), !0) : !1;}, unstable_createPortal: function unstable_createPortal() {return ai.apply(void 0, arguments);}, unstable_batchedUpdates: Nh, unstable_interactiveUpdates: Ph, flushSync: function flushSync(a, b) {W ? t("187") : void 0;var c = Z;Z = !0;try {return qh(a, b);} finally {Z = c, Kh(1073741823, !1);}}, unstable_flushControlled: function unstable_flushControlled(a) {var b = Z;Z = !0;try {qh(a);} finally {(Z = b) || W || Kh(1073741823, !1);}}, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { Events: [Ja,
    Ka, La, Ca.injectEventPluginsByName, qa, Ra, function (a) {za(a, Qa);}, Ib, Jb, Jd, Ea] }, unstable_createRoot: function unstable_createRoot(a, b) {Yh(a) ? void 0 : t("299", "unstable_createRoot");return new Xh(a, !0, null != b && !0 === b.hydrate);} };(function (a) {var b = a.findFiberByHostInstance;return Ve(n({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {a = nd(a);return null === a ? null : a.stateNode;}, findFiberByHostInstance: function findFiberByHostInstance(a) {return b ? b(a) : null;} }));})({ findFiberByHostInstance: Ia, bundleType: 0, version: "16.6.3", rendererPackageName: "react-dom" });
var ei = { default: bi },fi = ei && bi || ei;module.exports = fi.default || fi;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(66);
__webpack_require__(80);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
module.exports = __webpack_require__(13).Map;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(566);
var validate = __webpack_require__(524);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(567)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(34);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(568)('Map') });


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(569)('Map');


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(570)('Map');


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(955);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.11.3
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var _typeof2 = __webpack_require__(25);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}Object.defineProperty(exports, "__esModule", { value: !0 });var d = null,f = !1,h = 3,k = -1,l = -1,m = !1,n = !1;function p() {if (!m) {var a = d.expirationTime;n ? q() : n = !0;_r(t, a);}}
function u() {var a = d,b = d.next;if (d === b) d = null;else {var c = d.previous;d = c.next = b;b.previous = c;}a.next = a.previous = null;c = a.callback;b = a.expirationTime;a = a.priorityLevel;var e = h,Q = l;h = a;l = b;try {var g = c();} finally {h = e, l = Q;}if ("function" === typeof g) if (g = { callback: g, priorityLevel: a, expirationTime: b, next: null, previous: null }, null === d) d = g.next = g.previous = g;else {c = null;a = d;do {if (a.expirationTime >= b) {c = a;break;}a = a.next;} while (a !== d);null === c ? c = d : c === d && (d = g, p());b = c.previous;b.next = c.previous = g;g.next = c;g.previous =
    b;}}function v() {if (-1 === k && null !== d && 1 === d.priorityLevel) {m = !0;try {do {u();} while (null !== d && 1 === d.priorityLevel);} finally {m = !1, null !== d ? p() : n = !1;}}}function t(a) {m = !0;var b = f;f = a;try {if (a) for (; null !== d;) {var c = exports.unstable_now();if (d.expirationTime <= c) {do {u();} while (null !== d && d.expirationTime <= c);} else break;} else if (null !== d) {do {u();} while (null !== d && !w());}} finally {m = !1, f = b, null !== d ? p() : n = !1, v();}}
var x = Date,y = "function" === typeof setTimeout ? setTimeout : void 0,z = "function" === typeof clearTimeout ? clearTimeout : void 0,A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,C,D;function E(a) {C = A(function (b) {z(D);a(b);});D = y(function () {B(C);a(exports.unstable_now());}, 100);}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, _typeof3.default)(performance)) && "function" === typeof performance.now) {var F = performance;exports.unstable_now = function () {return F.now();};} else exports.unstable_now = function () {return x.now();};var _r,q,w,G = null;"undefined" !== typeof window ? G = window : "undefined" !== typeof global && (G = global);
if (G && G._schedMock) {var H = G._schedMock;_r = H[0];q = H[1];w = H[2];exports.unstable_now = H[3];} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {var I = null,J = function J(a) {if (null !== I) try {I(a);} finally {I = null;}};_r = function r(a) {null !== I ? setTimeout(_r, 0, a) : (I = a, setTimeout(J, 0, !1));};q = function q() {I = null;};w = function w() {return !1;};} else {"undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
  "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K = null,L = !1,M = -1,N = !1,O = !1,P = 0,R = 33,S = 33;w = function w() {return P <= exports.unstable_now();};var T = new MessageChannel(),U = T.port2;T.port1.onmessage = function () {L = !1;var a = K,b = M;K = null;M = -1;var c = exports.unstable_now(),e = !1;if (0 >= P - c) if (-1 !== b && b <= c) e = !0;else {N || (N = !0, E(V));K = a;M = b;return;}if (null !== a) {O = !0;try {a(e);} finally {O = !1;}}};
  var V = function V(a) {if (null !== K) {E(V);var b = a - P + S;b < S && R < S ? (8 > b && (b = 8), S = b < R ? R : b) : R = b;P = a + S;L || (L = !0, U.postMessage(void 0));} else N = !1;};_r = function _r(a, b) {K = a;M = b;O || 0 > b ? U.postMessage(void 0) : N || (N = !0, E(V));};q = function q() {K = null;L = !1;M = -1;};}exports.unstable_ImmediatePriority = 1;exports.unstable_UserBlockingPriority = 2;exports.unstable_NormalPriority = 3;exports.unstable_IdlePriority = 5;exports.unstable_LowPriority = 4;
exports.unstable_runWithPriority = function (a, b) {switch (a) {case 1:case 2:case 3:case 4:case 5:break;default:a = 3;}var c = h,e = k;h = a;k = exports.unstable_now();try {return b();} finally {h = c, k = e, v();}};
exports.unstable_scheduleCallback = function (a, b) {var c = -1 !== k ? k : exports.unstable_now();if ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) && null !== b && "number" === typeof b.timeout) b = c + b.timeout;else switch (h) {case 1:b = c + -1;break;case 2:b = c + 250;break;case 5:b = c + 1073741823;break;case 4:b = c + 1E4;break;default:b = c + 5E3;}a = { callback: a, priorityLevel: h, expirationTime: b, next: null, previous: null };if (null === d) d = a.next = a.previous = a, p();else {c = null;var e = d;do {if (e.expirationTime > b) {c = e;break;}e = e.next;} while (e !== d);null === c ? c = d : c === d && (d = a, p());
    b = c.previous;b.next = c.previous = a;a.next = c;a.previous = b;}return a;};exports.unstable_cancelCallback = function (a) {var b = a.next;if (null !== b) {if (b === a) d = null;else {a === d && (d = b);var c = a.previous;c.next = b;b.previous = c;}a.next = a.previous = null;}};exports.unstable_wrapCallback = function (a) {var b = h;return function () {var c = h,e = k;h = b;k = exports.unstable_now();try {return a.apply(this, arguments);} finally {h = c, k = e, v();}};};exports.unstable_getCurrentPriorityLevel = function () {return h;};
exports.unstable_shouldYield = function () {return !f && (null !== d && d.expirationTime < l || w());};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) {if (!exports.hasOwnProperty(p)) exports[p] = m[p];}
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(957));
__export(__webpack_require__(958));
__export(__webpack_require__(959));
//# sourceMappingURL=index.js.map

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(514);
exports.Connect = function (name) {
    return function (state, dispatch, render) {
        var res = react_redux_1.connect(state, dispatch)(render);
        return res;
    };
};
//# sourceMappingURL=Connect.js.map

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];}
    if (s != null && typeof _getOwnPropertySymbols2.default === "function")
    for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {if (e.indexOf(p[i]) < 0)
        t[p[i]] = s[p[i]];}
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var nameFunction_1 = __webpack_require__(647);
var React = __webpack_require__(171);
var react_redux_1 = __webpack_require__(514);var
PureComponentWrap = function (_React$PureComponent) {(0, _inherits3.default)(PureComponentWrap, _React$PureComponent);function PureComponentWrap() {(0, _classCallCheck3.default)(this, PureComponentWrap);return (0, _possibleConstructorReturn3.default)(this, (PureComponentWrap.__proto__ || (0, _getPrototypeOf2.default)(PureComponentWrap)).apply(this, arguments));}(0, _createClass3.default)(PureComponentWrap, [{ key: "render", value: function render()
        {
            var _a = this.props,_inner = _a._inner,others = __rest(_a, ["_inner"]);
            return _inner(others);
        } }]);return PureComponentWrap;}(React.PureComponent);

exports.PureConnect = function (name) {
    return function (state, dispatch, render) {
        var component = (0, _assign2.default)(nameFunction_1.nameFunction("PureConnect_" + name, function PureFunction(props) {
            return React.createElement(PureComponentWrap, (0, _assign2.default)({ _inner: render }, props));
        }), {
            displayName: "PureConnect(" + name + ")" });

        if (state)
        state = nameFunction_1.nameFunction("PureConnect_" + name + "_state", state);
        if (dispatch)
        dispatch = nameFunction_1.nameFunction("PureConnect_" + name + "_dispatch", dispatch);
        if (render)
        render = nameFunction_1.nameFunction("PureConnect_" + name + "_render", render);
        return react_redux_1.connect(state, dispatch)(component);
    };
};
//# sourceMappingURL=PureConnect.js.map

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _assign = __webpack_require__(77);var _assign2 = _interopRequireDefault(_assign);var _getPrototypeOf = __webpack_require__(232);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(105);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(110);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(515);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(516);var _inherits3 = _interopRequireDefault(_inherits2);var _getOwnPropertySymbols = __webpack_require__(248);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];}
    if (s != null && typeof _getOwnPropertySymbols2.default === "function")
    for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {if (e.indexOf(p[i]) < 0)
        t[p[i]] = s[p[i]];}
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var nameFunction_1 = __webpack_require__(647);
var React = __webpack_require__(171);var
PureComponentWrap = function (_React$PureComponent) {(0, _inherits3.default)(PureComponentWrap, _React$PureComponent);function PureComponentWrap() {(0, _classCallCheck3.default)(this, PureComponentWrap);return (0, _possibleConstructorReturn3.default)(this, (PureComponentWrap.__proto__ || (0, _getPrototypeOf2.default)(PureComponentWrap)).apply(this, arguments));}(0, _createClass3.default)(PureComponentWrap, [{ key: "render", value: function render()
        {
            var _a = this.props,_inner = _a._inner,others = __rest(_a, ["_inner"]);
            return _inner(others);
        } }]);return PureComponentWrap;}(React.PureComponent);

exports.PureFunctional = function (name) {
    return function (render) {
        var component = (0, _assign2.default)(nameFunction_1.nameFunction("PureFunctional_" + name, function PureFunction(props) {
            return React.createElement(PureComponentWrap, (0, _assign2.default)({ _inner: render }, props));
        }), {
            displayName: "PureFunctional(" + name + ")" });

        return component;
    };
};
//# sourceMappingURL=PureFunctional.js.map

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {


        // classnames-loader: automatically bind css-modules to classnames
        var classNames = __webpack_require__(492);
        var locals = __webpack_require__(961);
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(962);

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {"attributes":{}}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(491)(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(undefined);
// imports


// module
exports.push([module.i, "._3J6c1GJ-{font-weight:300}._3dnuGMVg{font-family:Roboto,Helvetica,Arial,sans-serif;position:absolute;z-index:100}._2CLbH3Xy,.UiJNjMsL{position:relative}._2Mv_0brQ{position:fixed;right:0;bottom:0;left:0;display:-ms-flexbox;display:-webkit-box;display:flex;white-space:nowrap;background:#fff;-webkit-box-shadow:3px 0 6px rgba(0,0,0,.16);box-shadow:3px 0 6px rgba(0,0,0,.16);list-style-type:none;-webkit-padding-start:0;-moz-padding-start:0;padding-inline-start:0;-webkit-margin-after:0;margin-block-end:0;height:60px}.JoKYflo5{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._1lhQ5irr,.JoKYflo5{line-height:50px;height:50px}.JoKYflo5{border-width:0 1px;border-style:solid;border-color:#d6d6d6;border-color:rgba(0,0,0,.16)}._3dnuGMVg._2jjcLBMk{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";opacity:.5}._3dnuGMVg._2HA4QvyM{-webkit-transition:opacity .3s ease;transition:opacity .3s ease;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";opacity:1}", ""]);

// exports
exports.locals = {
	"minireset": "_3J6c1GJ-",
	"ls-userdata": "_3dnuGMVg",
	"ls-userdata-app": "_2CLbH3Xy",
	"ls-userdata-ui": "UiJNjMsL",
	"ls-userdata-bar": "_2Mv_0brQ",
	"ls-userdata-note": "JoKYflo5",
	"ls-userdata-quicknav": "_1lhQ5irr",
	"loading": "_2jjcLBMk",
	"loaded": "_2HA4QvyM"
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// noteservice.js